import * as Yup from 'yup';
import axios from 'axios';
import { Icon } from '@iconify/react';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import settingsOutline from '@iconify/icons-eva/settings-outline';
import fileTextOutline from '@iconify/icons-eva/file-text-outline';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { capitalCase, sentenceCase } from 'change-case';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Form, FormikProvider, useFormik } from 'formik';
import { isAdminUser } from '../../utils/adminUserTypes';
import {
  Container, Grid, IconButton,
  Stack, Box, Button, TableRow,
  TableBody, Checkbox, Card,
  TableCell, Typography,
  TableContainer, Table,
  TablePagination,
  TextField,
  Switch,
  FormControlLabel,
  Autocomplete,
  Divider,
  Paper,
  Popover,
  CardHeader,
  TableHead,
  List,
  Menu,
  MenuItem,
  ListItemText,
  ListItemIcon,
  ListItem,
  Tabs,
  Tab,
  Tooltip,
  CircularProgress,
  Badge,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  RadioGroup,
  Radio,
  DialogActions,
  ButtonGroup,
  Skeleton,
  FormHelperText,
} from '@material-ui/core';
import { useTheme, experimentalStyled as styled } from '@material-ui/core/styles';
import plusFill from '@iconify/icons-eva/plus-fill';
// redux
import { LoadingButton, MobileDatePicker, MobileDateRangePicker } from '@material-ui/lab';
import { empty } from 'src/Helpers/Common';
// routes
// components
import Page from '../../components/Page';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import Modal from '../../components/_dashboard/blog/ProjectModel';
import Label from 'src/components/Label';
import { useSnackbar } from 'notistack';
import { Delete, UploadFile, LocationOn, ExpandMore, ExpandLess, Remove, Add, NoteAdd, ViewModule, ViewList,List as ListIcon, Settings, Visibility, VisibilityOff, FilterList, KeyboardBackspaceOutlined } from '@material-ui/icons';
import OfficialRequestSearch from 'src/components/_dashboard/official-request/OfficialRequestSearch';
import InfiniteScroll from 'react-infinite-scroll-component';
import OfficialCard from 'src/components/_dashboard/official-request/OfficialCard';
import Scrollbar from 'src/components/Scrollbar';
import moment from 'moment';
import { REST_API, REST_API_END_POINT, UNITS } from 'src/constants/Defaultvalues';
import { UploadAvatar, UploadMultiFile } from 'src/components/upload';
import { storage } from '../../firebase/firebase'
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import LoadingScreen from 'src/components/LoadingScreen';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import FullScreenDialogEstimate from '../components-overview/material-ui/dialog/FullScreenDialogEstimate';
import { supabase } from '../../supabase/supabaseClient';
import DesignOrderList from './DesignOrderList';
import RequestProgressModal from 'src/components/RequestProgressModal';
import { cancelAllGlobalRequests } from 'src/utils/globalApiCancellationManager';
import { formatDateOnly, dateOnlyMoment, dateOnlyToUnix, localTodayDateOnlyUnix, toDateOnlyUnix } from 'src/utils/dateOnly';
import getLabourCostServiceTabLabel from 'src/utils/getLabourCostServiceTabLabel';
import { isNumber } from 'lodash';
import RequestEstimate from './RequestEstimate';
import {
  getCommunityPageBackKey,
  readCommunityPageBackFromLocation,
  persistCommunityPageBack,
  navigateCommunityPageBack,
} from 'src/helpers/communityPageNavigation';

const SkeletonLoad = () => (
  <Grid container spacing={3} sx={{ padding: 2 }}>
    {[...Array(3)].map((_, index) => (
      <Grid item xs={12} sm={6} md={4} key={index}>
        <Skeleton variant="rectangular" width="100%" sx={{ height: 200, borderRadius: 2 }} />
        <Box sx={{ display: 'flex', mt: 1.5 }}>
          <Skeleton variant="circular" sx={{ width: 40, height: 40 }} />
          <Skeleton variant="text" sx={{ mx: 1, flexGrow: 1 }} />
        </Box>
      </Grid>
    ))}
  </Grid>
);

const MAX_CHARACTERS = 500;
const formatProjectAddress = (project) => {
  if (!project) return 'No address available';
  const addressParts = [project.address, project.city, project.state, project.zip]
    .map((part) => (part || '').toString().trim())
    .filter(Boolean);
  return addressParts.length > 0 ? addressParts.join(', ') : 'No address available';
};
const getStatusColorAndLabel = (status) => {
  switch (status) {
    case 1:
      return { color: 'warning', label: 'Status: Draft' };
    case 2:
      return { color: 'info', label: 'Status: Open' };
    case 3:
      return { color: 'primary', label: 'Status: Evaluating' };
    case 4:
      return { color: 'success', label: 'Status: Accepted' };
    case 5:
      return { color: 'warning', label: 'Status: Closed' };
    case 6:
      return { color: 'error', label: 'Status: Rejected' };
    default:
      return { color: 'default', label: 'Status: Open' };
  }
};

const markupTypes = [
  { id: 1, name: 'Wholesale Markup' },
  { id: 2, name: 'Retail Markup' }
]

const marketingAdjustmentType = [
  { id: 1, name: '%' },
  { id: 2, name: '$' },
  { id: 3, name: '¢' }
];


const SORT = [
  { id: 'new', label: 'Newest', color: '#54D62C' },
  { id: 'old', label: 'Oldest', color: '#ffff00' },
  { id: 'last_updated', label: 'Recently Updated', color: '#ffff00' },
  { id: 'custom_order', label: 'Custom Order', color: '#ffff00' },
];

const splitOrderCatalogTypes = [
  { id: 'all', label: 'All', inhouse: null, isTrafficCatalog: null },
  { id: 'in_stock', label: 'In Stock', inhouse: 4, isTrafficCatalog: false },
  { id: 'client_owned', label: 'Client Owned', inhouse: 5, isTrafficCatalog: false },
  { id: 'traffic', label: 'Traffic', inhouse: 1, isTrafficCatalog: true },
  { id: 'production_catalog', label: 'Production Catalog', inhouse: 1, isTrafficCatalog: false },
  { id: 'split_catalog', label: 'Split Catalog', inhouse: 6, isTrafficCatalog: false },
  { id: 'estimate_catalog', label: 'Estimate Catalog', inhouse: 7, isTrafficCatalog: false }
];
  const CustomTab = styled(Tab)(({ theme }) => ({
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    boxShadow: 'none', //theme.shadows[5],
    minHeight: 'fit-content',
    indicator: {
      display: 'none',
    },
    height: 38,
    fontSize: 12,
    borderRadius: 'none', //20
    border: '1.5px solid #00c2ff', //newlyadded
    background: '#161c24',
    margin: 0, //5
    color: theme.palette.text.primary,
    '&:hover': {
      background: '#161c24',
    },
    '&.Mui-selected': {
      background: theme.palette.primary.main,
      color: '#fff',
    },
    '&:first-child': {
      borderRadius: '7px 0 0 7px',
      borderLeft: `1.5px solid ${theme.palette.primary.main}`,
    },
    '&:nth-child(2)': {
      borderRadius: '0',
      borderLeft: '0',
    },
    '&:nth-child(3)': {
      borderRadius: '0',
      borderLeft: '0',
    },
    '&:last-child': {
      borderRadius: '0 7px 7px 0',
      borderLeft: '0',
    },
  
    [theme.breakpoints.up('lg')]: {
      marginRight: `0 !important`,
      minWidth: '20% !important',
    },
    [theme.breakpoints.down('lg')]: {
      marginRight: `0 !important`,
      minWidth: '20% !important',
    },
    [theme.breakpoints.down('sm')]: {
      marginRight: `0 !important`,
      minWidth: '30.33% !important',
    },
  }))

// const getMaxNegativeAdjustment = (data) => {
//   const formula = Number(data.formula_cost ?? data.expected_cost ?? 0);
//   const retail = Math.max(0, Number(data?.original_actual_retail_price ?? data?.original_retail_price ?? data?.actual_retail_price ?? data?.retail_price ?? 0));
//   const qty = Number(data.quantity) || 1;
//   const locQty = Number(data.locationQuantity) || 1;

//   const totalFormula = formula * qty * locQty;
//   const totalRetail = retail * qty * locQty;
//   console.log('getMaxNegativeInstallAdjustment-formula--',formula)
//   console.log('getMaxNegativeInstallAdjustment-retail--',retail)
//   console.log('getMaxNegativeInstallAdjustment-qty--',qty)
//   console.log('getMaxNegativeInstallAdjustment-locQty--',locQty)
//   console.log('getMaxNegativeInstallAdjustment-totalFormula--',totalFormula)
//   console.log('getMaxNegativeInstallAdjustment-totalRetail--',totalRetail)
//   return Math.max(0, retail - formula);
//   // return Math.max(0, totalRetail - totalFormula); // Cannot go below 0
// };
const getMaterialMaxNegativeAdjustment = (item) => {
  // Quantity and location quantities
  const qty = Number(item.quantity) || 1;
  const formulaEach = Number(item.price)
  const retailEachBase = Number(item.markUpCost)
  const formulaTotal = formulaEach * qty ;
  const retailTotal = retailEachBase * qty ;

  // Max negative adjustment allowed so that retailTotal - adjustment >= formulaTotal
  // const maxNegative = Math.max(0, retailTotal - formulaTotal);
  const maxNegative = Math.max(0, retailEachBase - formulaEach);

  console.log('getMaxNegativeAdjustment1-item--', item);
  console.log('getMaxNegativeAdjustment1-formulaEach--', formulaEach);
  console.log('getMaxNegativeAdjustment1-retailEachBase--', retailEachBase);
  console.log('getMaxNegativeAdjustment1-qty--', qty);
  console.log('getMaxNegativeAdjustment1-formulaTotal--', formulaTotal);
  console.log('getMaxNegativeAdjustment1-retailTotal--', retailTotal);
  console.log('getMaxNegativeAdjustment1-maxNegative--', maxNegative);
  // maxNegative.toFixed(2)
  return maxNegative.toFixed(2);
};
const getMaxNegativeAdjustment = (item) => {
  // Quantity and location quantities
  const qty = Number(item.quantity) || 1;
  const locQty = Number(item.locationQuantity) || 1;

  // Product Formula Cost per unit (material + service with markup)
  const formulaEach = Number(
    (item?.expected_material_cost_with_markup || 0) +
      (item?.expected_service_cost_with_markup || 0),
  );
  const formulaTotal = formulaEach * qty * locQty;

  // Base retail each BEFORE marketing adjustment
  const retailEachBase = Math.max(
    0,
    Number(
      item.original_actual_retail_price ??
        item.original_retail_price ??
        item.actual_retail_price ??
        item.retail_price ??
        item.product_retail_price ??
        0,
    ),
  );
  const retailTotal = retailEachBase * qty * locQty;

  // Max negative adjustment allowed so that retailTotal - adjustment >= formulaTotal
  // const maxNegative = Math.max(0, retailTotal - formulaTotal);
  const maxNegative = Math.max(0, retailEachBase - formulaEach);

  console.log('getMaxNegativeAdjustment1-item--', item);
  console.log('getMaxNegativeAdjustment1-formulaEach--', formulaEach);
  console.log('getMaxNegativeAdjustment1-retailEachBase--', retailEachBase);
  console.log('getMaxNegativeAdjustment1-qty--', qty);
  console.log('getMaxNegativeAdjustment1-locQty--', locQty);
  console.log('getMaxNegativeAdjustment1-formulaTotal--', formulaTotal);
  console.log('getMaxNegativeAdjustment1-retailTotal--', retailTotal);
  console.log('getMaxNegativeAdjustment1-maxNegative--', maxNegative);

  return maxNegative;
};
const getMaxNegativeInstallAdjustment = (data) => {
  const formula = Number(data?.expected_install_labor_cost_with_markup) || 0;
  const retail = Math.max(
    0,
    Number(data?.original_install_cost) || Number(data?.install_cost) || 0,
  );
  const qty = Number(data?.install_quantity) || 1;
  const locQty = Number(data?.locationQuantity) || 1;

  const totalFormula = formula * qty * locQty;
  const totalRetail = retail * qty * locQty;
  console.log('getMaxNegativeInstallAdjustment-formula--',formula)
  console.log('getMaxNegativeInstallAdjustment-retail--',retail)
  console.log('getMaxNegativeInstallAdjustment-qty--',qty)
  console.log('getMaxNegativeInstallAdjustment-locQty--',locQty)
  console.log('getMaxNegativeInstallAdjustment-totalFormula--',totalFormula)
  console.log('getMaxNegativeInstallAdjustment-totalRetail--',totalRetail)

  return Math.max(0, retail - formula);
  // return Math.max(0, totalRetail - totalFormula);
};


  const capitalCaseWithSlash = (text) =>
    text
      .split(' ')
      .map(word => {
        if (word === '/') return '/'
        return word
          .split('/')
          .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
          .join('/')
      })
      .join(' ')

// Alphanumeric comparison helper function (natural sort)
function alphanumericCompare(str1, str2) {
  const normalize = (str) => {
    if (str === null || str === undefined) return '';
    // Strip leading and trailing quotes before comparison
    let normalized = str.toString().trim();
    // Remove leading and trailing quotes (both single and double)
    normalized = normalized.replace(/^["']+|["']+$/g, '');
    return normalized;
  };

  const a = normalize(str1);
  const b = normalize(str2);

  if (!a && !b) return 0;
  if (!a) return -1;
  if (!b) return 1;

  const getChunks = (str) => {
    const chunks = [];
    let currentChunk = '';
    let chunkType = null; // 'hash', 'otherSpecial', 'digit', or 'letter'

    for (let i = 0; i < str.length; i++) {
      const char = str[i];
      const isDigit = /\d/.test(char);
      const isLetter = /[a-zA-Z]/.test(char);
      const isHash = char === '#';
      const isOtherSpecial = !isDigit && !isLetter && !isHash;
      
      // Determine chunk type with priority: hash < otherSpecial < digit < letter
      let currentType;
      if (isHash) {
        currentType = 'hash';
      } else if (isOtherSpecial) {
        currentType = 'otherSpecial';
      } else if (isDigit) {
        currentType = 'digit';
      } else {
        currentType = 'letter';
      }

      if (i === 0) {
        chunkType = currentType;
        currentChunk = char;
      } else if (currentType === chunkType) {
        currentChunk += char;
      } else {
        chunks.push({
          value: chunkType === 'digit' ? parseInt(currentChunk, 10) : currentChunk.toLowerCase(),
          type: chunkType
        });
        currentChunk = char;
        chunkType = currentType;
      }
    }

    if (currentChunk) {
      chunks.push({
        value: chunkType === 'digit' ? parseInt(currentChunk, 10) : currentChunk.toLowerCase(),
        type: chunkType
      });
    }

    return chunks;
  };

  const chunksA = getChunks(a);
  const chunksB = getChunks(b);
  const len = Math.min(chunksA.length, chunksB.length);

  // Type priority: hash (0) < otherSpecial (1) < digit (2) < letter (3)
  const getTypePriority = (type) => {
    if (type === 'hash') return 0;
    if (type === 'otherSpecial') return 1;
    if (type === 'digit') return 2;
    return 3; // letter
  };

  for (let i = 0; i < len; i++) {
    const chunkA = chunksA[i];
    const chunkB = chunksB[i];

    const priorityA = getTypePriority(chunkA.type);
    const priorityB = getTypePriority(chunkB.type);

    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }

    // Same type, compare values
    if (chunkA.type === 'digit') {
      if (chunkA.value < chunkB.value) return -1;
      if (chunkA.value > chunkB.value) return 1;
    } else {
      if (chunkA.value < chunkB.value) return -1;
      if (chunkA.value > chunkB.value) return 1;
    }
  }

  if (chunksA.length < chunksB.length) return -1;
  if (chunksA.length > chunksB.length) return 1;

  return 0;
}

export default function CommunityEstimates() {
  const theme = useTheme()
  const navigate = useNavigate();
  const locationState = useLocation()
  const communityId = locationState.state?.id;
  const communityName = locationState.state?.name;
  const projectsClients = locationState.state?.clients;
  const projectsClientsArray = projectsClients ? projectsClients.split(',').map(id => id.trim()) : [];
  console.log("projectsClientsArrayprojectsClientsArrayprojectsClientsArray",locationState.state);
  const { fromClientProject, clientProjectBackState } = readCommunityPageBackFromLocation(locationState)
  const communityPageBackKey = getCommunityPageBackKey(communityId)
  useEffect(() => {
    persistCommunityPageBack(communityPageBackKey, fromClientProject, clientProjectBackState)
  }, [communityPageBackKey, fromClientProject, clientProjectBackState])
  const handleCommunityPageBack = () => {
    navigateCommunityPageBack(navigate, fromClientProject, clientProjectBackState, communityPageBackKey)
  }
  const [isSubmitted, setIsSubmitted] = useState(false);
  const newTab = locationState.state?.newTab
  const [settingsOpenMenu, setSettingsOpenMenu] = useState(false)
  const { enqueueSnackbar } = useSnackbar();
  const [searching, setSearching] = useState(null)
  const [open, setOpen] = useState(false)
  const [openRequestEstimate, setOpenRequestEstimate] = useState(false)
  const [renderCards, setRenderCards] = useState(false)
  const [page, setPage] = useState(0);
  const [preview, setPreview] = useState([])
  const [rowsPerPage, setRowsPerPage] = useState(12);
  const [totalCount, setTotalCount] = useState(0)
  const [allRequest, setAllRequest] = useState([])
  const [skillServices, setSkillServices] = useState([])
  const [allProducts, setAllproducts] = useState([])
  console.log('allProducts', allProducts)
  const [labourCostServices, setLabourCostServices] = useState([])
  const [filteredServices, setFilteredServices] = useState([])
  const [requestTeam, setRequestTeam] = useState([])
  const [openPreview, setOpenPreview] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [additionalSelectedServices, setAdditionalSelectedServices] = useState([]);
  const [avatarUrl, setAvatarUrl] = useState([]);
  const [isUploading,setIsUploading] = useState(false)
  const [loadingCards, setLoadingCards] = useState(false)
  const [loadingCardsForAdd, setLoadingCardsForAdd] = useState(false)
  const [location, setLocation] = useState(false);
  const [projectTypes, setProjectTypes] = useState([]);
  const [signAgreement, setSignAgreement] = useState([]);
  const [workflow, setWorkFlow] = useState([]);
  const [projectCategories, setProjectCategories] = useState([]);
  const [communities, setCommunities] = useState([]);
  const [clientCommunities, setClientCommunities] = useState([]);
  const [allCommunities, setAllCommunities] = useState([]);
  const [salesRepName, setSalesRepName] = useState('');
  const [salesRepId, setSalesRepId] = useState(null);
  const [salesRepOptions, setSalesRepOptions] = useState([]);
  const [locationStates, setLocationStates] = useState({});
  const [allLocationSame, setAllLocationSame] = useState(false)
  const [address, setAddress] = useState({ 23: [{ '0': { address: 'addd', city: 'fsdasadf', state: 'fsd', zip: 1654 } }] }); // 23:[{address:'sdfsdf',city:'fsdasadf',state:'fsd',zip:1654}]
  const [progress, setProgress] = useState(null)
  const [currentDate, setCurrentDate] = useState(() => localTodayDateOnlyUnix());
  const [rfps, setRfps] = useState([]);
  const [valueTab,setValueTab]=useState('one')
  const refSettings = useRef(null)
  const saveAsDraftRef = useRef(false)
  const QUOTATION_DRAFT_KEY = 'quotation_create_draft'
  const draftSaveTimeoutRef = useRef(null)
  const latestDraftRef = useRef(null)
  const [filtersAnchorEl, setFiltersAnchorEl] = useState(null)
  const isFiltersOpen = Boolean(filtersAnchorEl)
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [progressRequestData, setProgressRequestData] = useState(null);
  // Changed: Added state for estimate settings popover anchor
  const [settingsAnchorEl, setSettingsAnchorEl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [collaborators, setCollaborators] = useState([]);
  const [teamMembersOptions, setTeamMembersOptions] = useState([]);
  const [teamMembersLoading, setTeamMembersLoading] = useState(false);
  const [refreshCalculation,setRefreshCalculation] = useState(false)
  // Auto-save confirmation dialog state
  const [openBackConfirm, setOpenBackConfirm] = useState(false);

  // Fetch view type from backend
  const fetchViewType = async () => {
    try {
      const userId = user?.user_id || user?.id;
      if (!userId) return;

      const res = await axios.post(`${REST_API_END_POINT}get-quotation-view-type`, { userId });
      if (res.data?.status === 1 && res.data?.data?.viewType !== undefined) {
        const viewType = res.data.data.viewType;
        setValueTab(viewType);
        // Set dueData based on tab selection
        if (viewType === 'two' || viewType === 'three') {
          setDueData(false);
        } else {
          setDueData(true);
        }
      }
    } catch (error) {
      console.error('Error fetching view type:', error);
    }
  };

  const handleChange = async (event, newValue) => {
    setValueTab(newValue);
    // Set dueData based on tab selection
    if (newValue === 'two' || newValue === 'three') {
      setDueData(false);
    } else {
      setDueData(true);
    }
    // Save view type to backend
    try {
      const userId = user?.user_id || user?.id;
      if (!userId) return;
      
      await axios.post(`${REST_API_END_POINT}update-quotation-view-type`, { userId, viewType: newValue });
    } catch (error) {
      console.error('Error updating view type:', error);
    }
  };

  let user = JSON.parse(localStorage.getItem('user'))
 
  let isClient = user?.isClient || user?.isclient;
  let userType =isClient ? 3 : user.user_type
  let userId = user?.user_id;
  let teamId = user?.team_id||null;
  if(user.added_by_client && user.parent_user_type && user.parent_id) {
    userId = user.parent_id
    userType =3 //user.parent_user_type
  }

  const explodedPermissions = user?.exploded_permissions
  const hasMarkupPermission = explodedPermissions?.some(permission => ['View Markup'].includes(permission)) ? true : false
  const hasDiscountPermission = explodedPermissions?.some(permission => ['Manage Discount'].includes(permission)) ? false : true
  const refCommunities = useRef(null);
  const [allClients, setAllClients] = useState([])
  const [communitiesOpen, setCommunitiesOpen] = useState(false);
  const [communitiesData, setCommunitiesData] = useState([]);
  const [filterCommunity, setFilterCommunity] = useState([communityId || '']);
  const [markupType, setMarkupType] = useState(2);
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('id');
  const [showServices, setShowServices] = useState(false)
  const [showWarning, setShowWarning] = useState(selectedServices.map(() => false));
  const [currentTab, setCurrentTab] = useState(newTab ||'ALL')
  const [indexCounter, setIndexCounter] = useState(0)
  const [serviceIndexCounter, setServiceIndexCounter] = useState(0)
  const [rfpLocationStates, setRfpLocationStates] = useState({});
  const [rfpServiceLocationStates, setRfpServiceLocationStates] = useState({});
  const [allRfpServiceLocationSame, setAllRfpServiceLocationSame] = useState(true)
  const [allRfpProductsLocationSame, setAllRfpProductsLocationSame] = useState(true)
  // const [userId, setUserId] = useState(() => {
  //   const storedUser = JSON.parse(localStorage.getItem('user'));
  //   return storedUser ? storedUser.user_id : null;
  // });
  const [selectedRfp, setSelectedRfp] = useState(null); // Selected RFP
  const [openModal, setOpenModal] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [isClearingNote, setIsClearingNote] = useState(false);
  const [rfpServices, setRfpServices] = useState([]);
  const [rfpProducts, setRfpProducts] = useState([]);
  const [cart, setCart] = useState([]);

  // Fetch filters (clients, communities, staffMembers) for Quotation page - using same endpoint as OfficialRequest
  const fetchQuotationFilters = async () => {
    try {
      await axios
        .post(`${REST_API}webservice/request/get-all-request-filters`, {
          userType: userType,
          userId: userId,
          isQuotation: true,
          // From:"addSalesOrder",
          // teamId: teamId,
        })
        .then((res) => {
          const othersCommunity = { id: 'other', name: 'Others' }

          let communitiesDataList = res.data.community || []
          if (res.data?.community) {
            communitiesDataList = communitiesDataList.map((community) => ({
              ...community,
              checked: filterCommunity.includes(community.id),
            }))
            setCommunitiesData([...communitiesDataList])
          } else {
            setCommunitiesData([othersCommunity])
          }

          let clientDataList = res.data.clients || []
          if (res.data?.clients) {
            clientDataList = clientDataList.map((client) => ({
              ...client,
              checked: filterClient.includes(client.id),
            }))
            setClientData([...clientDataList])
          } else {
            setClientData([])
          }

          if (res.data?.staffMembers) {
            const staffData = res.data.staffMembers.map((staff) => ({
              ...staff,
              checked: filterUser.includes(staff.id),
            }))
            setUserData([...staffData])
          } else {
            setUserData([])
          }
        })
        .catch((errors) => {
          console.log(errors, 'error in fetching request filters')
        })
    } catch (error) {
      console.log('fetchQuotationFilters error : ', error)
    }
  }
  const [cartService, setCartService] = useState([]);
  const [materials, setAllMaterials] = useState([])
  const [selectedMaterials, setSelectedMaterials] = useState([]);
  const [totalProductLabourCost, setTotalProductLabourCost] = useState(0)
  ////below state is for sorting the quickbid
  const [sortOpen, setSortOpen] = useState(false);
  const refSort = useRef(null);
  const [sort, setSort] = useState(SORT[0])
  const [filterDateValue, setFilterDateValue] = useState([null, null]);
  const [skipFetch,setSkipFetch] = useState(false)
  const refClients = useRef(null)
  const refUsers = useRef(null)
  const [clientsOpen, setClientsOpen] = useState(false)
  const [usersOpen, setUsersOpen] = useState(false)
  const [clientData, setClientData] = useState([])
  const [userData, setUserData] = useState([])
  const [filterClient, setFilterClient] = useState([])
  const [filterUser, setFilterUser] = useState([])
  const [clientSearchTerm, setClientSearchTerm] = useState('')
  const [userSearchTerm, setUserSearchTerm] = useState('')
  const [dueData, setDueData] = useState(true)
  const [projectSearchTerm, setProjectSearchTerm] = useState('')
  const [openProductNote, setOpenProductNote] = useState({});
  const [openMaterialNote, setOpenMaterialNote] = useState({}); 
  const [openInstallNote, setOpenInstallNote] = useState({});
  const [openServiceNote, setOpenServiceNote] = useState({});
  const [isSavingNote, setIsSavingNote] = useState(false);
  const [currentNote, setCurrentNote] = useState('');
  const [error, setError] = useState(false);
  const [quantity, setQuantity] = useState(1); // Initialize quantity state
  //to store the modified services data

  const [modifiedRows, setModifiedRows] = useState([]);
  const [markAdjType, setMarkAdjType] = useState(1)
  const [selectedTaxCategory,setSelectedTaxCategory]=  useState(null);
  const [taxCategories,setTaxCategories]=  useState([]);
  const [isCommunityLoading, setIsCommunityLoading] = useState(false);
  const [mapServices,setMapServices]=  useState([]);
  const [mapServicesLoading, setMapServicesLoading] = useState(false);
  const [selectedMapserviceProducts, setSelectedMapserviceProducts] = useState([]);
  // Clear popup localStorage immediately to prevent popups from persisting
  localStorage.removeItem('estimateProjectId');
  localStorage.removeItem('estimateProjectName');
  localStorage.removeItem('isEditEstimate');
  localStorage.removeItem('estimateOpenProductionPopup');
  localStorage.removeItem('openProductionPopup');
  
  const [handleOpenEstimate,setHandleOpenEstimate] = useState(false)
  const [estimateId,setEstimateId] = useState(false)
  const [estimateName,setEstimateName] = useState(false)
  const [isEditEstimate,setIsEditEstimate] = useState(false)
  const [openCount,setOpenCount] = useState(null)
  const [approvedCount,setApprovedCount] = useState(null)
  const [archiveCount,setArchiveCount] = useState(null)
  const [rejectedCount,setRejectedCount] = useState(null)
  const [showAddNewRow,setShowAddNewRow] = useState(false)
  const [isNewRowIdPresent,setIsNewRowIdPresent] = useState([])
  const [singleLocationCard,setSingleLocationCard] = useState(true)
  const [pendingAutocompleteMaterials, setPendingAutocompleteMaterials] = useState([]);
  const [openDialog,setOpenDialog] = useState(false);
  const [pendingProject, setPendingProject] = useState(null);
  const [stockType, setStockType] = useState(1);
  const [pendingMaterial, setPendingMaterial] = useState(null);
  const [partialProducts, setPartialProducts] = useState([]);
  const [convertionUnit, setConvertionUnit] = useState(0);
  const [filterProjectType, setFilterProjectType] = useState('ALL'); 
  const [totalMinusMaterialTax,setTotalMinusMaterialTax] = useState(null)
  const [produtFormulaMaterial,setProductFormulaMaterial] = useState([])
  
  const [totalProductInstallCost, setTotalProductInstallCost] = useState(0)
  const [installCost, setInstallCost] = useState(0);
  const handleMaterialStockCheck = async (material) => {
  setPendingMaterial(material);
  setStockType(1);
  setConvertionUnit(0);
  setPartialProducts([]);

  // if (material.inhouse !== 1) {
  //   enqueueSnackbar('Only inhouse materials can be stocked', { variant: 'warning' });
  //   return;
  // }

  try {
    const res = await axios.post(`${REST_API_END_POINT}product/get-partial-finished-products-stock-by-unit`, { editId: material?.id });
    setPartialProducts(res.data.results || []);
  } catch (err) {
    console.error(err);
    setPartialProducts([]);
  } finally {
    openDialogs();
  }
};


  const handleSubmitPopUp = () => {
  if (!pendingMaterial) return;

 if (stockType === 2 && !convertionUnit) {
    enqueueSnackbar('Please choose a conversion unit', { variant: 'error' });
    return;
  }

  const normalizedId = pendingMaterial.product_id || pendingMaterial.id;

  console.log('  Selected Material:', pendingMaterial);
  console.log('🔹 Selected stock type:', stockType === 1 ? 'Finished' : 'Partial');
  console.log('🔹 Conversion unit:', convertionUnit);

  // Check if exact match already added
  const exactDuplicate = selectedMaterials.some(
    (item) =>
      (item.product_id || item.id) === normalizedId &&
      item.stock_type === stockType &&
      (stockType === 1 || item.convertion_unit === convertionUnit)
  );

  if (exactDuplicate) {
    enqueueSnackbar('Material Already Added', { variant: 'error' });
    console.warn('❌ Exact duplicate detected. Skipping...');
    return;
  }

  // Check for multiple partial types of the same product
  if (stockType === 2) {
    const hasPartialAlready = selectedMaterials.some(
      (item) =>
        (item.product_id || item.id) === normalizedId &&
        item.stock_type === 2 // Already has a partial type
    );

    if (hasPartialAlready) {
      // enqueueSnackbar('Only one partial type allowed per product', { variant: 'error' });
      enqueueSnackbar('Material Already Added', { variant: 'error' });
      console.warn('❌ Partial duplicate detected. Skipping...');
      return;
    }
  }

  let initial_max_price = 0;
  let unit = 4;

  if (stockType === 1) {
    initial_max_price = pendingMaterial.max_price || pendingMaterial.special_price;
    unit = pendingMaterial.unit || 4;
  } else {
    const selectedUnitData = partialProducts.find(p => p.partial_unit === convertionUnit);
    if (!selectedUnitData || selectedUnitData.total_qty <= 0) {
      enqueueSnackbar('No Partial Stock Available', { variant: 'error' });
      return;
    }
    initial_max_price = selectedUnitData.max_unit_cost || 0;
    unit = selectedUnitData.partial_unit || 4;
  }

  const maxIndexId = selectedMaterials.reduce(
    (max, item) => Math.max(max, item.newIndexId || 0),
    0
  );

  const newMaterial = {
    ...pendingMaterial,
    product_id: normalizedId,
    quantity: 1,
    price: initial_max_price,
    unit,
    stock_type: stockType,
    convertion_unit: convertionUnit || 0,
    initial_max_price,
    newIndexId: maxIndexId + 1
  };

  const updatedMaterials = [
    ...selectedMaterials.filter(item => !item.isAdditionalProduct),
    newMaterial
  ];

  setSelectedMaterials(updatedMaterials);
  setPendingAutocompleteMaterials(updatedMaterials);
  setFieldValue('additionalMaterials', updatedMaterials);
  handleMaterial(updatedMaterials);
  // markUnsavedChanges();

  setPendingMaterial(null);
  setPartialProducts([]);
  setStockType(1);
  setConvertionUnit(0);
  closeDialog();
};
    const closeDialog=()=>{
      setOpenDialog(false);
    }
    const openDialogs=()=>{
      setOpenDialog(true);
    }

  const handleOpenViewEstimate = (id,name) =>{
    setIsEditEstimate(true)
    setEstimateId(id)
    setEstimateName(name)
    setHandleOpenEstimate(true)
    console.log('hjsfgdhjdhbfhhhh')
    localStorage.setItem('estimateProjectId', id);
    localStorage.setItem('estimateProjectName', name);
    localStorage.setItem('isEditEstimate', "true");
    localStorage.setItem('estimateOpenProductionPopup', 'true');

  }
  const handleOpenDetails= (id,name) =>{
    setIsEditEstimate(false)
    setEstimateId(id)
    setEstimateName(name)
    setHandleOpenEstimate(true)
    localStorage.setItem('estimateProjectId', id);
    localStorage.setItem('estimateProjectName', name);
    localStorage.setItem('isEditEstimate', "false");
    localStorage.setItem('estimateOpenProductionPopup', 'true');
  }

  const ACCOUNT_TABS = [
    {
      value: 'ALL',
      name: 'ALL',
      count:0
      // count : projectCategoriesInitialData?.filter((item)=>item?.category_type == 1)?.length || 0
    },
    {
      value: 'NEW',
      name: 'NEW',
      count:openCount
      // count : projectCategoriesInitialData?.filter((item)=>item?.category_type == 2)?.length || 0
    },
    {
      value: 'IN QUEUE',
      name: 'IN QUEUE',
      count:openCount
      // count : projectCategoriesInitialData?.filter((item)=>item?.category_type == 2)?.length || 0
    },
    {
      value: 'IN PROGRESS',
      name: 'IN PROGRESS',
      count:openCount
      // count : projectCategoriesInitialData?.filter((item)=>item?.category_type == 2)?.length || 0
    },
    {
      value: 'REVIEW/ SEND FOR APPROVAL',
      name: 'REVIEW/ SEND FOR APPROVAL',
      count:openCount
      // count : projectCategoriesInitialData?.filter((item)=>item?.category_type == 2)?.length || 0
    },
    {
      value: 'AWAITING APPROVAL',
      name: 'AWAITING APPROVAL',
      count:openCount
      // count : projectCategoriesInitialData?.filter((item)=>item?.category_type == 2)?.length || 0
    },
    {
      value: 'APPROVED',
      name: 'APPROVED',
      count: approvedCount
      // count : projectCategoriesInitialData?.filter((item)=>item?.category_type == 2)?.length || 0
    },
    {
      value: 'REJECTED',
      name: 'REJECTED',
      count: rejectedCount
      // count : projectCategoriesInitialData?.filter((item)=>item?.category_type == 2)?.length || 0
    },
    {
      value: 'ARCHIVE',
      name: 'ARCHIVE',
      count:archiveCount
      // count : projectCategoriesInitialData?.filter((item)=>item?.category_type == 2)?.length || 0
    },
    {
      value: 'HOLD',
      name: 'HOLD',
      count:archiveCount
      // count : projectCategoriesInitialData?.filter((item)=>item?.category_type == 2)?.length || 0
    },
    {
      value: 'DRAFT',
      name: 'DRAFT',
      count:archiveCount
      // count : projectCategoriesInitialData?.filter((item)=>item?.category_type == 2)?.length || 0
    },
  ]



  // const handleQuantityChange = (event) => {
  //   let newValue = event.target.value;

  //   // Prevent negative values
  //   if (newValue.startsWith('-')) {
  //     newValue = newValue.slice(1);
  //   }

  //   // Handle quantity changes
  //   if (Number(newValue) < previousQty) {
  //     setShowWarning(prev => {
  //       const newWarnings = [...prev];
  //       newWarnings[index] = true;
  //       return newWarnings;
  //     });
  //     newValue = previousQty;
  //   } else {
  //     setShowWarning(prev => {
  //       const newWarnings = [...prev];
  //       newWarnings[index] = false;
  //       return newWarnings;
  //     });
  //   }

  //   // Update quantity state and formik values
  //   setQuantity(newValue);
  //   data['quantity'] = newValue || 1;
  //   setFieldValue(quantityFieldName, newValue);

  //   // Save the updated hour data to modifiedRows state
  //   setModifiedRows(prev => {
  //     const updatedRows = [...prev];
  //     const rowIndex = updatedRows.findIndex(row => row.index === index);
  //     if (rowIndex !== -1) {
  //       updatedRows[rowIndex] = { ...updatedRows[rowIndex], quantity: newValue };
  //     } else {
  //       updatedRows.push({ index, quantity: newValue });
  //     }
  //     return updatedRows;
  //   });
  // };



  // useEffect(() => {
  //   console.log("modifiedRows", modifiedRows)
  // }, [modifiedRows])

  const handleOpenNote = (indexId, note) => {
    setCurrentNote(note || '');
    setOpenProductNote((prev) => ({ ...prev, [indexId]: true }));
  };

  const handleCloseNote = (indexId) => {
    setOpenProductNote((prev) => ({ ...prev, [indexId]: false }));
    setCurrentNote('');
  };

  const handleNoteChange = (event) => {
    const newNote = event.target.value;
    if (newNote.length <= MAX_CHARACTERS) {
      setCurrentNote(newNote);
    }
    if (error) {
      setError(false);
    }
  };

  // Install notes handlers
  const handleOpenInstallNote = (indexId, note) => {
    setCurrentNote(note || '');
    setOpenInstallNote((prev) => ({ ...prev, [indexId]: true }));
  };

  const handleCloseInstallNote = (indexId) => {
    setOpenInstallNote((prev) => ({ ...prev, [indexId]: false }));
    setCurrentNote('');
  };

  const handleSaveInstallNote = (indexId) => {
    if (!currentNote.trim()) {
      setError('Note cannot be empty or just spaces');
      return; // Exit early if validation fails
    }
    setIsSavingNote(true);
    setTimeout(() => {
      setSelectedProducts((prev) =>
        prev.map((product) =>
          product.indexId === indexId ? { ...product, install_notes: currentNote } : product
        )
      );
      setIsSavingNote(false);
      handleCloseInstallNote(indexId);
    }, 100);
  };

  // Clear install note and save empty value
  const handleClearInstallNote = (indexId) => {
    setError(false);
    setIsClearingNote(true);
    setTimeout(() => {
      setSelectedProducts((prev) =>
        prev.map((product) =>
          product.indexId === indexId ? { ...product, install_notes: '' } : product
        )
      );
      setCurrentNote('');
      setIsClearingNote(false);
    }, 100);
  };
  function handleToggleClient(id) {
    setFilterClient((prevIds) => {
      // If not yet in filterCommunity, add it
      if (!prevIds.includes(id)) {
        return [...prevIds, id]
      }
      // If it's already in there, remove it
      return prevIds.filter((oldId) => oldId !== id)
    })
  }

  function handleToggleUser(id) {
    setFilterUser((prevIds) => {
      // If not yet in filterUser, add it
      if (!prevIds.includes(id)) {
        return [...prevIds, id]
      }
      // If it's already in there, remove it
      return prevIds.filter((oldId) => oldId !== id)
    })
  }

  function handleToggleCommunity(id) {
    setFilterCommunity((prevIds) => {
      // If not yet in filterCommunity, add it
      if (!prevIds.includes(id)) {
        return [...prevIds, id]
      }
      // If it's already in there, remove it
      return prevIds.filter((oldId) => oldId !== id)
    })
  }

  const handleByDue = () => {
    setDueData(!dueData)
  }

  const handleOpenFilters = (event) => {
    setFiltersAnchorEl(event.currentTarget)
  }

  const handleCloseFilters = () => {
    setFiltersAnchorEl(null)
    setCommunitiesOpen(false)
    setClientsOpen(false)
    setUsersOpen(false)
    setSortOpen(false)
  }

  const handleSaveNote = (indexId) => {
    if (!currentNote.trim()) {
      setError('Note cannot be empty or just spaces');
      return; // Exit early if validation fails
    }
    setIsSavingNote(true);
    setTimeout(() => {
      setSelectedProducts((prev) =>
        prev.map((product) =>
          product.indexId === indexId ? { ...product, product_notes: currentNote } : product
        )
      );
      setIsSavingNote(false);
      handleCloseNote(indexId);
    }, 100);
  };
// Material notes handlers
  const handleOpenMaterialNote = (indexId, note) => {
    setCurrentNote(note || '');
    setOpenMaterialNote((prev) => ({ ...prev, [indexId]: true }));
  };
  const handleCloseMaterialNote = (indexId) => {
    setOpenMaterialNote((prev) => ({ ...prev, [indexId]: false }));
    setCurrentNote('');
  };
  const handleSaveMaterialNote = (indexId) => {
    if (!currentNote.trim()) {
      setError('Note cannot be empty or just spaces');
      return; 
    }
    setIsSavingNote(true);
    setTimeout(() => {
      setSelectedMaterials((prev) =>
        prev.map((material) =>
          material.newIndexId === indexId ? { ...material, material_notes: currentNote } : material
        )
      );
      setIsSavingNote(false);
      handleCloseMaterialNote(indexId);
    }, 100);
  };
    // Clear material note and save empty value
    const handleClearMaterialNote = (indexId) => {
      setError(false);
      setIsClearingNote(true);
      setTimeout(() => {
        setSelectedMaterials((prev) =>
          prev.map((material) =>
            material.newIndexId === indexId ? { ...material, material_notes: '' } : material
          )
        );
        setCurrentNote('');
        setIsClearingNote(false);
      }, 100);
    };
  // Clear product note and save empty value
  const handleClearNote = (indexId) => {
    setError(false);
    setIsClearingNote(true);
    setTimeout(() => {
      setSelectedProducts((prev) =>
        prev.map((product) =>
          product.indexId === indexId ? { ...product, product_notes: '' } : product
        )
      );
      setCurrentNote('');
      setIsClearingNote(false);
    }, 100);
  };

  // Service notes handlers
  const handleOpenServiceNote = (indexId, note) => {
    setCurrentNote(note || '');
    setOpenServiceNote((prev) => ({ ...prev, [indexId]: true }));
  };

  const handleCloseServiceNote = (indexId) => {
    setOpenServiceNote((prev) => ({ ...prev, [indexId]: false }));
    setCurrentNote('');
  };

  const handleServiceNoteChange = (event) => {
    const newNote = event.target.value;
    if (newNote.length <= MAX_CHARACTERS) {
      setCurrentNote(newNote);
    }
    if (error) {
      setError(false);
    }
  };

  const handleSaveServiceNote = (indexId) => {
    if (!currentNote.trim()) {
      setError('Note cannot be empty or just spaces');
      return; // Exit early if validation fails
    }
    setIsSavingNote(true);
    setTimeout(() => {
      // Update selectedServices
      setSelectedServices((prev) =>
        prev.map((service) =>
          service.indexId === indexId ? { ...service, service_notes: currentNote } : service
        )
      );
      // Update additionalSelectedServices
      setAdditionalSelectedServices((prev) =>
        prev.map((service) =>
          service.indexId === indexId ? { ...service, service_notes: currentNote } : service
        )
      );
      // Update cartService
      setCartService((prev) =>
        prev.map((service) =>
          service.indexId === indexId ? { ...service, service_notes: currentNote } : service
        )
      );
      setIsSavingNote(false);
      handleCloseServiceNote(indexId);
    }, 100);
  };

  // Clear service note and save empty value
  const handleClearServiceNote = (indexId) => {
    setError(false);
    setIsClearingNote(true);
    setTimeout(() => {
      setSelectedServices((prev) =>
        prev.map((service) =>
          service.indexId === indexId ? { ...service, service_notes: '' } : service
        )
      );
      setAdditionalSelectedServices((prev) =>
        prev.map((service) =>
          service.indexId === indexId ? { ...service, service_notes: '' } : service
        )
      );
      setCartService((prev) =>
        prev.map((service) =>
          service.indexId === indexId ? { ...service, service_notes: '' } : service
        )
      );
      setCurrentNote('');
      setIsClearingNote(false);
    }, 100);
  };

  const handleRfpSelect = (event, value) => {

    if (!empty(value)) {
      setOpenModal(true);
      setSelectedRfp(value);
      console.log("########Services", value?.services);
      console.log("########Services cart", value?.products);

      // Sort RFP services alphanumerically by name
      const filteredRfpServices = value?.services?.filter(service => !isInCartService(service)) || [];
      const sortedRfpServices = [...filteredRfpServices].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
      setRfpServices(sortedRfpServices);
      setRfpProducts(value?.products?.filter(product => !isInCart(product)) || []);
    }
    // markUnsavedChanges();
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };
 
  // const addToCart = (item) => {
  //   // Extract community address from Formik's values
  //   const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
  //   const communityAddress = { address: projAddress, city: projCity, state: projState, zip: projZip };
  
  //   if (tabIndex === 0) {
  //     // Handle RFP services
  //     let addresses = [
  //       {
  //         id: 0,
  //         address: '',
  //         city: '',
  //         state: '',
  //         zip: '',
  //       },
  //     ];
  
  //     if (projAddress && projCity && projState && projZip) {
  //       addresses = [
  //         {
  //           id: 0,
  //           address: projAddress,
  //           city: projCity,
  //           state: projState,
  //           zip: projZip,
  //         },
  //       ];
  //     }
  
  //     const newService = {
  //       ...item,
  //       addresses,
  //     };
  
  //     setCartService((prevServices) => [...prevServices, newService]);
  //   } else {
  //     // Handle RFP products
  //     let addresses = [
  //       {
  //         id: 0,
  //         address: '',
  //         city: '',
  //         state: '',
  //         zip: '',
  //       },
  //     ];
  
  //     if (projAddress && projCity && projState && projZip) {
  //       addresses = [
  //         {
  //           id: 0,
  //           address: projAddress,
  //           city: projCity,
  //           state: projState,
  //           zip: projZip,
  //         },
  //       ];
  //     }
  
  //     const newProduct = {
  //       ...item,
  //       addresses,
  //     };
  
  //     setCart((prevProducts) => [...prevProducts, newProduct]);
  //   }
  
  //   // Close modal and reset RFP selection
  //   setOpenModal(false);
  //   setSelectedRfp(null);
  //   setFieldValue('rfp', null);
  
  //   // Additional logic for services (if applicable)
  //   if (tabIndex === 0) {
  //     const commonAddress = cartService[0]?.addresses?.[0] || {
  //       address: '',
  //       city: '',
  //       state: '',
  //       zip: '',
  //     };
  
  //     setCartService((prevServices) =>
  //       prevServices.map((service) => ({
  //         ...service,
  //         addresses: service.addresses
  //           ? service.addresses.map(() => ({ ...commonAddress }))
  //           : [{ ...commonAddress }],
  //       }))
  //     );
  //   }
  // };

  const assignAddresses = (existingCart, newProduct, allLocationsSame, communityAddress) => {
    let assignedAddresses = [];

    if (allLocationsSame && existingCart.length > 0) {
        
        const commonAddress = existingCart[0].addresses[0] || {
        address: '',
        city: '',
        state: '',
        zip: '',
        };
        assignedAddresses = [{ ...commonAddress }];
    } else {
        
        assignedAddresses = [{
        id: 0,
        address: communityAddress.address,
        city: communityAddress.city,
        state: communityAddress.state,
        zip: communityAddress.zip,
        }];
    }

    return {
        ...newProduct,
        addresses: assignedAddresses,
    };
    };
    
  const addToCart = (item) => {
    console.log("communitycommunitycommunity", item);

    let { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
    let communityAddress = { address: projAddress, city: projCity, state: projState, zip: projZip };

    if (tabIndex === 1) {
        // **For Services**
      let addresses = [{
        id: 0,
        address: '',
        city: '',
        state: '',
        zip: '',
      }];
      
      let newService = { ...item, addresses: addresses };
      
      if (values?.community?.address && values?.community?.city && values?.community?.state && values?.community?.zip) {
        // Assign addresses using utility function
        newService = assignAddresses(cartService, item, allRfpServiceLocationSame, communityAddress);
      }
      
      setCartService([...cartService, newService]);
    } else {
      // **For Products**
      let locationQuantity = item?.location_quantity || 1;

      // Generate `locationQuantity` number of address fields
      let addresses = Array.from({ length: locationQuantity }, () => ({
        id: 0,
        address: '',
        city: '',
        state: '',
        zip: '',
      }));

      let newProduct = { 
        ...item, 
        allRfpProductsLocationSame: true, // Each product gets its own flag
        addresses 
      };

      setCart([...cart, newProduct]);

      if (values?.community?.address && values?.community?.city && values?.community?.state && values?.community?.zip) {
        newProduct = assignAddresses(cart, newProduct, newProduct.allRfpProductsLocationSame, communityAddress);
        setCart([...cart, newProduct]);
      }
    }

    communityAddress = { address: '', city: '', state: '', zip: '' };
    setOpenModal(false);
    setSelectedRfp(null);
    setFieldValue('rfp', null);
    // markUnsavedChanges();

    // Ensure each product maintains its own independent "All Locations Same" state
    setCart(prevProducts =>
        prevProducts.map(product => {
            let locationQuantity = product?.location_quantity || 1;
            const commonAddress = prevProducts[0]?.addresses?.[0] || {
                address: '',
                city: '',
                state: '',
                zip: '',
            };

            return {
                ...product,
                addresses: product.allRfpProductsLocationSame
                    ? Array.from({ length: locationQuantity }, () => ({ ...commonAddress }))
                    : product.addresses
            };
        })
    );
  };
 
  console.log("######################Cart111", cart);
  const isInCart = (item) => {
    console.log("######################Cart111New", item);
    console.log("######################Cart111", cart);
    return cart.some(cartItem => cartItem.product_id === item.product_id);
  };
  const isInCartService = (item) => {
    return cartService.some(cartItem => cartItem.id === item.id);
  };
  const closeModal = () => {
    setOpenModal(false);
    setFieldValue('rfp', null)
  };
  console.log("cart servicessssssssssss------", cart);
  const handleDeleteRFPProduct = (productId) => {
    setCart(prevCart => prevCart.filter(item => item.id !== productId));
  };
  const handleDeleteRFPService = (productId) => {
    console.log("######################Cartde", productId);
    setCartService(prevCart => prevCart.filter(item => item.id !== productId));
  };

  // const handleMaterial = (newValue) => {
  //   setSelectedMaterials((prevMaterials) => {
  //     const additionals = prevMaterials?.filter(item => item.isAdditionalProduct == true);
  //     return [...newValue, ...additionals];
  //   });
  // };

  const handleMaterial = (newValue) => {
    setSelectedMaterials((prevMaterials) => {
      // Assign quantity = 1 to each item in newValue
      const updatedNewValue = newValue.map(item => ({
        ...item,
        quantity: item.quantity ?? 1, // Set quantity to 1 for each item
      }));
  
      // Filter out additional products
      const additionals = prevMaterials?.filter(item => item.isAdditionalProduct === true);
  
      // Return the new state with updated newValue and additional products
      return [...updatedNewValue, ...additionals];
    });
  };
  

  // const handleDeleteMaterial = (id, indexId) => {
  //   // setSelectedMaterials(selectedMaterials.filter(item => item.id !== id));
  //   const updatedMaterials = selectedMaterials?.filter((data) => {
  //     if (data?.isAdditionalProduct) {
  //       return data?.newIndexId !== indexId;
  //     }
  //     return data?.id !== id;
  //   });
  //   setSelectedMaterials(updatedMaterials);
  // };

  // const addNewProductRow = () => {
  //   const newIndexCounter = indexCounter + 1
  //   setIndexCounter(newIndexCounter)
  //   const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
  //   // Auto-populate addresses from the selected Project
  //   const newAddresses = [{
  //     id: 0,
  //     address: projAddress,
  //     city: projCity,
  //     state: projState,
  //     zip: projZip
  //   }];
  
  //   setSelectedProducts((prevProducts) => {
  //   // if (allLocationSame && prevProducts.length > 0) {
  //   //     const commonAddress = { ...prevProducts[0].addresses[0] } || {
  //   //     address: '',
  //   //     city: '',
  //   //     state: '',
  //   //     zip: '',
  //   //     };
  //   //     newAddresses[0] = commonAddress;
  //   // }
  //   return [
  //   ...prevProducts,
  //   { 
  //       indexId: newIndexCounter, 
  //       name: '', 
  //       quantity: 1, 
  //       price: 0,
  //       retail_price:0, 
  //       adjustment:0,
  //       unit:4,
  //       locationQuantity: 1, 
  //       expected_total_service_cost:0,
  //       expected_service_cost:0,
  //       expected_material_cost:0,
  //       discount: 0 ,
  //       allLocationSame: true,
  //       service:[],
  //       isAdditionalProduct:true,
  //       addresses: newAddresses
  //   },
  //   ]});
  // };
const handleDeleteMaterial = (id, stockType, convertionUnit, indexId) => {
  const updatedMaterials = selectedMaterials.filter((item) => {
    if (item.isAdditionalProduct) {
      return item.newIndexId !== indexId;
    }
    return !((item.product_id || item.id) === id && item.stock_type === stockType && item.convertion_unit === convertionUnit);
  });

  setSelectedMaterials(updatedMaterials);
  setPendingAutocompleteMaterials(updatedMaterials);
  setFieldValue('additionalMaterials', updatedMaterials);
  handleMaterial(updatedMaterials);
  // markUnsavedChanges();
};

  const addNewProductRow = () => {
    const newIndexCounter = indexCounter + 1;
    setIndexCounter(newIndexCounter);
  
    const {
      address: projAddress = '',
      city: projCity = '',
      state: projState = '',
      zip: projZip = ''
    } = values?.community || {};
  
    const newAddresses = [{
      id: 0,
      address: projAddress,
      city: projCity,
      state: projState,
      zip: projZip
    }];
  
    // const newProduct = {
    //   indexId: newIndexCounter,
    //   name: '',
    //   quantity: 1,
    //   price: 0,
    //   retail_price: 0,
    //   adjustment: 0,
    //   unit: 4,
    //   locationQuantity: 1,
    //   expected_total_service_cost: 0,
    //   expected_service_cost: 0,
    //   expected_material_cost: 0,
    //   discount: 0,
    //   allLocationSame: true,
    //   service: [],
    //   isAdditionalProduct: true,
    //   addresses: newAddresses
    // };

    const newProduct = {
      indexId: newIndexCounter,
      name: '',
      quantity: 1,
      price: 0,
      retail_price: 0,
      adjustment: 0,
      unit: 4,
      locationQuantity: 1,
      expected_cost: 1, // ✅ added
      expected_total_service_cost: 0,
      expected_service_cost: 0,
      expected_material_cost: 0,
      discount: 0,
      allLocationSame: true,
      service: [],
      isAdditionalProduct: true,
      markAdjType: 1, // ✅ added
      wholesaleMarkup: 0, // ✅ added
      retailMarkup: 0, // ✅ added
      addresses: newAddresses,
      is_single_card:values.project_categories?.id !== 14 ? true : false
    };
    
  
    console.log(" New product row added:", newProduct);
  
    setSelectedProducts((prevProducts) => [...prevProducts, newProduct]);
  };
  

  // const addNewServiceRow = () => {
  //   const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
  //   // Auto-populate addresses from the selected Project
  //   const newAddresses = [{
  //     id: 0,
  //     address: projAddress,
  //     city: projCity,
  //     state: projState,
  //     zip: projZip
  //   }];

  //   setAdditionalSelectedServices((prevServices) => {
  //     return [
  //       ...prevServices,
  //       {  
  //         id:null,
  //         newIndexId: prevServices?.length + 1,
  //         name: '', 
  //         avatarUrl: null,
  //         quantity: 1, 
  //         cost: 0,
  //         markup: 0, 
  //         workflow: null,
  //         originalMarkup: 0, 
  //         service_type: null,
  //         total_cost:0,
  //         product_total:0,
  //         allLocationSame: true,
  //         isAdditionalProduct:true,
  //         addresses: newAddresses,
  //       }
  //     ]
  //   });
  // };

  const addNewServiceRow = () => {
    const {
      address: projAddress = '',
      city: projCity = '',
      state: projState = '',
      zip: projZip = ''
    } = values?.community || {};
  
    const newAddresses = [{
      id: 0,
      address: projAddress,
      city: projCity,
      state: projState,
      zip: projZip
    }];
  
    setAdditionalSelectedServices((prevServices) => {
      const maxId = prevServices.reduce(
        (max, item) => Math.max(max, item.newIndexId || 0),
        0
      );
  
      return [
        ...prevServices,
        {
          id: null,
          newIndexId: maxId + 1,
          name: '',
          avatarUrl: null,
          quantity: 1,
          cost: 0,
          markup: 0,
          workflow: null,
          originalMarkup: 0,
          service_type: null,
          total_cost: 0,
          product_total: 0,
          allLocationSame: true,
          isAdditionalProduct: true,
          addresses: newAddresses,
        }
      ];
    });
  };
  

  // const addNewMaterialRow = () => {
  //   setSelectedMaterials((prevProducts) => {
  //   return [
  //   ...prevProducts,
  //   { 
  //     newIndexId: prevProducts?.length + 1,
  //     quantity: 1, 
  //     allLocationSame: true,
  //     isAdditionalProduct:true,
  //     description: '',
  //     finishedProductQty: 0,
  //     markUpCost: 0,
  //     markup: 0,
  //     material_types: 1,
  //     max_price: null,
  //     max_value: 10,
  //     meterial: 1,
  //     min_value: 1,
  //     name: '',
  //     partial: 0,
  //     partialProductQty: 0,
  //     pf_retail_markup: null,
  //     price: 0,
  //     recipe_id: null,
  //     retail_price: 0,
  //     special_price: 0,
  //     tags: '',
  //     tax: null,
  //     tax_category: 0,
  //     total_qty: 0,
  //     twilio_field_value_sid: null,
  //     unit: 4,
  //     unit_qty: 0,
  //     vendor_id: '',
  //     vpt_number: '',
  //     workflow: null,
  //   },
  //   ]});
  // };


  const addNewMaterialRow = () => {
    setSelectedMaterials((prevProducts) => {
      const maxId = prevProducts.reduce(
        (max, item) => Math.max(max, item.newIndexId || 0),
        0
      );
  
      return [
        ...prevProducts,
        {
          newIndexId: maxId + 1,
          quantity: 1,
          allLocationSame: true,
          isAdditionalProduct: true,
          description: '',
          finishedProductQty: 0,
          markUpCost: 0,
          markup: 0,
          material_types: 1,
          max_price: null,
          max_value: 10,
          meterial: 1,
          min_value: 1,
          name: '',
          partial: 0,
          partialProductQty: 0,
          pf_retail_markup: null,
          price: 0,
          recipe_id: null,
          retail_price: 0,
          special_price: 0,
          tags: '',
          tax: null,
          tax_category: 0,
          total_qty: 0,
          twilio_field_value_sid: null,
          unit: 4,
          unit_qty: 0,
          vendor_id: '',
          vpt_number: '',
          workflow: null,
        }
      ];
    });
  };
  

  useEffect(() => {
    if (selectedProducts.length <= 0) {
      setAllLocationSame(false)
    }
  }, [selectedProducts])
  const VALUE = [
    { id: 1, value: 'Sl No.' },
    { id: 2, value: 'Products' },
    { id: 3, value: 'Note' },
    //  { id: 10, value: 'Product formula cost (Material cost + Service cost with markup)' },

    { id: 4, value: 'Product formula cost Each' },
    { id: 5, value: markupType == 2 ? (hasMarkupPermission ? 'Retail Price Each' : null) : null },
    { id: 6, value: markupType == 1 ? (hasMarkupPermission ? 'Retail Price Each' : null) : null },
    // { id: 14, value: hasMarkupPermission ? 'SPMA' : null },
    // { id: 7, value: hasMarkupPermission ? 'Markup (%)' : null },
    // { id: 8, value: 'Unit' },
    { id: 9, value: 'Quantity' },
    { id: 10, value: 'Location' },
    { id: 11, value: 'Marketing Adjustment Type' },
    { id: 15, value: 'Marketing Adjustment' }, //id:11
    // { id: 11, value: 'Discount' },
    { id: 12, value: 'Subtotal' },
    { id: 14, value: 'Product Total' },
    { id: 13, value: '' }
  ];

  const VALUEPreview = [
    { id: 9, value: 'Sl No.' },
    { id: 0, value: 'Products' },
    // { id: 9, value: 'Product formula cost' }, // (Material cost + Service cost with markup)
    { id: 1, value: markupType == 2 ? (hasMarkupPermission ? 'Retail Price Each' : null) : null },
    { id: 2, value: markupType == 1 ? (hasMarkupPermission ? 'Retail Price Each' : null) : null },
    { id: 14, value: hasMarkupPermission ? 'SPMA' : null },
    { id: 3, value: hasMarkupPermission ? 'Markup (%)' : null },
    { id: 4, value: 'Unit  ' },
    { id: 5, value: 'Quantity' },
    // { id: 6, value: 'Discount' },
    { id: 6, value: 'Marketing Adjustment Type' },
    { id: 6, value: 'Marketing Adjustment' },
    { id: 7, value: 'Subtotal' },
    { id: 8, value: '' }
  ]

  const VALUE_SERVICES = [
    { id: 0, value: 'Sl No.' },
    { id: 1, value: 'Service Name' },
    { id: 2, value: 'Notes' },
    { id: 3, value: 'Markup (%)' },
    { id: 4, value: 'Cost (Hourly)' },
    { id: 5, value: 'Markup Cost (Hourly)' },
    { id: 6, value: 'Hours' },
    // { id: 7, value: 'Make As Task' },
    // { id: 8, value: 'Make Install Card' },
    { id: 7, value: 'Product Formula Cost'},
    { id: 8, value: 'Additional cost' },
    { id: 9, value: 'Total cost' },
    { id: 10, value: '' }
  ];
  const VALUE_RFP_Product = [
    { id: -1, value: 'Sl No.' },
    { id: 0, value: 'Name' },
    { id: 1, value: 'Mark Up (%)' },
    { id: 2, value: 'Cost ' },
    { id: 3, value: 'Retail Price Each ' },
    { id: 4, value: 'Unit' },
    { id: 5, value: 'Quantity' },
    // { id: 6, value: 'Product Formula Cost'},
    { id: 7, value: 'Total' },
    // { id: 8, value: 'Make As Task' },
    // { id: 9, value: 'Make Install Card' },
    { id: 10, value: 'Location' },
    { id: 11, value: '' }
  ];
  const VALUE_MATERIAL = [
    { id: -1, value: 'Sl No.' },
    { id: 0, value: 'Product' },
    { id: 10, value: 'Note' },
    {id: 9, value: 'Stock Type'},
    { id: 1, value: 'Unit Price' },
    { id: 2, value: 'Markup (%)' },
    { id: 3, value: 'Markup Cost (Unit)' },
    { id: 4, value: 'Quantity' },
    { id: 8, value: 'Marketing Adjustment Type' },
    { id: 9, value: 'Marketing Adjustment' },
    // { id: 5, value: 'Product Formula Cost' },
    { id: 6, value: 'Total' },
    { id: 7, value: '' }
  ]
  // const [expandedCommunities, setExpandedCommunities] = useState({});

  // const handleExpandToggle = (community) => {
  //   setExpandedCommunities(prevState => ({
  //     ...prevState,
  //     [community]: !prevState[community]
  //   }));
  // };

  const NewUserSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    description: Yup.string().required('Description is required'),
    // address: Yup.string().required('Address is required'),
    // city: Yup.string().required('City is required'),
    // state: Yup.string().required('State is required'),
    // zip: Yup.string().required('Zip/Postal Code is required'),
    // skills:userType!=3 && Yup.array().min(1, 'Skill is required'),
    // clients:userType!=3 && Yup.array().min(1, 'Clients is required'),
    clients: (userType != 3 && !isClient) && Yup.object().nullable().required('Clients is required'),
    // workflows:userType!=3 && Yup.array().min(1, 'workflow is required'),
    // start: Yup.mixed().required('Start Date is required'),
    // end: Yup.date()
    //   .nullable()
    //   .when('start', (start, schema) => {
    //     return start
    //       ? schema.min(
    //         start,
    //         'Installation Date must be greater than the Start Date'
    //       )
    //       : schema;
    //   }),
    products: (userType != 3 && !isClient) && Yup.array(), //.min(1, 'At least one product is required'),
    // services:userType!=3 && Yup.array(), 
    project_type: (userType != 3 && !isClient) && Yup.object().nullable().required('Job class is required'),
    markup_type: (userType != 3 && !isClient)&& Yup.object().nullable().required('Please select the markup type'),
    // map_service: (userType != 3 && values.project_type?.name == 'TS') && Yup.object().nullable().required('Please select the map service'),
    map_service: Yup.mixed().when('project_categories', {
      is: (project_categories) => (userType !== 3 && !isClient) && project_categories?.id == 14 && values.project_type?.name == 'TS',
      then: Yup.object().nullable().required('Please select the map service'),
      otherwise: Yup.mixed().nullable(),
    }),
    // project_categories: userType != 3 && Yup.object().nullable().required('Job Category is required'),
    community: userType != 3 
      ? Yup.object().nullable().required('Project is required,Enable projects for client')
      : Yup.object().nullable().required('Project is required'),
  });
  //
  const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.subtitle2,
    // color: theme.palette.text.secondary,
    //   marginBottom: theme.spacing(1)
  }));
  const LabelStyleHead = styled(Typography)(({ theme }) => ({
    ...theme.typography.h5,
    // color: theme.palette.text.secondary,
  }))
  const load = useLocation().state
  //get All request 
  // const fetchAllRequest = async () => {
  //   setLoadingCards(true)
  //   try {
  //     let user = JSON.parse(localStorage.getItem('user'))
  //     let userType = user.user_type
  //     let userId = user.user_id

  //     const values = {
  //       userType: userType, userId: userId, page: page + 1, rowsPerPage, search: searching,
  //       sort: sort.id,
  //       from: filterDateValue[0],
  //       to: filterDateValue[1]
  //     }
  //     await axios.post(`${REST_API}webservice/request/get-all-quotations`, values)
  //       .then((res) => {
  //         res.data.data
  //         setAllRequest(res.data.data.data)
  //         if (res?.data?.data?.totalCount) {
  //           setTotalCount(res?.data?.data?.totalCount)
  //         } else {
  //           setTotalCount(0)
  //         }
  //         setRfps(res.data.allProposals)
  //         setRequestTeam(res.data.requestTeam)
  //         setSkillServices(res.data.services)
  //         setWorkFlow(res.data.workflows)
  //         setAllproducts(res.data.products)
  //         // setAllMaterials(res.data.materials)  15/01/25

  //          //new
  //          const allMatData = Array.isArray(res.data.materials) 
  //          ? res.data.materials.map((material) => ({
  //              ...material,
  //              markup: Number(material.retail_price || 0), 
  //            }))
  //          : [];
 
  //          setAllMaterials(allMatData) 

  //         setLabourCostServices(res.data.labourCostServices)
  //         setFilteredServices(res.data.labourCostServices)
  //         const othersCommunity = { id: 'other', name: 'Others' };
  //         if (res.data?.community) {
  //           setCommunitiesData([...res.data.community, othersCommunity]);
  //         } else {
  //           setCommunitiesData([othersCommunity]);
  //         }
  //       })
  //       .catch((errors) => {
  //         console.log(errors, 'error in fetching all requests')
  //       })
  //   } catch (error) {
  //     console.log("fetchAllRequest error : ", error)
  //   } finally {
  //     setLoadingCards(false)
  //   }
  // }

  //fetch all add data
  const fetchAllRequest = async () => {
    setLoadingCardsForAdd(true)
    try {
      let user = JSON.parse(localStorage.getItem('user'))
     

      let whereCondition = ''
      if (currentTab == 'NEW') {
        whereCondition = ` (r.status = 8 and r.quotation_status = 2 and r.hold = 0) `
      } else if (currentTab == 'IN QUEUE') {
        whereCondition = ` (r.status = 8 and r.quotation_status = 3 and est_prj.status = 1 and r.hold = 0) `
      } else if (currentTab == 'IN PROGRESS') {
        whereCondition = ` (r.status = 8 and r.quotation_status = 3 and est_prj.status = 2 and r.hold = 0) `
      } else if (currentTab == 'REVIEW/ SEND FOR APPROVAL') {
        whereCondition = ` (r.status = 8 and r.quotation_status = 3 and est_prj.status = 3 and r.hold = 0) `
      } else if (currentTab == 'AWAITING APPROVAL') {
        whereCondition = ` (r.status = 8 and r.quotation_status = 9 and r.hold = 0) `
      } else if (currentTab == 'APPROVED') {
        whereCondition = ` (r.status = 8 and r.quotation_status = 4 and r.hold = 0) ` 
      } else if (currentTab == 'REJECTED') {
        whereCondition = ` (r.quotation = 1 and r.quotation_status = 6 and r.hold = 0) `
      } else if (currentTab == 'ARCHIVE') {
        whereCondition = ` (r.quotation = 0 and r.quotation_status = 4 and r.hold = 0) `
      } else if (currentTab == 'HOLD') {
        whereCondition = ` (r.status = 8 and r.hold = 1) `
      } else if (currentTab == 'DRAFT') {
        whereCondition = ` (r.status = 8 and r.quotation_status = 1 and r.hold = 0 and IFNULL(r.draft_source, 0) != 3) `
      } else if (currentTab == 'ALL') {
        // whereCondition = ` (r.status = 8) `
        whereCondition = ` ((r.was_from_estimate = 1 and r.status NOT IN (0,8)) OR (d_ord.request_id IS NOT NULL and d_ord.status <> 0 and d_ord.hold = 0 and r.status = 0 and r.isFromDesignOrder = 1)) `
      }
      const values = {
        userType: userType,isClient, userId: userId, page: page + 1,where:whereCondition, rowsPerPage, search: searching,
        sort: sort.id,
        from: filterDateValue[0],
        to: filterDateValue[1],
        filterClient:filterClient,
        filterUser:filterUser,
        dueData:dueData,
        filterProjectType:filterProjectType,
        filterCommunity:filterCommunity,
        projectEstimate:true
      }
      await axios.post(`${REST_API}webservice/request/get-all-quotations-add`, values)
        .then((res) => {
          // res.data.data
          // setAllRequest(res.data.data.data)
          // if (res?.data?.data?.totalCount) {
          //   setTotalCount(res?.data?.data?.totalCount)
          // } else {
          //   setTotalCount(0)
          // }
          // Sort proposals alphanumerically by description
          const sortedProposals = [...(res.data.allProposals || [])].sort((a, b) => alphanumericCompare(a?.description || '', b?.description || ''))
          setRfps(sortedProposals)
          setRequestTeam(res.data.requestTeam)
          // Sort services alphanumerically by name
          const sortedServices = [...(res.data.services || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
          setSkillServices(sortedServices)
          setWorkFlow(res.data.workflows)
          setAllproducts(res.data.products)
          // setAllMaterials(res.data.materials)  15/01/25

           //new
           const allMatData = Array.isArray(res.data.materials) 
           ? res.data.materials.map((material) => ({
               ...material,
               markup: Number(material.retail_price || 0), 
             }))
           : [];
 
          //  setAllMaterials(allMatData) 
          const filteredMaterials = allMatData?.filter(item=>item.isAdditionalProduct == 0)
          // Sort materials alphanumerically by description (fallback to name)
          const sortedMaterials = [...(filteredMaterials || [])].sort((a, b) => {
            const aValue = a?.description || a?.name || '';
            const bValue = b?.description || b?.name || '';
            return alphanumericCompare(aValue, bValue);
          })
          setAllMaterials(sortedMaterials)

          // Sort labour cost services alphanumerically by name
          const sortedLabourCostServices = [...(res.data.labourCostServices || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
          setLabourCostServices(sortedLabourCostServices)
          setFilteredServices(sortedLabourCostServices)
          // const othersCommunity = { id: 'other', name: 'Others' };
          // const othersClient = { id: 'other', name: 'Others' };
          // if (res.data?.community) {
          //   setCommunitiesData([...res.data.community, othersCommunity]);
          // } else {
          //   setCommunitiesData([othersCommunity]);
          // }
          // if (res.data?.clients) {
          //   setClientData([...res.data.clients]);
          // } else {
          //   setClientData([]);
          // }
        })
        .catch((errors) => {
          console.log(errors, 'error in fetching all requests')
        })
    } catch (error) {
      console.log("fetchAllRequest error : ", error)
    } finally {
      setLoadingCardsForAdd(false)
    }
  }

  const fetchAllRequestCards = async () => {
    setLoadingCards(true)
    try {
      // Cancel only previous cards requests, not all requests
      if(openRequestEstimate == true){
        console.log('dont cancel')
      }else{
        console.log('dont cancel')
        // cancelAllGlobalRequests('Cards request');
      }
      
      let user = JSON.parse(localStorage.getItem('user'))
   

      let whereCondition = ''
      if (currentTab == 'NEW') {
        whereCondition = ` (r.status = 8 and r.quotation_status = 2 and r.hold = 0) `
      } else if (currentTab == 'IN QUEUE') {
        whereCondition = ` (r.status = 8 and r.quotation_status = 3 and est_prj.status = 1 and r.hold = 0) `
      } else if (currentTab == 'IN PROGRESS') {
        whereCondition = ` (r.status = 8 and r.quotation_status = 3 and est_prj.status = 2 and r.hold = 0) `
      } else if (currentTab == 'REVIEW/ SEND FOR APPROVAL') {
        whereCondition = ` (r.status = 8 and r.quotation_status = 3 and est_prj.status = 3 and r.hold = 0) `
      } else if (currentTab == 'AWAITING APPROVAL') {
        whereCondition = ` (r.status = 8 and r.quotation_status = 9 and r.hold = 0) `
      } else if (currentTab == 'APPROVED') {
        whereCondition = ` (r.status = 8 and r.quotation_status = 4 and r.hold = 0) ` 
      }
      else if (currentTab == 'REJECTED') {
        whereCondition = ` (r.quotation = 1 and r.quotation_status = 6 and r.hold = 0) `
      } else if (currentTab == 'ARCHIVE') {
        whereCondition = ` (r.quotation = 0 and r.quotation_status = 4 and r.hold = 0) `
      } else if (currentTab == 'HOLD') {
        whereCondition = ` (r.status = 8 and r.hold = 1) `
      } else if (currentTab == 'DRAFT') {
        whereCondition = ` (r.status = 8 and r.quotation_status = 1 and r.hold = 0 and IFNULL(r.draft_source, 0) != 3) `
      } else if (currentTab == 'ALL') {
        // whereCondition = ` (r.status = 8 ) `
        whereCondition = ` ((r.was_from_estimate = 1 and r.status NOT IN (0,8)) OR (d_ord.request_id IS NOT NULL and d_ord.status <> 0 and d_ord.hold = 0 and r.status = 0 and r.isFromDesignOrder = 1)) `
      }

      const values = {
        userType: userType,isClient, userId: userId, page: page + 1, rowsPerPage, search: searching,
        sort: sort.id,
        from: filterDateValue[0],
        to: filterDateValue[1],
        filterClient:filterClient,
        filterUser:filterUser,
        dueData:dueData,
        where:whereCondition,
        filterProjectType:filterProjectType,
        filterCommunity:filterCommunity,
        projectEstimate:true
      }
      await axios.post(`${REST_API}webservice/request/get-all-quotations-cards`, values)
        .then((res) => {
          res.data.data
          setAllRequest(res.data.data.data)
          if (res?.data?.data?.totalCount) {
            setTotalCount(res?.data?.data?.totalCount)
          } else {
            setTotalCount(0)
          }
        
        })
        .catch((errors) => {
          if (axios.isCancel(errors)) {
            console.log('fetchAllRequestCards cancelled');
            return;
          }
          console.log(errors, 'error in fetching all requests')
        })
    } catch (error) {
      console.log("fetchAllRequest error : ", error)
    } finally {
      setLoadingCards(false)
    }
  }

  useEffect(() => {
    if (!skipFetch) {
      fetchAllRequestCards()
      // Note: Add-data fetch moved to Settings button click
    }
    setSkipFetch(false)
  }, [open, openRequestEstimate, searching, page, rowsPerPage, sort, filterDateValue , renderCards,filterClient,filterUser,dueData,filterProjectType,filterCommunity])
console.log('renderCardsrenderCardsrenderCardsrenderCards',renderCards)
  useEffect(() => {
    if (!skipFetch) {
      fetchViewType()
      // Note: Add-data fetch moved to Settings button click
    }
    setSkipFetch(false)
  }, [open, searching, page, rowsPerPage, sort, filterDateValue , renderCards,filterClient,filterUser,filterProjectType,filterCommunity])
  
  // Load filters once on mount (clients, communities)
  useEffect(() => {
    fetchQuotationFilters()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const reorderedItems = Array.from(allRequest);
    const [movedItem] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, movedItem);

    setAllRequest(reorderedItems);

    console.log("reorderedItemsreorderedItemsreorderedItems", reorderedItems)
    saveNewOrder(reorderedItems);
  };


  const saveNewOrder = async (reorderedItems) => {
    try {
      await axios.post(`${REST_API}webservice/request/save-order`, { reorderedItems });
      console.log('Order saved successfully');
    } catch (error) {
      console.error('Error saving order:', error);
    }
  };


  const fetchAllCommunityByClient = async (clientId) => {
    console.log("####################ClientIs", clientId);
    setIsCommunityLoading(true);
    try {
      clientId = clientId.id
      const res = await axios.post(`${REST_API}webservice/rfq/get-community-by-client`, { clientId,From:"addSalesOrder",teamId: teamId })
      let data = res.data?.community
      // Sort communities alphanumerically by name
      const sortedCommunities = [...(data || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
      await setCommunities(sortedCommunities)
      // Store all communities for later use in getSalesRepOptionsFromCommunity
      setAllCommunities(sortedCommunities)
    } catch (error) {
      console.log(error, 'Error in fetching all clients')
    }finally {
      setIsCommunityLoading(false)
    }
  }

  const getSalesRepOptionsFromCommunity = (community) => {
    const rawNames = community?.all_sales_rep_names;
    const rawIds = community?.all_sales_rep_ids;

    const names = Array.isArray(rawNames)
      ? rawNames
      : typeof rawNames === 'string'
        ? rawNames.split(',').map((s) => s.trim()).filter(Boolean)
        : [];

    const ids = Array.isArray(rawIds)
      ? rawIds
      : typeof rawIds === 'string'
        ? rawIds.split(',').map((s) => s.trim()).filter(Boolean)
        : [];

    return names.map((name, idx) => ({
      id: ids[idx] ?? null,
      name,
    }));
  };

  // New function for client-specific project autocomplete
  const fetchClientSpecificProjects = async () => {
    console.log('Quotation fetchClientSpecificProjects called with:', { userId, userType, isClient, clientId: user?.client_id });
    setIsCommunityLoading(true);
    try {
      const res = await axios.post(`${REST_API}webservice/rfq/get-communities-for-client-autocomplete`, {
        userId: userId,
        userType: userType,
        isClient: isClient,
        clientId: user?.client_id
      });
      
      console.log('Quotation API response:', res.data);
      if (res.data?.status === 1) {
        // Sort client communities alphanumerically by name
        const sortedClientCommunities = [...(res.data.data || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
        setClientCommunities(sortedClientCommunities);
        // Store all communities for later use in getSalesRepOptionsFromCommunity
        setAllCommunities(sortedClientCommunities);
        console.log('Quotation Set clientCommunities to:', sortedClientCommunities);
      } else {
        setClientCommunities([]);
        console.log('Quotation API returned status 0, setting empty clientCommunities');
      }
    } catch (error) {
      console.log('Quotation Error fetching client-specific projects:', error);
      setClientCommunities([]);
    } finally {
      setIsCommunityLoading(false);
    }
  };

  const getCommunitySalesRepIds = (community) => {
    const rawIds = community?.all_sales_rep_ids || community?.sales_rep_ids;
    if (!rawIds) {
      return [];
    }

    const ids = Array.isArray(rawIds)
      ? rawIds
      : typeof rawIds === 'string'
        ? rawIds.split(',')
        : [];

    return ids
      .map((id) => String(id ?? '').trim())
      .filter(Boolean);
  };

  const fetchAllMapServices = async () => {
    setMapServicesLoading(true);
    try {
      const res = await axios.post(`${REST_API}webservice/route/fetch-routes-with-locations`)
      let data = res.data?.routeData
      if(data){
        const newData = data?.filter((i) => i.locations != null)
        if(newData){
          setMapServices(newData);
        }else{
          setMapServices([]);
        }
      }else{
        setMapServices([]);
      }
    } catch (error) {
      setMapServices([]);
      console.log(error, 'Error in fetching map services');
    }finally {
      setMapServicesLoading(false)
    }
  }

  const fetchAllClients = async () => {

    try {
      const res = await axios.post(`${REST_API}webservice/clients/getAllClients`, { userType, userId: userId ,order:true,From:"addSalesOrder",teamId: teamId })
      let data = res.data?.customer
      await setAllClients(data)
    } catch (error) {
      console.log(error, 'Error in fetching all clients', error)
    }
  }

  const fetchTeamMembersForCollaborators = async () => {
    setTeamMembersLoading(true);
    try {
      const res = await axios.post(`${REST_API_END_POINT}teams/get-all-teams-data-collaborators`, {
        usersId: userId,
        usersType: userType,
        isClient: isClient || false,
        page: 1,
        rowsPerPage: 5000,
        orderBy: 'name',
        order: 'asc',
      });
      const raw = res.data?.team_members?.data || res.data?.team_members || [];
      const list = Array.isArray(raw) ? raw : [];
      const filteredList = list.filter(member => member.userRole !== "Development" && member.user_type !== 51);
      setTeamMembersOptions(filteredList);
    } catch (error) {
      console.log(error, 'Error fetching team members for collaborators');
      setTeamMembersOptions([]);
    } finally {
      setTeamMembersLoading(false);
    }
  };

  const fetchTaxCategory = async () => {
    try{
        const response = await axios.post(`${REST_API_END_POINT}product/get-tax-category`)
        if(response.data.status === 1){
            setTaxCategories(response.data.taxResult);
        }else{
          setTaxCategories([])
        }
    }catch(error){
        console.log("Error - ",error);
        setTaxCategories([])
    }
  }

  const fetchAllAgreements = async () => {
    try {
      const response = await axios.post(`${REST_API_END_POINT}agreement/get-all-agreements`);
      if (response.data.status === 1 && Array.isArray(response.data.result)) {
        setSignAgreement(response.data.result); // Set only if it's an array
      } else {
        setSignAgreement([]); // Empty array if the result is not valid
      }
    } catch (error) {
      console.log(error, 'Error in fetching all agreements');
      setSignAgreement([]); // Ensure signAgreement is an empty array on error
    }
  };

  useEffect(() => {
    try {
      axios.post(`${REST_API_END_POINT}project/get-data-for-add-project`, {
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if (response.data.status === 1) {
          setProjectTypes(response.data.projectTypes)
          const category = response.data.projectCategories;
          const filteredCategory = category?.filter(item=>item.id == 14)
          setProjectCategories(filteredCategory)
          // setProjectCategories(response.data.projectCategories)
          // setCommunities(response.data.community)
        }
      }).catch((error) => {
        console.error(error);
      })
    }
    catch (error) {
      console.error("Error fetching data:", error);
    }
    fetchAllMapServices();
    fetchAllClients()
    fetchAllClients();
    fetchTeamMembersForCollaborators();
    fetchTaxCategory()
    fetchAllAgreements()
  }, [])

  // Load client-specific projects on component mount for clients
  useEffect(() => {
    console.log('Quotation useEffect triggered - isClient:', isClient, 'userType:', userType, 'userId:', userId);
    if (isClient || userType === 3) {
      console.log('Quotation Calling fetchClientSpecificProjects');
      fetchClientSpecificProjects();
    }
  }, [isClient, userType, userId]);

    const fetchEstimateTabCount = async () => {
      try {
        let userId = user.user_id;
        const response = await axios.post(`${REST_API}webservice/estimate/estimate-tabs-count`, { userId });
    
        if (response?.data?.status === 1) {
          const { open_count, approved_count, open_count_ids = [], approved_count_ids = []} = response.data?.data;
          const validOpenCountIds = open_count_ids ? open_count_ids.split(',') : [];
          const validApprovedCountIds = approved_count_ids ? approved_count_ids.split(',') : [];
          const allIds = [...validOpenCountIds, ...validApprovedCountIds];
          const uniqueIds = [...new Set(allIds)];
          const commaSeparatedIds = uniqueIds.join(',');
          setIsNewRowIdPresent(commaSeparatedIds);
          console.log('commaSeparatedIds', commaSeparatedIds)
          // Uncomment to update counts as needed
          // setOpenCount(open_count);
          // setApprovedCount(approved_count);
          // setArchiveCount(response.data?.data?.archive_count);
          // setHoldCount(response.data?.data?.completed_count);
    
        } else {
          console.warn("Failed to fetch Install counts:", response?.data?.message);
        }
      } catch (error) {
        console.error("Error fetching Install counts:", error);
      }
    };
    
    
    useEffect(async()=>{
      fetchEstimateTabCount()
    },[open, openRequestEstimate, searching, page, rowsPerPage, sort, filterDateValue , renderCards,filterClient,filterUser,dueData])

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

//   const handleProduct = (value) => {
//   // Extract community address from Formik's values
//   const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
//   const communityAddress = { 
//     address: projAddress, 
//     city: projCity, 
//     state: projState, 
//     zip: projZip 
//   };

//   setSelectedProducts((prevProducts) => {
//     // If "All Locations Same" is on, we might use the addresses from the very first product
//     const commonAddress = allLocationSame && prevProducts.length > 0
//       ? { ...prevProducts[0].addresses[0] }
//       : null;

//     const updatedProducts = value.map((product) => {
//       // Check if the product already exists in selectedProducts
//       const existingProduct = prevProducts.find(
//         (p) => p.id === product.id && p.indexId === product.indexId
//       );

//       if (existingProduct) {
//         // If product already exists, update its quantity and address
//         const quantity = existingProduct.quantity;
//         const locationQuantity = existingProduct.locationQuantity;

//         // Preserve existing address if it exists; otherwise, assign dynamically
//         let address = existingProduct.addresses[0] || {
//           id: 0,
//           address: '',
//           city: '',
//           state: '',
//           zip: '',
//         };

//         if (allLocationSame && commonAddress) {
//           address = { ...commonAddress };
//         } else if (projAddress && projCity && projState && projZip) {
//           address = { ...communityAddress };
//         }

//         return {
//           ...existingProduct,
//           quantity,
//           addresses: [address],
//           locationQuantity,
//         };
//       } else {
//         // If product doesn't exist, add it with default quantity and addresses
//         let newAddress = {
//           id: 0,
//           address: '',
//           city: '',
//           state: '',
//           zip: '',
//         };

//         if (allLocationSame && commonAddress) {
//           newAddress = { ...commonAddress };
//         } else if (projAddress && projCity && projState && projZip) {
//           newAddress = { ...communityAddress };
//         }

//         const newIndexCounter = indexCounter + 1;
//         setIndexCounter(newIndexCounter);

//         return {
//           ...product,
//           indexId: newIndexCounter,
//           quantity: 1,
//           locationQuantity: 1,
//           discount: 0,
//           addresses: [newAddress],
//         };
//       }
//     });

//     console.log("Updated Products:", updatedProducts);
    
//     // Merge products from selectedMapserviceProducts with fromMapServices = true into the value
//     const allSelectedProducts = [
//       ...updatedProducts,
//       ...selectedMapserviceProducts.filter(product => product?.fromMapServices == true)
//     ];


//     // Build up a combined list of “services” for all products
//     const productServices = allSelectedProducts?.reduce((services, product) => {
//       if (product.services && product.services.length > 0) {
//         return services.concat(
//           product.services.map((service) => ({
//             ...service,
//             productIndex: product?.indexId,
//             fromMapServices: product?.fromMapServices,
//             quantity: service.quantity * product.quantity * product.locationQuantity,
//             previousQty: service.quantity,
//             qtyData: product.quantity,
//             locationQuantity: product.locationQuantity,
//           }))
//         );
//       }
//       return services;
//     }, []);

//     setSelectedServices(productServices);

//     const filteredServices =
//       productServices.length === 0
//         ? labourCostServices
//         : labourCostServices.filter((service) =>
//             !productServices.find(
//               (selectedService) => selectedService.id === service.id
//             )
//           );
//     setFilteredServices(filteredServices);
//     setFieldValue('products', allSelectedProducts);
//     return allSelectedProducts;
//   });
// };

const handleProduct = (value) => {
  console.log('New product row added 1',value)
  // 1) Grab the project's address data from Formik (or wherever you store your project)
  //    If there's no project selected, default to empty strings.
  const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};

  setSelectedProducts((prevProducts) => {
    // If "All Locations Same" is on, we might use the addresses from the very first product
    let commonAddresses = null;
    // const commonAddresses = (allLocationSame && prevProducts.length > 0) ? [...prevProducts[0].addresses] : null;

    // 2) Map over the newly selected array of products
    const updatedProducts = value.map((product, index) => {
      // Check if product already exists in selectedProducts
      const existingProduct = prevProducts.find((p) => p.id === product.id && p.indexId === product.indexId);
      console.log('existingProduct', existingProduct)

      if (existingProduct) {
        // -----------------------
        // If product already exists
        // -----------------------
        const quantity = existingProduct.quantity; 
        const locationQuantity = existingProduct.locationQuantity;
        let addresses = [...existingProduct.addresses];

        if (allLocationSame && commonAddresses) {
            // Overwrite all addresses with the "common" addresses (from the first product)
            addresses = [...commonAddresses];
        } else {
            // Ensure at least one address object
            for (let i = addresses.length; i < 1; i++) {
            addresses.push({
                id: i,
                address: '',
                city: '',
                state: '',
                zip: '',
            });
            }
        }

        return {
            ...existingProduct,
            quantity,
            locationQuantity,
            addresses
        };
      } else {
        // -----------------------
        // BRAND NEW product
        // -----------------------
        // Auto-populate addresses from the selected Project
        const newAddresses = [
            {
            id: 0,
            address: projAddress,
            city: projCity,
            state: projState,
            zip: projZip
            }
        ];

        // If "allLocationSame" is on, we might prefer the addresses from the first product
        if (false) {
        // if (allLocationSame && prevProducts.length > 0) {
            const commonAddress = { ...prevProducts[0].addresses[0] } || {
            address: '',
            city: '',
            state: '',
            zip: '',
            };
            newAddresses[0] = commonAddress;
        }

        // Bump the index counter for a unique indexId
        const newIndexCounter = indexCounter + 1;
        setIndexCounter(newIndexCounter);

        return {
            ...product,
            indexId: newIndexCounter,
            allLocationSame: true,
            quantity: 1,
            locationQuantity: 1,
            discount: 0,
            addresses: newAddresses
        };
      }
    });
     // Reassign indexId starting from 1 for remaining products
     const resetIndexProducts = updatedProducts.map((product, idx) => ({
      ...product,
      indexId: idx + 1 // Reset the index to start from 1
    }));

    setSelectedProducts(resetIndexProducts);

    console.log('updatedProducts', updatedProducts)
    // Merge products from selectedMapserviceProducts with fromMapServices = true into the value
    const allSelectedProducts = [
        ...updatedProducts,
        ...selectedProducts?.filter((item)=>item.isAdditionalProduct == true),
        ...selectedMapserviceProducts.filter(product => product?.fromMapServices == true)
    ];

    // 3) Build up a combined list of “services” for all products
    const productServices = allSelectedProducts?.reduce((services, product) => {
      if (product.services && product.services.length > 0) {
        return services.concat(
          product.services.map((service) => ({
            ...service,
            productIndex: product?.indexId,
            fromMapServices: product?.fromMapServices,
            quantity: service.quantity * product.quantity * product.locationQuantity,
            previousQty: service.quantity,
            qtyData: product.quantity,
            locationQuantity: product.locationQuantity
          }))
        );
      }
      return services;
    }, []);


    // Update your “selectedServices” state (if your code needs it)
    setSelectedServices(productServices);

    // Optionally filter out services you’ve already chosen, etc.
    const filteredServices =
      productServices.length === 0
      ? labourCostServices
      : labourCostServices.filter(
          (service) =>
              !productServices.find(
              (selectedService) => selectedService.id === service.id
              )
          );
    setFilteredServices(filteredServices);
    setFieldValue('products', allSelectedProducts);

    ///////////////////////for additional service filter
    const updatedAdditionalSelectedServices = additionalSelectedServices?.filter(
      (service) => !productServices.some(
        (selectedService) => selectedService.id === service.id
      )
    );
    
    // Now update the state
    setAdditionalSelectedServices(updatedAdditionalSelectedServices);
    setFieldValue('services', updatedAdditionalSelectedServices)
////////////////////////
    
    // Calculate installation date based on highest lead_time of selected products
    const productsWithLeadTime = allSelectedProducts.filter(product => product.lead_time && product.lead_time > 0);
    
    if (productsWithLeadTime.length > 0) {
      const highestLeadTime = Math.max(...productsWithLeadTime.map(product => product.lead_time));
      const installationDate = moment().add(highestLeadTime, 'days');
      
      // Set only the single installation date field
      setFieldValue('end', dateOnlyToUnix(installationDate));
    } else {
      // If no products with lead_time, set installation date to current date
      setFieldValue('end', localTodayDateOnlyUnix());
    }
    
    return allSelectedProducts;
  });

  setShowAddNewRow(true)
};
  // const handleAllLocationSameChange = () => {

  //   console.log("##################Alllll", allLocationSame);
  //   if (!allLocationSame) {
  //     const commonAddress = selectedProducts[0]?.addresses[0] || {
  //       address: '',
  //       city: '',
  //       state: '',
  //       zip: '',
  //     };
  //     setSelectedProducts(prevProducts =>
  //       prevProducts.map(product => ({
  //         ...product,
  //         addresses: product.addresses.map(() => commonAddress),
  //       }))
  //     );
  //   }
  //   setAllLocationSame(!allLocationSame);
  // };

  
  const handleAllLocationSameChange = (productIndex) => {
    setSelectedProducts(prevProducts =>
      prevProducts.map((product, index) => {
        if (index === productIndex) {
          console.log('productIndex--1---', index)
          console.log('productIndex--2---', productIndex)

          // Toggle allLocationSame flag
          const isAllSame = !product?.allLocationSame;
          // Get the first address of the selected product
          const commonAddress = product.addresses[0] || {
            address: '',
            city: '',
            state: '',
            zip: '',
          };
  
          return {
            ...product,
            allLocationSame: isAllSame,
            addresses: product.addresses.map(() => commonAddress),
          };
        }
        return product;
      })
    );
    // markUnsavedChanges();
  };

  // const calculateTotal = (price, quantity, discount, location = 1, adjustment = 0, markAdjType = 1) => {
  //   const parsedQuantity = parseFloat(quantity) || 1;
  //   const parsedDiscount = parseFloat(discount) || 0;
  //   const locationQuantity = parseFloat(location) || 1;
  //   const newPrice = parseFloat(price) || 0
  //   console.log("markAdjType", markAdjType);


  //   // let subtotal = price * parsedQuantity * locationQuantity;

  //   let SPMA = newPrice + ((newPrice * (adjustment ? Number(adjustment) : 0)) / 100)
  //   let subtotal = parseFloat(SPMA)?.toFixed(2) * parsedQuantity * locationQuantity;

  //   if (markAdjType == 2 || markAdjType == 3) {
  //     SPMA = newPrice + (adjustment ? Number(adjustment) : 0)
  //     subtotal = parseFloat(SPMA)?.toFixed(2) * parsedQuantity * locationQuantity;
  //   }

  //   if (discount) {
  //     subtotal = subtotal - discount;
  //   }
  //   // if (adjustment) {
  //   //   subtotal = subtotal + ((subtotal * adjustment) / 100);
  //   // }
  //   return subtotal;
  // };
 

  const calculateTotal = (price, quantity, discount, location = 1, adjustment = 0, markAdjType = 1,adj_value_type=true) => {
    const parsedQuantity = parseFloat(quantity) || 0;
    const parsedDiscount = parseFloat(discount) || 0;
    const locationQuantity = parseFloat(location) || 1;
    const newPrice = parseFloat(price) || 0;
  
    let SPMA = newPrice //+ ((newPrice * (adjustment ? Number(adjustment) : 0)) / 100);
  
    if (markAdjType == 2 || markAdjType == 3) {
      SPMA = newPrice //+ (adjustment ? Number(adjustment) : 0);
    }
  
    let subtotal = SPMA * parsedQuantity * locationQuantity;
  
    if (parsedDiscount) {
      subtotal -= parsedDiscount;
    }
    // if(adjustment){
    //   subtotal = subtotal + (adj_value_type ? Number(adjustment || 0) : -(Number(adjustment || 0)))
    // }
  
    return parseFloat(subtotal.toFixed(2)); // Ensures a clean number
  };
  
 
  const handleDeleteProduct = (productId, indexId) => {
    const filteredProduct = selectedProducts?.filter((data) => !(data.id === productId && data.indexId === indexId));
    // Reassign indexId starting from 1 for the remaining products
    const resetIndexProducts = filteredProduct.map((product, idx) => ({
      ...product,
      indexId: idx + 1 // Reset the index to start from 1
    }));

    setFieldValue('products', resetIndexProducts);
  setSelectedProducts(resetIndexProducts);
    // markUnsavedChanges();
    // setFieldValue('products', filteredProduct);
    // setSelectedProducts(filteredProduct);

    // Remove the corresponding location state when a product is deleted
    const newLocationStates = { ...locationStates };
    delete newLocationStates[indexId];
    setLocationStates(newLocationStates);
    console.log("Filtered products", filteredProduct);
    console.log("Filtered All Services", selectedServices);
    const optedProductIds = filteredProduct.map(product => product.id);
    const result = selectedServices?.filter(service =>
      filteredProduct?.some((product) => (product?.id === service?.product_id && product?.indexId === service?.productIndex))
    )


    console.log("Filtered chat", result);
    const filteredServices = selectedServices?.filter(service => !filteredProduct?.some(product => product?.services?.includes(service)));
    console.log("Filtered Services", filteredServices);
    if (filteredProduct?.length == 0) {
      setSelectedServices([])
    }
    else {
      // setSelectedServices(filteredServices);
      setSelectedServices(result)
    }
    
    // Recalculate installation date based on remaining products
    const productsWithLeadTime = filteredProduct.filter(product => product.lead_time && product.lead_time > 0);
    
    if (productsWithLeadTime.length > 0) {
      const highestLeadTime = Math.max(...productsWithLeadTime.map(product => product.lead_time));
      const installationDate = moment().add(highestLeadTime, 'days');
      
      // Set only the single installation date field
      setFieldValue('end', dateOnlyToUnix(installationDate));
    } else {
      // If no products with lead_time remain, reset installation date to current date
      setFieldValue('end', localTodayDateOnlyUnix());
    }

  };

  const handleDeleteInstallCost = (productId, indexId) => {
    // Remove only the install_cost from the product, keeping the product itself
    const updatedProducts = selectedProducts?.map((product) => {
      if (product.id === productId && product.indexId === indexId) {
        return {
          ...product,
          install_cost: null, // or 0, depending on your preference

          retail_price:product.actual_retail_price * product.locationQuantity,
        };
      }
      return product;
    });
    setFieldValue('products', updatedProducts);
    setSelectedProducts(updatedProducts);
  };

  const handleDeleteService = (servId, indexId) => {
    const newFilteredServices = additionalSelectedServices?.filter((data) => {
      if (data?.isAdditionalProduct) {
        return data?.newIndexId !== indexId;
      }
      return data?.id !== servId;
    });
    

    // const allFilteredServices = filteredServices?.find(data => data.id !== servId);
    setFieldValue('services', newFilteredServices);
    setAdditionalSelectedServices(newFilteredServices);
    // markUnsavedChanges();
  };

  console.log('selectedProducts**', selectedProducts)
  const selectedProductsAdditionalCost = selectedProducts?.filter(item=>item?.isAdditionalProduct == true)
      ?.reduce((total, item) => total + (item.product_total || 0), 0)
      ?.toFixed(2)

  // const selectedProductsAdditionalCost = useMemo(() => {
  //   return selectedProducts
  //     ?.filter((item) => item?.isAdditionalProduct)
  //     ?.reduce((total, item) => total + (parseFloat(item.product_total) || 0), 0)
  //     ?.toFixed(2);
  // }, [selectedProducts]);
  

  // const selectedMaterialSubTotal = selectedMaterials //?.filter(item=>item?.isAdditionalProduct == true)
  //     ?.reduce((total, item) => total + ((item.markUpCost || 0) * (item.quantity || 0)), 0)
  //     // ?.reduce((total, item) => total + ((item.markUpCost + (item.adj_value_type ? Number(item.adjustment) : -Number(item.adjustment))) || 0) * (item.quantity || 0), 0)
  //     ?.toFixed(2)  
  const selectedMaterialSubTotal = selectedMaterials //?.filter(item=>item?.isAdditionalProduct == true)
    ?.reduce((total, item) => total + (((item.markUpCost + (item.adj_value_type ? Number(item.adjustment || 0) : -Number(item.adjustment || 0))) || 0) * (item.quantity || 0)), 0)
    ?.toFixed(2) 
  // const selectedMaterialSubTotal = selectedMaterials?.reduce((total, item) => total + ((item.markUpCost + (item.adj_value_type ? Number(item.adjustment) : -Number(item.adjustment))) || 0) * (item.quantity || 0), 0)
  //     ?.toFixed(2)   

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function applySortFilter(array, comparator, community) {
    const stabilizedThis = array?.map((el, index) => [el, index]);
    stabilizedThis?.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    // Filter based on the community parameter
    if (community && community?.length > 0) {
      if (community?.includes('other')) {
        array = array?.filter((item) => item?.community === null || community?.includes(item?.community));
      } else {
        array = array?.filter((item) => community?.includes(item?.community));
      }
    }
    return array;
  }


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: '',
      po_number: '',
      description: '',
      notes: '',
      // skills: [],
      clients: null,
      // workflows:[],
      start: toDateOnlyUnix(currentDate) ?? localTodayDateOnlyUnix(),
      end: toDateOnlyUnix(currentDate) ?? localTodayDateOnlyUnix(),
      installation_start_date: null,
      installation_end_date: null,
      // avatarUrl: [],
      products: [],
      services: [],
      additionalMaterials: [],
      labour_cost: 0,
      budget: 0,
      invoice_discount: null,
      welcome_message: null,
      draft: null,
      // client_approve: (userType !==3 && !isClient)? false : true,
      // is_single_card: true,
      client_approve: true,
      total: 0,
      taxAmount: 0,
      subject: null,
      email_content: null,
      project_categories: null,
      project_type: null,
      sign_agreement: [],
      markup_type: markupTypes[1] ||null,
      map_service: null,
      community: null,
      rfp: null,
      split_catalog_type: splitOrderCatalogTypes.find((type) => type.id === 'all'), // Default to "All"
      modifiedServices: modifiedRows
      // address:null,
      // city:null,
      // state:null,
      // zip:null,
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        setIsSubmitted(true);
        const hasEmptyProductName = selectedProducts?.some(product => product.name.trim() === '');
        const hasEmptyServiceName = additionalSelectedServices?.some(product => product.name.trim() === '');
        const hasEmptyMaterialName = selectedMaterials?.some(product => product.name.trim() === '');
        if (hasEmptyProductName) {
          enqueueSnackbar('Please fill in all required product names.', { variant: 'error' });
          return;
        }
        if (hasEmptyServiceName) {
          enqueueSnackbar('Please fill in all required service names.', { variant: 'error' });
          return;
        }
        if (hasEmptyMaterialName) {
          enqueueSnackbar('Please fill in all required material names.', { variant: 'error' });
          return;
        }
        const hasInvalidProductName = selectedProducts?.filter(item=>item?.isAdditionalProduct == true)?.some(product => {
          const trimmedName = product.name.trim();
          if (trimmedName === '.') {
            enqueueSnackbar('Product name cannot be just a dot.', { variant: 'error' });
            return true;
          }
          if (trimmedName === '-') {
            enqueueSnackbar('Product name cannot be just a hyphen.', { variant: 'error' });
            return true;
          }
          // if (!/^[a-zA-Z0-9\s-]+$/.test(trimmedName)) {
          //   enqueueSnackbar('Product name can only contain letters, numbers, and hyphens.', { variant: 'error' });
          //   return true;
          // }
          if (/[:]/.test(trimmedName)) {
            enqueueSnackbar('Product name cannot contain colon (:).', { variant: 'error' });
            return true;
          }
          if (trimmedName[0] === '.') {
            enqueueSnackbar('Product name cannot start with a dot.', { variant: 'error' });
            return true;
          }
          if (trimmedName[0] === '-') {
            enqueueSnackbar('Product name cannot start with a hyphen.', { variant: 'error' });
            return true;
          }
          if (trimmedName === '') {
            enqueueSnackbar('Product name cannot be empty or just spaces.', { variant: 'error' });
            return true;
          }
          return false;
        });
        
        const hasInvalidServiceName = additionalSelectedServices?.filter(item=>item?.isAdditionalProduct == true)?.some(product => {
          const trimmedName = product.name.trim();
          if (trimmedName === '.') {
            enqueueSnackbar('Service name cannot be just a dot.', { variant: 'error' });
            return true;
          }
          if (trimmedName === '-') {
            enqueueSnackbar('Service name cannot be just a hyphen.', { variant: 'error' });
            return true;
          }
          if (/[:]/.test(trimmedName)) {
            enqueueSnackbar('Service name cannot contain colon (:).', { variant: 'error' });
            return true;
          }                
          if (trimmedName[0] === '.') {
            enqueueSnackbar('Service name cannot start with a dot.', { variant: 'error' });
            return true;
          }
          if (trimmedName[0] === '-') {
            enqueueSnackbar('Service name cannot start with a hyphen.', { variant: 'error' });
            return true;
          }
          if (trimmedName === '') {
            enqueueSnackbar('Service name cannot be empty or just spaces.', { variant: 'error' });
            return true;
          }
          return false;
        });
        
        const hasInvalidMaterialName = selectedMaterials?.filter(item=>item?.isAdditionalProduct == true)?.some(product => {
          const trimmedName = product.name.trim();
          if (trimmedName === '.') {
            enqueueSnackbar('Material name cannot be just a dot.', { variant: 'error' });
            return true;
          }
          if (trimmedName === '-') {
            enqueueSnackbar('Material name cannot be just a hyphen.', { variant: 'error' });
            return true;
          }
          if (/[:]/.test(trimmedName)) {
            enqueueSnackbar('Material name cannot contain colon (:).', { variant: 'error' });
            return true;
          }                
          if (trimmedName[0] === '.') {
            enqueueSnackbar('Material name cannot start with a dot.', { variant: 'error' });
            return true;
          }
          if (trimmedName[0] === '-') {
            enqueueSnackbar('Material name cannot start with a hyphen.', { variant: 'error' });
            return true;
          }
          if (trimmedName === '') {
            enqueueSnackbar('Material name cannot be empty or just spaces.', { variant: 'error' });
            return true;
          }
          return false;
        });
        
        if (hasInvalidProductName || hasInvalidServiceName || hasInvalidMaterialName) {
          // enqueueSnackbar('Product names must contain letters or numbers.', { variant: 'error' });
          return;
        }
        let user = JSON.parse(localStorage.getItem('user'));
        // const userType = userType;
        // const userId = userId;
        const userName = user.first_name;
        const clientsArray = values.clients ? [values.clients] : [];
        values.clientsData = clientsArray
        
        values.project_categories = values.project_type?.name == 'TS' ? (values.project_categories || null) : null
        values.map_service = (values.project_type?.name == 'TS' && (values.project_categories && values.project_categories?.id == 14)) ? values.map_service : null

        values.avatarUrl = avatarUrl
        const markupTotal = markupType == 1 ? (((values.totalWholesalePrice - values.totalProductFormula) / values.totalProductFormula) * 100)?.toFixed(2) : (((values.totalRetailPrice - values.totalProductFormula) / values.totalProductFormula) * 100)?.toFixed(2)
        values.totalMarkup = markupTotal
        values.products = selectedProducts
        // const allServices = [...selectedServices, ...additionalSelectedServices];
         const allServices = [
          ...selectedServices.map(s => ({ ...s, quantityDifference: 0 })),
          ...additionalSelectedServices
        ];
        values.selectedServices = allServices
        values.additionalSelectedServices = additionalSelectedServices
        const servicesIdArray = allServices?.map(service => service.id);
        values.sub_total = values.sub_total + selectedMaterialCost + selectedRfpProduct
        values.serviceData = servicesIdArray?.join(',')
        const requestData = {
          values,
          userId,
          taxCategory : selectedTaxCategory?.id,
          userType,isClient,
          userName,
          allLocationSame,
          salesRepName,
          salesRepId,
          allRfpServiceLocationSame : allRfpServiceLocationSame ,
          rfpProducts: cart,
          rfpServices: cartService,
          materials: selectedMaterials,
          produtFormulaMaterial:produtFormulaMaterial,
          collaborators: Array.isArray(collaborators) ? collaborators.map((c) => (typeof c === 'object' && c?.id != null ? c.id : c)).filter(Boolean).join(',') : (collaborators || ''),
          address: selectedProducts.reduce((acc, product) => {
            return [
              ...acc,
              ...product.addresses.map((address) => ({
                ...address,
                productId: product.id,
                productIndex: product.indexId,
              })),
            ];
          }, []),
        };
        console.log("######isvalidationNotOk", selectedProducts);
        const isvalidationNotOk = selectedProducts.find(product => {
          if (product.addresses.length && product.addresses.some(obj =>
            [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
          )) {
            return true
          } else {
            return false
          }
        })
        console.log("######isvalidationNotOk", isvalidationNotOk);
        console.log("######totalAmount", values.total);
        requestData.quotation = 1
        requestData.is_draft = saveAsDraftRef.current
        requestData.saveAsDraft = saveAsDraftRef.current
        saveAsDraftRef.current = false
        const isvalidationNotOkRfp = cart?.find(product => {
          console.log("Checking product:", product);

          if (product.addresses.length > 0 && product.addresses.some(obj =>
            [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
          )) {
            console.log("Validation failed for product:", product);
            return true;
          } else {
            console.log("Validation passed for product:", product);
            return false;
          }
        });
        if (isvalidationNotOk || isvalidationNotOkRfp) {
          enqueueSnackbar('Please fill all the address fields', { variant: 'error' });
        } else {
          console.log("values-------------", values)
          console.log('selectedRfp--------------', rfpServices)

          setProgressRequestData(requestData);
          setShowProgressModal(true);
          await new Promise(resolve => setTimeout(resolve, 1000));
          
          await axios.post(`${REST_API}webservice/request/add-request`, requestData)
          .then((res) => {
              setOpen(false);
              resetForm();
              setSelectedProducts([]);
              setSelectedMapserviceProducts([]);
              setSelectedTaxCategory(null);
              setSelectedServices([]);
              setAdditionalSelectedServices([])
              setFilteredServices([])
              setAvatarUrl([])
              setCollaborators([])
              setRfps([])
              setCart([])
              setCartService([])
              setSelectedMaterials([])
              setShowProgressModal(false);
              // localStorage.removeItem(QUOTATION_DRAFT_KEY);
              enqueueSnackbar('Create success', { variant: 'success' });
            })
            .catch((errors) => {
              console.log(errors, 'error');
              setShowProgressModal(false);
            });
        }
      } catch (error) {
        console.error(error);
      }
    }

  });
  let totalAmount = 0;
  let totalMarkup = 0;
  let totalProductFormula = 0;
  let totalWholesalePrice = 0;
  let totalRetailPrice = 0;
  let originaltotalMarkup = 0
  let originaltotalServiceMarkup = 0
  let totalServiceMarkup = 0;

  let totalDiscount = 0

  const {
    errors,
    values,
    touched,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    getFieldProps,
    setValues,
    resetForm,
    initialValues: formInitialValues,
  } = formik;

  const collaboratorOptions = useMemo(() => {
    const availableTeamMembers = Array.isArray(teamMembersOptions) ? teamMembersOptions : [];
    let filteredMembers = availableTeamMembers;
    const communitySalesRepIds = getCommunitySalesRepIds(values.community);

    if (values.community && communitySalesRepIds.length > 0) {
      const allowedIds = new Set(communitySalesRepIds.map((id) => String(id)));
      filteredMembers = availableTeamMembers.filter((member) => {
        const memberId = member?.id ?? member?.user_id;
        return memberId != null && allowedIds.has(String(memberId));
      });
    }

    if (collaborators?.length) {
      const filteredIds = new Set(
        filteredMembers.map((member) => String(member?.id ?? member?.user_id))
      );
      const missingSelections = collaborators.filter((member) => {
        const memberId = member?.id ?? member?.user_id;
        return memberId != null && !filteredIds.has(String(memberId));
      });
      if (missingSelections.length) {
        filteredMembers = [...filteredMembers, ...missingSelections];
      }
    }

    return filteredMembers;
  }, [teamMembersOptions, values.community, collaborators]);

  // Mark this estimate form as having unsaved changes
  const markUnsavedChanges = useCallback(() => {
    if (!open || hasUnsavedChanges) return;
    setHasUnsavedChanges(true);
  }, [open, hasUnsavedChanges]);

  // Generic form change handler (covers most inputs)
  const handleFormChange = () => {
    // markUnsavedChanges();
  };

  const buildDraftPayload = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    const userName = user?.first_name || '';
    const clientsArray = values.clients ? [values.clients] : [];
    values.clientsData = clientsArray
    const allServices = [
      ...selectedServices.map(s => ({ ...s, quantityDifference: 0 })),
      ...additionalSelectedServices
    ];
    const servicesIdArray = allServices?.map(service => service.id);
    const vals = {
      ...values,
      clientsData: clientsArray,
      project_categories: values.project_type?.name == 'TS' ? values.project_categories : null,
      map_service: (values.project_type?.name == 'TS' && values.project_categories?.id == 14) ? values.map_service : null,
      avatarUrl,
      products: selectedProducts,
      selectedServices: allServices,
      additionalSelectedServices,
      serviceData: servicesIdArray?.join(',') || '',
    };
    return {
      values: vals,
      userId: user?.user_id || user?.id,
      taxCategory: selectedTaxCategory?.id,
      userType: isClient ? 3 : user?.user_type,
      isClient,
      userName,
      allLocationSame,
      allRfpServiceLocationSame,
      rfpProducts: cart,
      rfpServices: cartService,
      materials: selectedMaterials,
      produtFormulaMaterial: produtFormulaMaterial || [],
      address: (selectedProducts || []).reduce((acc, product) => {
        const addrs = product?.addresses || [];
        return [...acc, ...addrs.map((address) => ({ ...address, productId: product.id, productIndex: product.indexId }))];
      }, []),
      quotation: 1,
      is_draft: true,
      saveAsDraft: true,
      draft_source: 1, // drafted from Estimate
    };
  };

  const handleSaveDraft = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    try {
      const requestData = buildDraftPayload();
      setProgressRequestData({ ...requestData, processType: 'draft' });
      setShowProgressModal(true);
      await new Promise(resolve => setTimeout(resolve, 1000));
      await axios.post(`${REST_API}webservice/request/add-request-draft`, requestData)
        .then((res) => {
          setOpen(false);
          resetForm();
          setSelectedProducts([]);
          setSelectedMapserviceProducts([]);
          setSelectedTaxCategory(null);
          setSelectedServices([]);
          setAdditionalSelectedServices([]);
          setFilteredServices([]);
          setAvatarUrl([]);
          setRfps([]);
          setCart([]);
          setCartService([]);
          setSelectedMaterials([]);
          localStorage.removeItem(QUOTATION_DRAFT_KEY);
          enqueueSnackbar('Draft saved', { variant: 'success' });
          setShowProgressModal(false);
          setHasUnsavedChanges(false);
        })
        .catch((err) => {
          console.log(err, 'error');
          setShowProgressModal(false);
          enqueueSnackbar('Failed to save draft', { variant: 'error' });
        });
    } catch (error) {
      console.error(error);
      setShowProgressModal(false);
    }
  };

  useEffect(() => {
    if (!open) return;
    const raw = localStorage.getItem(QUOTATION_DRAFT_KEY);
    if (!raw) return;
    try {
      const data = JSON.parse(raw);

      // Compare draft values to the original initial values.
      // If they are different, it means the user actually changed something.
      const baselineValues = formInitialValues || {};
      const draftValues = data.values || {};

      const deepEqual = (a, b) => {
        if (a === b) return true;
        if (typeof a !== typeof b) return false;
        if (a == null || b == null) return false;

        if (Array.isArray(a) && Array.isArray(b)) {
          if (a.length !== b.length) return false;
          for (let i = 0; i < a.length; i += 1) {
            if (!deepEqual(a[i], b[i])) return false;
          }
          return true;
        }

        if (typeof a === 'object') {
          const aKeys = Object.keys(a);
          const bKeys = Object.keys(b);
          if (aKeys.length !== bKeys.length) return false;
          for (const key of aKeys) {
            if (!deepEqual(a[key], b[key])) return false;
          }
          return true;
        }

        return false;
      };

      if (data.values) setValues(data.values);
      if (Array.isArray(data.selectedProducts)) setSelectedProducts(data.selectedProducts);
      if (Array.isArray(data.cart)) setCart(data.cart);
      if (Array.isArray(data.cartService)) setCartService(data.cartService);
      if (Array.isArray(data.selectedMaterials)) setSelectedMaterials(data.selectedMaterials);
      if (Array.isArray(data.avatarUrl)) setAvatarUrl(data.avatarUrl);
      if (data.selectedTaxCategory != null) setSelectedTaxCategory(data.selectedTaxCategory);
      if (data.allLocationSame != null) setAllLocationSame(data.allLocationSame);
      if (data.allRfpServiceLocationSame != null) setAllRfpServiceLocationSame(data.allRfpServiceLocationSame);

      const isSameAsInitial = deepEqual(draftValues, baselineValues);

      // Consider draft "meaningful" if it has any products / proposals / services / materials / attachments
      const hasAnyDraftCollections =
        (Array.isArray(data.selectedProducts) && data.selectedProducts.length > 0) ||
        (Array.isArray(data.cart) && data.cart.length > 0) ||
        (Array.isArray(data.cartService) && data.cartService.length > 0) ||
        (Array.isArray(data.selectedMaterials) && data.selectedMaterials.length > 0) ||
        (Array.isArray(data.avatarUrl) && data.avatarUrl.length > 0) ||
        (Array.isArray(data.values?.selectedServices) && data.values.selectedServices.length > 0) ||
        (Array.isArray(data.values?.services) && data.values.services.length > 0) ||
        (Array.isArray(data.values?.additionalSelectedServices) && data.values.additionalSelectedServices.length > 0);

      // Also treat edits to primary header fields as "meaningful" (name, description, client/project, job, dates, etc.)
      // For dates: default is "today". We only treat them as meaningful when they
      // differ from the *current* date, so keeping them on today does NOT trigger
      // a "Draft restored" snackbar by itself.
      const isStartEdited =
        typeof draftValues?.start === 'number' &&
        !moment.unix(draftValues.start).isSame(moment(), 'day');
      const isEndEdited =
        typeof draftValues?.end === 'number' &&
        !moment.unix(draftValues.end).isSame(moment(), 'day');

      const hasAnyHeaderFieldEdits =
        Boolean(draftValues?.name) ||
        Boolean(draftValues?.description) ||
        Boolean(draftValues?.clients) ||
        Boolean(draftValues?.community) ||
        Boolean(draftValues?.project_type) ||
        Boolean(draftValues?.project_categories) ||
        Boolean(draftValues?.map_service) ||
        isStartEdited ||
        isEndEdited ||
        Boolean(draftValues?.installation_start_date) ||
        Boolean(draftValues?.installation_end_date) ||
        Boolean(draftValues?.notes) ||
        (draftValues?.invoice_discount !== null &&
         draftValues?.invoice_discount !== undefined &&
         draftValues?.invoice_discount !== '') ||
        // Boolean flags: treat as meaningful when they differ from baseline,
        // even if the restored value is false.
        (typeof draftValues?.client_approve === 'boolean' &&
         draftValues.client_approve !== baselineValues.client_approve) ||
        (typeof draftValues?.welcome_message === 'boolean' &&
         draftValues.welcome_message !== baselineValues.welcome_message) ||
        Boolean(draftValues?.subject) ||
        Boolean(draftValues?.email_content);

      const hasAnyMeaningfulDraftData = hasAnyDraftCollections || hasAnyHeaderFieldEdits;

      // Show snackbar only when there is actual draft data (including services / header fields) AND it differs from the initial form
      if (!isSameAsInitial && hasAnyMeaningfulDraftData) {
        enqueueSnackbar('Draft restored', { variant: 'info' });
      }
    } catch (e) {
      console.warn('Failed to restore draft', e);
    }
  }, [open, formInitialValues]);

  useEffect(() => {
    if (!open) return;
    const state = { draftOpen: true };
    window.history.pushState(state, '');
    const onPopState = () => {
      // Only prompt / save when there are unsaved changes
      // if (hasUnsavedChanges) {
      //   setOpenBackConfirm(true);
      // } else {
        handleCancelAction();
      // }
    };
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const onBeforeUnload = () => {
      try {
        if (latestDraftRef.current) {
          localStorage.setItem(QUOTATION_DRAFT_KEY, JSON.stringify(latestDraftRef.current));
        }
      } catch (e) {}
    };
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, [open]);

  useEffect(() => {
    setPreview(values)
  }, [openPreview])
  const selectedProductsTotalDiscount = selectedProducts?.reduce((total, data, index) => {
    const quantityFieldName = `quantity_${index}`;
    const discountFieldName = `discount_${index}`;
    // const quantityVal = values[quantityFieldName] ? values[quantityFieldName] : 1
    const discountVal = values[discountFieldName] ? values[discountFieldName] : 0
    const quantityVal = data.quantity ? Number(data.quantity) : 1
    
    // Calculate product subtotal (same as Product Total calculation in table)
    const locQty = Number(data?.locationQuantity) || 1
    const productSubTotal =
      markupType == 1
        ? (Number(data?.price) || 0) * locQty
        : markupType == 2
        ? (Number(data?.actual_retail_price || data?.retail_price || 0)) * locQty
        : 0
    
    // Calculate install subtotal (same as Install Subtotal calculation in table)
    const installQty = Number(data?.install_quantity) || 1
    const installSubTotal =
      (Number(data?.install_cost) || 0) *
      installQty

    // Product Total is the sum of both subtotals minus discount (same as table calculation)
    const productTotal = Math.max(
      0,
      productSubTotal + installSubTotal - discountVal,
    )
    const fixedProductTotal = parseFloat(productTotal).toFixed(2);
    return total + parseFloat(fixedProductTotal);
  }, 0);

  const selectedProductsTotalDiscountForJobCost = selectedProducts?.reduce((total, data, index) => {
    const quantityFieldName = `quantity_${index}`;
    const discountFieldName = `discount_${index}`;
    // const quantityVal = values[quantityFieldName] ? values[quantityFieldName] : 1
    const quantityVal = data.quantity ? Number(data.quantity) : 1
    const discountVal = values[discountFieldName] ? values[discountFieldName] : 0
    console.log("#########DATAJobcost", data);
    const productTotal = calculateTotal(parseFloat(data.expected_material_cost), quantityVal, 0, data.locationQuantity,data.adjustment,data.markAdjType,data.adj_value_type);
    // const productTotal = calculateTotal(data.expected_material_cost, quantityVal, discountVal); 
    console.log("#####################ProductTotal", productTotal);
    return total + parseFloat(productTotal);
  }, 0);

  // const allServices = [...selectedServices, ...additionalSelectedServices];
  const allServices = [ ...additionalSelectedServices];
  let selectedServicesCost = allServices?.reduce((total, service, index) => { //allServices
    const quantityFieldName = `service_quantity_${index}`;
    const quantityVal = values[quantityFieldName] ? values[quantityFieldName] : 1
    console.log("#######Service Total-------", service.quantity);
    const serviceTotal = calculateTotal(service.cost, Number(service.quantity), 0, 1);
    console.log("#######Service Total-------", serviceTotal);
    return total + parseFloat(serviceTotal?.toFixed(2));
  }, 0);
  const selectedServicesTotalCost = allServices?.reduce((total, service, index) => {
    const quantityFieldName = `service_quantity_${index}`;
    const quantityVal = values[quantityFieldName] ? values[quantityFieldName] : 1
    console.log("###########service?.locationQuantity", service?.locationQuantity);
    const serviceTotal = calculateTotal(service?.total_cost, service?.quantity, 0, 1);
    console.log("###########service", service);
    console.log("###########serviceTotal", serviceTotal);
    // return total + Number(service?.total);
    return total + parseFloat(Number(serviceTotal)?.toFixed(2));
  }, 0);
  const InitialServiceCostInProductFormula =0
  //  selectedProducts?.reduce((total, data, index) => {
  //   const serviceTotal = (data?.quantity) * parseFloat(data?.expected_total_service_cost?.toFixed(2)) * (data?.locationQuantity || 1);
  //   return total + parseFloat(Number(serviceTotal)?.toFixed(2));
  // }, 0);
  const InitialServiceCostforJobcost = selectedProducts?.reduce((total, data, index) => {
    const totalServiceCost = (data?.quantity) * parseFloat(data?.expected_service_cost?.toFixed(2)) * (data?.locationQuantity || 1)
    return total + parseFloat(Number(totalServiceCost)?.toFixed(2));
  }, 0);
  // selectedServicesCost = selectedServicesCost - InitialServiceCostforJobcost
  const selectedServicesSubTotal = selectedServicesTotalCost - InitialServiceCostInProductFormula
  values['labour_cost'] = selectedServicesSubTotal // selectedServicesCost
  const RFQSubTotal = (selectedProductsTotalDiscount + selectedServicesTotalCost) - (values['invoice_discount'] ? values['invoice_discount'] : 0)

  console.log('InitialServiceCostforJobcost-------', InitialServiceCostforJobcost);
  console.log('InitialServiceCostInProductFormula-------', InitialServiceCostInProductFormula);
  console.log('selectedServicesCost--------hhhh', selectedServicesCost);
  console.log('selectedServicesTotalCost-------', selectedServicesTotalCost);
  console.log('selectedServicesSubTotal-------', selectedServicesSubTotal);
  // console.log('InitialServiceCostInProductFormula-------',InitialServiceCostInProductFormula);
  console.log('selectedProductsTotalDiscountForJobCost111-------', selectedProductsTotalDiscountForJobCost);
  console.log('selectedProductsTotalDiscount-------', selectedProductsTotalDiscount);
  const calculateProductTotal = (price, markup, quantity, location = 1) => {
    return parseFloat((price + price * (markup / 100))?.toFixed(2)) * quantity * location;
  };

  const calculateJobCostTotal = (price, quantity, location = 1) => {
    console.log('calculateJobCostTotal-price----------', price);
    console.log('calculateJobCostTotal-quantity----------', quantity);
    console.log('calculateJobCostTotal-location----------', location);
    return price * quantity * location;
  };

  const getProductMarkup = (data, markupType) => {
    if (markupType) {
      return markupType === 1 ? data.WholesaleMarkup || data.product_markup : data.RetailMarkup || data.product_markup;
    }
    return 0;
  };

  const selectedRfpProduct = useMemo(() => {
    return cart?.reduce((total, data) => {
      const markup = getProductMarkup(data, markupType);
      let productTotal = calculateProductTotal(data.product_price, markup, data.quantity, data.location_quantity);
      productTotal = parseFloat(productTotal.toFixed(2));
      console.log("#####################ProductTotal", productTotal);
      console.log("#####################data", data);
      console.log("#####################markup", markup);
      return total + productTotal;
    }, 0);
  }, [cart, markupType]);

  const selectedRfpServices = useMemo(() => {
    return cartService?.reduce((total, data) => {
      let productTotal = calculateProductTotal(data.sellingPrice, data.originalMarkup, data.qty);
      productTotal = parseFloat(productTotal.toFixed(2));
      return total + productTotal;
    }, 0);
  }, [cartService]);
    const selectedNonTaxRfpServices = useMemo(() => {
    return cartService?.reduce((total, data) => {
      if (data?.taxable === 0) return total;
      let productTotal = calculateProductTotal(data.sellingPrice, data.originalMarkup, data.qty);
      productTotal = parseFloat(productTotal.toFixed(2));
      return total + productTotal;
    }, 0);
  }, [cartService]);
  console.log("#####################selectedRfpProduct", selectedRfpProduct);
  console.log("#####################selectedRfpServices", selectedRfpServices);
  const selectedRfpServicesForJobCost = useMemo(() => {
    return cartService?.reduce((total, data) => {
      let productTotal = calculateJobCostTotal(data.sellingPrice, data.qty);
      productTotal = parseFloat(productTotal.toFixed(2));
      return total + productTotal;
    }, 0);
  }, [cartService]);

  const selectedRfpProductJobCost = useMemo(() => {
    return cart?.reduce((total, data) => {
      let productTotal = calculateJobCostTotal(data.product_price, data.quantity, data.location_quantity);
      productTotal = parseFloat(productTotal.toFixed(2));
      return total + productTotal;
    }, 0);
  }, [cart]);

    useEffect(()=>{
      const productMaterial = selectedProducts?.reduce((materials, product) => {
        if (product.materials && product.materials.length > 0) {
          return materials.concat(
            product.materials
              .map((material) => {
                console.log('materialsssssss',material)
                const price = parseFloat(material.max_unit_cost || 0);
                const quantity = parseFloat(material.quantity || 1);
                const retail_price = parseFloat(material.retail_price || 0);
  
                const subtotal = price * quantity;
                const markup = (subtotal * retail_price) / 100;
                const total = (subtotal + markup) * (product.locationQuantity || 1)
  
                console.log('✅ total, subtotal, markup:', total, subtotal, markup);
                console.log('✅ price, quantity, retail_price:', price, quantity, retail_price);
  
                return {
                  ...material,
                  totalCost: total.toFixed(2),
                };
              })
          );
        }
        return materials;
      }, []);

      setProductFormulaMaterial(productMaterial)
  
      const getTotalCostSum = (productMaterial) => {
        return productMaterial.reduce((sum, item) => {
                  console.log('itemmmmmm',item)
          // Only include if taxable == 0 (string or number)
          if (Number(item.taxable) !== 0) return sum;
  
          const cost = parseFloat(item.totalCost || 0);
          return sum + cost;
        }, 0).toFixed(2);
      };
  
      const totalCostSum = getTotalCostSum(productMaterial);
      setTotalMinusMaterialTax(totalCostSum)
      console.log('🧾 Total cost sum of all materials:', totalCostSum);
      // const productServices = selectedProducts?.reduce((services, product) => {
      //   if (product.services?.length > 0) {
      //     return services.concat(
      //       product.services.map((service) => {
      //         const cost = parseFloat(service.unit_cost ?? service.total_cost ?? 0);
      //         const quantity = parseFloat(service.quantity ?? 1);
      //         const retail_price = parseFloat(service.retail_price ?? 0);
      //         const locationQty = parseFloat(product.locationQuantity ?? 1);

      //         const subtotal = cost * quantity;
      //         const markup = (subtotal * retail_price) / 100;
      //         const total = (subtotal + markup) * locationQty;

      //         return {
      //           ...service,
      //           totalCost: total.toFixed(2),
      //         };
      //       })
      //     );
      //   }
      //   return services;
      // }, []);
    //   const installCost = selectedProducts?.map((product) => {
    //     const retailPrice = parseFloat(product.install_cost || 0);
    //     const locationQuantity = parseFloat(product.locationQuantity || 1);
    //     const total = retailPrice * locationQuantity;

    //     return {
    //       ...product,
    //       totalCost: total.toFixed(2),
    //     };
    //   });
    //   console.log('productServicesproductServices', installCost)
    //   const getTotalServiceCostSum = (services) => {
    //     return parseFloat(
    //       services.reduce((sum, item) => {
    //         console.log('itemservices', item);
    //         if (item.id !== 10) return sum;
    //         const cost = parseFloat(item.totalCost ?? 0);
    //         return sum + cost;
    //       }, 0).toFixed(2)
    //     );
    //   };
    // const totalInstallServiceCostSum = getTotalServiceCostSum(productServices);
    // setTotalProductInstallCost(totalInstallServiceCostSum)
        const installCost = selectedProducts?.map((product) => {
      const retailPrice = parseFloat(product.install_cost  || 0);
      const locationQuantity = parseFloat(product.locationQuantity || 1);

      const total = retailPrice * locationQuantity;

      return {
        ...product,
        totalCost: total.toFixed(2),
      };
    });

    console.log('🧾 installCost', installCost);

    const getTotalInstallCostSum = (installCost = []) => {
      return installCost.reduce((sum, item) => {
        const cost = parseFloat(item.totalCost || 0);
        return sum + cost;
      }, 0).toFixed(2);
    };

    const totalInstallCostSum = getTotalInstallCostSum(installCost);
    console.log('🧾 Total cost production costtt', totalInstallCostSum);
    setInstallCost(totalInstallCostSum)
    },[selectedProducts])

  // Browser back button interception for auto-save (only when form is open)
  useEffect(() => {
    if (!open) return; // Only intercept when form is open

    const handlePopState = (event) => {
      event.preventDefault();
      setOpenBackConfirm(true);
      // Push a dummy state to prevent immediate navigation
      window.history.pushState(null, '', window.location.href);
    };

    // Push initial state for back button interception
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [open]);

  const selectedMaterialCostJobCost = useMemo(() => {
    return selectedMaterials?.reduce((total, data) => {
      console.log("########SElectedmaterial-jobcost", data);
      let productTotal = data.price * (data.quantity || 0);
      // let productTotal = calculateJobCostTotal(data.price, data.quantity||1);
      console.log("########SElectedmaterial-jobcost-productTotal", productTotal);
      productTotal = parseFloat(productTotal.toFixed(2));
      return total + productTotal;
    }, 0);
  }, [selectedMaterials]);

  const selectedMaterialCost = useMemo(() => {
    return selectedMaterials?.reduce((total, data) => {
      console.log("########SElectedmaterial-totalsum", data);
      let markUpCost = data.price + ((parseFloat(data.price) * parseFloat(data.markup || 0)) / 100)
      markUpCost = parseFloat(parseFloat(markUpCost).toFixed(2)) || 0;
      let adjustment = data.adj_value_type ? Number(data.adjustment || 0) : -Number(data.adjustment || 0);
      let productTotal = (markUpCost + adjustment) * (data.quantity || 0);
      // let productTotal = calculateJobCostTotal(data.markUpCost, data.quantity||1);
      console.log("########SElectedmaterial-totalsum-markUpCost", markUpCost);
      console.log("########SElectedmaterial-totalsum-productTotal", productTotal);
      productTotal = parseFloat(productTotal.toFixed(2));
      return total + productTotal;
    }, 0);
  }, [selectedMaterials,refreshCalculation]);

  const selectedNonTaxMaterialCost = useMemo(() => {
    return selectedMaterials?.reduce((total, data) => {
      if (data?.taxable === 0) return total;
      let markUpCost = data.price + ((parseFloat(data.price) * parseFloat(data.markup || 0)) / 100)
      markUpCost = parseFloat(parseFloat(markUpCost).toFixed(2)) || 0;
      let productTotal = markUpCost * (data.quantity || 0);
      // let productTotal = calculateJobCostTotal(data.markUpCost, data.quantity||1);
      console.log("########SElectedmaterial-totalsum-markUpCost", markUpCost);
      console.log("########SElectedmaterial-totalsum-productTotal", productTotal);
      productTotal = parseFloat(productTotal.toFixed(2));
      return total + productTotal;
    }, 0);
  }, [selectedMaterials]);
  console.log('selectedMaterials-useMemo-----------', selectedMaterials);
  console.log('selectedMaterialCost-useMemo-----------', selectedMaterialCost);

  values['labour_cost'] = selectedServicesSubTotal + selectedRfpServices
  // const totalsum = (selectedProductsTotalDiscount + selectedServicesSubTotal) - parseFloat(values['invoice_discount'] || 0);
  // const totalJobcostSum = (selectedProductsTotalDiscountForJobCost + selectedServicesCost);
  const totalsum = useMemo(() => {
    return (selectedProductsTotalDiscount + selectedServicesSubTotal + selectedMaterialCost + selectedRfpProduct + selectedRfpServices + totalProductInstallCost) - parseFloat(values['invoice_discount'] || 0);
  }, [selectedProductsTotalDiscount, selectedServicesSubTotal, selectedMaterialCost, selectedRfpProduct, selectedRfpServices,totalProductInstallCost, values['invoice_discount']]);
  
  // New Tax calculation
  const selectedServicesTaxTotalCost = allServices?.reduce((total, service, index) => {
  // Skip services that are not taxable
    if (service?.taxable === 0) return total;

    const quantityFieldName = `service_quantity_${index}`;
    const quantityVal = values[quantityFieldName] ? values[quantityFieldName] : 1;

    console.log("###########service?.locationQuantity", service?.locationQuantity);
    const serviceTotal = calculateTotal(service?.total_cost, service?.quantity, 0, 1);
    console.log("###########service", service);
    console.log("###########serviceTotal", serviceTotal);

    return total + parseFloat(Number(serviceTotal)?.toFixed(2));
  }, 0);

  const selectedTaxServicesSubTotal = selectedServicesTaxTotalCost - InitialServiceCostInProductFormula
  const newTaxTotalsum = useMemo(() => {
    return (selectedProductsTotalDiscount + selectedTaxServicesSubTotal + selectedNonTaxMaterialCost + selectedRfpProduct + selectedNonTaxRfpServices) - parseFloat(values['invoice_discount'] || 0) - parseFloat(totalMinusMaterialTax || 0);
  }, [selectedProductsTotalDiscount, selectedTaxServicesSubTotal, selectedNonTaxMaterialCost, selectedRfpProduct, selectedNonTaxRfpServices,totalMinusMaterialTax, values['invoice_discount']]);
  

  const taxAmount = 0 // selectedTaxCategory ? (selectedTaxCategory.type === 1 ? (totalsum * (selectedTaxCategory.value || 0) / 100) : (selectedTaxCategory.value || 0) ) : 0;
  const newFixedTaxAmount = selectedTaxCategory ? (selectedTaxCategory.type === 1 ? (newTaxTotalsum * (selectedTaxCategory.value || 0) / 100) : (selectedTaxCategory.value || 0) ) : 0;
  const newTaxAmount = parseFloat(parseFloat(newFixedTaxAmount).toFixed(2))
  console.log('taxAmounttttt old',taxAmount)
  console.log('taxAmounttttt new',newTaxAmount)
  const grandTotal =  (parseFloat(totalsum) + parseFloat(taxAmount)).toFixed(2); //old tax
  // const grandTotal =  (parseFloat(totalsum) + parseFloat(newTaxAmount)).toFixed(2); // new tax

  const totalJobcostSum = useMemo(() => {
    return (selectedProductsTotalDiscountForJobCost + selectedServicesCost + selectedMaterialCostJobCost + selectedRfpProductJobCost + selectedRfpServicesForJobCost);
  }, [selectedProductsTotalDiscountForJobCost, selectedServicesCost, selectedMaterialCostJobCost, selectedRfpProductJobCost, selectedRfpServicesForJobCost]);

  console.log("Budget---------------", totalJobcostSum)
  values['total'] = totalsum
  values['taxAmount'] = taxAmount
  values['budget'] = totalJobcostSum
  //discount count
  const selectedProductDiscount = selectedProducts?.reduce((acc, data, index) => {
    // const discountFieldName = `discount_${index}`;
    // const discountVal = values[discountFieldName] ? values[discountFieldName] : 0
    const discountVal = data.discount ? data.discount : 0
    let productDiscount = +discountVal || 0;
    return acc + productDiscount;
  }, 0);

  const DiscountTotal = selectedProductDiscount + (parseFloat(values['invoice_discount']) || 0);

  // const handleDrop = useCallback(
  //     (acceptedFiles) => {
  //       let permission =!explodedPermissions?.some((permission) => ['Upload Files Sales Order'].includes(permission))
  //       if(permission &&  user?.added_by_client ==1){
  //         return   enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
  //       }
  //       if (acceptedFiles && acceptedFiles.length > 0) {
  //         setIsUploading(true);
  //         const uploadPromises = acceptedFiles?.map((file) => {
  //           return new Promise((resolve, reject) => {
  //             const Filename = new Date().getTime() + file.name;
  //             const StorageRef = ref(storage, Filename);
  //             const uploadTask = uploadBytesResumable(StorageRef, file);
  
  //             uploadTask.on(
  //               'state_changed',
  //               (snapshot) => {
  //                 const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
  //                 setProgress(progress);
  //               },
  //               (error) => {
  //                 console.error(error.message);
  //                 setIsUploading(false);
  //                 reject(error);
  //               },
  //               () => {
  //                 getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
  //                   resolve({
  //                     url: downloadURL,
  //                     file_type: file.type,
  //                     extension: file.name.split('.').pop(),
  //                     size: file.size
  //                   });
  //                 });
  //               }
  //             );
  //           });
  //         });
  
  //         Promise.all(uploadPromises)
  //           .then((downloadURLs) => {
  //             setAvatarUrl((prevAvatarUrls) => {
  //               const updatedFiles = downloadURLs.map((file) => ({
  //                 url: file.url,
  //                 file_type: file.file_type,
  //                 extension: file.extension,
  //                 size: file.size
  //               }));
  //               return [...prevAvatarUrls, ...updatedFiles]
  //             });
  //             setIsUploading(false);
  //           })
  //           .catch((error) => {
  //             console.error(error.message);
  //             setIsUploading(false);
  //           });
  //       }
  //     },
  //     [setFieldValue]
  //   );

  const handleDrop = useCallback(
    async (acceptedFiles) => {
      // ───────────────── permission gate ─────────────────
      const noPermission = !explodedPermissions?.some(
        (p) => p === 'Upload Files Sales Order'
      );
      if (noPermission && user?.added_by_client === 1) {
        enqueueSnackbar('Access Denied: You do not have sufficient permissions', {
          variant: 'error'
        });
        return;
      }
      // ───────────────────────────────────────────────────
      if (!acceptedFiles || acceptedFiles.length === 0) return;

      setIsUploading(true);

      try {
        const uploadPromises = acceptedFiles.map(async (file) => {
          const timestamp = Date.now();
          // This removes all #, %, &, + and other dangerous URL characters
const sanitizedName = file.name.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9.\-_]/g, '');;
          const fileName = `${timestamp}_${sanitizedName}`;
          const filePath = `estimate/attachments/${fileName}`;   // 🔑 folder

          // upload
          const { error: uploadError } = await supabase.storage
            .from('signwise-attachments')
            .upload(filePath, file);

          if (uploadError) throw uploadError;

          // mark progress as complete for this file
          setProgress(100);

          // public URL
          const { data: publicUrlData, error: urlError } = supabase.storage
            .from('signwise-attachments')
            .getPublicUrl(filePath);

          if (urlError || !publicUrlData?.publicUrl) {
            throw new Error('Failed to get public URL');
          }

          return {
            url: publicUrlData.publicUrl,
            file_type: file.type,
            extension: file.name.split('.').pop(),
            size: file.size
          };
        });

        const uploadedFiles = await Promise.all(uploadPromises);

        // update state
        setAvatarUrl((prev) => [...prev, ...uploadedFiles]);
        // mark form as having unsaved changes
        // markUnsavedChanges();
      } catch (err) {
        console.error('Upload error:', err.message);
        enqueueSnackbar('Upload failed: ' + err.message, { variant: 'error' });
      } finally {
        setIsUploading(false);
        setProgress(null);
      }
    },
    [explodedPermissions, user, setAvatarUrl, setIsUploading, setProgress]
  );

  const handleRemoveAll = () => {
    setAvatarUrl([]);
    // removing files is also a meaningful edit
    // markUnsavedChanges();
  };
  //  console.log({avatarUrl},'--------avt')
  const handleRemove = (file) => {
    // console.log(file, '--------file');
    const filteredItems = avatarUrl.filter((_file) => _file !== file);
    setAvatarUrl(filteredItems);
    // file removal should mark the form as dirty
    // markUnsavedChanges();
  };

  const handleCancel = async () => {
    setOpenBackConfirm(true);
  }

  // Auto-save confirmation dialog handlers
  const handleBackConfirmYes = async () => {
    setOpenBackConfirm(false);
    // If nothing has changed, just cancel without saving
    // if (!hasUnsavedChanges) {
    //   handleCancelAction();
    //   return;
    // }
    try {
      await formik.submitForm();
      // Navigation will happen in onSubmit success handler
    } catch (error) {
      console.error('Auto-save failed:', error);
      // Still proceed with cancel on error
      handleCancelAction();
    }
  };

  const handleBackConfirmNo = () => {
    setOpenBackConfirm(false);
    handleCancelAction();
  };

  const handleCancelAction = () => {
    // If the current estimate is effectively blank (only default values, no products/services/materials/files/etc.),
    // then remove any saved draft from localStorage on cancel.
    try {
      const deepEqual = (a, b) => {
        if (a === b) return true;
        if (typeof a !== typeof b) return false;
        if (a == null || b == null) return false;

        if (Array.isArray(a) && Array.isArray(b)) {
          if (a.length !== b.length) return false;
          for (let i = 0; i < a.length; i += 1) {
            if (!deepEqual(a[i], b[i])) return false;
          }
          return true;
        }

        if (typeof a === 'object') {
          const aKeys = Object.keys(a);
          const bKeys = Object.keys(b);
          if (aKeys.length !== bKeys.length) return false;
          for (const key of aKeys) {
            if (!deepEqual(a[key], b[key])) return false;
          }
          return true;
        }

        return false;
      };

      // Only consider user-editable fields; ignore calculated totals etc.
      const pickEditableValues = (vals) => {
        const v = vals || {};
        const keys = [
          'name',
          'description',
          'notes',
          'clients',
          'start',
          'end',
          'installation_start_date',
          'installation_end_date',
          'products',
          'services',
          'additionalMaterials',
          'invoice_discount',
          'welcome_message',
          'draft',
          'client_approve',
          'subject',
          'email_content',
          'project_categories',
          'project_type',
          'markup_type',
          'map_service',
          'community',
          'rfp',
          'split_catalog_type',
          'modifiedServices',
        ];
        const result = {};
        keys.forEach((k) => {
          if (Object.prototype.hasOwnProperty.call(v, k)) {
            result[k] = v[k];
          }
        });
        return result;
      };

      const baselineSnapshot = {
        values: pickEditableValues(formInitialValues || {}),
        selectedProducts: [],
        cart: [],
        cartService: [],
        selectedMaterials: [],
        avatarUrl: [],
      };

      const currentSnapshot = {
        values: pickEditableValues(values || {}),
        selectedProducts: selectedProducts || [],
        cart: cart || [],
        cartService: cartService || [],
        selectedMaterials: selectedMaterials || [],
        avatarUrl: avatarUrl || [],
      };

      const isEffectivelyBlank = deepEqual(currentSnapshot, baselineSnapshot);
      console.log("isEffectivelyBlank",isEffectivelyBlank)
      if (isEffectivelyBlank) {
        localStorage.removeItem(QUOTATION_DRAFT_KEY);
      }
    } catch (e) {
      console.warn('Failed to check blank estimate on cancel', e);
    }

    setOpen(false);
    setHasUnsavedChanges(false);
    formik.resetForm();
    setSelectedProducts([]);
    setSelectedMapserviceProducts([]);
    setSelectedServices([]);
    setAdditionalSelectedServices([])
    setSelectedMaterials([]);
    setSelectedRfp(null);
    setFilteredServices([])
    setAllLocationSame(false)
    setShowAddNewRow(false)
    setAvatarUrl([])
    setRfps([])
    setCart([])
    setCartService([])
    setCollaborators([])
  }

  const handleAllRfpProductsLocationSameChange = (productIndex) => {
    setCart(prevProducts => 
      prevProducts.map((product, index) => {
        if (index === productIndex) {
          const isAllSame = !product?.allRfpProductsLocationSame;
  
          // Ensure there's at least one service and its location array is valid
          const commonAddress = product?.addresses?.[0] || {
            address: '',
            city: '',
            state: '',
            zip: '',
          };
  
          console.log("Common Address being applied:", commonAddress);
  
          return {
            ...product,
            allRfpProductsLocationSame: isAllSame,
            addresses: product.addresses ? product.addresses.map(() => ({ ...commonAddress })) : [{ ...commonAddress }]
          };
        }
        return product; // Keep other products unchanged
      })
    );
  };

    
  const handleAllRfpServiceLocationSameChange = () => {
      
    if (!allRfpServiceLocationSame) {
      // Ensure there's at least one service and its location array is valid
      const commonAddress = cartService[0]?.addresses?.[0] || {
        address: '',
        city: '',
        state: '',
        zip: '',
      };
  
      console.log("Common Address being applied:", commonAddress);
  
      // Update all locations to use the commonAddress
      setCartService(prevProducts =>
        prevProducts.map(product => ({
          ...product,
          addresses: product.addresses ? product.addresses.map(() => ({ ...commonAddress })) : [{ ...commonAddress }],
        }))
      );
      setAllRfpServiceLocationSame(true);

    }else{

      setAllRfpServiceLocationSame(false);
    }
  
  };

  const handleChangeTab = async (event, newValue) => {
      // Cancel all active requests when switching tabs
      cancelAllGlobalRequests(`Tab switch to ${newValue}`);
      
      setLoadingCards(true)
      setSkipFetch(true)
      setCurrentTab(newValue)
      setSearching('')
      setFilterDateValue([null, null])
      // setSalesOrderName('')
      // setSalesOrderId('')
      let newPage = 0
      setPage(0)

    if (newValue == 'NEW') {
      let user = JSON.parse(localStorage.getItem('user'))
    
      const where = `(r.status = 8 and r.quotation_status = 2 and r.hold = 0)`

      const values = {
        userType: userType,isClient, userId: userId, page: newPage + 1, rowsPerPage,where , search: searching , filterClient, filterUser, dueData, filterProjectType, filterCommunity
      }
      await axios.post(`${REST_API}webservice/request/get-all-quotations-cards`, values)
        .then((res) => {
          res.data.data
          setAllRequest(res.data.data.data)
          if (res?.data?.data?.totalCount) {
            setTotalCount(res?.data?.data?.totalCount)
          } else {
            setTotalCount(0)
          }
          setRequestTeam(res.data.requestTeam)
          setSkillServices(res.data.services)
          setWorkFlow(res.data.workflows)
          setAllproducts(res.data.products)
          setLabourCostServices(res.data.labourCostServices)
          setFilteredServices(res.data.labourCostServices)
          const othersCommunity = { id: 'other', name: 'Others' };
          const othersClient = { id: 'other', name: 'Others' };
          if (res.data?.community) {
            setCommunitiesData([...res.data.community, othersCommunity]);
          } else {
            console.log('no community data')
            // setCommunitiesData([othersCommunity]);
          }
          if (res.data?.clients) {
            setClientData([...res.data.clients]);
          } else {
            // setClientData([]);
            console.log('no client data')
          }
          setLoadingCards(false)
        })
        .catch((errors) => {
          if (axios.isCancel(errors)) {
            console.log('NEW tab request cancelled');
            return;
          }
          console.log(errors, 'error in fetching all requests')
        })
    }
    else if (newValue == 'IN QUEUE') {
      let user = JSON.parse(localStorage.getItem('user'))
    
      const where = `(r.status = 8 and r.quotation_status = 3 and est_prj.status = 1 and r.hold = 0)`

      const values = {
        userType: userType,isClient, userId: userId, page: newPage + 1, rowsPerPage,where , search: searching , filterClient, filterUser, dueData, filterProjectType, filterCommunity
      }
      await axios.post(`${REST_API}webservice/request/get-all-quotations-cards`, values)
        .then((res) => {
          res.data.data
          setAllRequest(res.data.data.data)
          if (res?.data?.data?.totalCount) {
            setTotalCount(res?.data?.data?.totalCount)
          } else {
            setTotalCount(0)
          }
          setRequestTeam(res.data.requestTeam)
          setSkillServices(res.data.services)
          setWorkFlow(res.data.workflows)
          setAllproducts(res.data.products)
          setLabourCostServices(res.data.labourCostServices)
          setFilteredServices(res.data.labourCostServices)
          const othersCommunity = { id: 'other', name: 'Others' };
          const othersClient = { id: 'other', name: 'Others' };
          if (res.data?.community) {
            setCommunitiesData([...res.data.community, othersCommunity]);
          } else {
            console.log('no community data')
            // setCommunitiesData([othersCommunity]);
          }
          if (res.data?.clients) {
            setClientData([...res.data.clients]);
          } else {
            // setClientData([]);
            console.log('no client data')
          }
          setLoadingCards(false)
        })
        .catch((errors) => {
          if (axios.isCancel(errors)) {
            console.log('IN QUEUE tab request cancelled');
            return;
          }
          console.log(errors, 'error in fetching all requests')
        })
    }
    else if (newValue == 'IN PROGRESS') {
      let user = JSON.parse(localStorage.getItem('user'))
    
      const where = `(r.status = 8 and r.quotation_status = 3 and est_prj.status = 2 and r.hold = 0)`

      const values = {
        userType: userType,isClient, userId: userId, page: newPage + 1, rowsPerPage,where , search: searching , filterClient, filterUser, dueData, filterProjectType, filterCommunity
      }
      await axios.post(`${REST_API}webservice/request/get-all-quotations-cards`, values)
        .then((res) => {
          res.data.data
          setAllRequest(res.data.data.data)
          if (res?.data?.data?.totalCount) {
            setTotalCount(res?.data?.data?.totalCount)
          } else {
            setTotalCount(0)
          }
          setRequestTeam(res.data.requestTeam)
          setSkillServices(res.data.services)
          setWorkFlow(res.data.workflows)
          setAllproducts(res.data.products)
          setLabourCostServices(res.data.labourCostServices)
          setFilteredServices(res.data.labourCostServices)
          const othersCommunity = { id: 'other', name: 'Others' };
          const othersClient = { id: 'other', name: 'Others' };
          if (res.data?.community) {
            setCommunitiesData([...res.data.community, othersCommunity]);
          } else {
            console.log('no community data')
            // setCommunitiesData([othersCommunity]);
          }
          if (res.data?.clients) {
            setClientData([...res.data.clients]);
          } else {
            // setClientData([]);
            console.log('no client data')
          }
          setLoadingCards(false)
        })
        .catch((errors) => {
          if (axios.isCancel(errors)) {
            console.log('IN PROGRESS tab request cancelled');
            return;
          }
          console.log(errors, 'error in fetching all requests')
        })
    }
    else if (newValue == 'REVIEW/ SEND FOR APPROVAL') {
      let user = JSON.parse(localStorage.getItem('user'))
    
      const where = `(r.status = 8 and r.quotation_status = 3 and est_prj.status = 3 and r.hold = 0)`

      const values = {
        userType: userType,isClient, userId: userId, page: newPage + 1, rowsPerPage,where , search: searching , filterClient, filterUser, dueData, filterProjectType, filterCommunity
      }
      await axios.post(`${REST_API}webservice/request/get-all-quotations-cards`, values)
        .then((res) => {
          res.data.data
          setAllRequest(res.data.data.data)
          if (res?.data?.data?.totalCount) {
            setTotalCount(res?.data?.data?.totalCount)
          } else {
            setTotalCount(0)
          }
          setRequestTeam(res.data.requestTeam)
          setSkillServices(res.data.services)
          setWorkFlow(res.data.workflows)
          setAllproducts(res.data.products)
          setLabourCostServices(res.data.labourCostServices)
          setFilteredServices(res.data.labourCostServices)
          const othersCommunity = { id: 'other', name: 'Others' };
          const othersClient = { id: 'other', name: 'Others' };
          if (res.data?.community) {
            setCommunitiesData([...res.data.community, othersCommunity]);
          } else {
            console.log('no community data')
            // setCommunitiesData([othersCommunity]);
          }
          if (res.data?.clients) {
            setClientData([...res.data.clients]);
          } else {
            // setClientData([]);
            console.log('no client data')
          }
          setLoadingCards(false)
        })
        .catch((errors) => {
          if (axios.isCancel(errors)) {
            console.log('REVIEW/ SEND FOR APPROVAL tab request cancelled');
            return;
          }
          console.log(errors, 'error in fetching all requests')
        })
    }
    else if (newValue == 'AWAITING APPROVAL') {
      let user = JSON.parse(localStorage.getItem('user'))
    
      const where = `(r.status = 8 and r.quotation_status = 9 and r.hold = 0)`

      const values = {
        userType: userType,isClient, userId: userId, page: newPage + 1, rowsPerPage,where , search: searching , filterClient, filterUser, dueData, filterProjectType, filterCommunity
      }
      await axios.post(`${REST_API}webservice/request/get-all-quotations-cards`, values)
        .then((res) => {
          res.data.data
          setAllRequest(res.data.data.data)
          if (res?.data?.data?.totalCount) {
            setTotalCount(res?.data?.data?.totalCount)
          } else {
            setTotalCount(0)
          }
          setRequestTeam(res.data.requestTeam)
          setSkillServices(res.data.services)
          setWorkFlow(res.data.workflows)
          setAllproducts(res.data.products)
          setLabourCostServices(res.data.labourCostServices)
          setFilteredServices(res.data.labourCostServices)
          const othersCommunity = { id: 'other', name: 'Others' };
          const othersClient = { id: 'other', name: 'Others' };
          if (res.data?.community) {
            setCommunitiesData([...res.data.community, othersCommunity]);
          } else {
            console.log('no community data')
            // setCommunitiesData([othersCommunity]);
          }
          if (res.data?.clients) {
            setClientData([...res.data.clients]);
          } else {
            // setClientData([]);
            console.log('no client data')
          }
          setLoadingCards(false)
        })
        .catch((errors) => {
          if (axios.isCancel(errors)) {
            console.log('AWAITING APPROVAL tab request cancelled');
            return;
          }
          console.log(errors, 'error in fetching all requests')
        })
    }
    else if (newValue == 'APPROVED') {
      let user = JSON.parse(localStorage.getItem('user'))
    

      const values = {
        userType: userType, userId: userId,isClient, page: page + 1, rowsPerPage, search: searching,filterClient,filterUser,dueData,filterProjectType,filterCommunity,
        where: `(r.status = 8 and r.quotation_status = 4 and r.hold = 0)`
      }
      await axios.post(`${REST_API}webservice/request/get-all-quotations-cards`, values)
        .then((res) => {
          res.data.data
          setAllRequest(res.data.data.data)
          if (res?.data?.data?.totalCount) {
            setTotalCount(res?.data?.data?.totalCount)
          } else {
            setTotalCount(0)
          }
          setRequestTeam(res.data.requestTeam)
          setSkillServices(res.data.services)
          setWorkFlow(res.data.workflows)
          setAllproducts(res.data.products)
          setLabourCostServices(res.data.labourCostServices)
          setFilteredServices(res.data.labourCostServices)
          const othersCommunity = { id: 'other', name: 'Others' };
          const othersClient = { id: 'other', name: 'Others' };
          if (res.data?.community) {
            setCommunitiesData([...res.data.community, othersCommunity]);
          } else {
            console.log('no community data')
            // setCommunitiesData([othersCommunity]);
          }
          if (res.data?.clients) {
            setClientData([...res.data.clients]);
          } else {
            console.log('no client data')
            // setClientData([]);
          }
          setLoadingCards(false)
        })
        .catch((errors) => {
          if (axios.isCancel(errors)) {
            console.log('APPROVED tab request cancelled');
            return;
          }
          console.log(errors, 'error in fetching all requests')
        })
    }
    else if (newValue == 'REJECTED') {
      let user = JSON.parse(localStorage.getItem('user'))
      const values = {
        userType: userType, userId: userId,isClient, page: page + 1, rowsPerPage, search: searching,filterClient,filterUser,dueData,filterProjectType,filterCommunity,
        where: `(r.quotation = 1 and r.quotation_status = 6 and r.hold = 0)`
        }
      await axios.post(`${REST_API}webservice/request/get-all-quotations-cards`, values)
        .then((res) => {
          res.data.data
          setAllRequest(res.data.data.data)
          if (res?.data?.data?.totalCount) {
            setTotalCount(res?.data?.data?.totalCount)
          } else {
            setTotalCount(0)
          }
        })
        .catch((errors) => {
          if (axios.isCancel(errors)) {
            console.log('REJECTED tab request cancelled');
            return;
          }
          console.log(errors, 'error in fetching all requests')
        }).finally(() => {
          setLoadingCards(false)
        })
    }
    else if (newValue == 'ARCHIVE') {
      let user = JSON.parse(localStorage.getItem('user'))
  

      const values = {
        userType: userType, userId: userId,isClient, page: page + 1, rowsPerPage, search: searching,filterClient,filterUser,dueData,filterProjectType,filterCommunity,
        where: `(r.quotation = 0 and r.quotation_status = 4 and r.hold = 0)`
      }
      await axios.post(`${REST_API}webservice/request/get-all-quotations-cards`, values)
        .then((res) => {
          res.data.data
          setAllRequest(res.data.data.data)
          if (res?.data?.data?.totalCount) {
            setTotalCount(res?.data?.data?.totalCount)
          } else {
            setTotalCount(0)
          }
          setRequestTeam(res.data.requestTeam)
          setSkillServices(res.data.services)
          setWorkFlow(res.data.workflows)
          setAllproducts(res.data.products)
          setLabourCostServices(res.data.labourCostServices)
          setFilteredServices(res.data.labourCostServices)
          const othersCommunity = { id: 'other', name: 'Others' };
          const othersClient = { id: 'other', name: 'Others' };
          if (res.data?.community) {
            setCommunitiesData([...res.data.community, othersCommunity]);
          } else {
            console.log('no community data')
            // setCommunitiesData([othersCommunity]);
          }
          if (res.data?.clients) {
            setClientData([...res.data.clients]);
          } else {
            console.log('no client data')
            // setClientData([]);
          }
          setLoadingCards(false)
        })
        .catch((errors) => {
          if (axios.isCancel(errors)) {
            console.log('ARCHIVE tab request cancelled');
            return;
          }
          console.log(errors, 'error in fetching all requests')
        })
    }
    else if (newValue == 'HOLD') {
      let user = JSON.parse(localStorage.getItem('user'))
  

      const values = {
        userType: userType, userId: userId,isClient, page: page + 1, rowsPerPage, search: searching,filterClient,filterUser,dueData,filterProjectType,filterCommunity,
        where: `(r.status = 8 and r.hold = 1)`
      }
      await axios.post(`${REST_API}webservice/request/get-all-quotations-cards`, values)
        .then((res) => {
          res.data.data
          setAllRequest(res.data.data.data)
          if (res?.data?.data?.totalCount) {
            setTotalCount(res?.data?.data?.totalCount)
          } else {
            setTotalCount(0)
          }
          setRequestTeam(res.data.requestTeam)
          setSkillServices(res.data.services)
          setWorkFlow(res.data.workflows)
          setAllproducts(res.data.products)
          setLabourCostServices(res.data.labourCostServices)
          setFilteredServices(res.data.labourCostServices)
          const othersCommunity = { id: 'other', name: 'Others' };
          const othersClient = { id: 'other', name: 'Others' };
          if (res.data?.community) {
            setCommunitiesData([...res.data.community, othersCommunity]);
          } else {
            console.log('no community data')
            // setCommunitiesData([othersCommunity]);
          }
          if (res.data?.clients) {
            setClientData([...res.data.clients]);
          } else {
            console.log('no client data')
            // setClientData([]);
          }
          setLoadingCards(false)
        })
        .catch((errors) => {
          if (axios.isCancel(errors)) {
            console.log('HOLD tab request cancelled');
            return;
          }
          console.log(errors, 'error in fetching all requests')
        })
    }
    else if (newValue == 'DRAFT') {
      let user = JSON.parse(localStorage.getItem('user'))
  

      const values = {
        userType: userType, userId: userId,isClient, page: page + 1, rowsPerPage, search: searching,filterClient,filterUser,dueData,filterProjectType,filterCommunity,
        where: `(r.status = 8 and r.quotation_status = 1 and r.hold = 0)`
      }
      await axios.post(`${REST_API}webservice/request/get-all-quotations-cards`, values)
        .then((res) => {
          res.data.data
          setAllRequest(res.data.data.data)
          if (res?.data?.data?.totalCount) {
            setTotalCount(res?.data?.data?.totalCount)
          } else {
            setTotalCount(0)
          }
          setRequestTeam(res.data.requestTeam)
          setSkillServices(res.data.services)
          setWorkFlow(res.data.workflows)
          setAllproducts(res.data.products)
          setLabourCostServices(res.data.labourCostServices)
          setFilteredServices(res.data.labourCostServices)
          const othersCommunity = { id: 'other', name: 'Others' };
          const othersClient = { id: 'other', name: 'Others' };
          if (res.data?.community) {
            setCommunitiesData([...res.data.community, othersCommunity]);
          } else {
            console.log('no community data')
            // setCommunitiesData([othersCommunity]);
          }
          if (res.data?.clients) {
            setClientData([...res.data.clients]);
          } else {
            console.log('no client data')
            // setClientData([]);
          }
          setLoadingCards(false)
        })
        .catch((errors) => {
          if (axios.isCancel(errors)) {
            console.log('DRAFT tab request cancelled');
            return;
          }
          console.log(errors, 'error in fetching all requests')
        })
    }
    else {
      let user = JSON.parse(localStorage.getItem('user'))
  

      const values = {
        userType: userType, userId: userId,isClient, page: page + 1, rowsPerPage, search: searching,filterClient,filterUser,dueData,filterProjectType,filterCommunity,
        where : ` (r.status = 8) `
      }
      await axios.post(`${REST_API}webservice/request/get-all-quotations-cards`, values)
        .then((res) => {
          res.data.data
          setAllRequest(res.data.data.data)
          if (res?.data?.data?.totalCount) {
            setTotalCount(res?.data?.data?.totalCount)
          } else {
            setTotalCount(0)
          }
          setRequestTeam(res.data.requestTeam)
          setSkillServices(res.data.services)
          setWorkFlow(res.data.workflows)
          setAllproducts(res.data.products)
          setLabourCostServices(res.data.labourCostServices)
          setFilteredServices(res.data.labourCostServices)
          const othersCommunity = { id: 'other', name: 'Others' };
          const othersClient = { id: 'other', name: 'Others' };
          if (res.data?.community) {
            setCommunitiesData([...res.data.community, othersCommunity]);
          } else {
            console.log('no community data')
            // setCommunitiesData([othersCommunity]);
          }
          if (res.data?.clients) {
            setClientData([...res.data.clients]);
          } else {
            console.log('no client data')
            // setClientData([]);
          }
          setLoadingCards(false)
        })
        .catch((errors) => {
          if (axios.isCancel(errors)) {
            console.log('ALL tab request cancelled');
            return;
          }
          console.log(errors, 'error in fetching all requests')
        })
    }
  };
  const filteredUsers = applySortFilter(allRequest, getComparator(order, orderBy), filterCommunity);
  const handleChangeSort = (category) => {
    setSort(category);
    setSortOpen(false);
  };

  const handleFilterProjectType = (type) => {
    setFilterProjectType(type);
  };

  const filteredProductOptions = useMemo(() => {
    // Filter products based on catalog type
    const filtered = (allProducts || []).filter((option) => {
      const catalogType = values?.split_catalog_type;
      
      if (catalogType) {
        // If "All" is selected, show all products except split catalog
        if (catalogType?.id === 'all') {
          return option.inhouse !== 6;
        }
        // Check isTrafficCatalog first before inhouse === 1 to avoid conflicts
        if (catalogType?.isTrafficCatalog) {
          return option.isTrafficCatalog === 1;
        } else if (catalogType?.inhouse === 4) {
          return option.inhouse === 4;
        } else if (catalogType?.inhouse === 5) {
          return option.inhouse === 5;
        } else if (catalogType?.inhouse === 1) {
          return option.inhouse === 1 && option.isTrafficCatalog !== 1; // Production Catalog (inhouse 1 but not traffic)
        } else if (catalogType?.inhouse === 0) {
          return option.inhouse === 0; // Sub Contract
        } else if (catalogType?.inhouse === 7) {
          return option.inhouse === 7; // Estimate Catalog
        }
        // If no match, exclude split catalog
        return option.inhouse !== 6;
      }
      
      // Default: show all except split catalog
      return option.inhouse !== 6;
    });
    
    // Sort in strict alphanumeric order based on description and name only (ignore suffix)
    return filtered.sort((a, b) => {
      const getSortKey = (option) => {
        const name = (option.name || '').trim();
        const description = (option.description || '').trim();
        // Sort by description first, then by name for strict alphanumeric order
        // const sortString = `${description} ${name}`.trim();
       //sort by name only for st
        const sortString = ` ${name}`.trim();
        return sortString;
      };

      const keyA = getSortKey(a);
      const keyB = getSortKey(b);
      
      // Strict alphanumeric sort: case-insensitive with natural numeric ordering
      return keyA.localeCompare(keyB, undefined, { 
        numeric: true, 
        sensitivity: 'base' 
      });
    });
  }, [allProducts, values?.split_catalog_type]);

  const computedProducts = useMemo(() => {
    let totalProductFormula = 0;
    let totalWholesalePrice = 0;
    let totalRetailPrice = 0;
    let totalAmount = 0;
    let totalMarkup = 0;
    let originaltotalMarkup = 0;
  
    const updatedProducts = selectedProducts.map((product) => {
      const {
        price = 0,
        retail_price = 0,
        quantity = 1,
        discount = 0,
        locationQuantity = 1,
        adjustment = 0,
        expected_cost = 1,
        markAdjType = 1,
        adj_value_type = true,
        wholesaleMarkup = 0,
        retailMarkup = 0,
      } = product;
  
      const selectedPrice = markupType === 1 ? Number(price) : Number(retail_price);
      const qty = Number(quantity);
      const disc = Number(discount);
      const locQty = Number(locationQuantity);
      const adj = Number(adjustment);
  
      const rowTotal = calculateTotal(
        selectedPrice,
        qty,
        disc,
        locQty,
        adj,
        markAdjType,
        adj_value_type
      );
  
      totalAmount += rowTotal;
  
      const cost = parseFloat(expected_cost?.toFixed(2)) || 1;
      const markup = ((selectedPrice - cost) / cost) * 100 || 0;
      totalMarkup += markup;
  
      const expectedCost = cost * qty * locQty;
      const wholesale = Number(price) * qty * locQty;
      const retail = Number(retail_price) * qty * locQty;
  
      let newWholesale = wholesale;
      let newRetail = retail;
  
      if (adj) {
        newWholesale += (newWholesale * adj) / 100;
        newRetail += (newRetail * adj) / 100;
      }
  
      totalProductFormula += expectedCost;
      totalWholesalePrice += newWholesale;
      totalRetailPrice += newRetail;
  
      const originalMarkup = markupType === 1 ? wholesaleMarkup : retailMarkup;
      originaltotalMarkup += originalMarkup;
  
      let SPMA = 0;
      if (markupType === 1) {
        SPMA = [2, 3].includes(markAdjType)
          ? Number(price) + adj
          : Number(price) + (Number(price) * adj) / 100;
      } else {
        SPMA = [2, 3].includes(markAdjType)
          ? Number(retail_price) + adj
          : Number(retail_price) + (Number(retail_price) * adj) / 100;
      }
  
      return {
        ...product,
        markup_type: markupType,
        markup: markup.toFixed(2),
        SPMA: SPMA.toFixed(2),
        product_total: rowTotal,
        product_sub_total: rowTotal,
      };
    });
  
    return {
      updatedProducts,
      totals: {
        sub_total: totalAmount.toFixed(2),
        totalProductFormula: totalProductFormula.toFixed(2),
        totalWholesalePrice: totalWholesalePrice.toFixed(2),
        totalRetailPrice: totalRetailPrice.toFixed(2),
        totalMarkup: totalMarkup.toFixed(2),
        originaltotalMarkup: originaltotalMarkup.toFixed(2),
      },
    };
  }, [selectedProducts, markupType]);
  

  const handleRetailPriceChange = (indexId, value) => {
    const updatedPrice = parseFloat(value) || 0;
  
    setSelectedProducts((prevProducts) =>
      prevProducts.map((product) => {
        if (product.indexId === indexId) {
          const total = calculateTotal(
            updatedPrice,
            Number(product.quantity),
            product.discount || 0,
            product.locationQuantity,
            product.adjustment,
            product.markAdjType,
            product.adj_value_type
          );
  
          return {
            ...product,
            retail_price: updatedPrice,
            price: updatedPrice,
            product_total: total
          };
        }
        return product;
      })
    );
    // markUnsavedChanges();
  };
  
  return (
    <Page title="Estimate: list | Sign Wise Solutions">
      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
                        <Button
                        variant="outlined"
                        type="submit"
                        onClick={handleCommunityPageBack}
                        sx={{ alignItems: 'flex-end', mb: 4 }}
                        startIcon={ 
                          <Stack>
                            <KeyboardBackspaceOutlined />
                          </Stack>
            
                        }
                      >
                        Back
                      </Button>
          <HeaderBreadcrumbs
            // heading={user.isVendor ? "Request for Estimate" : "Estimate"}
            heading={communityName ? `${communityName} - Estimates ` :"Estimates"}
          />

          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            {(isAdminUser (userType) ||
              explodedPermissions?.some((permission) =>
                ['Create Estimate'].includes(permission),
              )) &&
              !user.isVendor &&
              open == false &&
              !openRequestEstimate ? (
                <Button
                  ref={refSettings}
                  onClick={handleOpenFilters}
                  variant="contained"
                  color="success"
                  sx={{
                    color: 'common.white',
                  }}
                  startIcon={<FilterList />}
                >
                  Filters
                </Button>
            ) : (
              ''
            )}

          {/* {(((userType === 3 || isClient) && !user.isVendor) || ((explodedPermissions?.some(permission => ['Create Estimate'].includes(permission))) && !user.isVendor && !open)) && !open && !openRequestEstimate ? (
            <Box>
              {(userType === 3 || isClient) ? (
              <Button
                disabled={loadingCardsForAdd}
                onClick={async () => {
                  await fetchAllRequest()
                  setOpen(true)
                  setShowProgressModal(false)
                }}
                variant="contained"
                startIcon={
                  loadingCardsForAdd ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    <Icon icon={plusFill} />
                  )
                }
              >
                {loadingCardsForAdd ? 'Loading Data...' : 'Add New Estimate'}
              </Button>
              ) : (
                <>
                  <Tooltip title="Create">
                    <IconButton color='primary'
                      sx={{ border: '1px solid',
                        borderColor: 'divider',
                        bgcolor: 'background.paper'
                      }} 
                      onClick={(e) => setSettingsAnchorEl(e.currentTarget)}
                      disabled={loadingCardsForAdd}
                    >
                      {loadingCardsForAdd ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        <Icon icon={plusFill} width={24} height={24} color="#ffffff" />

                      )}
                    </IconButton>
                  </Tooltip>
                  <Popover
                    open={Boolean(settingsAnchorEl)}
                    anchorEl={settingsAnchorEl}
                    onClose={() => setSettingsAnchorEl(null)}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                  >
                    <Paper sx={{ p: 2, minWidth: 250 }}>
                      <Stack spacing={1}>
                        <LoadingButton
                          loading={loadingCardsForAdd}
                          startIcon={!loadingCardsForAdd ? <Icon icon={plusFill} width={20} height={20} /> : null}
                          sx={{ boxShadow: 'none' }}
                          onClick={async () => {
                            await fetchAllRequest()
                            setOpen(true)
                            setShowProgressModal(false)
                            setSettingsAnchorEl(null)
                          }}
                          variant="contained"
                          fullWidth
                        >
                          New Estimate
                        </LoadingButton>
                        <Button
                          onClick={() => {
                            setOpenRequestEstimate(true);
                            setIsLoading(true)
                            setShowProgressModal(false);
                            setSettingsAnchorEl(null);
                          }}
                          variant="outlined"
                          startIcon={<Icon icon={fileTextOutline} width={20} height={20} />}
                          fullWidth
                          sx={{ boxShadow: 'none' }}
                        >
                          Request Estimate
                        </Button>
                      </Stack>
                    </Paper>
                  </Popover>
                </>
                )}
            </Box>
          ) : ""} */}
          </Box>
        </Stack>
        <Popover
          open={isFiltersOpen}
          anchorEl={filtersAnchorEl}
          onClose={handleCloseFilters}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{
            sx: {
              width: { xs: '92vw', sm: 620, md: 780 },
              maxWidth: '92vw',
              p: 2,
            },
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <MobileDateRangePicker
                startText="Filter Date"
                endText="Filter Date"
                value={filterDateValue}
                onChange={(newValue) => {
                  setFilterDateValue(newValue);
                }}
                renderInput={(startProps, endProps) => (
                  <>
                    <TextField {...startProps} sx={{ width: '100%' }} helperText='Filter By Date Created' label='From Date' size="small" InputLabelProps={{ style: { color: theme.palette.primary.main, borderColor: theme.palette.primary.main } }} />
                    <Box sx={{ mx: 1, color: theme.palette.primary.main, display:'flex', alignItems:'center' }}> - </Box>
                    <TextField {...endProps} sx={{ width: '100%' }} helperText='' label='To Date' size="small" InputLabelProps={{ style: { color: theme.palette.primary.main, borderColor: theme.palette.primary.main } }} />
                  </>
                )}
              />
            </Grid>
            {/* <Grid item xs={12} sm={6}>
              <ButtonGroup variant="outlined" sx={{ width: '100%' }}>
                <Button
                  startIcon={<Stack className='si--projects-alt-duotone' />}
                  variant={filterProjectType === 'ALL' ? 'contained' : 'outlined'}
                  sx={{ boxShadow: 'none', width: '100%' }}
                  onClick={() => handleFilterProjectType('ALL')}
                >
                  All
                </Button>
                <Button
                  startIcon={<Stack className='carbon--traffic-flow' />}
                  variant={filterProjectType === 1 ? 'contained' : 'outlined'}
                  sx={{ boxShadow: 'none', width: '100%' }}
                  onClick={() => handleFilterProjectType(1)}
                >
                  TS
                </Button>
                <Button
                  startIcon={<Stack className='fluent--production-checkmark-20-regular' />}
                  variant={filterProjectType === 2 ? 'contained' : 'outlined'}
                  sx={{ boxShadow: 'none', width: '100%' }}
                  onClick={() => handleFilterProjectType(2)}
                >
                  PS
                </Button>
                <Button
                  startIcon={<Stack className='fluent--split-horizontal-20-regular' />}
                  variant={filterProjectType === 3 ? 'contained' : 'outlined'}
                  sx={{ boxShadow: 'none', width: '100%' }}
                  onClick={() => handleFilterProjectType(3)}
                >
                  Split
                </Button>
              </ButtonGroup>
            </Grid> */}

            <Grid item xs={12} sm={6}>
              <Tabs
                value={valueTab}
                onChange={handleChange}
                textColor="secondary"
                indicatorColor="none"
                aria-label="secondary tabs example"
                sx={{ minHeight: 42 }}
              >
                <CustomTab value="one" icon={<ViewModule />} />
                <CustomTab value="two" icon={<ViewList  />} />
                <CustomTab value="three" icon={<ListIcon />} />
              </Tabs>
            </Grid>

            {/* <Grid item xs={12} sm={6}>
              <Stack>
                {!user.isVendor && userType !==3 && (
                  <Button
                    ref={refClients}
                    onClick={() =>
                      setClientsOpen((prevState) => !prevState)
                    }
                    variant="outlined"
                    type="submit"
                    sx={{ alignItems: 'flex-end' }}
                    endIcon={
                      <Stack>
                        {clientsOpen ? (
                          <ExpandLess sx={{ ml: 'auto' }} />
                        ) : (
                          <ExpandMore sx={{ ml: 'auto' }} />
                        )}
                      </Stack>
                    }
                  >
                    Filter By Client
                  </Button>
                )}
                <Menu
                  open={Boolean(clientsOpen)}
                  anchorEl={refClients.current}
                  onClose={() => setClientsOpen(false)}
                  PaperProps={{
                    sx: { width: 'auto', maxWidth: '100%' },
                  }}
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                  <Box sx={{ p: 2, pb: 1 }}>
                    <TextField
                      size="small"
                      placeholder="Search clients..."
                      value={clientSearchTerm}
                      onChange={(e) => setClientSearchTerm(e.target.value)}
                      fullWidth
                      variant="outlined"
                      sx={{ 
                        mb: 1,
                      }}
                    />
                    <Divider sx={{ mt: 1 }}/>
                  </Box>
                  <List style={{ maxHeight: '200px', overflowY: 'auto' }}>
                    {(() => {
                      const filteredClients = clientData?.filter((type) =>
                        type.name?.toLowerCase().includes(clientSearchTerm.toLowerCase())
                      ) || [];
                      
                      // Sort in strict alphanumeric order
                      const sortedClients = filteredClients.sort((a, b) => {
                        const nameA = (a.name || '').trim();
                        const nameB = (b.name || '').trim();
                        return nameA.localeCompare(nameB, undefined, { 
                          numeric: true, 
                          sensitivity: 'base' 
                        });
                      });
                      
                      if (sortedClients.length === 0 && clientSearchTerm) {
                        return (
                          <MenuItem disabled sx={{ justifyContent: 'center' }}>
                            <ListItemText 
                              primary="No result found" 
                              sx={{ textAlign: 'center' }}
                            />
                          </MenuItem>
                        );
                      }
                      
                      return sortedClients.map((type) => (
                        <MenuItem key={type.id}>
                          {type.id === 'other' ? (
                            <ListItemText primary={`${type.name}`} />
                          ) : (
                            <ListItemText
                              primary={`${type.name}`}
                            />
                          )}
                          <Checkbox
                            checked={filterClient.includes(type.id)}
                            onChange={() => {
                              setPage(0)
                              handleToggleClient(type.id)
                            }}
                          />
                        </MenuItem>
                      ));
                    })()}
                  </List>
                </Menu>
              </Stack>
            </Grid> */}

            <Grid item xs={12} sm={6}>
              <Stack>
                {!user.isVendor && (
                  <Button
                    ref={refUsers}
                    onClick={() =>
                      setUsersOpen((prevState) => !prevState)
                    }
                    variant="outlined"
                    type="submit"
                    sx={{ alignItems: 'flex-end' }}
                    endIcon={
                      <Stack>
                        {usersOpen ? (
                          <ExpandLess sx={{ ml: 'auto' }} />
                        ) : (
                          <ExpandMore sx={{ ml: 'auto' }} />
                        )}
                      </Stack>
                    }
                  >
                    Filter By User
                  </Button>
                )}
              <Menu
                open={Boolean(usersOpen)}
                anchorEl={refUsers.current}
                onClose={() => setUsersOpen(false)}
                PaperProps={{
                  sx: { width: 'auto', maxWidth: '100%' },
                }}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              >
                <Box sx={{ p: 1 }}>
                  <TextField
                    size="small"
                    placeholder="Search users..."
                    value={userSearchTerm}
                    onChange={(e) => setUserSearchTerm(e.target.value)}
                    fullWidth
                    variant="outlined"
                    sx={{ 
                      mb: 1,
                    }}
                  />
                  <Divider sx={{ mt: 1 }}/>
                </Box>
                <List style={{ maxHeight: '200px', overflowY: 'auto' }}>
                  {(() => {
                    const filteredUsers = userData?.filter((userItem) => {
                      const searchText = userSearchTerm.toLowerCase();
                      const userName = (userItem.userName || userItem.person_name || userItem.name || userItem.email || '').toLowerCase();
                      return userName.includes(searchText);
                    }) || [];
                    
                    // Sort in strict alphanumeric order
                    const sortedUsers = filteredUsers.sort((a, b) => {
                      const nameA = (a.userName || a.person_name || a.name || a.email || '').trim();
                      const nameB = (b.userName || b.person_name || b.name || b.email || '').trim();
                      return nameA.localeCompare(nameB, undefined, { 
                        numeric: true, 
                        sensitivity: 'base' 
                      });
                    });
                    
                    if (sortedUsers.length === 0 && userSearchTerm) {
                      return (
                       <MenuItem disabled sx={{ justifyContent: 'center' }}>
                         <ListItemText 
                           primary="No result found" 
                           sx={{ textAlign: 'center' }}
                         />
                       </MenuItem>
                      );
                    }
                    
                    return sortedUsers.map((userItem) => (
                      <MenuItem key={userItem.id}>
                        <ListItemText
                          primary={`${userItem.userName || userItem.person_name || userItem.name || userItem.email}`}
                        />
                        <Checkbox
                          checked={filterUser.includes(userItem.id)}
                          onChange={() => {
                            setPage(0)
                            handleToggleUser(userItem.id)
                          }}
                        />
                      </MenuItem>
                    ));
                  })()}
                </List>
              </Menu>
              </Stack>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
                <Button
                  variant="outlined"
                  sx={{
                    maxHeight: '36px',
                    backgroundColor: dueData ? '#1ccaff' : '',
                    color: dueData ? '#fff' : '',
                  }}
                  onClick={handleByDue}
                  endIcon={
                    <Stack>
                      {' '}
                      {dueData ? <Visibility /> : <VisibilityOff />}{' '}
                    </Stack>
                  }
                >
                  By Due
                </Button>
                <Stack>
                  <Button
                    ref={refSort}
                    onClick={() => setSortOpen((prevState) => !prevState)}
                    variant="outlined"
                    disabled={dueData}
                    type="button"
                    endIcon={
                      <Stack>
                        {sortOpen ? <ExpandLess sx={{ ml: 'auto' }} /> : <ExpandMore sx={{ ml: 'auto' }} />}
                      </Stack>
                    }
                  >
                    {sort.label}
                  </Button>
                  {dueData && (
                    <FormHelperText sx={{ color: 'error.main', fontSize: '0.65rem', mt: 0.5 }}>
                      Disable "By Due" to enable this.
                    </FormHelperText>
                  )}
                  <Menu
                    open={Boolean(sortOpen)}
                    anchorEl={refSort.current}
                    onClose={() => setSortOpen(false)}
                    PaperProps={{
                      sx: { width: 'auto', maxWidth: '100%', maxHeight: '250px' },
                    }}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  >
                    {SORT.map((category) => (
                      <MenuItem key={category.id} onClick={() => handleChangeSort(category)}>
                        <ListItemText primary={category.label} />
                      </MenuItem>
                    ))}
                  </Menu>
                </Stack>
              </Stack>
            </Grid>

            {/* <Grid item xs={12} sm={6}>
              <Stack>
                {!user.isVendor && (
                  <Button
                    ref={refCommunities}
                    onClick={() =>
                      setCommunitiesOpen((prevState) => !prevState)
                    }
                    variant="outlined"
                    type="submit"
                    sx={{ alignItems: 'flex-end' }}
                    endIcon={
                      <Stack>
                        {communitiesOpen ? (
                          <ExpandLess sx={{ ml: 'auto' }} />
                        ) : (
                          <ExpandMore sx={{ ml: 'auto' }} />
                        )}
                      </Stack>
                    }
                  >
                    Filter Project
                  </Button>
                )}
                <Menu
                  open={Boolean(communitiesOpen)}
                  anchorEl={refCommunities.current}
                  onClose={() => setCommunitiesOpen(false)}
                  PaperProps={{
                    sx: { width: 'auto', maxWidth: '100%' },
                  }}
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                  <Box sx={{ p: 2, pb: 1 }}>
                    <TextField
                      size="small"
                      placeholder="Search projects..."
                      value={projectSearchTerm}
                      onChange={(e) => setProjectSearchTerm(e.target.value)}
                      fullWidth
                      variant="outlined"
                      sx={{ 
                        mb: 1,
                      }}
                    />
                    <Divider sx={{ mt: 1 }}/>
                  </Box>
                  <List style={{ maxHeight: '200px', overflowY: 'auto' }}>
                    {(() => {
                      const filteredProjects = communitiesData?.filter((type) =>
                        type.name?.toLowerCase().includes(projectSearchTerm.toLowerCase())
                      ) || [];
                      
                      // Sort in strict alphanumeric order
                      const sortedProjects = filteredProjects.sort((a, b) => {
                        const nameA = (a.name || '').trim();
                        const nameB = (b.name || '').trim();
                        return nameA.localeCompare(nameB, undefined, { 
                          numeric: true, 
                          sensitivity: 'base' 
                        });
                      });
                      
                      if (sortedProjects.length === 0 && projectSearchTerm) {
                        return (
                          <MenuItem disabled sx={{ justifyContent: 'center' }}>
                            <ListItemText 
                              primary="No result found" 
                              sx={{ textAlign: 'center' }}
                            />
                          </MenuItem>
                        );
                      }
                      
                      return sortedProjects.map((type) => (
                        <MenuItem key={type.id}>
                          {type.id === 'other' ? (
                            <ListItemText primary={`${type.name}`} />
                          ) : (
                            <ListItemText
                              primary={`${type.name} (${type.no_of_quotations || 0})`}
                            />
                          )}
                          <Checkbox
                            checked={filterCommunity.includes(type.id)}
                            onChange={() => {
                              setPage(0)
                              handleToggleCommunity(type.id)
                            }}
                          />
                        </MenuItem>
                      ));
                    })()}
                  </List>
                </Menu>
              </Stack>
            </Grid> */}

            <Grid item xs={12}>
              {/* {filterCommunity?.length > 0 && (
                <Button
                  variant="outlined"
                  sx={{
                    color: 'white',
                    borderColor: 'primary.main',
                    pointerEvents: 'none',
                    userSelect: 'text',
                    marginRight: 2,
                    marginBottom: 2,
                  }}
                >
                  <span
                    style={{
                      color: theme.palette.primary.darker,
                      marginRight: 8,
                    }}
                  >
                    Selected Projects{' '}
                  </span>
                  {communitiesData
                    .filter((community) =>
                      filterCommunity?.includes(community.id),
                    )
                    .map((community) => community.name)
                    .join(', ')}
                </Button>
              )}
              {filterClient?.length > 0 && (
                <Button
                  variant="outlined"
                  sx={{
                    color: 'white',
                    borderColor: 'primary.main',
                    pointerEvents: 'none',
                    userSelect: 'text',
                    marginRight: 2,
                    marginBottom: 2,
                  }}
                >
                  <span
                    style={{
                      color: theme.palette.primary.darker,
                      marginRight: 8,
                    }}
                  >
                    Selected Clients{' '}
                  </span>
                  {clientData
                    .filter((client) =>
                      filterClient?.includes(client.id),
                    )
                    .map((client) => client.name)
                    .join(', ')}
                </Button>
              )} */}
              {filterUser?.length > 0 && (
                <Button
                  variant="outlined"
                  sx={{
                    color: 'white',
                    borderColor: 'primary.main',
                    pointerEvents: 'none',
                    userSelect: 'text',
                    marginRight: 2,
                    marginBottom: 2,
                  }}
                >
                  <span
                    style={{
                      color: theme.palette.primary.darker,
                      marginRight: 8,
                    }}
                  >
                    Selected Users{' '}
                  </span>
                  {userData
                    .filter((userItem) =>
                      filterUser?.includes(userItem.id),
                    )
                    .map((userItem) => userItem.userName || userItem.person_name || userItem.name || userItem.email)
                    .join(', ')}
                </Button>
              )}
            </Grid>
          </Grid>
        </Popover>
        {!open && !openRequestEstimate && (
          <Box sx={{ mt: -4, mb: 3 }}>
            <OfficialRequestSearch
              searching={searching}
              setSearching={setSearching}
              setAllRequest={setAllRequest}
            />
          </Box>
        )}
        {(open && !openRequestEstimate) ? (
          <FormikProvider value={formik}>
            <Form noValidate autoComplete="off" onSubmit={handleSubmit} onChange={handleFormChange}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
                    <Button
                      variant="outlined"
                      onClick={handleCancel}
                      sx={{ alignItems: 'right' }}
                      startIcon={
                        <Stack>
                          <KeyboardBackspaceOutlined />
                        </Stack>
                      }
                    >
                      Back
                    </Button>
                  </Box>
                </Grid>
                <Grid item xs={12} md={12}>
                  <Card sx={{ p: 3 }}>
                    <CardHeader sx={{ ml: -3, mt: -4 }} title='New Estimate' />
                    <Stack spacing={3}>
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                        <Stack flexDirection={'column'}>

                          <TextField required
                            //   fullWidth
                            sx={{ width: 400 }}
                            label="Estimate Name"
                            {...getFieldProps('name')}
                            onChange={(e) => {
                              getFieldProps('name').onChange(e);
                              // markUnsavedChanges();
                            }}
                            error={Boolean(touched.name && errors.name)}
                            helperText={touched.name && errors.name}
                          />
                        </Stack>
                        <TextField
                          sx={{ width: 400 }}
                          label="PO Number"
                          {...getFieldProps('po_number')}
                          error={Boolean(touched.po_number && errors.po_number)}
                          helperText={touched.po_number && errors.po_number}
                        />
                      </Stack>
                      <LabelStyle>Description</LabelStyle>
                      <TextField required
                        fullWidth
                        multiline
                        minRows={3}
                        maxRows={7}
                        label="keep the summary brief and make it communicates"
                        {...getFieldProps('description')}
                        onChange={(e) => {
                          getFieldProps('description').onChange(e);
                          // markUnsavedChanges();
                        }}
                        error={Boolean(touched.description && errors.description)}
                        helperText={touched.description && errors.description}
                      />

                      <>
                        <LabelStyle>Upload Designs / Documents</LabelStyle>
                        <UploadMultiFile
                          showPreview
                          // maxSize={1024 * 1024 * 1024}
                          maxSize={1024 * 1024 * 1024}
                          accept="image/*,application/pdf"
                          files={avatarUrl}
                          onDrop={handleDrop}
                          onRemove={handleRemove}
                          onRemoveAll={handleRemoveAll}
                          isUploading={isUploading}
                          // error={Boolean(touched.avatarUrl && errors.avatarUrl)}
                        />
                      </>

                      {((userType !== 3 && !isClient) && (explodedPermissions?.some(permission => ['Create Estimate'].includes(permission)))) && (
                        <>

                          {/* <LabelStyle>Upload Design</LabelStyle>
                          <UploadMultiFile
                            showPreview
                            maxSize={1024 * 1024 * 1024}
                            accept="image/*"
                            files={avatarUrl}
                            onDrop={handleDrop}
                            onRemove={handleRemove}
                            onRemoveAll={handleRemoveAll}
                         
                          /> */}

                          {/* {touched.avatarUrl && errors.avatarUrl && (
                      <FormHelperText error sx={{ px: 2 }}>
                        {touched.avatarUrl && errors.avatarUrl}
                      </FormHelperText>
                    )} */}

                          {/* <LabelStyle>Skills or services required</LabelStyle> */}
                          {/* <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}> */}
                          {/* <Autocomplete
                          multiple
                          // sx={{ width: 400 }}
                          fullWidth
                          id="combo-box-demo"
                          options={skillServices}
                          value={values.skills}
                          onChange={(event, newValue) => setFieldValue('skills', newValue)}
                          renderInput={(params) => (
                            <TextField  required 
                            {...params} label="Skills or services required"
                            error={Boolean(touched.skills && errors.skills)}
                            helperText={touched.skills && errors.skills} />
                          )}
                          getOptionLabel={(option) => option.name}
                        /> */}
                          {/* <Stack flexDirection={'row'} alignItems='center' justifyContent='space-between'> */}
                          <Stack flexDirection={'row'} alignItems='center' justifyContent='center' gap={2}>
                            <Autocomplete
                              // multiple
                              // sx={{ width: '50%' }}
                              // fullWidth
                              sx={{ width: '49%' }}

                              id="combo-box-demo"
                              options={allClients}
                              value={values.clients}
                              onChange={(event, newValue) => {
                                if (newValue) {
                                  setFieldValue('clients', newValue);
                                  setFieldValue('community', null);
                                  setSalesRepName('');
                                  setSalesRepId(null);
                                  setSalesRepOptions([]);
                                  fetchAllCommunityByClient(newValue);
                                  setShowAddNewRow(true)
                                } else {
                                  setFieldValue('clients', null);
                                  setFieldValue('community', null);
                                  setSalesRepName('');
                                  setSalesRepId(null);
                                  setSalesRepOptions([]);
                                  setCommunities([]);
                                }
                                // markUnsavedChanges();
                              }}

                              renderInput={(params) => (
                                <TextField required
                                  {...params} label="Clients"
                                  error={Boolean(touched.clients && errors.clients)}
                                  helperText={touched.clients && errors.clients} />
                              )}
                              getOptionLabel={(option) => option.name}
                            />

                            {isCommunityLoading ?
                              <Stack flexDirection={'row'} alignItems='center' justifyContent='center'>
                                <CircularProgress color="primary" variant="indeterminate" />
                                <Typography variant='body2'>Loading projects...</Typography>
                              </Stack> :
                              ((communities?.length > 0 ? (
                                <Autocomplete
                                  // fullWidth
                                  sx={{ width: '49%' }}
                                  id="community"
                                  options={
                                    [...(communities || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
                                  }
                                  value={values.community}
                                  // onChange={(event, newValue) =>{
                                  //   if(newValue){
                                   
                                  //   setFieldValue('community', newValue)
                                  //   console.log('dataaaaaaaaaaaaaa',newValue)
                                  //   if(newValue.tax_category){
                                  //     let taxCat = taxCategories?.find(cat => newValue.tax_category === cat.id) || null
                                  //     setSelectedTaxCategory(taxCat)
                                  //   }
                                       
                                  // }else {
                              
                                  //   setFieldValue('community', null);
                                  //   setSelectedTaxCategory(null);
                                  // }

                                  // }}
                                  onChange={(event, newValue) => {
                                    if (newValue) {
                                      // Set the selected community in Formik
                                      setFieldValue('community', newValue);
                                      console.log('Selected Community:', newValue);

                                      // Sales reps dropdown: populate all sales reps for selected project
                                      const matchedCommunity = allCommunities?.find(
                                        (community) => community?.id === newValue?.id
                                      );
                                      const repOptions = getSalesRepOptionsFromCommunity(matchedCommunity);
                                      setSalesRepOptions(repOptions);
                                      if (repOptions.length > 0) {
                                        // Keep current behavior (auto-select first), but allow changing via dropdown
                                        setSalesRepName(repOptions[0]?.name || '');
                                        setSalesRepId(repOptions[0]?.id || null);
                                      } else {
                                        setSalesRepName('');
                                        setSalesRepId(null);
                                      }
                                  
                                      // Update tax category if applicable
                                      if (newValue.tax_category) {
                                        const taxCat = taxCategories?.find((cat) => newValue.tax_category === cat.id) || null;
                                        setSelectedTaxCategory(taxCat);
                                      }
                                  
                                      // Extract new community address
                                      const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = newValue || {};
                                      const communityAddress = {
                                        id: 0,
                                        address: projAddress,
                                        city: projCity,
                                        state: projState,
                                        zip: projZip,
                                      };
                                  
                                      // Update locations in `setSelectedProducts`
                                      setSelectedProducts((prevProducts) =>
                                        prevProducts?.map((product) => {
                                          if (product?.fromMapServices == true) {
                                            return product;
                                          }else{
                                            const updatedAddresses = product.addresses?.map((loc) => ({
                                              ...loc,
                                              address: projAddress || loc.address,
                                              city: projCity || loc.city,
                                              state: projState || loc.state,
                                              zip: projZip || loc.zip,
                                            })) || [communityAddress];
                                            return { ...product, addresses: updatedAddresses };
                                          }
                                        })
                                      );
                                  
                                      // Update locations in `setCart`
                                      setCart((prevCart) =>
                                        prevCart.map((product) => {
                                          const updatedAddresses = product.addresses?.map((loc) => ({
                                            ...loc,
                                            address: projAddress || loc.address,
                                            city: projCity || loc.city,
                                            state: projState || loc.state,
                                            zip: projZip || loc.zip,
                                          })) || [communityAddress];
                                          return { ...product, addresses: updatedAddresses };
                                        })
                                      );
                                    } else {
                                      // Clear community and tax category when no project is selected
                                      setFieldValue('community', null);
                                      setSelectedTaxCategory(null);
                                      setSalesRepName('');
                                      setSalesRepId(null);
                                      setSalesRepOptions([]);
                                    }
                                    // markUnsavedChanges();
                                  }}
                                  
                                  renderInput={(params) => (
                                    <Tooltip
                                      title={values.community ? formatProjectAddress(values.community) : ''}
                                    >
                                      <TextField
                                        required
                                        {...params}
                                        label="Project"
                                        error={Boolean(touched.community && errors.community)}
                                        helperText={touched.community && errors.community}
                                      />
                                    </Tooltip>
                                  )}
                                  getOptionLabel={(option) => option.name}
                                  renderOption={(props, option) => {
                                    const { style, ...liProps } = props;
                                    return (
                                      <li
                                        {...liProps}
                                        style={{
                                          ...style,
                                          display: 'flex',
                                          alignItems: 'center',
                                        }}
                                      >
                                        <Tooltip title={formatProjectAddress(option)}>
                                          <span
                                            style={{
                                              flex: 1,
                                              minWidth: 0,
                                              display: 'block',
                                            }}
                                          >
                                            <span
                                              style={{
                                                display: 'block',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                              }}
                                            >
                                              {option?.name || ''}
                                            </span>
                                            {/* <span
                                              style={{
                                                display: 'block',
                                                fontSize: 12,
                                                color: '#6b7280',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                              }}
                                            >
                                              {formatProjectAddress(option)}
                                            </span> */}
                                          </span>
                                        </Tooltip>
                                        <span style={{ display: 'none' }}>{option?.name || ''}</span>
                                      </li>
                                    );
                                  }}
                                />
                              ) : (
                                <Stack sx={{ width: '50%' }} justifyContent={'center'}>
                                  {values?.clients ?
                                    <Typography sx={{ color: "red" }}>The selected client does not have any projects yet. Please create a new project for them!</Typography>
                                    : <Typography sx={{ color: "red" }}>No client selected. Please choose a client from the list.</Typography>}
                                </Stack>
                              )))
                            }
                          </Stack>
                          {salesRepOptions?.length > 0 && (
                            <Stack sx={{ width: '100%' }}>
                              <Autocomplete
                                id="sales-rep"
                                options={salesRepOptions}
                                value={
                                  salesRepOptions.find((opt) => {
                                    if (salesRepId != null && opt?.id != null) {
                                      return String(opt.id) === String(salesRepId);
                                    }
                                    return salesRepName && opt?.name === salesRepName;
                                  }) || null
                                }
                                onChange={(event, newValue) => {
                                  setSalesRepName(newValue?.name || '');
                                  setSalesRepId(newValue?.id || null);
                                }}
                                isOptionEqualToValue={(option, value) =>
                                  (option?.id != null && value?.id != null && String(option.id) === String(value.id)) ||
                                  option?.name === value?.name
                                }
                                getOptionLabel={(option) => option?.name || ''}
                                renderInput={(params) => (
                                  <TextField {...params} label="Sales Rep" fullWidth />
                                )}
                              />
                            </Stack>
                          )}

                          {(values.community?.id != null && values.community?.sales_rep_names != null)  && (
                          <Stack sx={{ width: '100%' }}>
                            <Autocomplete
                              multiple
                              id="collaborators"
                              options={collaboratorOptions}
                              value={collaborators}
                              onChange={(event, newValue) => setCollaborators(newValue || [])}
                              loading={teamMembersLoading}
                              isOptionEqualToValue={(option, value) => (option?.id != null && value?.id != null && String(option.id) === String(value.id))}
                              getOptionLabel={(option) => {
                                if (!option) return '';
                                const name = option.name || [option.first_name, option.last_name].filter(Boolean).join(' ').trim();
                                return name || String(option.id || '');
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Collaborators"
                                  fullWidth
                                  placeholder="Select Collaborators"
                                />
                              )}
                            />
                          </Stack>
                          )}
                          {/* {communities && communities.length > 0 ? (
                              <Autocomplete
                                fullWidth
                                id="community"
                                options={communities}
                                value={values.community}
                                onChange={(event, newValue) => setFieldValue('community', newValue)}
                                renderInput={(params) => (
                                  <TextField
                                    required
                                    {...params}
                                    label="Project"
                                    error={Boolean(touched.community && errors.community)}
                                    helperText={touched.community && errors.community}
                                  />
                                )}
                                getOptionLabel={(option) => option.name}
                              />
                            ) : (
                              <Typography sx={{ color: "red", width: '50%' }}>The client you have chosen does not have a project yet. Please create one for them! </Typography>
                            )} */}

                          {/* </Stack> */}
                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            {/* <Autocomplete
                              fullWidth
                              disabled
                              id="combo-box-demo-type"
                              options={markupTypes}
                              value={values.markup_type}
                              onChange={(event, newValue) => {
                                setFieldValue('markup_type', newValue)
                                setMarkupType(newValue?.id)
                              }}
                              renderInput={(params) => (
                                <TextField required
                                  {...params} label="Markup Type"
                                  error={Boolean(touched.markup_type && errors.markup_type)}
                                  helperText={touched.markup_type && errors.markup_type} />
                              )}
                              getOptionLabel={(option) => option.name}
                            /> */}
                            <Autocomplete
                              fullWidth
                              sx={{ width: {xs:'100%' ,sm:'50%'} }}
                              id="combo-box-demo-type"
                              options={projectTypes}
                              value={values.project_type}
                              onChange={(event, newValue) => {
                                setFieldValue('project_type', newValue)
                                setShowAddNewRow(true)
                                if (newValue?.name !== 'TS') {
                                  setFieldValue('map_service', null)
                                  const filteredProducts = selectedProducts?.filter(product => product?.fromMapServices !== true);
                                  setSelectedProducts(filteredProducts);
                                }
                                // markUnsavedChanges();
                              }}
                              renderInput={(params) => (
                                <TextField required
                                  {...params} label="Job Class"
                                  error={Boolean(touched.project_type && errors.project_type)}
                                  helperText={touched.project_type && errors.project_type} />
                              )}
                              getOptionLabel={(option) => option.name}
                            />
                            <Autocomplete
                              multiple
                              fullWidth
                              sx={{ width: { xs: '100%', sm: '50%' } }}
                              id="combo-box-demo-sign-agreement"
                              options={signAgreement}
                              value={values.sign_agreement} // This should be an array of selected agreements
                              onChange={(event, newValue) => {
                                setFieldValue('sign_agreement', newValue); // Update state with selected values
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  required={false}
                                  InputLabelProps={{
                                    ...params.InputLabelProps,
                                    required: false,
                                  }}
                                  label="Select Sign Agreements"
                                  error={Boolean(touched.sign_agreement && errors.sign_agreement)}
                                  helperText={touched.sign_agreement && errors.sign_agreement}
                                />
                              )}
                              getOptionLabel={(option) => option.name}
                              renderTags={(value, getTagProps) =>
                                value?.map((option, index) => (
                                  <Chip
                                    label={option.name}
                                    {...getTagProps({ index })}
                                    key={index}
                                  />
                                ))
                              }
                            />
                          </Stack>
                          {values?.project_type?.name == 'TS' ? 
                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}> 
                            <Autocomplete
                              // fullWidth
                              sx={{ width: '50%' }}
                              id="combo-box-demo-category"
                              options={projectCategories}
                              value={values.project_categories}
                              onChange={(event, newValue) => {
                                setFieldValue('project_categories', newValue)
                                if (values?.project_type?.name !== 'TS' || newValue?.id != 14) {
                                  setFieldValue('map_service', null)
                                  const filteredProducts = selectedProducts?.filter(product => product?.fromMapServices !== true);
                                  setSelectedProducts(filteredProducts);
                                  setSelectedMapserviceProducts([]);
                                  setSelectedServices([]);
                                }
                                if(values.project_categories?.id == 14){
                                  setSelectedProducts([]);
                                  setSelectedMapserviceProducts([]);
                                  setSelectedServices([]);
                                }
                                // markUnsavedChanges();
                              }}
                              renderInput={(params) => (
                                <TextField 
                                  {...params} label="Job Type"
                                  error={Boolean(touched.project_categories && errors.project_categories)}
                                  helperText={touched.project_categories && errors.project_categories} />
                              )}
                              getOptionLabel={(option) => option.name}
                            />
                            {values.project_categories?.id == 14 ? 
                            <Autocomplete
                              // fullWidth
                              sx={{ width: '50%' }}
                              id="combo-box-demo-type"
                              options={mapServices}
                              value={values.map_service}
                              onChange={(event, newValue) => {
                                setFieldValue('map_service', newValue)
                                if (newValue?.products) {
                                  let newIndexCounter = indexCounter;
                                  const updatedProductsWithLocations = newValue?.products?.map((product,index) => {
                                    const filteredData = allProducts?.find((i) => i.id === product.product_id);
                                    const associatedLocations = newValue?.locations
                                      .filter((location) => location?.route_product_id === product?.id)
                                      .map((location) => ({
                                        address: location.address,
                                        city: location.city,
                                        state: location.state,
                                        zip: location.zip,
                                        route_location_id: location.id,
                                      }));
                                      newIndexCounter += 1;
                                    return {
                                      ...product,
                                      ...filteredData,
                                      indexId: newIndexCounter, //`map_${index}`,
                                      fromMapServices:true,
                                      locationQuantity: product?.qty,
                                      addresses: associatedLocations,
                                      discount: 0,
                                      adjustment: 0,
                                      quantity: 1,
                                      markAdjType:2
                                    };
                                  });
                                  console.log('updatedProductsWithLocations-----------',updatedProductsWithLocations)

                                  const mergedSelectedProducts = [
                                    ...selectedProducts.filter((product) => product?.fromMapServices !== true), // Keep existing products without fromMapServices
                                    ...updatedProductsWithLocations, // Add the new products from map services
                                  ];

                                  setSelectedMapserviceProducts(updatedProductsWithLocations);
                                  setSelectedProducts(mergedSelectedProducts);
                                  setFieldValue('products', mergedSelectedProducts)
                                  setIndexCounter(newIndexCounter);
                                  // markUnsavedChanges();
                                  const productServices = mergedSelectedProducts?.reduce((services, product) => {
                                    if (product.services && product.services.length > 0) {
                                      return services.concat(
                                        product.services.map((service) => ({
                                          ...service,
                                          fromMapServices:product?.fromMapServices || false,
                                          productIndex: product?.indexId,
                                          quantity: service.quantity * product.quantity * product.locationQuantity,
                                          previousQty: service.quantity,
                                          qtyData: product.quantity,
                                          locationQuantity: product.locationQuantity,
                                        }))
                                      );
                                    }
                                    return services;
                                  }, []);
                              
                                  setSelectedServices(productServices);
                                  
                                }
                              }}
                              renderInput={(params) => (
                                <TextField required
                                  {...params} label="Routes"
                                  error={Boolean(touched.map_service && errors.map_service)}
                                  helperText={touched.map_service && errors.map_service} />
                              )}
                              // getOptionLabel={(option) => option.name}
                              getOptionLabel={(option) => `${option.name} (${option.locations_count})`}
                            /> : ''}
                          </Stack> : '' }
                          {/* <Stack>
                      <Autocomplete
                          multiple
                          // sx={{ width: 400 }}
                          fullWidth
                          id="combo-box-demo"
                          options={workflow}
                          value={values.workflows}
                          onChange={(event, newValue) => setFieldValue('workflows', newValue)}
                          renderInput={(params) => (
                            <TextField  required 
                            {...params} label="WorkFlows"
                            error={Boolean(touched.workflows && errors.workflows)}
                            helperText={touched.workflows && errors.workflows} />
                          )}
                          getOptionLabel={(option) => option.name}

                        />
                      </Stack> */}
                        </>
                      )}
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                        <Box
                          component={MobileDatePicker}
                          minDate={moment()}
                          label="Start Date"
                          value={dateOnlyMoment(values.start)}
                          onChange={(date) => {
                            setFieldValue('start', dateOnlyToUnix(date));
                            // markUnsavedChanges();
                          }}
                          renderInput={(params) => (
                            <TextField size="medium" {...params} fullWidth />
                          )}
                        />
                        <Box
                          component={MobileDatePicker}
                          minDate={moment()}
                          label="Installation Date"
                          value={values.end ? dateOnlyMoment(values.end) : null}
                          onChange={(date) => {
                            setFieldValue('end', dateOnlyToUnix(date));
                            setFieldValue('installation_start_date', null);
                            setFieldValue('installation_end_date', null);
                            // markUnsavedChanges();
                          }}
                          renderInput={(params) => (
                            <TextField size="medium" {...params} fullWidth
                              error={Boolean(touched.end && errors.end)}
                              helperText={touched.end && errors.end} />
                          )}
                        />
                      </Stack>
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 2, mb: 1, fontStyle: 'italic' }}>
                        Choose either single installation date above OR installation date range below
                      </Typography>
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <Box
                          component={MobileDatePicker}
                          minDate={moment()}
                          label="Installation Start Date"
                          value={values.installation_start_date ? dateOnlyMoment(values.installation_start_date) : null}
                          onChange={(date) => {
                            setFieldValue('installation_start_date', dateOnlyToUnix(date));
                            setFieldValue('end', null);
                            // markUnsavedChanges();
                          }}
                          renderInput={(params) => (
                            <TextField 
                              size="medium" 
                              {...params} 
                              fullWidth
                              error={Boolean(touched.installation_start_date && errors.installation_start_date)}
                              helperText={touched.installation_start_date && errors.installation_start_date}
                            />
                          )}
                        />
                        <Box
                          component={MobileDatePicker}
                          minDate={values.installation_start_date ? dateOnlyMoment(values.installation_start_date) : moment()}
                          label="Installation End Date"
                          value={values.installation_end_date ? dateOnlyMoment(values.installation_end_date) : null}
                          onChange={(date) => {
                            setFieldValue('installation_end_date', dateOnlyToUnix(date));
                            setFieldValue('end', null);
                            // markUnsavedChanges();
                          }}
                          renderInput={(params) => (
                            <TextField 
                              size="medium" 
                              {...params} 
                              fullWidth
                              error={Boolean(touched.installation_end_date && errors.installation_end_date)}
                              helperText={touched.installation_end_date && errors.installation_end_date}
                            />
                          )}
                        />
                      </Stack>
                      {/* Client-specific project autocomplete - only visible for clients */}
                      {(isClient || userType === 3) && (
                        <>
                          {isCommunityLoading ? (
                            <Stack
                              flexDirection={'row'}
                              alignItems="center"
                              justifyContent="center"
                              sx={{ mt: 2 }}
                            >
                              <CircularProgress
                                color="primary"
                                variant="indeterminate"
                              />
                              <Typography variant="body2">
                                Loading your projects...
                              </Typography>
                            </Stack>
                          ) : (
                             <Autocomplete
                               sx={{ width: '100%', mt: 2 }}
                               id="client-community"
                               options={
                                 [...(clientCommunities || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
                               }
                              value={values.community}
                              onChange={(event, newValue) => {
                                if (newValue) {
                                  setFieldValue('community', newValue)
                                  // markUnsavedChanges();

                                  // Sales reps dropdown: populate all sales reps for selected project
                                  const matchedCommunity = clientCommunities?.find(
                                    (community) => community?.id === newValue?.id
                                  );
                                  setCollaborators([])
                                  const repOptions = getSalesRepOptionsFromCommunity(matchedCommunity);
                                  setSalesRepOptions(repOptions);
                                  if (repOptions.length > 0) {
                                    // Keep current behavior (auto-select first), but allow changing via dropdown
                                    setSalesRepName(repOptions[0]?.name || '');
                                    setSalesRepId(repOptions[0]?.id || null);
                                  } else {
                                    setSalesRepName('');
                                    setSalesRepId(null);
                                  }

                                  // Check if the project has address/city/state/zip
                                  if (newValue.address || newValue.city || newValue.state || newValue.zip) {
                                    const { address: projAddress, city: projCity, state: projState, zip: projZip } = newValue;

                                    const communityAddress = {
                                      address: projAddress,
                                      city: projCity,
                                      state: projState,
                                      zip: projZip,
                                    };

                                    // Update selected products' addresses
                                    setSelectedProducts((prevProducts) =>
                                      prevProducts.map((product) => {
                                        if (product?.fromMapServices == true) {
                                          return product;
                                        } else {
                                          const updatedAddresses = product.addresses?.map((loc) => ({
                                            ...loc,
                                            address: projAddress || loc.address,
                                            city: projCity || loc.city,
                                            state: projState || loc.state,
                                            zip: projZip || loc.zip,
                                          })) || [communityAddress];
                                          return { ...product, addresses: updatedAddresses };
                                        }
                                      })
                                    );

                                    // Update locations in `setCart`
                                    setCart((prevCart) =>
                                      prevCart.map((product) => {
                                        const updatedAddresses = product.addresses?.map((loc) => ({
                                          ...loc,
                                          address: projAddress || loc.address,
                                          city: projCity || loc.city,
                                          state: projState || loc.state,
                                          zip: projZip || loc.zip,
                                        })) || [communityAddress];
                                        return { ...product, addresses: updatedAddresses };
                                      })
                                    );
                                  }

                                  // Set tax category if available
                                  if (newValue.tax_category) {
                                    let taxCat = taxCategories?.find(cat => newValue.tax_category === cat.id) || null
                                    setSelectedTaxCategory(taxCat)
                                  }
                                } else {
                                  setFieldValue('community', null);
                                  setSelectedTaxCategory(null);
                                  setSalesRepName('');
                                  setSalesRepId(null);
                                  setSalesRepOptions([]);
                                }
                                // markUnsavedChanges();
                              }}
                              renderInput={(params) => (
                                <Tooltip
                                  title={values.community ? formatProjectAddress(values.community) : ''}
                                >
                                  <TextField
                                    required
                                    {...params}
                                    label="Select Project"
                                    error={Boolean(touched.community && errors.community)}
                                    helperText={touched.community && errors.community}
                                  />
                                </Tooltip>
                              )}
                              getOptionLabel={(option) => option.name}
                              renderOption={(props, option) => {
                                const { style, ...liProps } = props;
                                return (
                                  <li
                                    {...liProps}
                                    style={{
                                      ...style,
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <Tooltip title={formatProjectAddress(option)}>
                                      <span
                                        style={{
                                          flex: 1,
                                          minWidth: 0,
                                          display: 'block',
                                        }}
                                      >
                                        <span
                                          style={{
                                            display: 'block',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                          }}
                                        >
                                          {option?.name || ''}
                                        </span>
                                        <span
                                          style={{
                                            display: 'block',
                                            fontSize: 12,
                                            color: '#6b7280',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                          }}
                                        >
                                          {formatProjectAddress(option)}
                                        </span>
                                      </span>
                                    </Tooltip>
                                    <span style={{ display: 'none' }}>{option?.name || ''}</span>
                                  </li>
                                );
                              }}
                            />
                          )}
                        </>
                      )}
                      {salesRepOptions?.length > 0 && (isClient || userType === 3) && (
                        <Stack sx={{ width: '100%', mt: 2 }}>
                          <Autocomplete
                            id="sales-rep-client"
                            options={salesRepOptions}
                            value={
                              salesRepOptions.find((opt) => {
                                if (salesRepId != null && opt?.id != null) {
                                  return String(opt.id) === String(salesRepId);
                                }
                                return salesRepName && opt?.name === salesRepName;
                              }) || null
                            }
                            onChange={(event, newValue) => {
                              setSalesRepName(newValue?.name || '');
                              setSalesRepId(newValue?.id || null);
                            }}
                            isOptionEqualToValue={(option, value) =>
                              (option?.id != null && value?.id != null && String(option.id) === String(value.id)) ||
                              option?.name === value?.name
                            }
                            getOptionLabel={(option) => option?.name || ''}
                            renderInput={(params) => (
                              <TextField {...params} label="Sales Rep" fullWidth />
                            )}
                          />
                        </Stack>
                      )}
                      {((userType !== 3 && !isClient) && (explodedPermissions?.some(permission => ['Create Estimate'].includes(permission)))) && (
                        <>
                          <Divider />
                          <LabelStyleHead>Products</LabelStyleHead>
                          {/* <Typography></Typography> */}
                          <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={'center'} spacing={{ xs: 3, sm: 2 }}>
                            <Autocomplete
                              sx={{ width: '50%' }}
                              multiple
                              id="combo-box-demo"
                              options={filteredProductOptions}
                              value={selectedProducts?.filter(item=>item?.fromMapServices != true  && !item.isAdditionalProduct)}
                              onChange={(event, newValue) => { 
                                const updated = newValue.map((item) => ({
                                  ...item,
                                  is_single_card: values.project_categories?.id !== 14 ? true : false
                                }));
                                setFieldValue('products', updated);
                                handleProduct(updated);
                                // markUnsavedChanges();
                              }}
                              renderInput={(params) => (
                                <TextField {...params} required
                                  error={Boolean(touched.products && errors.products)}
                                  helperText={touched.products && errors.products}
                                  label="Select a product" />
                              )}
                              renderOption={(props, option) => {
                              const { style, ...liProps } = props;
                              const description =option.name // option.description || option.name;
                              const suffix = option.isTrafficCatalog ? '(TC)' : option.inhouse === 5 ? '(Client Owned Catalog)': option.inhouse === 4 ? '(In Stock Catalog)': option.inhouse === 0 ? '(Sub Contract)' : option.inhouse === 6 ? '(Split Catalog)' : option.inhouse === 7 ? '(Estimate Catalog)' : '(Production Catalog)';
                              return (
                                <li
                                  {...liProps}
                                  style={{
                                    ...style,
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <Tooltip title={`${description} ${suffix}`}>
                                    <span style={{
                                      flex: 1,
                                      minWidth: 0,
                                      display: 'block',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                    }}>
                                     {`${description} ${suffix}`}
                                    </span>
                                  </Tooltip>
                                  <span style={{ display: 'none' }}>{option.name}</span>
                                </li>
                              );
                              }}
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) =>{ 
                                  const suffix = option.isTrafficCatalog ? '(TC)': option.inhouse === 5 ? '(Client Owned Catalog)' :option.inhouse === 4 ? '(In Stock Catalog)': option.inhouse === 0 ? '(Sub Contract)' : option.inhouse === 6 ? '(Split Catalog)' : option.inhouse === 7 ? '(Estimate Catalog)' : '(Production Catalog)';
                                  return(
                                  <Tooltip key={index} title={`${option.name || ''} ${suffix}`}>
                                  <Chip
                                    {...getTagProps({ index })}
                                    // label={option.description || ''}
                                    // label={`${option.description || option.name || ''} ${suffix}`}
                                    label={`${option.name || ''} ${suffix}`}
                                  />
                                   </Tooltip>
                                )})
                              }
                              // isOptionEqualToValue={(option, value) => option.id === value.id}
                              isOptionEqualToValue={() => false}
                              // getOptionLabel={(option) => option.name ? option.name : ''}
                              getOptionLabel={(option) => {
                                const name = option.name || '';
                                const description = option.description || '';
                                const suffix = option.isTrafficCatalog ? '(TC)' :  option.inhouse === 5 ? '(Client Owned Catalog)' : option.inhouse === 4 ? '(In Stock Catalog)': option.inhouse === 0 ? '(Sub Contract)':'(Production Catalog)';
                                // return `${description} \u200B${name}`;
                                return `${description} ${suffix} \u200B${name}`;
                              }}
                              filterOptions={(options, { inputValue }) =>
                              options.filter((option) => {
                                const searchText = inputValue.toLowerCase();
                                return (
                                  option.name?.toLowerCase().includes(searchText) ||
                                  option.description?.toLowerCase().includes(searchText) ||
                                  option.tags?.toLowerCase().includes(searchText) ||
                                  String(option.id).includes(searchText)
                                  // option.description?.toLowerCase().includes(searchText)
                                );
                              })
                            }

                            />
                            {(() => {
                              // Hide Catalog Type field when project category is Build Order (id 15)
                              const categoryId = values?.project_categories?.id;
                              const isBuildOrder = categoryId === 15;
                              
                              // Don't show Catalog Type for Build Order
                              if (isBuildOrder) {
                                return null;
                              }
                              
                              // For normal orders: remove split_catalog, add sub_contract (keep production_catalog and estimate_catalog)
                              const filteredCatalogTypes = splitOrderCatalogTypes
                                .filter(type => type.id !== 'split_catalog')
                                .concat([{ id: 'sub_contract', label: 'Sub Contract', inhouse: 0, isTrafficCatalog: false }])
                                .sort((a, b) => {
                                  // Keep "All" at the top, then sort rest alphabetically
                                  if (a.id === 'all') return -1;
                                  if (b.id === 'all') return 1;
                                  return a.label.localeCompare(b.label);
                                });
                              
                              return (
                                <Autocomplete
                                  sx={{ width: '50%' }}
                                  id="normal-catalog-type"
                                  options={filteredCatalogTypes}
                                  value={values.split_catalog_type || splitOrderCatalogTypes.find((type) => type.id === 'all')}
                                  onChange={(event, newValue) => {
                                    const finalValue = newValue || splitOrderCatalogTypes.find((type) => type.id === 'all');
                                    setFieldValue('split_catalog_type', finalValue);
                                    // markUnsavedChanges();
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Catalog Type"
                                      placeholder="Select catalog type"
                                    />
                                  )}
                                  getOptionLabel={(option) => option.label}
                                />
                              );
                            })()}
                          </Stack>
                          <LabelStyle>Selected Products</LabelStyle>
                          <Scrollbar>
                            <TableContainer sx={{ minWidth: 500 }}>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    {VALUE?.map((val) => (
                                      val.id === 14 ? (
                                        <Tooltip key={val.id} title="Selling Price With Marketing Adjustment">
                                          <TableCell>{val.value}</TableCell>
                                        </Tooltip>
                                        // ) : (val.id === 2 ? (
                                        //   <Tooltip key={val.id} title="((Wholesale Price - Product Formula Cost)/Product Formula Cost) * 100">
                                        //     <TableCell>{val.value}</TableCell>
                                        //   </Tooltip>
                                      )
                                        : (
                                          <TableCell key={val.id}>{val.value}</TableCell>
                                        )
                                      // )
                                    ))}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {selectedProducts?.sort((a, b) => a.indexId - b.indexId)?.map((data, index) => {
                                  // {computedProducts?.updatedProducts?.sort((a, b) => a.indexId - b.indexId)?.map((data, index) => {
                                    const quantityFieldName = `quantity_${index}`;
                                    const discountFieldName = `discount_${index}`;
                                    const adjustmentFieldName = `adjustment_${index}`;
                                    let unitName = UNITS?.filter((item) => item?.id == data?.unit)
                                    unitName = unitName[0]?.name
                                    let shortUnitName = ''
                                    if (unitName == 'Square feet') {
                                      shortUnitName = 'Sq ft'
                                    } else if (unitName == 'Lineal feet') {
                                      shortUnitName = 'Lin ft'
                                    } else if (unitName == 'Square Inches') {
                                      shortUnitName = 'Sq Inches'
                                    } else if (unitName == 'Unit') {
                                      shortUnitName = 'Unit'
                                    }
                                    if(data.inhouse !== 1 || (data.inhouse ==1 && data.isTrafficCatalog == 1)){
                                      let price = data.max_price ? data.max_price : data.actual_retail_price
                                      const installCost = parseFloat(data?.install_cost) || 0
                                      data['actual_retail_price'] = price
                                      const calculatedRetailPrice = installCost > 0 ? price + installCost : price
                                      data['retail_price'] = calculatedRetailPrice
                                    }

                                    if(data.adj_value_type == null){
                                      data.adj_value_type =true
                                     }

                                    const rowTotal = calculateTotal(markupType == 1 ? data.price : (markupType == 2 ? data.retail_price : 0), Number(data.quantity), values[discountFieldName], data.locationQuantity, data?.adjustment,data.markAdjType,data.adj_value_type);
                                    // Accumulate the totalAmount
                                    totalAmount += rowTotal;
                                    values['sub_total'] = totalAmount?.toFixed(2)
                                    data['product_sub_total'] = rowTotal
                                    data['product_total'] = rowTotal
                                    data['markup_type'] = markupType
                                    const invoiceAmount = parseFloat(data?.expected_material_cost?.toFixed(2)) + parseFloat(data?.expected_total_service_cost?.toFixed(2))

                                    let markup = markupType == 1 ? (((data.price - parseFloat(data.expected_cost?.toFixed(2))) / parseFloat(data.expected_cost?.toFixed(2))) * 100)
                                      : (markupType == 2 ? (((data.retail_price - parseFloat(data.expected_cost?.toFixed(2))) / parseFloat(data.expected_cost?.toFixed(2))) * 100) : 0);
                                    // const markup = ((data.retail_price - data.price) / data.price) * 100;
                                    // let markup = markupType ? (invoiceAmount / rowTotal) : null
                                    markup = markup ? Number(markup) : 0

                                    let newTotalProductFormula = parseFloat(data.expected_cost?.toFixed(2)) * data.quantity * data.locationQuantity
                                    newTotalProductFormula = newTotalProductFormula ? Number(newTotalProductFormula) : 0

                                    let newTotalWholesalePrice = data.price * data.quantity * data.locationQuantity
                                    if (data?.adjustment) {
                                      newTotalWholesalePrice = newTotalWholesalePrice ? newTotalWholesalePrice + ((newTotalWholesalePrice * data?.adjustment) / 100) : 0
                                    }
                                    newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0

                                    let newTotalRetailPrice = data.retail_price * data.quantity * data.locationQuantity
                                    if (data?.adjustment) {
                                      newTotalRetailPrice = newTotalRetailPrice ? newTotalRetailPrice + ((newTotalRetailPrice * data?.adjustment) / 100) : 0
                                    }
                                    newTotalRetailPrice = newTotalRetailPrice ? Number(newTotalRetailPrice) : 0

                                    totalProductFormula += Number(newTotalProductFormula)
                                    totalWholesalePrice += Number(newTotalWholesalePrice)
                                    totalRetailPrice += Number(newTotalRetailPrice)

                                    values['totalProductFormula'] = totalProductFormula
                                    values['totalWholesalePrice'] = totalWholesalePrice
                                    values['totalRetailPrice'] = totalRetailPrice

                                    totalMarkup += markup;
                                    let originalMarkup = markupType == 1 ? data.wholesaleMarkup : markupType == 2 ? data.retailMarkup : 0
                                    originaltotalMarkup += originalMarkup
                                    // values['totalMarkup'] = totalMarkup?.toFixed(2)
                                    data['markup'] = markup?.toFixed(2)
                                    // data['markup'] = Math.round(markup)
                                    console.log("###############markup", markup);
                                    console.log("###############devvvvvv123", data);

                                    const pfc = parseFloat(data.expected_cost?.toFixed(2)) * data.quantity * data.locationQuantity // total product formula cost
                                    const rtp = data.retail_price * data.quantity * data.locationQuantity // total retail price
                                    const wsp = data.price * data.quantity * data.locationQuantity // total wholesale price

                                    // const maxDiscount_wholesale = (wsp - pfc) - DiscountTotal
                                    // const maxDiscount_retail = (rtp - pfc) - DiscountTotal

                                    const maxDiscount_wholesale = wsp - pfc
                                    const maxDiscount_retail = rtp - pfc

                                    console.log('maxDiscount_wholesale--', maxDiscount_wholesale);
                                    console.log('maxDiscount_retail--', maxDiscount_retail);
                                    console.log('DiscountTotal--', DiscountTotal);
                                    console.log('pfc--', pfc);
                                    console.log('rtp--', rtp);
                                    console.log('wsp--', wsp);

                                    let SPMA = 0
                                    if (markupType) {
                                      if (markupType == 1) {
                                        if (data.markAdjType == 2 || data.markAdjType == 3) {
                                          SPMA = (Number(data.price) || 0) + (data.adjustment ? Number(data.adjustment) : 0)
                                        } else {
                                          SPMA = (Number(data.price) || 0) + (((Number(data.price) || 0) * (data.adjustment ? Number(data.adjustment) : 0)) / 100)

                                        }
                                      } else {
                                        if (data.markAdjType == 2 || data.markAdjType == 3) {
                                          SPMA = (Number(data.retail_price) || 0) + (data.adjustment ? Number(data.adjustment) : 0)
                                        } else {
                                          SPMA = (Number(data.retail_price) || 0) + (((Number(data.retail_price) || 0) * (data.adjustment ? Number(data.adjustment) : 0)) / 100)

                                        }
                                      }
                                    }
                                    console.log('SPMA-----data.price-----', data.price)
                                    console.log('SPMA-----data.adjustment-----', data.adjustment)
                                    console.log('SPMA-----data.retail_price-----', data.retail_price)
                                    console.log('SPMA-----SPMA-----', SPMA)
                                    SPMA = Number(SPMA)
                                    data['SPMA'] = SPMA?.toFixed(2)

                                    data['original_actual_retail_price'] = data?.original_actual_retail_price || data?.actual_retail_price
                                    data['original_retail_price'] = data?.original_retail_price || data?.retail_price
                                    data['original_price'] = data?.original_price || data?.price
                                    data['original_product_retail_price'] = data?.original_product_retail_price || data?.product_retail_price
                                    data['original_product_price'] = data?.original_product_price || data?.product_price

                                    data['actual_retail_price'] = data?.original_actual_retail_price + (data.adj_value_type ? (Number(data?.adjustment) || 0) : -(Number(data?.adjustment) || 0))
                                    data['retail_price'] = data?.original_retail_price + (data.adj_value_type ? (Number(data?.adjustment) || 0) : -(Number(data?.adjustment) || 0))
                                    data['price'] = data?.original_price + (data.adj_value_type ? (Number(data?.adjustment) || 0) : -(Number(data?.adjustment) || 0))
                                    data['product_retail_price'] = data?.original_product_retail_price + (data.adj_value_type ? (Number(data?.adjustment) || 0) : -(Number(data?.adjustment) || 0))
                                    data['original_product_price'] = data?.product_price + (data.adj_value_type ? (Number(data?.adjustment) || 0) : -(Number(data?.adjustment) || 0))

                                    // Initialize install adjustment fields
                                    if(data.install_adj_value_type == null && data.install_cost){
                                      data.install_adj_value_type = true
                                    }

                                    if(data.install_quantity == null && data.install_cost){
                                      data.install_quantity = 1
                                    }

                                    if(data.install_adjustment == null && data.install_cost){
                                      data.install_adjustment = 0
                                    }

                                    // Set original_install_cost if not already set
                                    if(!data.original_install_cost && data.install_cost){
                                      // If install_cost already includes adjustment, reverse calculate original
                                      const installAdj = parseFloat(data?.install_adjustment) || 0
                                      const installAdjValueType = data?.install_adj_value_type !== false && data?.install_adj_value_type !== 0
                                      const signedInstallAdj = installAdjValueType ? installAdj : -installAdj
                                      data.original_install_cost = Math.max(0, parseFloat(data.install_cost) - signedInstallAdj)
                                    } else if(data.install_cost && data.original_install_cost) {
                                      // Apply install adjustment calculation
                                      const baseInstallCost = parseFloat(data?.original_install_cost) || 0
                                      const installAdj = parseFloat(data?.install_adjustment) || 0
                                      const signedInstallAdj = (data?.install_adj_value_type === false || data?.install_adj_value_type === 0) ? -installAdj : installAdj
                                      data.install_cost = baseInstallCost ? Math.max(0, baseInstallCost + signedInstallAdj) : null
                                    }
                                    // Use actual_retail_price directly since it's already calculated with adjustment on line 5656
                                    // Or recalculate from original base if original exists
                                    const dataActualRetail = data.original_actual_retail_price != null 
                                      ? (data.original_actual_retail_price + (data.adj_value_type ? (Number(data?.adjustment) || 0) : -(Number(data?.adjustment) || 0)))
                                      : (data.actual_retail_price || data.retail_price || 0)

                                    const productFormulaEach =
                                      data?.inhouse === 0
                                        ? Number(data?.sub_contract_price || 0)
                                        : Number(
                                            (data?.expected_material_cost_with_markup ||
                                              0) +
                                              (data?.expected_service_cost_with_markup ||
                                                0),
                                          )
                                    const productRetailEach = Math.max(
                                      0,
                                      Number(
                                        data?.actual_retail_price ??
                                          data?.retail_price ??
                                          data?.product_retail_price ??
                                          0,
                                      ),
                                    )
                                    const isNegativeProductAdjustmentMode =
                                      data?.adj_value_type === false ||
                                      data?.adj_value_type === 0 ||
                                      data?.adj_value_type === '0' ||
                                      data?.adj_value_type === 'false'
                                    const isProductLosingMoney =
                                      isNegativeProductAdjustmentMode &&
                                      productRetailEach < productFormulaEach

                                    const installFormulaEach = Number(
                                      data?.expected_install_labor_cost_with_markup ||
                                        0,
                                    )
                                    const installRetailEach = Math.max(
                                      0,
                                      Number(data?.install_cost || 0),
                                    )
                                    const isNegativeInstallAdjustmentMode =
                                      data?.install_adj_value_type === false ||
                                      data?.install_adj_value_type === 0 ||
                                      data?.install_adj_value_type === '0' ||
                                      data?.install_adj_value_type === 'false'
                                    const isInstallLosingMoney =
                                      isNegativeInstallAdjustmentMode &&
                                      installRetailEach < installFormulaEach

                                    const isLosingMoneyItem =
                                      isProductLosingMoney ||
                                      isInstallLosingMoney

                                    const losingMoneyRowSx = isLosingMoneyItem
                                      ? {
                                          '& .MuiTableCell-root:not(:nth-of-type(4)):not(:nth-of-type(5)):not(:nth-of-type(11)), & .MuiTableCell-root:not(:nth-of-type(4)):not(:nth-of-type(5)):not(:nth-of-type(11)) .MuiInputBase-input, & .MuiTableCell-root:not(:nth-of-type(4)):not(:nth-of-type(5)):not(:nth-of-type(11)) .MuiFormLabel-root':
                                            {
                                              color: `${theme.palette.error.main} !important`,
                                            },
                                        }
                                      : undefined
                                    return (
                                      <>
                                        {/* <TableRow key={index}> */}
                                         <TableRow key={`main-${data.indexId}`} sx={losingMoneyRowSx}>
                                          <TableCell>#{data?.indexId}</TableCell>
                                          <TableCell>{data?.isAdditionalProduct ?
                                            <TextField
                                              required
                                              fullWidth
                                              type="text"
                                              label={'Product Name'}
                                              sx={{ width: 85 }}
                                              value={data.name}
                                              onChange={(event) => {
                                                let newValue =
                                                  event.target.value

                                                // Update the selectedProducts state
                                                setSelectedProducts(
                                                  (prevProducts) =>
                                                    prevProducts.map(
                                                      (product) => {
                                                        if (
                                                          product.indexId ===
                                                          data.indexId
                                                        ) {
                                                          return {
                                                            ...product,
                                                            name: newValue,
                                                          }
                                                        } else {
                                                          return product
                                                        }
                                                      },
                                                    ),
                                                )
                                                data['name'] =
                                                  newValue || ''
                                                if (isSubmitted)
                                                  setIsSubmitted(false)
                                                // markUnsavedChanges();
                                              }}
                                              error={
                                                isSubmitted &&
                                                data?.name?.trim() === ''
                                              }
                                              helperText={
                                                isSubmitted &&
                                                data?.name?.trim() === ''
                                                  ? 'Product Name is required'
                                                  : ''
                                              }
                                            />
                                          : <Typography sx={{ color: data.product_notes ? theme.palette.error.main : 'inherit' }}>{data.product_notes || data.name}</Typography>}</TableCell>
                                          <TableCell>
                                            <IconButton onClick={() => handleOpenNote(data.indexId, data.product_notes)}>
                                              <NoteAdd
                                                sx={{
                                                  color: (!data?.product_notes || data?.product_notes === '') ? '' : theme.palette.primary.main,
                                                }}
                                              />
                                            </IconButton>
                                          </TableCell>
                                          <TableCell>
                                            {data?.isAdditionalProduct ? 'N/A' : (data.inhouse === 0 ? '0.00' : 
                                            // (parseFloat((data.formula_cost || 0)?.toFixed(2)) * data.quantity * data.locationQuantity).toFixed(2)
                                            ((data?.expected_material_cost_with_markup || 0) + (data?.expected_service_cost_with_markup || 0))?.toFixed(2)
                                            )}</TableCell>
                                          {/* <TableCell>{invoiceAmount}</TableCell> */}
                                          <TableCell>{(hasMarkupPermission && markupType == 2) ? 
                                          (data?.isAdditionalProduct ?
                                            <TextField
                                              required
                                              fullWidth
                                              type="number"
                                              label={'Retail Price Each'}
                                              disabled={
                                                values.project_categories
                                                  ?.name ==
                                                'Time & Material'
                                                  ? true
                                                  : false
                                              }
                                              sx={{ width: 85 }}
                                              // value={data.retail_price}
                                              value={data?.actual_retail_price || data?.retail_price}
                                              onWheel={(e) => e.target.blur()}
                                              defaultValue={0}
                                              // onChange={(event) => {
                                              //   let newValue =
                                              //     event.target.value
                                              //   if (newValue !== '') {
                                              //     setSelectedProducts(
                                              //       (pv) => [
                                              //         ...pv.map((p) => {
                                              //           if (
                                              //             p.indexId ===
                                              //             data.indexId
                                              //           ) {
                                              //             return {
                                              //               ...p,
                                              //               retail_price: newValue,
                                              //               price: newValue,
                                              //             }
                                              //           } else {
                                              //             return p
                                              //           }
                                              //         }),
                                              //       ],
                                              //     )
                                              //     data['retail_price'] = newValue || 0
                                              //     data['price'] = newValue || 0
                                              //   }
                                              // }}

                                              onChange={(event) => {
                                                handleRetailPriceChange(data.indexId, event.target.value)
                                                // let newValue = event.target.value;
                                                // console.log('newValuenewValue',newValue)
                                                // if (newValue !== '') {
                                                //   setSelectedProducts((pv) =>
                                                //     pv.map((p) => {
                                                //       if (p.indexId === data.indexId) {
                                                //         const updatedPrice = parseFloat(newValue) || 0;
                                                //         const updatedTotal = calculateTotal(
                                                //           updatedPrice,
                                                //           Number(p.quantity),
                                                //           p.discount || 0,
                                                //           p.locationQuantity,
                                                //           p.adjustment,
                                                //           p.markAdjType
                                                //         );
                                                //         return {
                                                //           ...p,
                                                //           retail_price: updatedPrice,
                                                //           price: updatedPrice,
                                                //           product_total: updatedTotal,
                                                //         };
                                                //       } else {
                                                //         return p;
                                                //       }
                                                //     })
                                                //   );
                                                // }
                                              }}


                                              // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                              // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                            /> :
                                          // data.retail_price?.toFixed(2)) : null
                                          dataActualRetail?.toFixed(2))
                                          // (data?.actual_retail_price || data?.retail_price)?.toFixed(2))
                                           : null
                                            }
                                          </TableCell>
                                          <TableCell>{(hasMarkupPermission && markupType == 1) ? 
                                            (data?.isAdditionalProduct ?
                                              <TextField
                                                required
                                                fullWidth
                                                type="number"
                                                label={'Retail Price Each'}
                                                disabled={
                                                  values.project_categories
                                                    ?.name ==
                                                  'Time & Material'
                                                    ? true
                                                    : false
                                                }
                                                sx={{ width: 85 }}
                                                // value={data.retail_price}
                                              value={data?.actual_retail_price || data?.retail_price}
                                                onWheel={(e) => e.target.blur()}
                                                defaultValue={0}
                                                // onChange={(event) => {
                                                //   let newValue =
                                                //     event.target.value
                                                //   if (newValue !== '') {
                                                //     setSelectedProducts(
                                                //       (pv) => [
                                                //         ...pv.map((p) => {
                                                //           if (
                                                //             p.indexId ===
                                                //             data.indexId
                                                //           ) {
                                                //             return {
                                                //               ...p,
                                                //               retail_price:
                                                //                 newValue,
                                                //               price: newValue,
                                                //             }
                                                //           } else {
                                                //             return p
                                                //           }
                                                //         }),
                                                //       ],
                                                //     )
                                                //     data['retail_price'] =
                                                //       newValue || 0
                                                //     data['price'] =
                                                //       newValue || 0
                                                //   }
                                                // }}


                                                onChange={(event) => {
                                                  handleRetailPriceChange(data.indexId, event.target.value)
                                                  // let newValue = event.target.value;
                                                  // if (newValue !== '') {
                                                  //   const updatedPrice = parseFloat(newValue) || 0;
                                                
                                                  //   setSelectedProducts((pv) =>
                                                  //     pv.map((p) => {
                                                  //       if (p.indexId === data.indexId) {
                                                  //         const updatedTotal = calculateTotal(
                                                  //           updatedPrice,
                                                  //           Number(p.quantity),
                                                  //           p.discount || 0,
                                                  //           p.locationQuantity,
                                                  //           p.adjustment,
                                                  //           p.markAdjType
                                                  //         );
                                                  //         return {
                                                  //           ...p,
                                                  //           retail_price: updatedPrice,
                                                  //           price: updatedPrice,
                                                  //           product_total: updatedTotal,
                                                  //         };
                                                  //       } else {
                                                  //         return p;
                                                  //       }
                                                  //     })
                                                  //   );
                                                
                                                  //   // Also update local `data` object to match
                                                  //   const updatedTotal = calculateTotal(
                                                  //     updatedPrice,
                                                  //     Number(data.quantity),
                                                  //     data.discount || 0,
                                                  //     data.locationQuantity,
                                                  //     data.adjustment,
                                                  //     data.markAdjType
                                                  //   );
                                                  //   data['retail_price'] = updatedPrice;
                                                  //   data['price'] = updatedPrice;
                                                  //   data['product_total'] = updatedTotal;
                                                  // }
                                                }}

                                                
                                                // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                                // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                              /> : 
                                              // data.price?.toFixed(2)) : null
                                              (data?.actual_retail_price || data?.retail_price)?.toFixed(2)) : null

                                              }
                                              </TableCell>
                                          {/* <TableCell>{hasMarkupPermission ? (data?.SPMA || null) : null}</TableCell> */}
                                          {/* <TableCell> */}
                                            {/* old */}
                                            {/* {(hasMarkupPermission && markupType == 1) ? data.wholesaleMarkup?.toFixed(2)
                                              : (hasMarkupPermission && markupType == 2) ? data.retailMarkup?.toFixed(2)
                                                : null} */}
                                        {/* previos */}
                                            {/* {(hasMarkupPermission && markupType == 1) ? data.wholesaleMarkup?.toFixed(2)
                                              : (hasMarkupPermission && markupType == 2) ? data.pf_retail_markup?.toFixed(2)
                                                : null} */}
                                            {/* {(hasMarkupPermission && markupType) ? (markup * data.quantity).toFixed(2) : null} */}
                                          {/* </TableCell> */}

                                          {/* <TableCell>{shortUnitName}</TableCell> */}
                                          {/* <TableCell>
                                            <TextField required
                                              fullWidth
                                              type='number'
                                              label={shortUnitName}
                                              disabled={(data?.fromMapServices == true) ? true : shortUnitName == 'Unit' ? true : false}
                                              sx={{ width: 85 }}
                                              // {...getFieldProps(quantityFieldName)}
                                              value={Number(data.quantity)}
                                              defaultValue={1}
                                              onKeyPress={(event) => {
                                                if (event.key === '0' && event.target.value === '') {
                                                  event.preventDefault();
                                                }
                                                if (event.key === '-') {
                                                  event.preventDefault();
                                                }
                                                if (event.key === '.') {
                                                  event.preventDefault();
                                                }
                                              }}
                                              onChange={(event) => {

                                                let newValue = event.target.value;
                                                if (newValue !== "0" && newValue !== "") {
                                                  console.log("################SelectedSeer", selectedServices);

                                                  setSelectedProducts(pv => ([...pv.map(p => {
                                                    // if (p.id === data.id) {
                                                    if (p.indexId === data.indexId) {
                                                      // let arrayAddr

                                                      // const commonAddresses = (allLocationSame && pv.length > 0) ? [...pv[0].addresses][0] : null;

                                                      // if (allLocationSame && commonAddresses) {
                                                      //   arrayAddr = Array(Number(newValue)).fill().map((_, i) => ({
                                                      //     ...commonAddresses,
                                                      //     id: i
                                                      //   }));

                                                      // }
                                                      // else {
                                                      //   arrayAddr = [...p.addresses]
                                                      //   if (p.addresses.length < Number(newValue)) {
                                                      //     arrayAddr.push(...[...Array(Number(newValue) - p.addresses.length)].map((a, i) => {

                                                      //       return {
                                                      //         id: p.addresses.length + i,
                                                      //         address: '',
                                                      //         city: '',
                                                      //         state: '',
                                                      //         zip: '',
                                                      //       }
                                                      //     }))
                                                      //   } else {
                                                      //     arrayAddr = arrayAddr.slice(0, -(p.addresses.length - Number(newValue)));
                                                      //   }
                                                      // }


                                                      return {
                                                        ...p,
                                                        quantity: Number(newValue),
                                                        // addresses: arrayAddr
                                                      }
                                                    } else {
                                                      return p;
                                                    }
                                                  })]));
                                                  setSelectedServices(pv => ([...pv.map(service => {
                                                    // if (service.product_id === data.id) {
                                                    if (service.productIndex === data.indexId) {
                                                      return {
                                                        ...service,
                                                        productIndex: data.indexId,
                                                        quantity: (service.previousQty * Number(newValue) * service.locationQuantity)?.toFixed(2),
                                                        qtyData: Number(newValue),
                                                        total: ((service.cost) * (service.previousQty * Number(newValue) * service.locationQuantity))?.toFixed(2)
                                                      };
                                                    } else {
                                                      return service;
                                                    }
                                                  })]));
                                                  //new chnage on 2-2-24
                                                  if (newValue === '' || newValue <= 0) {
                                                    event.preventDefault();
                                                    return;
                                                  }
                                                  if (newValue.startsWith('-')) {
                                                    newValue = newValue.slice(1);
                                                  }
                                                  data['quantity'] = newValue || 1;
                                                  setFieldValue(quantityFieldName, newValue);
                                                }
                                              }}
                                              error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                              helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                            />
                                          </TableCell> */}
                                          <TableCell>
                                            <TextField required
                                              fullWidth
                                              type='number'
                                              label={'Qty'}
                                              disabled={(data?.fromMapServices == true) ? true : false}
                                              // {...getFieldProps(quantityFieldName)}
                                              value={Number(data.locationQuantity)}
                                              defaultValue={1}
                                              onKeyPress={(event) => {
                                                if (event.key === '0' && event.target.value === '') {
                                                  event.preventDefault();
                                                }
                                                if (event.key === '-') {
                                                  event.preventDefault();
                                                }
                                                if (event.key === '.') {
                                                  event.preventDefault();
                                                }
                                              }}
                                              onChange={(event) => {

                                                let newValue = event.target.value;
                                                if (newValue !== "0" && newValue !== "") {

                                                  const newAddr = data?.is_single_card ? 1 : newValue
                                                  setSelectedProducts(pv => ([...pv.map(p => {
                                                    console.log("################p.id", p.id);
                                                    console.log("################data.id", data.id);
                                                    // if (p.id === data.id) {
                                                    if (p.indexId === data.indexId) {
                                                      let arrayAddr

                                                      const commonAddresses = data?.allLocationSame && pv.length > 0 ? p.addresses[0] : null

                                                      if (data?.allLocationSame && commonAddresses) {
                                                        arrayAddr = Array(Number(newAddr)).fill().map((_, i) => ({ //1
                                                          ...commonAddresses,
                                                          id: i
                                                        }));

                                                      }
                                                      else {
                                                        arrayAddr = [...p.addresses]
                                                        console.log("################arrayAddr", arrayAddr);
                                                        console.log("################p.addresses.length", p.addresses.length);
                                                        console.log("################Number(newValue)", Number(newAddr));
                                                        if (p.addresses.length < Number(newAddr)) {
                                                          arrayAddr.push(...[...Array(Number(newAddr) - p.addresses.length)].map((a, i) => {

                                                            return {
                                                              id: p.addresses.length + i,
                                                              address: '',
                                                              city: '',
                                                              state: '',
                                                              zip: '',
                                                            }
                                                          }))
                                                        }
                                                        else if (p.addresses.length > Number(newAddr)) {
                                                          arrayAddr = arrayAddr.slice(0, Number(newAddr));
                                                        }
                                                        else {
                                                          arrayAddr = arrayAddr.slice(0, -(p.addresses.length - Number(newAddr)));
                                                        }
                                                      }

                                                      console.log("###########Arrayadde", arrayAddr);
                                                      return {
                                                        ...p,
                                                        // quantity: Number(newValue),
                                                        locationQuantity: Number(newValue),
                                                        addresses: arrayAddr
                                                      }
                                                    } else {
                                                      return p
                                                    }
                                                  })]));
                                                  setSelectedServices(pv => ([...pv.map(service => {
                                                    // if (service.product_id === data.id) {
                                                    if (service.productIndex === data.indexId) {
                                                      return {
                                                        ...service,
                                                        productIndex: data?.indexId,
                                                        quantity: (service.previousQty * Number(newValue) * (service.qtyData || 1))?.toFixed(2),
                                                        locationQuantity: Number(newValue),
                                                      };
                                                    } else {
                                                      return service;
                                                    }
                                                  })]));
                                                  //new chnage on 2-2-24
                                                  if (newValue === '' || newValue <= 0) {
                                                    event.preventDefault();
                                                    return;
                                                  }
                                                  if (newValue.startsWith('-')) {
                                                    newValue = newValue.slice(1);
                                                  }
                                                  data['locationQuantity'] = newValue || 1;
                                                  // setFieldValue(quantityFieldName, newValue);
                                                  // markUnsavedChanges();
                                                }
                                              }}
                                            // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                            // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                            />
                                          </TableCell>
                                          <TableCell>
                                            <IconButton
                                              onClick={() => {
                                                setLocationStates({ ...locationStates, [data.indexId]: true });
                                              }}
                                            >
                                              <LocationOn sx={{
                                                color: data?.addresses?.some(obj =>
                                                  [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
                                                ) ? '' : theme.palette.primary.main
                                              }} />
                                            </IconButton>
                                          </TableCell>
                                          {/* <TableCell>{data.id}</TableCell> */}
                                          {/* <TableCell>
                                            <Autocomplete
                                              sx={{ width: 70 }}
                                              id="combo-box-demo"
                                              disableClearable
                                              options={marketingAdjustmentType || []}
                                              defaultValue={marketingAdjustmentType.find((type) => type.id === data.markAdjType) || marketingAdjustmentType[0]}
                                              onChange={(event, newValue) => {
                                                setSelectedProducts((prevProducts) => {
                                                  return prevProducts.map((product) => {
                                                    if (product.indexId === data.indexId) {
                                                      return {
                                                        ...product,
                                                        markAdjType: newValue?.id || marketingAdjustmentType[0].id, // Set adjustment type or default to the first option
                                                        // adjustment: 0,
                                                      };
                                                    }
                                                    return product;
                                                  });
                                                });
                                              }}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  required
                                                  error={Boolean(touched.marketingAdjType && errors.marketingAdjType)}
                                                  helperText={touched.marketingAdjType && errors.marketingAdjType}
                                                  label="Select type"
                                                />
                                              )}
                                              getOptionLabel={(option) => (option.name ? option.name : '')}
                                            />
                                          </TableCell> */}
                                          {/* <TableCell> */}
                                            {/* <TextField
                                              type="number"
                                              label="Discount"
                                              defaultValue={0}
                                              value={Number(data.discount)}
                                              // {...getFieldProps(discountFieldName)}
                                              onChange={(event) => {
                                                let newValue = event.target.value;
                                                if (newValue.startsWith('-')) {
                                                  newValue = newValue.slice(1);
                                                }
                                                if (markupType == 1) {
                                                  if (Number(newValue) > maxDiscount_wholesale) {
                                                    newValue = maxDiscount_wholesale.toFixed(2);
                                                  }
                                                } else if (markupType == 2) {
                                                  if (Number(newValue) > maxDiscount_retail) {
                                                    newValue = maxDiscount_retail.toFixed(2);
                                                  }
                                                } else {
                                                  newValue = 0;
                                                }
                                                if (newValue === '-0.00') {
                                                  newValue = 0;
                                                }
                                                data['discount'] = newValue
                                                setFieldValue(discountFieldName, newValue);
                                              }}
                                              error={Boolean(touched[discountFieldName] && errors[discountFieldName])}
                                              helperText={touched[discountFieldName] && errors[discountFieldName]}
                                              inputProps={{ max: markupType == 1 ? maxDiscount_wholesale : markupType == 2 ? maxDiscount_retail : 0, min: 0 }}
                                            /> */}
                                            {/* <TextField
                                              type="number"
                                              // label="(%)"
                                              label={
                                                data.markAdjType === 2 ? "$" : data.markAdjType === 3 ? "¢" : "%"
                                              }

                                              value={Number(data.adjustment) || null}
                                              onChange={(event) => {
                                                let newValue = event.target.value;

                                                // Allow only two decimal places
                                                if (newValue.includes('.')) {
                                                  const parts = newValue.split('.');
                                                  if (parts[1].length > 2) {
                                                    newValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                                  }
                                                }
                                                
                                                data['adjustment'] = newValue
                                                setFieldValue(adjustmentFieldName, newValue);
                                              }}
                                              onKeyDown={(event) => {
                                                if (event.key === '-' || event.key === '+') {
                                                  event.preventDefault();
                                                }
                                              }}
                                              error={Boolean(touched[adjustmentFieldName] && errors[adjustmentFieldName])}
                                              helperText={touched[adjustmentFieldName] && errors[adjustmentFieldName]}
                                            />
                                          </TableCell> */}
                                          {/* <TableCell>
                                            {(calculateTotal(markupType == 1 ? data.price : (markupType == 2 ? data.retail_price : 0), Number(data.quantity), values[discountFieldName], data.locationQuantity, data?.adjustment, data.markAdjType))?.toFixed(2)}
                                          </TableCell> */}


                                          {/* //maketting adjustment */}
                                          <TableCell>
                                                <Stack direction="row" spacing={1} alignItems="center">
                                                  <Remove 
                                                    fontSize="small" 
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => {
                                                      const hasPermission =  explodedPermissions?.some((permission) =>
                                                        ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
                                                      )
                                                      if(!hasPermission) {
                                                        return enqueueSnackbar('Access Denied : You do not have Suffient Permission', { variant: 'error' })
                                                      }
                                                      const formulaEach = Number(
                                                        (data?.expected_material_cost_with_markup || 0) +
                                                          (data?.expected_service_cost_with_markup || 0),
                                                      )
                                                      const retailEachBase = Math.max(
                                                        0,
                                                        Number(
                                                          data.original_actual_retail_price ??
                                                            data.original_retail_price ??
                                                            data.actual_retail_price ??
                                                            data.retail_price ??
                                                            data.product_retail_price ??
                                                            0,
                                                        ),
                                                      )
                                                      if (retailEachBase <= formulaEach) {
                                                        return enqueueSnackbar(
                                                          'To apply a negative marketing adjustment, Retail Price Each must be higher than the Product formula cost Each.',
                                                          { variant: 'error' },
                                                        )
                                                      }
                                                      const maxNegative = getMaxNegativeAdjustment(data);
                                                      const adjustment = Number(data.adjustment) || 0;
                                                      if (adjustment > maxNegative) {
                                                        return enqueueSnackbar(
                                                          `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${maxNegative.toFixed(2)}`,
                                                          { variant: 'error' }
                                                        );
                                                      }
                                                      const newValue = false
                                                      setSelectedProducts(
                                                        (prevProducts) =>
                                                          prevProducts.map(
                                                            (product) => {
                                                              if (
                                                                product.indexId ===
                                                                data.indexId
                                                              ) {
                                                                return {
                                                                  ...product,
                                                                  adj_value_type: newValue,
                                                                }
                                                              }
                                                              return product
                                                            },
                                                          ),
                                                      )
                                                      data['adj_value_type'] = newValue
                                                      // markUnsavedChanges();
                                                    }}
                                                  />
                                                  <FormControlLabel
                                                    control={
                                                      <Switch
                                                        checked={data.adj_value_type}
                                                        onChange={(event) => {
                                                          const newValue = event.target.checked
                                                          const hasPermission =  explodedPermissions?.some((permission) =>
                                                            ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
                                                          )
                                                          if(!hasPermission && newValue === false) {
                                                            return enqueueSnackbar('Access Denied : You do not have Suffient Permission', { variant: 'error' })
                                                          }
                                                        if (newValue === false) {
                                                          const formulaEach = Number(
                                                            (data?.expected_material_cost_with_markup || 0) +
                                                              (data?.expected_service_cost_with_markup || 0),
                                                          )
                                                          const retailEachBase = Math.max(
                                                            0,
                                                            Number(
                                                              data.original_actual_retail_price ??
                                                                data.original_retail_price ??
                                                                data.actual_retail_price ??
                                                                data.retail_price ??
                                                                data.product_retail_price ??
                                                                0,
                                                            ),
                                                          )
                                                          if (retailEachBase <= formulaEach) {
                                                            return enqueueSnackbar(
                                                              'To apply a negative marketing adjustment, Retail Price Each must be higher than the Product formula cost Each.',
                                                              { variant: 'error' },
                                                            )
                                                          }
                                                        }
                                                          const maxNegative = getMaxNegativeAdjustment(data);
                                                          const adjustment = Number(data.adjustment) || 0;
                                                          if (adjustment > maxNegative && newValue === false) {
                                                            return enqueueSnackbar(
                                                              `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${maxNegative.toFixed(2)}`,
                                                              { variant: 'error' }
                                                            );
                                                          }
                                                          setSelectedProducts(
                                                            (prevProducts) =>
                                                              prevProducts.map(
                                                                (product) => {
                                                                  if (
                                                                    product.indexId ===
                                                                    data.indexId
                                                                  ) {
                                                                    return {
                                                                      ...product,
                                                                      adj_value_type: newValue,
                                                                    }
                                                                  }
                                                                  return product
                                                                },
                                                              ),
                                                          )
                                                          data['adj_value_type'] = newValue
                                                          // markUnsavedChanges();
                                                        }}
                                                      />
                                                    }
                                                    label=""
                                                  />
                                                  <Add 
                                                    fontSize="small" 
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => {
                                                      const newValue = true
                                                      setSelectedProducts(
                                                        (prevProducts) =>
                                                          prevProducts.map(
                                                            (product) => {
                                                              if (
                                                                product.indexId ===
                                                                data.indexId
                                                              ) {
                                                                return {
                                                                  ...product,
                                                                  adj_value_type: newValue,
                                                                }
                                                              }
                                                              return product
                                                            },
                                                          ),
                                                      )
                                                      data['adj_value_type'] = newValue
                                                      // markUnsavedChanges();
                                                    }}
                                                  />
                                                </Stack>
                                              </TableCell>
                                            <TableCell>
                                               <TextField
                                                  type="number"
                                                  inputProps={{ min: 0 }}
                                                  // label={
                                                  //   data.markAdjType === 2
                                                  //     ? '$'
                                                  //     : data.markAdjType === 3
                                                  //     ? '¢'
                                                  //     : '%'
                                                  // }
                                                  label='$'
                                                  value={
                                                    Number(data.adjustment) ||
                                                    null
                                                  }
                                                  onWheel={(e) => e.target.blur()}
                                                  onBeforeInput={(e) => {
                                                    // const char = e.data; // next typed character
                                                    // const nextValue = e.target.value + char;
                                                    const inputElement = e.target;
                                                    const nextValue = inputElement.value; 
                                                
                                                    const maxNegative = getMaxNegativeAdjustment(data);
                                                    if (Number(nextValue) > maxNegative && (data.adj_value_type === false || data.adj_value_type === 0)) {
                                                      e.preventDefault(); // ← stops the key BEFORE appearing
                                                      enqueueSnackbar(
                                                        `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${maxNegative.toFixed(2)}`,
                                                        { variant: "error" }
                                                      );
                                                    }
                                                  }}
                                                  onChange={(event) => {
                                                    let newValue =event.target.value
                                                    const maxNegative = getMaxNegativeAdjustment(data);
                                                    if (Number(newValue) > maxNegative && (data.adj_value_type === false || data.adj_value_type === 0)) {
                                                      enqueueSnackbar(
                                                        `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${maxNegative.toFixed(2)}`,
                                                        { variant: 'error' }
                                                      );
                                                      return;
                                                    }
                                                    const numValue = parseFloat(newValue) || 0
                                                    if(numValue < 0) {
                                                      newValue = 0
                                                    } else {
                                                      newValue = String(numValue)
                                                    }
                                                    // Allow only two decimal places
                                                    if (
                                                      newValue.includes('.')
                                                    ) {
                                                      const parts =
                                                        newValue.split('.')
                                                      if (parts[1].length > 2) {
                                                        newValue = `${
                                                          parts[0]
                                                        }.${parts[1].slice(
                                                          0,
                                                          2,
                                                        )}`
                                                      }
                                                    }
                                                    data['adjustment'] =
                                                      newValue
                                                      setFieldValue(
                                                      adjustmentFieldName,
                                                      newValue,
                                                    );
                                                    // markUnsavedChanges();
                                                  }}
                                                  onKeyDown={(event) => {
                                                    if (
                                                      event.key === '-' ||
                                                      event.key === '+'
                                                    ) {
                                                      event.preventDefault()
                                                    }
                                                    // Prevent arrow down key when value is 0 or would go negative
                                                    if (event.key === 'ArrowDown') {
                                                      const inputValue = event.target.value
                                                      const currentValue = parseFloat(inputValue) || 0
                                                      const step = parseFloat(event.target.step) || 1
                                                      if (currentValue - step < 0) {
                                                        event.preventDefault()
                                                      }
                                                    }
                                                  }}
                                                  error={Boolean(
                                                    touched[
                                                      adjustmentFieldName
                                                    ] &&
                                                      errors[
                                                        adjustmentFieldName
                                                      ],
                                                  )}
                                                  helperText={
                                                    touched[
                                                      adjustmentFieldName
                                                    ] &&
                                                    errors[adjustmentFieldName]
                                                  }
                                                />
                                              </TableCell>



                                          <TableCell>
                                            {((hasMarkupPermission && markupType == 2)
                                                ? 
                                                (data?.isAdditionalProduct ?
                                                  <TextField
                                                    required
                                                    fullWidth
                                                    type="number"
                                                    label={'Retail Price Each'}
                                                    // disabled={
                                                    //   values.project_categories
                                                    //     ?.name ==
                                                    //   'Time & Material'
                                                    //     ? true
                                                    //     : false
                                                    // }
                                                    disabled={
                                                        false
                                                    }
                                                    sx={{ width: 85 }}
                                                    value={data?.actual_retail_price || data?.retail_price}
                                                    // onWheel={(e) => e.target.blur()}
                                                    onKeyPress={(event) => {
                                                      // if (event.key === '0' && event.target.value === '') {
                                                      //   event.preventDefault();
                                                      // }
                                                      if (event.key === '-') {
                                                        event.preventDefault();
                                                      }
                                                      if (event.key === 'e') {
                                                        event.preventDefault();
                                                      }
                                                    }}
                                                    inputProps={{ min: 0 }}
                                                    defaultValue={0}
                                                    onChange={(event) => {
                                                      let newValue =
                                                        event.target.value
                                                      if (newValue !== '') {
                                                        setSelectedProducts(
                                                          (pv) => [
                                                            ...pv.map((p) => {
                                                              if (
                                                                p.indexId ===
                                                                data.indexId
                                                              ) {
                                                                return {
                                                                  ...p,
                                                                  retail_price:
                                                                    newValue,
                                                                  price: newValue,
                                                                }
                                                              } else {
                                                                return p
                                                              }
                                                            }),
                                                          ],
                                                        )
                                                        data['retail_price'] =
                                                          newValue || 0
                                                        data['price'] =
                                                          newValue || 0
                                                      }
                                                    }}
                                                    // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                                    // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                                  /> :
                                                  Math.max(
                                                  0,
                                                 ((data?.actual_retail_price || data?.retail_price || 0) *
                                                    (data?.locationQuantity || 1)) //+ (data.adj_value_type ? (Number(data?.adjustment) || 0) : -(Number(data?.adjustment) || 0))      //PRODUCT SUBTOTAL
                                                ).toFixed(2)
                                                ) 
                                                : null)}
                                          </TableCell>
                                          <TableCell>
                                            { data?.install_cost ? '' :
                                            calculateTotal(
                                              markupType == 1
                                                ? data.price
                                                : markupType == 2
                                                // ? data.retail_price
                                                ? (data?.actual_retail_price || data?.retail_price || 0)
                                                : 0,
                                              Number(data.quantity),
                                              values[discountFieldName],
                                              data.locationQuantity,
                                              data.adjustment,
                                              data.markAdjType,
                                              data.adj_value_type
                                            )?.toFixed(2)}
                                          </TableCell>
                                          <TableCell >
                                            {(data?.fromMapServices == true) ? '' : 
                                            <IconButton onClick={() => handleDeleteProduct(data.id, data.indexId)}>
                                              <Delete />
                                            </IconButton>}
                                          </TableCell>
                                        </TableRow>
                                        {
                      data?.install_cost ?
                        <TableRow key={`summary-${data.indexId}`} sx={losingMoneyRowSx}>
                          <TableCell>#{data?.indexId}</TableCell>
                          <TableCell><Typography sx={{color: data?.install_notes ? 'red' : 'inherit' ,whiteSpace: 'pre-wrap'}}>{data?.install_notes ? data?.install_notes : `Install Price`}</Typography></TableCell>
                          <TableCell align='center'>
                            <IconButton onClick={() => handleOpenInstallNote(data.indexId, data.install_notes)}>
                              <NoteAdd
                                sx={{
                                  color: (!data?.install_notes || data?.install_notes === '') ? '' : theme.palette.primary.main,
                                }}
                              />
                            </IconButton>
                          </TableCell>
                          <TableCell>{data?.expected_install_labor_cost_with_markup?.toFixed(2) || 0}</TableCell>
                                              <TableCell align='center'>
                                                {(
                                                parseFloat(data?.install_cost || 0)
                                                ).toFixed(2)}
                                              </TableCell>
                                              <TableCell align='center'></TableCell>
                                              {/* <TableCell align='center'></TableCell> */}
                                              <TableCell align='center'>
                                                <TextField
                                                  required
                                                  fullWidth
                                                  type="number"
                                                  label={'Qty'}
                                                  // sx={{ width: 85 }}
                                                  value={Number(data.install_quantity || 1)}
                                                  defaultValue={1}
                                                  onKeyPress={(event) => {
                                                    if (
                                                      event.key === '0' &&
                                                      event.target.value === ''
                                                    ) {
                                                      event.preventDefault()
                                                    }
                                                    if (event.key === '-') {
                                                      event.preventDefault()
                                                    }
                                                    if (event.key === '.') {
                                                      event.preventDefault()
                                                    }
                                                  }}
                                                  onChange={(event) => {
                                                    let newValue = event.target.value
                                                    if (newValue !== '0' && newValue !== '') {
                                                      setSelectedProducts((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.indexId !== data.indexId) return p
                                                          return {
                                                            ...p,
                                                            install_quantity: Number(newValue),
                                                          }
                                                        }),
                                                      )
                                                      data['install_quantity'] = Number(newValue)
                                                      // markUnsavedChanges();
                                                    }
                                                  }}
                                                />
                                              </TableCell>
                                              <TableCell align='center'></TableCell>
                                              {/* Marketing adjustment for Install Price (separate from product marketing adjustment) */}
                                              <TableCell>
                                                <Stack direction="row" spacing={1} alignItems="center">
                                                  <Remove
                                                    fontSize="small"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => {
                                                      const hasPermission =
                                                        explodedPermissions?.some((permission) =>
                                                          ['Allow Negative Marketing Adjustment Sales Order'].includes(permission),
                                                        )
                                                      if (!hasPermission) {
                                                        return enqueueSnackbar(
                                                          'Access Denied : You do not have Suffient Permission',
                                                          { variant: 'error' },
                                                        )
                                                      }
                                                      const formulaEach = Number(
                                                        data?.expected_install_labor_cost_with_markup || 0,
                                                      )
                                                      const retailEachBase = Math.max(
                                                        0,
                                                        Number(data.install_cost || 0),
                                                      )
                                                      if (retailEachBase <= formulaEach) {
                                                        return enqueueSnackbar(
                                                          'To apply a negative marketing adjustment, Install Price Each must be higher than the Install formula cost Each.',
                                                          { variant: 'error' },
                                                        )
                                                      }
                                                      const maxNegative = getMaxNegativeInstallAdjustment(data)
                                                      const adjustment = Number(data.install_adjustment) || 0
                                                      if (Number(adjustment) > maxNegative) {
                                                        return enqueueSnackbar(
                                                          `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Install Formula Limit)`,
                                                          { variant: 'error' },
                                                        )
                                                      }

                                                      const newValue = false
                                                      setSelectedProducts((prevProducts) =>
                                                        prevProducts.map((product) => {
                                                          if (product.indexId !== data.indexId) return product

                                                          const baseInstall = Number(data?.original_install_cost) || 0
                                                          const adj = Number(data?.install_adjustment) || 0
                                                          const newInstallCost = baseInstall ? Math.max(0, baseInstall + (newValue ? adj : -adj)) : null

                                                          return {
                                                            ...product,
                                                            install_adj_value_type: newValue,
                                                            install_cost: newInstallCost,
                                                          }
                                                        }),
                                                      )
                                                      data['install_adj_value_type'] = newValue
                                                      // markUnsavedChanges();
                                                    }}
                                                  />
                                                  <FormControlLabel
                                                    control={
                                                      <Switch
                                                        checked={Boolean(data.install_adj_value_type)}
                                                        onChange={(event) => {
                                                          const newValue = event.target.checked
                                                          const hasPermission =
                                                            explodedPermissions?.some((permission) =>
                                                              ['Allow Negative Marketing Adjustment Sales Order'].includes(permission),
                                                            )
                                                          if (!hasPermission && newValue === false) {
                                                            return enqueueSnackbar(
                                                              'Access Denied : You do not have Suffient Permission',
                                                              { variant: 'error' },
                                                            )
                                                          }
                                                        if (newValue === false) {
                                                          const formulaEach = Number(
                                                            data?.expected_install_labor_cost_with_markup || 0,
                                                          )
                                                          const retailEachBase = Math.max(
                                                            0,
                                                            Number(data.install_cost || 0),
                                                          )
                                                          if (retailEachBase <= formulaEach) {
                                                            return enqueueSnackbar(
                                                              'To apply a negative marketing adjustment, Install Price Each must be higher than the Install formula cost Each.',
                                                              { variant: 'error' },
                                                            )
                                                          }
                                                        }

                                                          const maxNegative = getMaxNegativeInstallAdjustment(data)
                                                          const adjustment = Number(data.install_adjustment) || 0
                                                          if (Number(adjustment) > maxNegative && newValue === false) {
                                                            return enqueueSnackbar(
                                                              `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Install Formula Limit)`,
                                                              { variant: 'error' },
                                                            )
                                                          }

                                                          setSelectedProducts((prevProducts) =>
                                                            prevProducts.map((product) => {
                                                              if (product.indexId !== data.indexId) return product

                                                              const baseInstall = Number(data?.original_install_cost) || 0
                                                              const adj = Number(data?.install_adjustment) || 0
                                                              const newInstallCost = baseInstall ? Math.max(0, baseInstall + (newValue ? adj : -adj)) : null

                                                              return {
                                                                ...product,
                                                                install_adj_value_type: newValue,
                                                                install_cost: newInstallCost,
                                                              }
                                                            }),
                                                          )
                                                          data['install_adj_value_type'] = newValue
                                                          // markUnsavedChanges();
                                                        }}
                                                      />
                                                    }
                                                    label=""
                                                  />
                                                  <Add
                                                    fontSize="small"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => {
                                                      const newValue = true
                                                      setSelectedProducts((prevProducts) =>
                                                        prevProducts.map((product) => {
                                                          if (product.indexId !== data.indexId) return product

                                                          const baseInstall = Number(data?.original_install_cost) || 0
                                                          const adj = Number(data?.install_adjustment) || 0
                                                          const newInstallCost = baseInstall ? Math.max(0, baseInstall + (newValue ? adj : -adj)) : null

                                                          return {
                                                            ...product,
                                                            install_adj_value_type: newValue,
                                                            install_cost: newInstallCost,
                                                          }
                                                        }),
                                                      )
                                                      data['install_adj_value_type'] = newValue
                                                      // markUnsavedChanges();
                                                    }}
                                                  />
                                                </Stack>
                                              </TableCell>
                                              <TableCell>
                                                <TextField
                                                  type="number"
                                                  inputProps={{ min: 0 }}
                                                  label="$"
                                                  value={Number(data.install_adjustment) || null}
                                                  onWheel={(e) => e.target.blur()}
                                                  onBeforeInput={(e) => {
                                                    // const char = e.data
                                                    // const nextValue = e.target.value + char
                                                    const inputElement = e.target;
                                                    const nextValue = inputElement.value; 
                                                    const maxNegative = getMaxNegativeInstallAdjustment(data)
                                                    if (
                                                      Number(nextValue) > maxNegative &&
                                                      data.install_adj_value_type === false
                                                    ) {
                                                      e.preventDefault()
                                                      enqueueSnackbar(
                                                        `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Install Formula Limit)`,
                                                        { variant: 'error' },
                                                      )
                                                    }
                                                  }}
                                                  onChange={(event) => {
                                                    let newValue = event.target.value
                                                    const maxNegative = getMaxNegativeInstallAdjustment(data)
                                                    if (
                                                      Number(newValue) > maxNegative &&
                                                      data.install_adj_value_type === false
                                                    ) {
                                                      enqueueSnackbar(
                                                        `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Install Formula Limit)`,
                                                        { variant: 'error' },
                                                      )
                                                      return
                                                    }

                                                    const numValue = parseFloat(newValue) || 0
                                                    if (numValue < 0) {
                                                      newValue = 0
                                                    } else {
                                                      newValue = String(numValue)
                                                    }

                                                    // Allow only two decimal places
                                                    if (newValue.includes('.')) {
                                                      const parts = newValue.split('.')
                                                      if (parts[1].length > 2) {
                                                        newValue = `${parts[0]}.${parts[1].slice(0, 2)}`
                                                      }
                                                    }

                                                    setSelectedProducts((prevProducts) =>
                                                      prevProducts.map((product) => {
                                                        if (product.indexId !== data.indexId) return product

                                                        const baseInstall = Number(data?.original_install_cost) || 0
                                                        const adj = Number(newValue) || 0
                                                        const newInstallCost = baseInstall ? Math.max(0, baseInstall + (product.install_adj_value_type ? adj : -adj)) : null

                                                        return {
                                                          ...product,
                                                          install_adjustment: newValue,
                                                          install_cost: newInstallCost,
                                                        }
                                                      }),
                                                    )
                                                    // markUnsavedChanges();
                                                  }}
                                                  onKeyDown={(event) => {
                                                    if (event.key === '-' || event.key === '+') {
                                                      event.preventDefault()
                                                    }
                                                    if (event.key === 'ArrowDown') {
                                                      const inputValue = event.target.value
                                                      const currentValue = parseFloat(inputValue) || 0
                                                      const step = parseFloat(event.target.step) || 1
                                                      if (currentValue - step < 0) {
                                                        event.preventDefault()
                                                      }
                                                    }
                                                  }}
                                                />
                                              </TableCell>
                                              <TableCell align='center'>
                                                {(
                                                parseFloat(data?.install_cost || 0) *
                                                (Number(data?.install_quantity) || 1)
                                                ).toFixed(2)}
                                              </TableCell>
                                              <TableCell>
                                               {(() => {
                                                  const locQty = Number(data?.locationQuantity) || 1
                                                  const installQty = Number(data?.install_quantity) || 1
                                                  const discount = Number(values[discountFieldName]) || 0

                                                  // Use the exact same calculation as the product subtotal column
                                                  const productSubTotal =
                                                    markupType == 1
                                                      ? (Number(data?.price) || 0) * locQty
                                                      : markupType == 2
                                                      ? (Number(data?.actual_retail_price || data?.retail_price || 0)) * locQty
                                                      : 0

                                                  // Use the exact same calculation as the install subtotal column
                                                  const installSubTotal =
                                                    (Number(data?.install_cost) || 0) *
                                                    installQty

                                                  // Product Total is the sum of both subtotals minus discount
                                                  return Math.max(
                                                    0,
                                                    productSubTotal + installSubTotal - discount,
                                                  ).toFixed(2)
                                                })()}
                                              </TableCell>
                                              <TableCell>
                                                <IconButton
                                                  onClick={() =>
                                                    handleDeleteInstallCost(
                                                      data.id,
                                                      data.indexId,
                                                    )
                                                  }
                                                >
                                                  <Delete />
                                                </IconButton>
                                              </TableCell>
                                            </TableRow> :
                                            ''
                                        }
                                        <TableRow>
                                          <TableCell colSpan={15} sx={{ padding: 0 }}>
                                            <Divider />
                                          </TableCell>
                                        </TableRow> 
                                        <Modal
                                          open={locationStates[data.indexId]}
                                          handleClose={() => {
                                            setLocationStates({ ...locationStates, [data.indexId]: false });
                                          }}
                                        >
                                          {/* {selectedProducts.map((product, index) => (
                                    <Stack key={index}> */}
                                          <Grid
                                            container
                                            spacing={3}
                                            sx={{ width: '100%' }}
                                          >
                                            <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent={'space-between'} alignItems={'center'} width={'100%'}>
                                            {((data?.fromMapServices != true) 
                                            // && index === 0
                                            ) && 
                                            <Box sx={{ width: '50%' ,
                                              display: 'flex',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                            }}>
                                            <FormControlLabel
                                              control={
                                                <Switch
                                                  checked={data?.allLocationSame}
                                                  onChange={() => handleAllLocationSameChange(index)}
                                                />
                                              }
                                              label="All Locations Same"
                                            />
                                          </Box>
                                            }
                                            {
                                              values.project_categories?.id !== 14 ?
                                            <Box sx={{ display: 'flex', flexDirection: 'column',width:'50%', alignItems: 'center', mt: 2 }}>
                                                <LabelStyle >Qty Location Settings</LabelStyle>
                                                <Box display="flex" alignItems="center" gap={1}>
                                                  <Typography variant="subtitle2">Multiple</Typography>
                                                  {/* <Switch
                                                color="primary"
                                                {...getFieldProps('is_single_card')}
                                                checked={values.is_single_card}
                                              
                                                onChange={(event) => {
                                                  const checked = event.target.checked;
                                                  setSingleLocationCard(checked);
                                                  setFieldValue('is_single_card', event.target.checked)
                                                  if (checked) {
                                                    setSelectedProducts((prev) =>
                                                      prev.map((p) => ({
                                                        ...p,
                                                        addresses: p.addresses?.length ? [p.addresses[0]] : [
                                                          {
                                                            id: 0,
                                                            address: '',
                                                            city: '',
                                                            state: '',
                                                            zip: '',
                                                          },
                                                        ],
                                                      }))
                                                    );
                                                  }else {
                                                    setSelectedProducts((prev) =>
                                                      prev.map((p) => {
                                                        const count = Number(p.locationQuantity || 1);
                                                        let arrayAddr = [];
                                                
                                                        const allSame = p.allLocationSame;
                                                        const firstAddress = p.addresses?.[0];
                                                
                                                        if (allSame && firstAddress) {
                                                          arrayAddr = Array(count).fill().map((_, i) => ({
                                                            ...firstAddress,
                                                            id: i,
                                                            req_loc_id: p.addresses[i]?.req_loc_id ?? null,
                                                          }));
                                                        } else {
                                                          arrayAddr = [...p.addresses];
                                                          if (arrayAddr.length < count) {
                                                            arrayAddr.push(
                                                              ...Array(count - arrayAddr.length)
                                                                .fill()
                                                                .map((_, i) => ({
                                                                  id: arrayAddr.length + i,
                                                                  address: '',
                                                                  city: '',
                                                                  state: '',
                                                                  zip: '',
                                                                }))
                                                            );
                                                          } else if (arrayAddr.length > count) {
                                                            arrayAddr = arrayAddr.slice(0, count);
                                                          }
                                                        }
                                                
                                                        return {
                                                          ...p,
                                                          addresses: arrayAddr,
                                                        };
                                                      })
                                                    );
                                                  }
                                                }}
                                                
                                              /> */}
                                              <Switch
                                              color="primary"
                                              checked={data?.is_single_card}
                                              onChange={(event) => {
                                                const checked = event.target.checked;

                                                setSelectedProducts((prev) =>
                                                  prev.map((p) => {
                                                    if (p.indexId !== data.indexId) return p;

                                                    const count = Number(p.locationQuantity || 1);

                                                    if (checked) {
                                                      return {
                                                        ...p,
                                                        is_single_card: true,
                                                        addresses: p.addresses?.length
                                                          ? [p.addresses[0]]
                                                          : [
                                                              {
                                                                id: 0,
                                                                address: '',
                                                                city: '',
                                                                state: '',
                                                                zip: '',
                                                              },
                                                            ],
                                                      };
                                                    } else {
                                                      const allSame = p.allLocationSame;
                                                      const firstAddress = p.addresses?.[0];
                                                      let arrayAddr = [];

                                                      if (allSame && firstAddress) {
                                                        arrayAddr = Array(count)
                                                          .fill()
                                                          .map((_, i) => ({
                                                            ...firstAddress,
                                                            id: i,
                                                            req_loc_id: p.addresses[i]?.req_loc_id ?? null,
                                                          }));
                                                      } else {
                                                        arrayAddr = [...p.addresses];
                                                        if (arrayAddr.length < count) {
                                                          arrayAddr.push(
                                                            ...Array(count - arrayAddr.length)
                                                              .fill()
                                                              .map((_, i) => ({
                                                                id: arrayAddr.length + i,
                                                                address: '',
                                                                city: '',
                                                                state: '',
                                                                zip: '',
                                                              }))
                                                          );
                                                        } else if (arrayAddr.length > count) {
                                                          arrayAddr = arrayAddr.slice(0, count);
                                                        }
                                                      }

                                                      return {
                                                        ...p,
                                                        is_single_card: false,
                                                        addresses: arrayAddr,
                                                      };
                                                    }
                                                  })
                                                );
                                                // markUnsavedChanges();
                                              }}
                                            />
                                            <Typography variant="subtitle2">Single</Typography>
                                          </Box>
                                      </Box>:''
                                        }
                                      </Stack>
                                            {data.addresses.map((addr, i) => (
                                              <Grid item xs={12}>
                                                {/* Side Heading */}
                                                <Typography variant="h5" sx={{ mb: 2 }}>
                                                  Location {data?.fromMapServices == true ? i+1 : i+1}
                                                </Typography>

                                                {/* Address Fields */}

                                                <Stack
                                                  direction={{ xs: 'column', sm: 'row' }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="Address"
                                                    size="small"
                                                    value={data.addresses[i].address || ''}
                                                    disabled={(data?.fromMapServices == true && data.addresses[i].address) ? true : (i !== 0 && data?.allLocationSame) ? true : false}
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.addresses]
                                                    //   arrayAddr[i].address = event.target.value;
                                                    //   setSelectedProducts(pv => ([...pv.map(p => {
                                                    //     // if (p.id === data.id) {
                                                    //     if (p.indexId === data.indexId) {
                                                    //       return {
                                                    //         ...p,
                                                    //         addresses: arrayAddr
                                                    //       }
                                                    //     } else {
                                                    //       return p;
                                                    //     }
                                                    //   })]))
                                                    // }}
                                                    onChange={(event) => {
                                                      setSelectedProducts((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.indexId === data.indexId) {
                                                            let updatedAddresses = [...p.addresses];
                                                            if (p.allLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                address: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                address: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              addresses: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                      // markUnsavedChanges();
                                                    }}
                                                  />
                                                </Stack>

                                                {/* City, State, Zip Fields */}
                                                <Stack
                                                  direction={{ xs: 'column', sm: 'row' }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="City"
                                                    size="small"
                                                    value={data.addresses[i].city || ''}
                                                    disabled={(data?.fromMapServices == true && data.addresses[i].city) ? true : (i !== 0 && data?.allLocationSame) ? true : false}
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.addresses]
                                                    //   arrayAddr[i].city = event.target.value;
                                                    //   setSelectedProducts(pv => ([...pv.map(p => {
                                                    //     // if (p.id === data.id) {
                                                    //     if (p.indexId === data.indexId) {
                                                    //       return {
                                                    //         ...p,
                                                    //         addresses: arrayAddr
                                                    //       }
                                                    //     } else {
                                                    //       return p;
                                                    //     }
                                                    //   })]))
                                                    // }}
                                                    onChange={(event) => {
                                                      setSelectedProducts((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.indexId === data.indexId) {
                                                            let updatedAddresses = [...p.addresses];
                                                            if (p.allLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                city: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                city: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              addresses: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                      // markUnsavedChanges();
                                                    }}
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="State"
                                                    size="small"
                                                    value={data.addresses[i].state || ''}
                                                    disabled={(data?.fromMapServices == true && data.addresses[i].state) ? true : (i !== 0 && data?.allLocationSame) ? true : false}
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.addresses]
                                                    //   arrayAddr[i].state = event.target.value;
                                                    //   setSelectedProducts(pv => ([...pv.map(p => {
                                                    //     // if (p.id === data.id) {
                                                    //     if (p.indexId === data.indexId) {
                                                    //       return {
                                                    //         ...p,
                                                    //         addresses: arrayAddr
                                                    //       }
                                                    //     } else {
                                                    //       return p;
                                                    //     }
                                                    //   })]))
                                                    // }}
                                                    onChange={(event) => {
                                                      setSelectedProducts((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.indexId === data.indexId) {
                                                            let updatedAddresses = [...p.addresses];
                                                            if (p.allLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                state: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                state: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              addresses: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                      // markUnsavedChanges();
                                                    }}
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="Zip / Postal Code"
                                                    size="small"
                                                    value={data.addresses[i].zip || ''}
                                                    disabled={(data?.fromMapServices == true && data.addresses[i].zip) ? true : (i !== 0 && data?.allLocationSame) ? true : false}
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.addresses]
                                                    //   arrayAddr[i].zip = event.target.value;
                                                    //   setSelectedProducts(pv => ([...pv.map(p => {
                                                    //     // if (p.id === data.id) {
                                                    //     if (p.indexId === data.indexId) {
                                                    //       return {
                                                    //         ...p,
                                                    //         addresses: arrayAddr
                                                    //       }
                                                    //     } else {
                                                    //       return p;
                                                    //     }
                                                    //   })]))
                                                    // }}
                                                    onChange={(event) => {
                                                      setSelectedProducts((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.indexId === data.indexId) {
                                                            let updatedAddresses = [...p.addresses];
                                                            if (p.allLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                zip: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                zip: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              addresses: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                      // markUnsavedChanges();
                                                    }}
                                                  />
                                                </Stack>
                                              </Grid>
                                            ))}
                                          </Grid>
                                          {/* </Stack>
                                ))} */}

                                          <Grid container justifyContent="center" alignItems="center">
                                            <Grid item xs={12} md={4}>
                                              {(data?.fromMapServices == true) ? true : //(i !== 0 && data?.allLocationSame) ? true :
                                                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                                  <LoadingButton variant="contained" onClick={() => {
                                                    setIsSaving(true)
                                                    setTimeout(() => {
                                                      setIsSaving(false)
                                                      setLocationStates(false)
                                                    }, 100)
                                                  }} loading={isSaving}>
                                                    {' Save '}
                                                  </LoadingButton>
                                                  {/* <Button variant="outlined" type="submit" onClick={() => { setLocationStates(false) }}>
                                                Cancel
                                              </Button> */}
                                                </Box>}
                                            </Grid>
                                          </Grid>
                                        </Modal>
                                        <Modal
                                          open={openProductNote[data.indexId] || false}
                                          handleClose={() => handleCloseNote(data.indexId)}
                                        >
                                          <Grid
                                            container
                                            spacing={3}
                                            sx={{ justifyContent: 'center', width: '100%' }}
                                          >
                                            <Grid item xs={12}>
                                              <Typography variant="h5" sx={{ mb: 2, }}>
                                                Note
                                              </Typography>

                                              <Stack
                                                direction={{ xs: 'column', sm: 'row' }}
                                                spacing={{ xs: 3, sm: 2 }}
                                                sx={{ mb: 2 }}
                                              >
                                                <TextField
                                                  fullWidth
                                                  multiline
                                                  rows={4}
                                                  size="medium"
                                                  value={currentNote}
                                                  onChange={handleNoteChange}
                                                  error={!currentNote.trim() && currentNote.length > 0}
                                                  inputProps={{ maxLength: MAX_CHARACTERS }}
                                                  helperText={
                                                    !currentNote.trim() && currentNote.length > 0
                                                      ? 'Note cannot be empty or contain only spaces'
                                                      : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                                  }
                                                  InputProps={{
                                                    sx: {
                                                      color: 'error.main',
                                                    }
                                                  }}
                                                />
                                              </Stack>
                                            </Grid>
                                          </Grid>

                                          <Grid container justifyContent="center" alignItems="center">
                                            <Grid item xs={12} md={4}>
                                              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                                <LoadingButton
                                                  variant="contained"
                                                  onClick={() => handleSaveNote(data.indexId)}
                                                  loading={isSavingNote}
                                                  disabled={!currentNote.trim()}>
                                                  Save
                                                </LoadingButton>
                                                <LoadingButton
                                                  variant="outlined"
                                                  color="error"
                                                  onClick={() => handleClearNote(data.indexId)}
                                                  loading={isClearingNote}
                                                  disabled={!currentNote.trim()}>
                                                  Clear
                                                </LoadingButton>
                                              </Box>
                                            </Grid>
                                          </Grid>
                                        </Modal>
                                        <Modal
                                          open={openInstallNote[data.indexId] || false}
                                          handleClose={() => handleCloseInstallNote(data.indexId)}
                                        >
                                          <Grid
                                            container
                                            spacing={3}
                                            sx={{ justifyContent: 'center', width: '100%' }}
                                          >
                                            <Grid item xs={12}>
                                              <Typography variant="h5" sx={{ mb: 2, }}>
                                                Install Note
                                              </Typography>

                                              <Stack
                                                direction={{ xs: 'column', sm: 'row' }}
                                                spacing={{ xs: 3, sm: 2 }}
                                                sx={{ mb: 2 }}
                                              >
                                                <TextField
                                                  fullWidth
                                                  multiline
                                                  rows={4}
                                                  size="medium"
                                                  value={currentNote}
                                                  onChange={handleNoteChange}
                                                  error={!currentNote.trim() && currentNote.length > 0}
                                                  inputProps={{ maxLength: MAX_CHARACTERS }}
                                                  helperText={
                                                    !currentNote.trim() && currentNote.length > 0
                                                      ? 'Note cannot be empty or contain only spaces'
                                                      : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                                  }
                                                  InputProps={{
                                                    sx: {
                                                      color: 'error.main',
                                                    }
                                                  }}
                                                />
                                              </Stack>
                                            </Grid>
                                          </Grid>

                                          <Grid container justifyContent="center" alignItems="center">
                                            <Grid item xs={12} md={4}>
                                              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                                <LoadingButton
                                                  variant="contained"
                                                  onClick={() => handleSaveInstallNote(data.indexId)}
                                                  loading={isSavingNote}
                                                  disabled={!currentNote.trim()}>
                                                  Save
                                                </LoadingButton>
                                                <LoadingButton
                                                  variant="outlined"
                                                  color="error"
                                                  onClick={() => handleClearInstallNote(data.indexId)}
                                                  loading={isClearingNote}
                                                  disabled={!currentNote.trim()}>
                                                  Clear
                                                </LoadingButton>
                                              </Box>
                                            </Grid>
                                          </Grid>
                                        </Modal>
                                      </>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Scrollbar>
                          
                          {/* Service Note Modal for selectedServices */}
                          {selectedServices?.map((data, index) => (
                            <Modal
                              key={`service-note-${data.indexId || data.id}`}
                              open={openServiceNote[data.indexId || data.id] || false}
                              handleClose={() => handleCloseServiceNote(data.indexId || data.id)}
                            >
                              <Grid
                                container
                                spacing={3}
                                sx={{ justifyContent: 'center', width: '100%' }}
                              >
                                <Grid item xs={12}>
                                  <Typography variant="h5" sx={{ mb: 2, }}>
                                    Service Note
                                  </Typography>

                                  <Stack
                                    direction={{ xs: 'column', sm: 'row' }}
                                    spacing={{ xs: 3, sm: 2 }}
                                    sx={{ mb: 2 }}
                                  >
                                    <TextField
                                      fullWidth
                                      multiline
                                      rows={4}
                                      size="medium"
                                      value={currentNote}
                                      onChange={handleServiceNoteChange}
                                      error={!currentNote.trim() && currentNote.length > 0}
                                      inputProps={{ maxLength: MAX_CHARACTERS }}
                                      helperText={
                                        !currentNote.trim() && currentNote.length > 0
                                          ? 'Note cannot be empty or contain only spaces'
                                          : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                      }
                                      InputProps={{
                                        sx: {
                                          color: 'error.main',
                                        }
                                      }}
                                    />
                                  </Stack>
                                </Grid>
                              </Grid>

                              <Grid container justifyContent="center" alignItems="center">
                                <Grid item xs={12} md={4}>
                                  <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                    <LoadingButton
                                      variant="contained"
                                      onClick={() => handleSaveServiceNote(data.indexId || data.id)}
                                      loading={isSavingNote}
                                      disabled={!currentNote.trim()}>
                                      Save
                                    </LoadingButton>
                                    <LoadingButton
                                      variant="outlined"
                                      color="error"
                                      onClick={() => handleClearServiceNote(data.indexId || data.id)}
                                      loading={isClearingNote}
                                      disabled={!currentNote.trim()}>
                                      Clear
                                    </LoadingButton>
                                  </Box>
                                </Grid>
                              </Grid>
                            </Modal>
                          ))}

                          {/* Service Note Modal for additionalSelectedServices */}
                          {additionalSelectedServices?.map((data, index) => (
                            <Modal
                              key={`additional-service-note-${data.indexId || data.newIndexId || index}`}
                              open={openServiceNote[data.indexId || data.newIndexId || index] || false}
                              handleClose={() => handleCloseServiceNote(data.indexId || data.newIndexId || index)}
                            >
                              <Grid
                                container
                                spacing={3}
                                sx={{ justifyContent: 'center', width: '100%' }}
                              >
                                <Grid item xs={12}>
                                  <Typography variant="h5" sx={{ mb: 2, }}>
                                    Service Note
                                  </Typography>

                                  <Stack
                                    direction={{ xs: 'column', sm: 'row' }}
                                    spacing={{ xs: 3, sm: 2 }}
                                    sx={{ mb: 2 }}
                                  >
                                    <TextField
                                      fullWidth
                                      multiline
                                      rows={4}
                                      size="medium"
                                      value={currentNote}
                                      onChange={handleServiceNoteChange}
                                      error={!currentNote.trim() && currentNote.length > 0}
                                      inputProps={{ maxLength: MAX_CHARACTERS }}
                                      helperText={
                                        !currentNote.trim() && currentNote.length > 0
                                          ? 'Note cannot be empty or contain only spaces'
                                          : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                      }
                                      InputProps={{
                                        sx: {
                                          color: 'error.main',
                                        }
                                      }}
                                    />
                                  </Stack>
                                </Grid>
                              </Grid>

                              <Grid container justifyContent="center" alignItems="center">
                                <Grid item xs={12} md={4}>
                                  <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                    <LoadingButton
                                      variant="contained"
                                      onClick={() => handleSaveServiceNote(data.indexId || data.newIndexId || index)}
                                      loading={isSavingNote}
                                      disabled={!currentNote.trim()}>
                                      Save
                                    </LoadingButton>
                                    <LoadingButton
                                      variant="outlined"
                                      color="error"
                                      onClick={() => handleClearServiceNote(data.indexId || data.newIndexId || index)}
                                      loading={isClearingNote}
                                      disabled={!currentNote.trim()}>
                                      Clear
                                    </LoadingButton>
                                  </Box>
                                </Grid>
                              </Grid>
                            </Modal>
                          ))}

                          {/* Service Note Modal for cartService */}
                          {cartService?.map((data, index) => (
                            <Modal
                              key={`cart-service-note-${data.id}`}
                              open={openServiceNote[data.id] || false}
                              handleClose={() => handleCloseServiceNote(data.id)}
                            >
                              <Grid
                                container
                                spacing={3}
                                sx={{ justifyContent: 'center', width: '100%' }}
                              >
                                <Grid item xs={12}>
                                  <Typography variant="h5" sx={{ mb: 2, }}>
                                    Service Note
                                  </Typography>

                                  <Stack
                                    direction={{ xs: 'column', sm: 'row' }}
                                    spacing={{ xs: 3, sm: 2 }}
                                    sx={{ mb: 2 }}
                                  >
                                    <TextField
                                      fullWidth
                                      multiline
                                      rows={4}
                                      size="medium"
                                      value={currentNote}
                                      onChange={handleServiceNoteChange}
                                      error={!currentNote.trim() && currentNote.length > 0}
                                      inputProps={{ maxLength: MAX_CHARACTERS }}
                                      helperText={
                                        !currentNote.trim() && currentNote.length > 0
                                          ? 'Note cannot be empty or contain only spaces'
                                          : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                      }
                                      InputProps={{
                                        sx: {
                                          color: 'error.main',
                                        }
                                      }}
                                    />
                                  </Stack>
                                </Grid>
                              </Grid>

                              <Grid container justifyContent="center" alignItems="center">
                                <Grid item xs={12} md={4}>
                                  <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                    <LoadingButton
                                      variant="contained"
                                      onClick={() => handleSaveServiceNote(data.id)}
                                      loading={isSavingNote}
                                      disabled={!currentNote.trim()}>
                                      Save
                                    </LoadingButton>
                                    <LoadingButton
                                      variant="outlined"
                                      color="error"
                                      onClick={() => handleClearServiceNote(data.id)}
                                      loading={isClearingNote}
                                      disabled={!currentNote.trim()}>
                                      Clear
                                    </LoadingButton>
                                  </Box>
                                </Grid>
                              </Grid>
                            </Modal>
                          ))}
                          
                          {/* {
                            showAddNewRow ?
                          
                          <Stack sx={{ justifyContent: 'space-between', alignItems: 'center', display:'flex', flexDirection:'row' }}>
                            <Button
                              variant="outlined"
                              startIcon={
                                <Stack>
                                  {' '}
                                  <Add />{' '}
                                </Stack>
                              }
                              onClick={() => {
                                addNewProductRow()
                              }}
                            >
                              Add Product Row
                            </Button>
                            <Typography variant="h6">
                              Total Additional Product Cost:{' '}
                              {selectedProductsAdditionalCost}
                            </Typography>
                          </Stack>
                          :
                          ""
} */}
                          <Divider />
                          <Stack direction='row'>
                            <LabelStyleHead>Services</LabelStyleHead>
                            {/* {showServices ? <Remove sx={{color:theme.palette.primary.main}} onClick={(e)=>{setShowServices(false)}} /> : <Add sx={{color:theme.palette.primary.main}} onClick={(e)=>{setShowServices(true)}} />} */}
                          </Stack>
                          {/* {showServices && <> */}
                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            <Autocomplete
                              sx={{ width: 400 }}
                              multiple
                              id="combo-box-demo"
                              options={filteredServices?.filter((item) => item.status == 1) || []}
                              value={values.services?.filter(item=>!item.isAdditionalProduct) || null}
                              onChange={(event, newValue) => {
                                setAdditionalSelectedServices((prevServices) => {
                                  const additionals = prevServices?.filter(item => item.isAdditionalProduct === true);
                                  
                                  // Map over the newly selected services and preserve existing properties
                                  const updatedServices = newValue?.map((service) => {
                                    // Check if the service already exists in the previous selected services
                                    const existingService = prevServices.find(
                                      (p) => p?.id === service?.id && p?.indexId === service?.indexId
                                    );

                                    if (existingService) {
                                      // If service already exists, preserve all existing properties including notes
                                      return {
                                        ...existingService,
                                        quantity: existingService.quantity ?? 1
                                      };
                                    } else {
                                      // If it's a new service, create it with default values
                                      return {
                                        ...service,
                                        indexId: serviceIndexCounter + newValue.indexOf(service) + 1,
                                        quantity: 1,
                                        note: '' // Initialize note as empty string
                                      };
                                    }
                                  }) || [];

                                  // Update the service index counter for new services
                                  if (updatedServices.length > 0) {
                                    const maxIndexId = Math.max(
                                      ...updatedServices.map(s => s.indexId || 0),
                                      serviceIndexCounter
                                    );
                                    setServiceIndexCounter(maxIndexId);
                                  }

                                  // Update Formik's 'services' field
                                  const finalServices = [...updatedServices, ...additionals];
                                  setFieldValue('services', finalServices);
                                  return finalServices;
                                });
                                setShowAddNewRow(true);
                                // markUnsavedChanges();
                              }}
                              renderInput={(params) => (
                                <TextField {...params} required
                                  error={Boolean(touched.services && errors.services)}
                                  helperText={touched.services && errors.services}
                                  label="Select additional services" />
                              )}
                              getOptionLabel={(option) =>
                                option?.name
                                  ? `${option.name} (${getLabourCostServiceTabLabel(option.inhouse)})`
                                  : ''
                              }
                            />
                          </Stack>
                          <LabelStyle>Selected services</LabelStyle>
                          <Scrollbar>
                            <TableContainer sx={{ minWidth: 500 }}>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    {VALUE_SERVICES?.map((val,index) => (
                                      <TableCell>{val.value}</TableCell>
                                    ))}
                                  </TableRow>

                                </TableHead>
                                <TableBody>
                                  {console.log('selectedServices--', selectedServices)}
                                  {/* {selectedServices?.map((data, index) => {
                                    console.log("############Services1111", data);
                                    const quantityFieldName = `service_quantity_${index}`;
                                    const total = data.total_cost * data.quantity
                                    const markup = data.total_cost / total
                                    let originalMarkup = data.originalMarkup || 0
                                    data['markup'] = markup?.toFixed(2)
                                    totalServiceMarkup += markup
                                    originaltotalServiceMarkup += originalMarkup
                                    console.log("#############Total", total);
                                    data['total'] = total?.toFixed(2)
                                    data['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                    values['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                    const previousQty = data.previousQty * (data.qtyData || 1) * data.locationQuantity || 0;

                                    const newQty = (data.previousQty * (data.qtyData || 1) * data.locationQuantity)?.toFixed(2);
                                    const quantityDifference = Number(data.quantity) - newQty;
                                    data['quantityDifference'] = quantityDifference

                                    let newTotalCost = (data.unit_cost * quantityDifference)?.toFixed(2)
                                    let newTotalProductFormula = (data.cost * quantityDifference)?.toFixed(2)
                                    totalProductFormula += Number(newTotalProductFormula)
                                    totalWholesalePrice += Number(newTotalCost)
                                    totalRetailPrice += Number(newTotalCost)
                                    values['totalProductFormula'] = totalProductFormula
                                    values['totalWholesalePrice'] = totalWholesalePrice
                                    values['totalRetailPrice'] = totalRetailPrice


                                    return (
                                      <>
                                        <TableRow key={index}>
                                          <TableCell>#{data.productIndex}</TableCell>
                                          <TableCell>{data.service_notes ? <Typography sx={{ color: 'red', whiteSpace: 'pre-wrap' }}>{data.service_notes}</Typography> : data.name}</TableCell>
                                          <TableCell>{originalMarkup?.toFixed(2)}</TableCell>
                                          <TableCell>{data.cost?.toFixed(2)}</TableCell>

                                          <TableCell>{data.total_cost?.toFixed(2)}</TableCell>
                                          <TableCell>
                                            <TextField
                                              type="number"
                                              // sx={{ width: 400 }}
                                              sx={{ minWidth: '80px' }}
                                              label={'Hours'}
                                              disabled={data?.fromMapServices ? true : false}
                                              {...getFieldProps(quantityFieldName)}
                                              value={Number(data.quantity)?.toFixed(2)}
                                              defaultValue={1}
                                              onChange={(event) => {
                                                let newValue = event.target.value;
                                                // if (newValue <= 0) {
                                                //   event.preventDefault();
                                                //   return;
                                                // }
                                                if (newValue.startsWith('-')) {
                                                  newValue = newValue.slice(1);
                                                }


                                                if (newValue < previousQty) {
                                                  setShowWarning(prev => {
                                                    const newWarnings = [...prev];
                                                    newWarnings[index] = true;
                                                    return newWarnings;
                                                  });
                                                  data['quantity'] = previousQty;
                                                } else {
                                                  setShowWarning(prev => {
                                                    const newWarnings = [...prev];
                                                    newWarnings[index] = false;
                                                    return newWarnings;
                                                  });
                                                  data['quantity'] = newValue || 1;

                                                }
                                                setFieldValue(quantityFieldName, newValue);



                                              }}
                                              inputProps={{ min: previousQty }}
                                              error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                              helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                            />
                                            {showWarning[index] && (
                                              <Typography color="error" variant='body2'>
                                                Cannot reduce the added hours in the product formula. If you need to reduce, change it in the product formula.
                                              </Typography>
                                            )}
                                          </TableCell>
                                          <TableCell>{(data.cost * quantityDifference?.toFixed(2))?.toFixed(2)}</TableCell>
                                          <TableCell>{(data.unit_cost * quantityDifference?.toFixed(2))?.toFixed(2)}</TableCell>
                                          <TableCell>{total?.toFixed(2)}</TableCell>
                                        </TableRow>
                                      </>
                                    );
                                  })} */}
                                  {additionalSelectedServices?.map((data, index) => {
                                    console.log("############additional services", data);
                                    const quantityFieldName = `service_quantity_${index}`;
                                    const dataQuantity = data?.quantity ? data?.quantity : 1;
                                    data['quantity'] = dataQuantity
                                    const total = data.total_cost * data?.quantity
                                    const markup = total != 0 ? data.total_cost / Number(total) : 0;
                                    data['markup'] = markup?.toFixed(2)

                                    console.log('totalProductFormula=5=',data.total_cost);
                                    console.log('totalProductFormula=6=',total);
                                    console.log('totalProductFormula=7=',markup);


                                    totalServiceMarkup += markup

                                    let originalMarkup = data.originalMarkup || 0
                                    originaltotalServiceMarkup += originalMarkup
                                    data['total'] = total?.toFixed(2)
                                    data['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                    console.log('totalProductFormula=4=',totalServiceMarkup);
                                    values['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                    const quantityDifference = Number(data.quantity)
                                    data['quantityDifference'] = quantityDifference

                                    let newTotalCost = total?.toFixed(2)
                                    let newTotalProductFormula = (data.cost * quantityDifference)?.toFixed(2)
                                    totalProductFormula += Number(newTotalProductFormula)
                                    totalWholesalePrice += Number(newTotalCost)
                                    totalRetailPrice += Number(newTotalCost)
                                    console.log('totalProductFormula=1=',totalProductFormula);
                                    console.log('totalProductFormula=2=',totalWholesalePrice);
                                    console.log('totalProductFormula=3=',totalRetailPrice);
                                    
                                    values['totalProductFormula'] = totalProductFormula
                                    values['totalWholesalePrice'] = totalWholesalePrice
                                    values['totalRetailPrice'] = totalRetailPrice

                                    return (
                                      <>
                                        <TableRow key={index}>
                                          
                                          <TableCell>{index+1}</TableCell>
                                          <TableCell>{data?.isAdditionalProduct ?
                                            <TextField
                                              required
                                              fullWidth
                                              type="text"
                                              label={'Service Name'}
                                              sx={{ width: 85 }}
                                              value={data.name}
                                              onChange={(event) => {
                                                let newValue = event.target.value

                                                // Update the selectedProducts state
                                                setAdditionalSelectedServices(
                                                  (prevProducts) =>
                                                    prevProducts.map((service) => {
                                                        if ( service.newIndexId === data.newIndexId ) {
                                                          return {
                                                            ...service,
                                                            name: newValue,
                                                          }
                                                        } else {
                                                          return service
                                                        }
                                                      },
                                                    ),
                                                )
                                                data['name'] = newValue || ''
                                                if (isSubmitted)
                                                  setIsSubmitted(false)
                                                markUnsavedChanges()
                                              }}
                                              error={
                                                isSubmitted && data?.name?.trim() === ''
                                              }
                                              helperText={
                                                isSubmitted && data?.name?.trim() === '' ? 'Service Name is required' : ''
                                              }
                                            />
                                          : data.service_notes ? <Typography sx={{ color: 'red', whiteSpace: 'pre-wrap' }}>{data.service_notes}</Typography> : data.name}
                                          </TableCell>
                                          <TableCell>
                                            <IconButton onClick={() => handleOpenServiceNote(data.newIndexId || data.indexId, data.service_notes)}>
                                              <NoteAdd
                                                sx={{
                                                  color: (!data?.service_notes || data?.service_notes === '') ? '' : theme.palette.primary.main,
                                                }}
                                              />
                                            </IconButton>
                                          </TableCell>
                                          <TableCell>{originalMarkup?.toFixed(2)}</TableCell>
                                          <TableCell>{data.cost}</TableCell>
                                          <TableCell>{data?.isAdditionalProduct ?
                                            <TextField
                                              required
                                              fullWidth
                                              type="number"
                                              label={'Hourly Cost'}
                                              disabled={values.project_categories?.name == 'Time & Material' ? true : false}
                                              sx={{ width: 85 }}
                                              value={data.total_cost}
                                              onWheel={(e) => e.target.blur()}
                                              defaultValue={0}
                                              onChange={(event) => {
                                                let newValue = event.target.value
                                                if (newValue !== '') {
                                                  setAdditionalSelectedServices((pv) => [
                                                      ...pv.map((p) => {
                                                        if ( p.newIndexId === data.newIndexId ) {
                                                          return {
                                                            ...p,
                                                            total_cost: newValue,
                                                          }
                                                        } else {
                                                          return p
                                                        }
                                                      }),
                                                    ],
                                                  )
                                                  data['total_cost'] =  newValue || 0
                                                }
                                                markUnsavedChanges()
                                              }}
                                              // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                              // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                            /> : data.total_cost}</TableCell>
                                          <TableCell>
                                            <TextField
                                              type="number"
                                              // sx={{ width: 400 }}
                                              sx={{ minWidth: '80px' }}
                                              label={'Hours'}
                                              // {...getFieldProps(quantityFieldName)}
                                              value={Number(data.quantity) || 0}
                                              defaultValue={1}
                                              onKeyPress={(event) => { 
                                                if (event.key === '-') {
                                                  event.preventDefault();
                                                }
                                              }}
                                              onChange={(event) => {
                                                let newValue = event.target.value;
                                                // if (newValue <= 0) {
                                                //   event.preventDefault();
                                                //   return;
                                                // }
                                                // if (newValue.startsWith('-')) {
                                                //   newValue = newValue.slice(1);
                                                // }
                                                data['quantity'] = newValue || 0;
                                                setFieldValue(quantityFieldName, newValue);
                                                markUnsavedChanges()
                                              }}

                                              onWheel={(e) => e.target.blur()}

                                              onKeyDown={(event) => {
                                                if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                                  const newValue = event.target.value || 0;
                                                  if (newValue < 1 && event.key === 'ArrowDown') {
                                                    event.preventDefault(); 
                                                  }
                                                }
                                              }}

                                              error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                              helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                            />
                                          </TableCell>
                                          {/* <TableCell>
                                            <Switch
                                              checked={data.makeAsTask === 1}
                                              onChange={(e) => {
                                                const newValue = e.target.checked ? 1 : 0;
                                                setAdditionalSelectedServices((prevServices) =>
                                                  prevServices.map((service) =>
                                                    service.indexId === data.indexId
                                                      ? { ...service, makeAsTask: newValue }
                                                      : service
                                                  )
                                                );
                                                data['makeAsTask'] = newValue;
                                              }}
                                              color="primary"
                                            />
                                          </TableCell>
                                          <TableCell>
                                            <Switch
                                              checked={data.makeInstallCard === 1}
                                              onChange={(e) => {
                                                const newValue = e.target.checked ? 1 : 0;
                                                setAdditionalSelectedServices((prevServices) =>
                                                  prevServices.map((service) =>
                                                    service.indexId === data.indexId
                                                      ? { ...service, makeInstallCard: newValue }
                                                      : service
                                                  )
                                                );
                                                data['makeInstallCard'] = newValue;
                                              }}
                                              color="primary"
                                            />
                                          </TableCell> */}
                                          <TableCell>{data?.isAdditionalProduct ? 'N/A' : (data.cost * quantityDifference?.toFixed(2))?.toFixed(2)}</TableCell>
                                          <TableCell>{total?.toFixed(2)}</TableCell>
                                          <TableCell>{total?.toFixed(2)}</TableCell>
                                          <TableCell align='right'>
                                            <IconButton onClick={() => handleDeleteService(data.id, data.newIndexId,)}>
                                              <Delete />
                                            </IconButton>
                                          </TableCell>
                                        </TableRow>
                                      </>
                                    );
                                  })}
                                  {/* <TableRow>
                                    <TableCell colSpan={8}>
                                      <Typography variant="h6" align="right">
                                        Total Additional Cost: {selectedServicesSubTotal?.toFixed(2)}
                                      </Typography>
                                    </TableCell>
                                  </TableRow> */}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Scrollbar>
                          {
                            showAddNewRow ?
                          <Stack sx={{ justifyContent: 'flex-end', alignItems: 'flex-end', display:'flex', flexDirection:'column' }}>
                            {/* <Button
                              variant="outlined"
                              startIcon={
                                <Stack>
                                  {' '}
                                  <Add />{' '}
                                </Stack>
                              }
                              onClick={() => {
                                addNewServiceRow()
                                // setMarkupType(1)
                              }}
                            >
                              Add Service Row
                            </Button> */}
                            <Typography variant="h6">
                              Total Additional Service Cost:{' '}
                              {selectedServicesSubTotal?.toFixed(2)}
                            </Typography>
                            {/* <Typography variant="h6">
                              Total Product Labor Cost:{' '}
                              {totalProductInstallCost?.toFixed(2)}
                            </Typography> */}
                          </Stack>
                          :
                          ""
                            }
                          <Divider />
                          {(values?.project_type?.name == 'TS' && values?.project_categories?.id == 14) ? '' :
                          <>
                          <LabelStyleHead>Proposals</LabelStyleHead>
                          <Autocomplete
                            options={rfps}
                            // getOptionLabel={(option) => option.description}
                            getOptionLabel={(option) =>
                            option && option.description
                              ? `${option.description} ( ${option.vendor_name || ''})`
                              : ''
                          }
                            value={values.rfp}
                            onChange={(event, value) => {
                              handleRfpSelect(event, value)
                              setFieldValue('rfp', value)
                            }
                            }
                            renderInput={(params) => <TextField {...params} label="Select Proposal" />}
                            filterOptions={(options, { inputValue }) =>
                              options.filter((option) => {
                                const searchText = inputValue.toLowerCase();
                                return (
                                  option.name?.toLowerCase().includes(searchText) ||
                                  option.description?.toLowerCase().includes(searchText)
                                  // option.description?.toLowerCase().includes(searchText)
                                );
                              })
                            }
                          />
                          <Modal open={openModal} handleClose={closeModal}>
                            <Box sx={{ position: 'relative', p: 3, bgcolor: 'background.paper', boxShadow: 24 }}>

                              <Tabs value={tabIndex} onChange={handleTabChange}
                                variant="fullWidth"
                                sx={{


                                  marginBottom: 4

                                }}>
                                <Tab label="Products" sx={{ width: '50%', minWidth: 0 }} />
                                <Tab label="Services" sx={{ width: '50%', minWidth: 0 }} />
                                <Tab label="Materials" sx={{ width: '50%', minWidth: 0 }} />
                              </Tabs>
                              {tabIndex === 0 && (
                                <TableContainer sx={{ minWidth: 500 }}>
                                  <Table>
                                    <TableHead>
                                      <TableCell align='center'>Name</TableCell>
                                      <TableCell align='center'>Unit Cost</TableCell>
                                      <TableCell align='center'>Unit</TableCell>
                                      <TableCell align='center'>Qty</TableCell>
                                      <TableCell align='center'>Total Cost</TableCell>
                                      <TableCell align='center'></TableCell>
                                    </TableHead>
                                    {rfpProducts?.filter((product)=>product.material == 0).map((product) => {
                                      let unitName = UNITS?.filter((item) => item?.id == product?.unit)
                                      unitName = unitName[0]?.name
                                      let shortUnitName = ''
                                      if (unitName == 'Square feet') {
                                        shortUnitName = 'Sq ft'
                                      } else if (unitName == 'Lineal feet') {
                                        shortUnitName = 'Lin ft'
                                      } else if (unitName == 'Square Inches') {
                                        shortUnitName = 'Sq Inches'
                                      } else if (unitName == 'Unit') {
                                        shortUnitName = 'Unit'
                                      }
                                      return (
                                        // <Box key={product.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                                        <TableRow key={product.id}>
                                          <TableCell align='center'>{product.product_name}</TableCell>
                                          <TableCell align='center'>${product.product_price}</TableCell>
                                          <TableCell align='center'>{product.quantity} {shortUnitName}</TableCell>
                                          <TableCell align='center'>{product.location_quantity}</TableCell>
                                          <TableCell align='center'>${(product.location_quantity * product.quantity * ((product.product_price).toFixed(2) || 0)).toFixed(2)}</TableCell>
                                          <TableCell align='center'><Button onClick={() => addToCart(product)}>Add</Button></TableCell>
                                        </TableRow>
                                        // </Box>
                                      )
                                    })}
                                  </Table>
                                </TableContainer>
                              )}
                              {tabIndex === 1 && (
                                <TableContainer sx={{ minWidth: 500 }}>
                                  <Table>
                                    <TableHead>
                                      <TableCell align='center'>Name</TableCell>
                                      <TableCell align='center'>Unit Cost</TableCell>
                                      <TableCell align='center'>Hours</TableCell>
                                      <TableCell align='center'>Total Cost</TableCell>
                                      <TableCell align='center'></TableCell>
                                    </TableHead>
                                    {rfpServices.map((service) => (
                                      // <Box key={service.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                                      <TableRow key={service.id}>
                                        <TableCell align='center'>{service.name}</TableCell>
                                        <TableCell align='center'>${service.sellingPrice}</TableCell>
                                        <TableCell align='center'>{service.quantity}</TableCell>
                                        <TableCell align='center'>${service.total_cost}</TableCell>
                                        <TableCell align='center'><Button onClick={() => addToCart(service)}>Add</Button></TableCell>
                                      </TableRow>
                                      // </Box>
                                    ))}
                                  </Table>
                                </TableContainer>
                              )}
                              {tabIndex === 2 && (
                                <TableContainer sx={{ minWidth: 500 }}>
                                  <Table>
                                    <TableHead>
                                      <TableCell align='center'>Name</TableCell>
                                      <TableCell align='center'>Unit Cost</TableCell>
                                      <TableCell align='center'>Unit</TableCell>
                                      <TableCell align='center'>Qty</TableCell>
                                      <TableCell align='center'>Total Cost</TableCell>
                                      <TableCell align='center'></TableCell>
                                    </TableHead>
                                    {rfpProducts.filter((product)=> product?.material == 1).map((product) => {
                                      let unitName = UNITS?.filter((item) => item?.id == product?.unit)
                                      unitName = unitName[0]?.name
                                      let shortUnitName = ''
                                      if (unitName == 'Square feet') {
                                        shortUnitName = 'Sq ft'
                                      } else if (unitName == 'Lineal feet') {
                                        shortUnitName = 'Lin ft'
                                      } else if (unitName == 'Square Inches') {
                                        shortUnitName = 'Sq Inches'
                                      } else if (unitName == 'Unit') {
                                        shortUnitName = 'Unit'
                                      }
                                      return (
                                        // <Box key={product.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                                        <TableRow key={product.id}>
                                          <TableCell align='center'>{product.product_name}</TableCell>
                                          <TableCell align='center'>${product.product_price}</TableCell>
                                          <TableCell align='center'>{product.quantity} {shortUnitName}</TableCell>
                                          <TableCell align='center'>{product.location_quantity}</TableCell>
                                          <TableCell align='center'>${(product.location_quantity * product.quantity * ((product.product_price).toFixed(2) || 0)).toFixed(2)}</TableCell>
                                          <TableCell align='center'><Button onClick={() => addToCart(product)}>Add</Button></TableCell>
                                        </TableRow>
                                        // </Box>
                                      )
                                    })}
                                  </Table>
                                </TableContainer>
                              )}
                            </Box>
                          </Modal>
                          <Scrollbar>
                            <TableContainer sx={{ minWidth: 500 }}>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    {VALUE_RFP_Product?.map((val,index) => (

                                      <TableCell key={val.id}>{val.value}</TableCell>

                                    ))}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {cart?.filter((item)=>item.material == 0).map((data, index) => {
                                    let unitName = UNITS?.filter((item) => item?.id == data?.unit)
                                    unitName = unitName[0]?.name
                                    let shortUnitName = ''
                                    if (unitName == 'Square feet') {
                                      shortUnitName = 'Sq ft'
                                    } else if (unitName == 'Lineal feet') {
                                      shortUnitName = 'Lin ft'
                                    } else if (unitName == 'Square Inches') {
                                      shortUnitName = 'Sq Inches'
                                    } else if (unitName == 'Unit') {
                                      shortUnitName = 'Unit'
                                    }
                                    // let markup = markupType ? markupType === 1 ? data.WholesaleMarkup : data.RetailMarkup : 0
                                    let markup = parseFloat(Number(data?.markup)) || 0
                                    data.product_markup = markup

                                    let newTotalProductFormula = (data.product_price * data.quantity * data.location_quantity)?.toFixed(2) || 0
                                    let newTotalCost = (data.location_quantity * data.quantity * ((data.product_price + (data.product_price * markup / 100)).toFixed(2) || 0)).toFixed(2)

                                    totalProductFormula += Number(newTotalProductFormula)
                                    totalWholesalePrice += Number(newTotalCost)
                                    totalRetailPrice += Number(newTotalCost)
                                    values['totalProductFormula'] = totalProductFormula
                                    values['totalWholesalePrice'] = totalWholesalePrice
                                    values['totalRetailPrice'] = totalRetailPrice

                                    return (
                                      <>
                                        <TableRow key={data.id}>
                                          <TableCell>{index + 1}</TableCell>
                                          <TableCell>{data.name || data.product_name}</TableCell>
                                          {/* <TableCell>{invoiceAmount}</TableCell> */}
                                          <TableCell>
                                            {markup?.toFixed(2) || 0.00}
                                          </TableCell>
                                          <TableCell>
                                            {data.product_price?.toFixed(2) || 0}
                                          </TableCell>
                                          <TableCell>
                                            {(data.product_price + (data.product_price * markup / 100)).toFixed(2) || 0.00}
                                          </TableCell>
                                          <TableCell>
                                            {data.quantity} {shortUnitName}
                                          </TableCell>
                                          <TableCell>
                                            {data.location_quantity}
                                          </TableCell>
                                          {/* <TableCell>
                                            {(data.product_price * data.quantity * data.location_quantity)?.toFixed(2) || 0}
                                          </TableCell> */}
                                          <TableCell>
                                            {(data.location_quantity * data.quantity * ((data.product_price + (data.product_price * markup / 100)).toFixed(2) || 0)).toFixed(2)}
                                          </TableCell>
                                          {/* <TableCell>N/A</TableCell>
                                          <TableCell>N/A</TableCell> */}
                                          <TableCell>
                                            <IconButton
                                              onClick={() => {
                                                setRfpLocationStates({ ...rfpLocationStates, [data.product_id]: true });
                                              }}
                                            >
                                              <LocationOn sx={{
                                                color: data && data.addresses && data.addresses.some(obj =>
                                                  [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
                                                ) ? '' : theme.palette.primary.main
                                              }} />
                                            </IconButton>
                                          </TableCell>
                                          <TableCell >
                                            <IconButton onClick={() => handleDeleteRFPProduct(data.id)}>
                                              <Delete />
                                            </IconButton>
                                          </TableCell>
                                        </TableRow>
                                        <Modal
                                          open={
                                            rfpLocationStates[data.product_id]
                                          }
                                          handleClose={() => {
                                            setRfpLocationStates({
                                              ...rfpLocationStates,
                                              [data.product_id]: false,
                                            })
                                          }}
                                        >
                                          {/* {index === 0 && ( */}
                                            <FormControlLabel
                                              control={
                                                <Switch
                                                  checked={
                                                    data?.allRfpProductsLocationSame
                                                  }
                                                  onChange={()=>
                                                    handleAllRfpProductsLocationSameChange(index)
                                                  }
                                                />
                                              }
                                              label="All Locations Same"
                                            />
                                          {/* )} */}

                                          <Grid
                                            container
                                            spacing={3}
                                            sx={{
                                              justifyContent: 'center',
                                              width: '100%',
                                            }}
                                          >
                                            {data?.addresses?.map((addr, i) => (
                                              <Grid item xs={12}>
                                                {/* Side Heading */}
                                                <Typography
                                                  variant="h5"
                                                  sx={{ mb: 2 }}
                                                >
                                                  Location {i+1}
                                                </Typography>

                                                {/* Address Fields */}

                                                <Stack
                                                  direction={{
                                                    xs: 'column',
                                                    sm: 'row',
                                                  }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="Address"
                                                    size="small"
                                                    value={
                                                      data.addresses[i]
                                                        .address || ''
                                                    }
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [
                                                    //     ...data.addresses,
                                                    //   ]
                                                    //   arrayAddr[i].address =
                                                    //     event.target.value

                                                    //   setCart((pv) => [
                                                    //     ...pv.map((p) => {
                                                    //       if (
                                                    //         p.product_id ===
                                                    //         data.product_id
                                                    //       ) {
                                                    //         return {
                                                    //           ...p,
                                                    //           addresses:
                                                    //             arrayAddr,
                                                    //         }
                                                    //       } else {
                                                    //         return {
                                                    //           ...p,
                                                    //         }
                                                    //       }
                                                    //     }),
                                                    //   ])
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.addresses];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                address: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                address: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              addresses: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                      // markUnsavedChanges();
                                                    }}
                                                  />
                                                </Stack>

                                                {/* City, State, Zip Fields */}
                                                <Stack
                                                  direction={{
                                                    xs: 'column',
                                                    sm: 'row',
                                                  }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="City"
                                                    size="small"
                                                    value={
                                                      data.addresses[i].city ||
                                                      ''
                                                    }
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [
                                                    //     ...data.addresses,
                                                    //   ]
                                                    //   arrayAddr[i].city =
                                                    //     event.target.value

                                                    //   setCart((pv) => [
                                                    //     ...pv.map((p) => {
                                                    //       if (
                                                    //         p.product_id ===
                                                    //         data.product_id
                                                    //       ) {
                                                    //         return {
                                                    //           ...p,
                                                    //           addresses:
                                                    //             arrayAddr,
                                                    //         }
                                                    //       } else {
                                                    //         return {
                                                    //           ...p,
                                                    //         }
                                                    //       }
                                                    //     }),
                                                    //   ])
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.addresses];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                city: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                city: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              addresses: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                      // markUnsavedChanges();
                                                    }}
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="State"
                                                    size="small"
                                                    value={
                                                      data.addresses[i].state ||
                                                      ''
                                                    }
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [
                                                    //     ...data.addresses,
                                                    //   ]
                                                    //   arrayAddr[i].state =
                                                    //     event.target.value

                                                    //   setCart((pv) => [
                                                    //     ...pv.map((p) => {
                                                    //       if (
                                                    //         p.product_id ===
                                                    //         data.product_id
                                                    //       ) {
                                                    //         return {
                                                    //           ...p,
                                                    //           addresses:
                                                    //             arrayAddr,
                                                    //         }
                                                    //       } else {
                                                    //         return {
                                                    //           ...p,
                                                    //         }
                                                    //       }
                                                    //     }),
                                                    //   ])
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.addresses];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                state: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                state: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              addresses: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                      // markUnsavedChanges();
                                                    }}
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="Zip / Postal Code"
                                                    size="small"
                                                    value={
                                                      data.addresses[i].zip ||
                                                      ''
                                                    }
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [
                                                    //     ...data.addresses,
                                                    //   ]
                                                    //   arrayAddr[i].zip =
                                                    //     event.target.value

                                                    //   setCart((pv) => [
                                                    //     ...pv.map((p) => {
                                                    //       if (
                                                    //         p.product_id ===
                                                    //         data.product_id
                                                    //       ) {
                                                    //         return {
                                                    //           ...p,
                                                    //           addresses:
                                                    //             arrayAddr,
                                                    //         }
                                                    //       } else {
                                                    //         return {
                                                    //           ...p,
                                                    //         }
                                                    //       }
                                                    //     }),
                                                    //   ])
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.addresses];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                zip: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                zip: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              addresses: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                      // markUnsavedChanges();
                                                    }}
                                                  />
                                                </Stack>
                                              </Grid>
                                            ))}
                                          </Grid>

                                          <Grid
                                            container
                                            justifyContent="center"
                                            alignItems="center"
                                          >
                                            <Grid item xs={12} md={4}>
                                              <Box
                                                sx={{
                                                  mt: 3,
                                                  display: 'flex',
                                                  justifyContent: 'center',
                                                  gap: 1,
                                                }}
                                              >
                                                <LoadingButton
                                                  variant="contained"
                                                  onClick={() => {
                                                    setIsSaving(true)
                                                    setTimeout(() => {
                                                      setIsSaving(false)
                                                      setRfpLocationStates(
                                                        false,
                                                      )
                                                    }, 100)
                                                  }}
                                                  loading={isSaving}
                                                >
                                                  {' Save '}
                                                </LoadingButton>
                                              </Box>
                                            </Grid>
                                          </Grid>
                                        </Modal>
                                      </>
                                    );
                                  })}
                                </TableBody>
                                {
                                  cartService?.length > 0 ?
                                  <Typography variant='subtitle2' sx={{fontWeight:500}}>Services</Typography>
                                :''
                                }
                                <TableBody>
                                  {cartService?.map((data, index) => {
                                    let newTotalProductFormula = (data.qty * data.sellingPrice).toFixed(2) || 0.00
                                    let newTotalCost = (data.qty * (data.sellingPrice + (data.sellingPrice * data.originalMarkup / 100)))?.toFixed(2)

                                    totalProductFormula += Number(newTotalProductFormula)
                                    totalWholesalePrice += Number(newTotalCost)
                                    totalRetailPrice += Number(newTotalCost)
                                    values['totalProductFormula'] = totalProductFormula
                                    values['totalWholesalePrice'] = totalWholesalePrice
                                    values['totalRetailPrice'] = totalRetailPrice

                                    return (
                                      <>
                                        <TableRow key={data.id}>
                                          <TableCell>{index + 1}</TableCell>
                                          <TableCell>{data.name || data.product_name}</TableCell>
                                          <TableCell>
                                            <IconButton onClick={() => handleOpenServiceNote(data.id, data.service_notes)}>
                                              <NoteAdd
                                                sx={{
                                                  color: (!data?.service_notes || data?.service_notes === '') ? '' : theme.palette.primary.main,
                                                }}
                                              />
                                            </IconButton>
                                          </TableCell>
                                          {/* <TableCell>{invoiceAmount}</TableCell> */}
                                          <TableCell>
                                            {data.originalMarkup?.toFixed(2)}
                                          </TableCell>
                                          <TableCell>
                                            {data.sellingPrice?.toFixed(2)}
                                          </TableCell>

                                          <TableCell>
                                            {((data.sellingPrice + (data.sellingPrice * data.originalMarkup / 100)))?.toFixed(2)}
                                          </TableCell>
                                          <TableCell>
                                            {data.qty} Hours
                                          </TableCell>
                                          <TableCell>-</TableCell>
                                          {/* <TableCell>
                                            {(data.qty * data.sellingPrice)?.toFixed(2) || 0.00}
                                          </TableCell> */}
                                          <TableCell>
                                            {(data.qty * (data.sellingPrice + (data.sellingPrice * data.originalMarkup / 100)))?.toFixed(2)}
                                          </TableCell>
                                          {/* <TableCell>
                                            <Switch
                                              checked={data.makeAsTask === 1}
                                              onChange={(e) => {
                                                const newValue = e.target.checked ? 1 : 0;
                                                setCartService((prevServices) =>
                                                  prevServices.map((service) =>
                                                    service.id === data.id
                                                      ? { ...service, makeAsTask: newValue }
                                                      : service
                                                  )
                                                );
                                                data['makeAsTask'] = newValue;
                                              }}
                                              color="primary"
                                            />
                                          </TableCell>
                                          <TableCell>
                                            <Switch
                                              checked={data.makeInstallCard === 1}
                                              onChange={(e) => {
                                                const newValue = e.target.checked ? 1 : 0;
                                                setCartService((prevServices) =>
                                                  prevServices.map((service) =>
                                                    service.id === data.id
                                                      ? { ...service, makeInstallCard: newValue }
                                                      : service
                                                  )
                                                );
                                                data['makeInstallCard'] = newValue;
                                              }}
                                              color="primary"
                                            />
                                          </TableCell> */}
                                          <TableCell>
                                            <IconButton
                                              onClick={() => {
                                                setRfpServiceLocationStates({
                                                  ...rfpServiceLocationStates,
                                                  [data.id]: true,
                                                })
                                              }}
                                            >
                                              <LocationOn
                                                sx={{
                                                  color:
                                                    data &&
                                                    data.addresses &&
                                                    data.addresses.some((obj) =>
                                                      [obj.address, obj.city, obj.state, obj.zip].some(
                                                        (value) => (value === '' || value === null),
                                                      ),
                                                    )
                                                      ? ''
                                                      : theme.palette.primary
                                                          .main,
                                                }}
                                              />
                                            </IconButton>
                                          </TableCell>
                                          {/* : '' } */}
                                          <TableCell>
                                            <IconButton onClick={() => handleDeleteRFPService(data.id)}>
                                              <Delete />
                                            </IconButton>
                                          </TableCell>
                                        </TableRow>
      <Modal
                                          open={
                                            rfpServiceLocationStates[
                                              data.id
                                            ]
                                          }
                                          handleClose={() => {
                                            setRfpServiceLocationStates({
                                              ...rfpServiceLocationStates,
                                              [data.id]: false,
                                            })
                                          }}
                                        >
                                          {index === 0 && (
                                            <FormControlLabel
                                              control={
                                                <Switch
                                                  checked={
                                                    allRfpServiceLocationSame
                                                  }
                                                  onChange={
                                                    handleAllRfpServiceLocationSameChange
                                                  }
                                                />
                                              }
                                              label="All Locations Same"
                                            />
                                          )}

                                          <Grid
                                            container
                                            spacing={3}
                                            sx={{
                                              justifyContent: 'center',
                                              width: '100%',
                                            }}
                                          >
                                            {data?.addresses?.map((addr, i) => (
                                              <Grid item xs={12}>
                                                {/* Side Heading */}
                                                <Typography
                                                  variant="h5"
                                                  sx={{ mb: 2 }}
                                                >
                                                  Location
                                                </Typography>

                                                {/* Address Fields */}

                                                <Stack
                                                  direction={{
                                                    xs: 'column',
                                                    sm: 'row',
                                                  }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="Address"
                                                    size="small"
                                                    value={
                                                      data.addresses[i]
                                                        .address || ''
                                                    }
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [
                                                    //     ...data.addresses,
                                                    //   ]
                                                    //   arrayAddr[i].address =
                                                    //     event.target.value

                                                    //   setCartService((pv) => [
                                                    //     ...pv.map((p) => {
                                                    //       if (
                                                    //         p.labour_cost_service_id ===
                                                    //         data.labour_cost_service_id
                                                    //       ) {
                                                    //         return {
                                                    //           ...p,
                                                    //           addresses:
                                                    //             arrayAddr,
                                                    //         }
                                                    //       } else {
                                                    //         return {
                                                    //           ...p,
                                                    //         }
                                                    //       }
                                                    //     }),
                                                    //   ])
                                                    // }}
                                                    disabled={index !== 0 && allRfpServiceLocationSame ? true : false}
                                                    onChange={(event) => {
                                                      const updatedValue = event.target.value;
                                                    
                                                      setCartService((prevServices) =>
                                                        prevServices.map((service) => {
                                                          let updatedLocations = [...service.addresses];
                                                    
                                                          if (allRfpServiceLocationSame) {
                                                            // Apply the new value to all services in cartService
                                                            return {
                                                              ...service,
                                                              addresses: updatedLocations.map(loc => ({
                                                                ...loc,
                                                                address: updatedValue, // Update address field, same logic applies for others
                                                              })),
                                                            };
                                                          } else {
                                                            // Update only the specific service
                                                            if (service.id === data.id) {
                                                              updatedLocations[i].address = updatedValue;
                                                            }
                                                            return {
                                                              ...service,
                                                              addresses: updatedLocations,
                                                            };
                                                          }
                                                        })
                                                      );
                                                      // markUnsavedChanges();
                                                    }}
                                                  />
                                                </Stack>

                                                {/* City, State, Zip Fields */}
                                                <Stack
                                                  direction={{
                                                    xs: 'column',
                                                    sm: 'row',
                                                  }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="City"
                                                    size="small"
                                                    value={
                                                      data.addresses[i].city ||
                                                      ''
                                                    }
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [
                                                    //     ...data.addresses,
                                                    //   ]
                                                    //   arrayAddr[i].city =
                                                    //     event.target.value

                                                    //   setCartService((pv) => [
                                                    //     ...pv.map((p) => {
                                                    //       if (
                                                    //         p.labour_cost_service_id ===
                                                    //         data.labour_cost_service_id
                                                    //       ) {
                                                    //         return {
                                                    //           ...p,
                                                    //           addresses:
                                                    //             arrayAddr,
                                                    //         }
                                                    //       } else {
                                                    //         return {
                                                    //           ...p,
                                                    //         }
                                                    //       }
                                                    //     }),
                                                    //   ])
                                                    // }}
                                                    disabled={index !== 0 && allRfpServiceLocationSame ? true : false}
                                                    onChange={(event) => {
                                                      const updatedValue = event.target.value;
                                                    
                                                      setCartService((prevServices) =>
                                                        prevServices.map((service) => {
                                                          let updatedLocations = [...service.addresses];
                                                    
                                                          if (allRfpServiceLocationSame) {
                                                            // Apply the new value to all services in cartService
                                                            return {
                                                              ...service,
                                                              addresses: updatedLocations.map(loc => ({
                                                                ...loc,
                                                                city: updatedValue, // Update city field, same logic applies for others
                                                              })),
                                                            };
                                                          } else {
                                                            // Update only the specific service
                                                            if (service.id === data.id) {
                                                              updatedLocations[i].city = updatedValue;
                                                            }
                                                            return {
                                                              ...service,
                                                              addresses: updatedLocations,
                                                            };
                                                          }
                                                        })
                                                      );
                                                      // markUnsavedChanges();
                                                    }}
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="State"
                                                    size="small"
                                                    value={
                                                      data.addresses[i].state ||
                                                      ''
                                                    }
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [
                                                    //     ...data.addresses,
                                                    //   ]
                                                    //   arrayAddr[i].state =
                                                    //     event.target.value

                                                    //   setCartService((pv) => [
                                                    //     ...pv.map((p) => {
                                                    //       if (
                                                    //         p.labour_cost_service_id ===
                                                    //         data.labour_cost_service_id
                                                    //       ) {
                                                    //         return {
                                                    //           ...p,
                                                    //           addresses:
                                                    //             arrayAddr,
                                                    //         }
                                                    //       } else {
                                                    //         return {
                                                    //           ...p,
                                                    //         }
                                                    //       }
                                                    //     }),
                                                    //   ])
                                                    // }}
                                                    disabled={index !== 0 && allRfpServiceLocationSame ? true : false}
                                                    onChange={(event) => {
                                                      const updatedValue = event.target.value;
                                                    
                                                      setCartService((prevServices) =>
                                                        prevServices.map((service) => {
                                                          let updatedLocations = [...service.addresses];
                                                    
                                                          if (allRfpServiceLocationSame) {
                                                            // Apply the new value to all services in cartService
                                                            return {
                                                              ...service,
                                                              addresses: updatedLocations.map(loc => ({
                                                                ...loc,
                                                                state: updatedValue, // Update state field, same logic applies for others
                                                              })),
                                                            };
                                                          } else {
                                                            // Update only the specific service
                                                            if (service.id === data.id) {
                                                              updatedLocations[i].state = updatedValue;
                                                            }
                                                            return {
                                                              ...service,
                                                              addresses: updatedLocations,
                                                            };
                                                          }
                                                        })
                                                      );
                                                      // markUnsavedChanges();
                                                    }}  
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="Zip / Postal Code"
                                                    size="small"
                                                    value={
                                                      data.addresses[i].zip ||
                                                      ''
                                                    }
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [
                                                    //     ...data.addresses,
                                                    //   ]
                                                    //   arrayAddr[i].zip =
                                                    //     event.target.value

                                                    //   setCartService((pv) => [
                                                    //     ...pv.map((p) => {
                                                    //       if (
                                                    //         p.labour_cost_service_id ===
                                                    //         data.labour_cost_service_id
                                                    //       ) {
                                                    //         return {
                                                    //           ...p,
                                                    //           addresses:
                                                    //             arrayAddr,
                                                    //         }
                                                    //       } else {
                                                    //         return {
                                                    //           ...p,
                                                    //         }
                                                    //       }
                                                    //     }),
                                                    //   ])
                                                    // }}
                                                    disabled={index !== 0 && allRfpServiceLocationSame ? true : false}
                                                    onChange={(event) => {
                                                      const updatedValue = event.target.value;
                                                    
                                                      setCartService((prevServices) =>
                                                        prevServices.map((service) => {
                                                          let updatedLocations = [...service.addresses];
                                                    
                                                          if (allRfpServiceLocationSame) {
                                                            // Apply the new value to all services in cartService
                                                            return {
                                                              ...service,
                                                              addresses: updatedLocations.map(loc => ({
                                                                ...loc,
                                                                zip: updatedValue, // Update zip field, same logic applies for others
                                                              })),
                                                            };
                                                          } else {
                                                            // Update only the specific service
                                                            if (service.id === data.id) {
                                                              updatedLocations[i].zip = updatedValue;
                                                            }
                                                            return {
                                                              ...service,
                                                              addresses: updatedLocations,
                                                            };
                                                          }
                                                        })
                                                      );
                                                      // markUnsavedChanges();
                                                    }}
                                                  />
                                                </Stack>
                                              </Grid>
                                            ))}
                                          </Grid>
                                          {index !== 0 && allRfpServiceLocationSame ? '' :
                                            <Grid
                                              container
                                              justifyContent="center"
                                              alignItems="center"
                                            >
                                              <Grid item xs={12} md={4}>
                                                <Box
                                                  sx={{
                                                    mt: 3,
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    gap: 1,
                                                  }}
                                                >
                                                  <LoadingButton
                                                    variant="contained"
                                                    onClick={() => {
                                                      setIsSaving(true)
                                                      setTimeout(() => {
                                                        setIsSaving(false)
                                                        setRfpServiceLocationStates(
                                                          false,
                                                        )
                                                      }, 100)
                                                    }}
                                                    loading={isSaving}
                                                  >
                                                    {' Save '}
                                                  </LoadingButton>
                                                </Box>
                                              </Grid>
                                            </Grid>
                                          }
                                        </Modal>
                                      </>
                                    );
                                  })}
                                </TableBody>
                                {cart?.filter((item)=>item.material == 1).length > 0 ?
                                <Typography variant='subtitle2' sx={{fontWeight:500}}>Materials</Typography>
                                :''}
                                <TableBody>
                                  {cart?.filter((item)=>item.material == 1).map((data, index) => {
                                    let unitName = UNITS?.filter((item) => item?.id == data?.unit)
                                    unitName = unitName[0]?.name
                                    let shortUnitName = ''
                                    if (unitName == 'Square feet') {
                                      shortUnitName = 'Sq ft'
                                    } else if (unitName == 'Lineal feet') {
                                      shortUnitName = 'Lin ft'
                                    } else if (unitName == 'Square Inches') {
                                      shortUnitName = 'Sq Inches'
                                    } else if (unitName == 'Unit') {
                                      shortUnitName = 'Unit'
                                    }
                                    // let markup = markupType ? markupType === 1 ? data.WholesaleMarkup : data.RetailMarkup : 0
                                    let markup = parseFloat(Number(data?.markup)) || 0
                                    data.product_markup = markup

                                    let newTotalProductFormula = (data.product_price * data.quantity * data.location_quantity)?.toFixed(2) || 0
                                    let newTotalCost = (data.location_quantity * data.quantity * ((data.product_price + (data.product_price * markup / 100)).toFixed(2) || 0)).toFixed(2)

                                    totalProductFormula += Number(newTotalProductFormula)
                                    totalWholesalePrice += Number(newTotalCost)
                                    totalRetailPrice += Number(newTotalCost)
                                    values['totalProductFormula'] = totalProductFormula
                                    values['totalWholesalePrice'] = totalWholesalePrice
                                    values['totalRetailPrice'] = totalRetailPrice

                                    return (
                                      <>
                                        <TableRow key={data.id}>
                                          <TableCell>{data.name || data.product_name}</TableCell>
                                          {/* <TableCell>{invoiceAmount}</TableCell> */}
                                          <TableCell>
                                            {markup?.toFixed(2) || 0.00}
                                          </TableCell>
                                          <TableCell>
                                            {data.product_price?.toFixed(2) || 0}
                                          </TableCell>
                                          <TableCell>
                                            {(data.product_price + (data.product_price * markup / 100)).toFixed(2) || 0.00}
                                          </TableCell>
                                          <TableCell>
                                            {data.quantity} {shortUnitName}
                                          </TableCell>
                                          <TableCell>
                                            {data.location_quantity}
                                          </TableCell>
                                          {/* <TableCell>
                                            {(data.product_price * data.quantity * data.location_quantity)?.toFixed(2) || 0}
                                          </TableCell> */}
                                          <TableCell>
                                            {(data.location_quantity * data.quantity * ((data.product_price + (data.product_price * markup / 100)).toFixed(2) || 0)).toFixed(2)}
                                          </TableCell>
                                          {/* <TableCell>N/A</TableCell>
                                          <TableCell>N/A</TableCell> */}
                                          <TableCell>
                                            <IconButton
                                              onClick={() => {
                                                setRfpLocationStates({ ...rfpLocationStates, [data.product_id]: true });
                                              }}
                                            >
                                              <LocationOn sx={{
                                                color: data && data.addresses && data.addresses.some(obj =>
                                                  [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
                                                ) ? '' : theme.palette.primary.main
                                              }} />
                                            </IconButton>
                                          </TableCell>
                                          <TableCell >
                                            <IconButton onClick={() => handleDeleteRFPProduct(data.id)}>
                                              <Delete />
                                            </IconButton>
                                          </TableCell>
                                        </TableRow>
                                        <Modal
                                          open={
                                            rfpLocationStates[data.product_id]
                                          }
                                          handleClose={() => {
                                            setRfpLocationStates({
                                              ...rfpLocationStates,
                                              [data.product_id]: false,
                                            })
                                          }}
                                        >
                                          {/* {index === 0 && ( */}
                                            <FormControlLabel
                                              control={
                                                <Switch
                                                  checked={
                                                    data?.allRfpProductsLocationSame
                                                  }
                                                  onChange={()=>
                                                    handleAllRfpProductsLocationSameChange(index)
                                                  }
                                                />
                                              }
                                              label="All Locations Same"
                                            />
                                          {/* )} */}

                                          <Grid
                                            container
                                            spacing={3}
                                            sx={{
                                              justifyContent: 'center',
                                              width: '100%',
                                            }}
                                          >
                                            {data?.addresses?.map((addr, i) => (
                                              <Grid item xs={12}>
                                                {/* Side Heading */}
                                                <Typography
                                                  variant="h5"
                                                  sx={{ mb: 2 }}
                                                >
                                                  Location {i+1}
                                                </Typography>

                                                {/* Address Fields */}

                                                <Stack
                                                  direction={{
                                                    xs: 'column',
                                                    sm: 'row',
                                                  }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="Address"
                                                    size="small"
                                                    value={
                                                      data.addresses[i]
                                                        .address || ''
                                                    }
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [
                                                    //     ...data.addresses,
                                                    //   ]
                                                    //   arrayAddr[i].address =
                                                    //     event.target.value

                                                    //   setCart((pv) => [
                                                    //     ...pv.map((p) => {
                                                    //       if (
                                                    //         p.product_id ===
                                                    //         data.product_id
                                                    //       ) {
                                                    //         return {
                                                    //           ...p,
                                                    //           addresses:
                                                    //             arrayAddr,
                                                    //         }
                                                    //       } else {
                                                    //         return {
                                                    //           ...p,
                                                    //         }
                                                    //       }
                                                    //     }),
                                                    //   ])
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.addresses];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                address: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                address: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              addresses: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                      // markUnsavedChanges();
                                                    }}
                                                  />
                                                </Stack>

                                                {/* City, State, Zip Fields */}
                                                <Stack
                                                  direction={{
                                                    xs: 'column',
                                                    sm: 'row',
                                                  }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="City"
                                                    size="small"
                                                    value={
                                                      data.addresses[i].city ||
                                                      ''
                                                    }
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [
                                                    //     ...data.addresses,
                                                    //   ]
                                                    //   arrayAddr[i].city =
                                                    //     event.target.value

                                                    //   setCart((pv) => [
                                                    //     ...pv.map((p) => {
                                                    //       if (
                                                    //         p.product_id ===
                                                    //         data.product_id
                                                    //       ) {
                                                    //         return {
                                                    //           ...p,
                                                    //           addresses:
                                                    //             arrayAddr,
                                                    //         }
                                                    //       } else {
                                                    //         return {
                                                    //           ...p,
                                                    //         }
                                                    //       }
                                                    //     }),
                                                    //   ])
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.addresses];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                city: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                city: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              addresses: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                      // markUnsavedChanges();
                                                    }}
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="State"
                                                    size="small"
                                                    value={
                                                      data.addresses[i].state ||
                                                      ''
                                                    }
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [
                                                    //     ...data.addresses,
                                                    //   ]
                                                    //   arrayAddr[i].state =
                                                    //     event.target.value

                                                    //   setCart((pv) => [
                                                    //     ...pv.map((p) => {
                                                    //       if (
                                                    //         p.product_id ===
                                                    //         data.product_id
                                                    //       ) {
                                                    //         return {
                                                    //           ...p,
                                                    //           addresses:
                                                    //             arrayAddr,
                                                    //         }
                                                    //       } else {
                                                    //         return {
                                                    //           ...p,
                                                    //         }
                                                    //       }
                                                    //     }),
                                                    //   ])
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.addresses];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                state: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                state: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              addresses: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                      // markUnsavedChanges();
                                                    }}
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="Zip / Postal Code"
                                                    size="small"
                                                    value={
                                                      data.addresses[i].zip ||
                                                      ''
                                                    }
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [
                                                    //     ...data.addresses,
                                                    //   ]
                                                    //   arrayAddr[i].zip =
                                                    //     event.target.value

                                                    //   setCart((pv) => [
                                                    //     ...pv.map((p) => {
                                                    //       if (
                                                    //         p.product_id ===
                                                    //         data.product_id
                                                    //       ) {
                                                    //         return {
                                                    //           ...p,
                                                    //           addresses:
                                                    //             arrayAddr,
                                                    //         }
                                                    //       } else {
                                                    //         return {
                                                    //           ...p,
                                                    //         }
                                                    //       }
                                                    //     }),
                                                    //   ])
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.addresses];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                zip: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                zip: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              addresses: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                </Stack>
                                              </Grid>
                                            ))}
                                          </Grid>

                                          <Grid
                                            container
                                            justifyContent="center"
                                            alignItems="center"
                                          >
                                            <Grid item xs={12} md={4}>
                                              <Box
                                                sx={{
                                                  mt: 3,
                                                  display: 'flex',
                                                  justifyContent: 'center',
                                                  gap: 1,
                                                }}
                                              >
                                                <LoadingButton
                                                  variant="contained"
                                                  onClick={() => {
                                                    setIsSaving(true)
                                                    setTimeout(() => {
                                                      setIsSaving(false)
                                                      setRfpLocationStates(
                                                        false,
                                                      )
                                                    }, 100)
                                                  }}
                                                  loading={isSaving}
                                                >
                                                  {' Save '}
                                                </LoadingButton>
                                              </Box>
                                            </Grid>
                                          </Grid>
                                        </Modal>
                                      </>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Scrollbar>
                          </>}
                          <LabelStyleHead>Materials</LabelStyleHead>
                          {/* <Typography></Typography> */}
                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            {/* <Autocomplete
                              sx={{ width: 400 }}
                              multiple
                              id="combo-box-demo"
                              // options={materials || []}
                              // options={materials?.filter((option) => !selectedMaterials?.some(selected => selected.id === option.id)) || []}
                              // options={
                              //   materials?.filter((option) => {
                              //     // Exclude selected materials
                              //     const isSelected = selectedMaterials?.some((selected) => selected.id === option.id);
                              //     const isServiceOnly = values.project_categories?.name === 'Service only';
                              //     // Filter materials: show only inhouse = 1 unless it's 'Service only'
                              //     const shouldInclude = isServiceOnly || option.inhouse === 1;
                              //     return !isSelected && shouldInclude;
                              //   }) || []
                              // }
                               options={
                                  materials?.filter((option) => {
                                    const isServiceOnly = values.project_categories?.name === 'Service only';
                                    // Show all materials if eligible (inhouse or service only)
                                    return isServiceOnly || option.inhouse === 1;
                                  }) || []
                                }
                              // value={selectedMaterials?.filter(item => !item?.isAdditionalProduct)}
                              value={pendingAutocompleteMaterials?.filter(item => !item?.isAdditionalProduct)}
                              // onChange={(event, newValue) => {
                              //   setFieldValue('additionalMaterials', newValue);
                              //   handleMaterial(newValue);
                              //   setShowAddNewRow(true)
                              // }}
                               onChange={(event, newValue) => {
                                if (newValue.length < selectedMaterials.length) {
                                // Only update state
                                setFieldValue('additionalMaterials', newValue);
                               setPendingAutocompleteMaterials(newValue); // ✅ sync Autocomplete state
                                handleMaterial(newValue); 
                                setSelectedMaterials([
                                  ...newValue,
                                  ...selectedMaterials.filter(item => item.isAdditionalProduct)
                                ]);
                                return;
                              }
                                if (!newValue || newValue.length === 0) return;
                                const lastSelected = newValue[newValue.length - 1];
                                setFieldValue('additionalMaterials', newValue)
                                // setPendingAutocompleteMaterials(newValue);
                                handleMaterialStockCheck(lastSelected);
                                setShowAddNewRow(true)                               

                              }}
                              renderInput={(params) => (
                                <TextField {...params} label="Materials"
                                  error={Boolean(touched.additionalMaterials && errors.additionalMaterials)}
                                  helperText={touched.additionalMaterials && errors.additionalMaterials}
                                />
                              )}
                              // getOptionLabel={(option) => option.name ? option.name : ''}
                              // getOptionLabel={(option) => {
                              //   const name = option.name || '';
                              //   const ownershipLabel = option.inhouse === 1 ? ' (Inhouse)' : ' (Client owned)';
                              //   return name + ownershipLabel;
                              // }}
                              isOptionEqualToValue={(option, value) => option.id === value.id}
                              getOptionLabel={(option) => {
                                  const name = option.name || '';
                                  const description = option.description || '';
                                  return `${description} \u200B${name}`.trim();
                                }}
                                renderOption={(props, option) => {
                                  const description = option.description || '';
                                  return (
                                     <li {...props}>
                                      <Tooltip title={description}>
                                        <span style={{
                                          display: 'inline-block',
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          maxWidth: '300px'
                                        }}>
                                          {description}
                                        </span>
                                      </Tooltip>
                                      <span style={{ display: 'none' }}>{option.name}</span>
                                    </li>
                                  );
                                }}
                              filterOptions={(options, { inputValue }) =>
                              options.filter((option) => {
                                console.log("Name:", option.name, "Description:", option.description);
                                const searchText = inputValue.toLowerCase();
                                return (
                                  option.name?.toLowerCase().includes(searchText) ||
                                  option.description?.toLowerCase().includes(searchText)
                                  // option.description?.toLowerCase().includes(searchText)
                                );
                              })
                            }
                            renderTags={(value, getTagProps) =>
                              value.map((option, index) => {
                                const suffix = option.inhouse === 1 ? '(Inhouse)' : '(Client owned)';
                                const tooltipText = `${option.description  || ''} ${suffix}`;
                                return(
                                  <Tooltip
                                     key={index}
                                     title={tooltipText}
                                   >
                                <Chip
                                  {...getTagProps({ index })}
                                  label={option.description || ''}
                                />
                                </Tooltip>
                              )})
                            }
                            /> */}
                            <Autocomplete
                              sx={{ width: 400 }}
                              multiple
                              id="material-autocomplete"
                              options={
                                materials?.filter(option => {
                                  const isServiceOnly = values.project_category?.name === 'Service only';
                                  return isServiceOnly || option.inhouse === 1;
                                }) || []
                              }
                              value={selectedMaterials.filter(item => !item.isAdditionalProduct)}
                              // onChange={(event, newValue) => {
                              //   if (!newValue || newValue.length === 0) return;

                              //   const lastSelected = newValue[newValue.length - 1];

                              //   // Material was removed
                              //   if (newValue.length < selectedMaterials.filter(item => !item.isAdditionalProduct).length) {
                              //     const updated = selectedMaterials.filter(
                              //       item => newValue.some(nv => (nv.product_id || nv.id) === (item.product_id || item.id))
                              //     );
                              //     setSelectedMaterials([
                              //       ...updated,
                              //       ...selectedMaterials.filter(item => item.isAdditionalProduct)
                              //     ]);
                              //     setPendingAutocompleteMaterials(updated);
                              //     setFieldValue('additionalMaterials', updated);
                              //     handleMaterial(updated);
                              //     return;
                              //   }

                              //   // Check if exact match already added (product_id + stock_type + convertion_unit)
                              //   const alreadySelected = selectedMaterials.some(
                              //     (item) =>
                              //       (item.product_id || item.id) === (lastSelected.product_id || lastSelected.id) &&
                              //       item.stock_type === lastSelected.stock_type &&
                              //       (item.stock_type === 1 || item.convertion_unit === lastSelected.convertion_unit)
                              //   );

                              //   if (alreadySelected) {
                              //     enqueueSnackbar('Material Already Added', { variant: 'error' });
                              //     return;
                              //   }

                              //   // Open dialog for choosing stock type (no immediate update)
                              //   handleMaterialStockCheck(lastSelected);
                              // }}
                                onChange={(event, newValue) => {
    if (!newValue) return;

    // 1. If cleared all
    if (newValue.length === 0) {
      const onlyAdditional = selectedMaterials.filter(item => item.isAdditionalProduct === true);
      setSelectedMaterials(onlyAdditional);
      setPendingAutocompleteMaterials(onlyAdditional);
      setFieldValue('additionalMaterials', onlyAdditional);
      handleMaterial(onlyAdditional);
      // markUnsavedChanges();
      return;
    }

    // 2. If item(s) removed
    const prevCore = selectedMaterials.filter(item => !item.isAdditionalProduct);
    if (newValue.length < prevCore.length) {
      const additionalRows = selectedMaterials.filter(item =>
        item.isAdditionalProduct === true &&
        !newValue.some(u =>
          (u.product_id || u.id) === (item.product_id || item.id) &&
          u.stock_type === item.stock_type &&
          (item.stock_type === 1 || u.convertion_unit === item.convertion_unit)
        )
      );

      const finalList = [...newValue, ...additionalRows];
      setSelectedMaterials(finalList);
      setPendingAutocompleteMaterials(newValue);
      setFieldValue('additionalMaterials', finalList);
      handleMaterial(finalList);
      // markUnsavedChanges();
      return;
    }

    // 3. If new item added
    const lastSelected = newValue[newValue.length - 1];

    const alreadySelected = selectedMaterials.some(
      (item) =>
        (item.product_id || item.id) === (lastSelected.product_id || lastSelected.id) &&
        item.stock_type === lastSelected.stock_type &&
        (item.stock_type === 1 || item.convertion_unit === lastSelected.convertion_unit)
    );

    // Trigger stock type selection popup
    if (lastSelected) {
      handleMaterialStockCheck(lastSelected);
    }
  }}
                              getOptionLabel={(option) => {
                                const name = option.name || option.product_name || '';
                                const description = option.description || option.product_description || option.product_name ||'';
                                const ownership = option.inhouse === 1 ? ' (Inhouse)' : ' (Client owned)';
                                return `${description}${ownership} \u200B${name}`;
                              }}
                              isOptionEqualToValue={(option, value) =>
                                (option.product_id || option.id) === (value.product_id || value.id) &&
                                option.stock_type === value.stock_type &&
                                (option.stock_type === 1 || option.convertion_unit === value.convertion_unit)
                              }
                              renderOption={(props, option) => {
                                const { style, ...liProps } = props;
                                const description = option.description || option.product_description || option.name || '';
                                const ownership = option.inhouse === 1 ? ' (Inhouse)' : ' (Client owned)';
                                // const stockLabel = option.stock_type === 1
                                //   ? 'Finished'
                                //   : `Partial - ${UNITS.find(u => u.id === option.convertion_unit)?.name || 'Unit'}`;
                                // const fullText = `${description} ${ownership} [${stockLabel}]`;
                                const fullText = `${description} ${ownership}`;
                                return (
                                  <li
                                    {...liProps}
                                    style={{
                                      ...style,
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <Tooltip title={fullText}>
                                      <span style={{
                                        flex: 1,
                                        minWidth: 0,
                                        display: 'block',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                      }}>
                                        {fullText}
                                      </span>
                                    </Tooltip>
                                    <span style={{ display: 'none' }}>{option.name}</span>
                                  </li>
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Materials"
                                  error={Boolean(touched.additionalMaterials && errors.additionalMaterials)}
                                  helperText={touched.additionalMaterials && errors.additionalMaterials}
                                />
                              )}
                              filterOptions={(options, { inputValue }) =>
                                options.filter((option) => {
                                  const searchText = inputValue.toLowerCase();
                                  return (
                                    option.name?.toLowerCase().includes(searchText) ||
                                    option.description?.toLowerCase().includes(searchText)
                                  );
                                })
                              }
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => {
                                  const suffix = option.inhouse === 1 ? '(Inhouse)' : '(Client owned)';
                                  const stockLabel = option.stock_type === 1
                                    ? 'Finished'
                                    : `Partial - ${UNITS.find(u => u.id === option.convertion_unit)?.name || 'Unit'}`;
                                  const tooltipText = `${option.description || option.name || option.product_name || ''} ${suffix} [${stockLabel}]`;
                                  return (
                                    <Tooltip key={index} title={tooltipText}>
                                      <Chip
                                        {...getTagProps({ index })}
                                        label={`${option.description || option.name || option.product_name || ''} ${suffix} [${stockLabel}]`}
                                      />
                                    </Tooltip>
                                  );
                                })
                              }
                            />

                          </Stack>
                          <LabelStyle>Selected Materials</LabelStyle>
                          <Scrollbar>
                            <TableContainer sx={{ minWidth: 500 }}>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    {VALUE_MATERIAL?.map((val,index) => (
                                      val.id === 3 ? (
                                        <Tooltip key={val.id} title="Unit Price + ((Unit Price * Markup)/100)">
                                          <TableCell key={val.id}>{val.value}</TableCell>
                                        </Tooltip>
                                      ) : val.id === 5 ? (
                                        <Tooltip key={val.id} title="Unit Price * Quantity">
                                          <TableCell key={val.id}>{val.value}</TableCell>
                                        </Tooltip>
                                      ) : val.id === 6 ? (
                                        <Tooltip key={val.id} title="Markup Cost * Quantity">
                                          <TableCell key={val.id}>{val.value}</TableCell>
                                        </Tooltip>
                                      ) :
                                        <TableCell key={val.id}>{val.value}</TableCell>

                                    ))}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {selectedMaterials?.map((data, index) => {
                                     const adjustmentFieldName = `adjustment_${index}`;
                                  let unitName ='';
                                  if(data?.stock_type===1){
                                  unitName = UNITS?.filter((item) => item?.id == data?.unit)
                                  }else{
                                    unitName = UNITS?.filter((item) => item?.id == data?.convertion_unit)
                                  }
                                    let shortUnitName = unitName[0]?.short_name
                                    // if (unitName == 'Square feet') {
                                    //   shortUnitName = 'Sq ft'
                                    // } else if (unitName == 'Lineal feet') {
                                    //   shortUnitName = 'Lin ft'
                                    // } else if (unitName == 'Square Inches') {
                                    //   shortUnitName = 'Sq Inches'
                                    // } else if (unitName == 'Unit') {
                                    //   shortUnitName = 'Unit'
                                    // }
                                    const markUpCost = data.price + ((parseFloat(data.price) * parseFloat(data.markup || 0)) / 100)
                                    data['markUpCost'] = parseFloat(parseFloat(markUpCost).toFixed(2)) || 0;

                                    let newTotalProductFormula = (data.price * (data.quantity || 1))?.toFixed(2)
                                    let newTotalCost = ((data.markUpCost || 0) * (data.quantity || 1))?.toFixed(2)

                                    totalProductFormula += Number(newTotalProductFormula)
                                    totalWholesalePrice += Number(newTotalCost)
                                    totalRetailPrice += Number(newTotalCost)
                                    values['totalProductFormula'] = totalProductFormula
                                    values['totalWholesalePrice'] = totalWholesalePrice
                                    values['totalRetailPrice'] = totalRetailPrice
                                    // console.log("datadatadatadatadata",data)
                                    if(data.adj_value_type == null){
                                      data.adj_value_type =true
                                     }
                                    return (
                                      <>
                                        <TableRow key={data?.newIndexId || index}>
                                          <TableCell>{index + 1}</TableCell>
                                          <TableCell>
                                            {data?.isAdditionalProduct ?
                                              <TextField
                                                required
                                                fullWidth
                                                type="text"
                                                label={'Material Name'}
                                                sx={{ width: 85 }}
                                                value={data.name}
                                                onChange={(event) => {
                                                  let newValue = event.target.value
  
                                                  // Update the selectedProducts state
                                                  setSelectedMaterials(
                                                    (prevProducts) =>
                                                      prevProducts.map((service) => {
                                                          if ( service.newIndexId === data.newIndexId ) {
                                                            return {
                                                              ...service,
                                                              name: newValue,
                                                            }
                                                          } else {
                                                            return service
                                                          }
                                                        },
                                                      ),
                                                  )
                                                  data['name'] = newValue || ''
                                                  if (isSubmitted)
                                                    setIsSubmitted(false)
                                                markUnsavedChanges()
                                                }}
                                                error={
                                                  isSubmitted && data?.name?.trim() === ''
                                                }
                                                helperText={
                                                  isSubmitted && data?.name?.trim() === '' ? 'Material Name is required' : ''
                                                }
                                              />
                                              : <Typography sx={{ color: data.material_notes ? theme.palette.error.main : 'inherit' }}>{data.material_notes || data.name}</Typography>}
                                          </TableCell>
                                          <TableCell>
                                            <IconButton onClick={() => handleOpenMaterialNote(data.newIndexId, data.material_notes)}>
                                              <NoteAdd
                                                sx={{
                                                  color: (!data?.material_notes || data?.material_notes === '') ? '' : theme.palette.primary.main,
                                                }}
                                              />
                                            </IconButton>
                                          </TableCell>
                                          <TableCell>{data.stock_type===1 ?"Finished":"Partial"}
                                            </TableCell>
                                          <TableCell>{data?.isAdditionalProduct ?
                                            <TextField
                                              required
                                              fullWidth
                                              type="number"
                                              label={'Unit Price'}
                                              disabled={values.project_categories?.name == 'Time & Material' ? true : false}
                                              sx={{ width: 85 }}
                                              value={data.price}
                                              onWheel={(e) => e.target.blur()}
                                              defaultValue={0}
                                              onChange={(event) => {
                                                let newValue = event.target.value
                                                if (newValue !== '') {
                                                  setSelectedMaterials((pv) => [
                                                      ...pv.map((p) => {
                                                        if ( p.newIndexId === data.newIndexId ) {
                                                          return {
                                                            ...p,
                                                            price: Number(newValue),
                                                          }
                                                        } else {
                                                          return p
                                                        }
                                                      }),
                                                    ],
                                                  )
                                                  data['price'] =  Number(newValue || 0)
                                                }
                                                markUnsavedChanges()
                                              }}
                                              // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                              // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                            />
                                          : data.price}</TableCell>
                                          <TableCell>
                                                  <TextField
                                                    required
                                                    fullWidth
                                                    type="number"
                                                    label="Markup"
                                                    value={Number(data.markup) || 0}
                                                    inputProps={{ min: 0 }}
                                                    onKeyPress={(event) => {
                                                      if (event.key === '-' || event.key === 'e') {
                                                        event.preventDefault();
                                                      }
                                                    }}
                                                    onChange={(event) => {
                                                      let newValue = event.target.value;

                                                      // Prevent negative values and invalid inputs
                                                      if (newValue.startsWith('-') || /^0[0-9]+$/.test(newValue)) {
                                                        newValue = '0';
                                                      }

                                                      setSelectedMaterials((prevMaterials) =>
                                                        prevMaterials.map((p) => {
                                                          const isMatchingProduct = data.isAdditionalProduct
                                                            ? p.newIndexId === data.newIndexId
                                                            : (p.product_id || p.id) === (data.product_id || data.id) &&
                                                              p.stock_type === data.stock_type &&
                                                              (p.stock_type === 1 || p.convertion_unit === data.convertion_unit) &&
                                                              (p.newIndexId === data.newIndexId || (!data.isAdditionalProduct && p.id === data.id));

                                                          return isMatchingProduct
                                                            ? { ...p, 
                                                              markup: newValue === '' ? 0 : Number(newValue),
                                                              adjustment: data.adj_value_type ? p.adjustment :null
                                                             }
                                                            : p;
                                                        }),
                                                      );
                                                      if(!data.adj_value_type){
                                                        data['adjustment'] = null
                                                        setFieldValue(adjustmentFieldName, null, );
                                                      }
                                                     
                                                    markUnsavedChanges()
                                                    }}
                                                    onWheel={(e) => e.target.blur()}
                                                  />
                                          </TableCell>

                                          {/* <TableCell>{data.markUpCost || 0}</TableCell> */}
                                          <TableCell>{(data.markUpCost + (data.adj_value_type ? Number(data.adjustment || 0) : -Number(data.adjustment || 0))).toFixed(2) || 0}</TableCell>
                                            <TableCell>
                                              <TextField
                                                required
                                                fullWidth
                                                type='number'
                                                label={shortUnitName || 'Quantity'}
                                                value={Number(data.quantity) || 0}
                                                defaultValue={1}
                                                onKeyPress={(event) => {
                                                  if (event.target.value === '') {
                                                    event.preventDefault();
                                                  }
                                                  if (event.key === '-' || event.key === 'e') {
                                                    event.preventDefault();
                                                  }
                                                }}
                                                onChange={(event) => {
                                                  const newValue = Number(event.target.value) || 0;

                                                  setSelectedMaterials((prevMaterials) =>
                                                    prevMaterials.map((p) => {
                                                      const isMatchingProduct = data.isAdditionalProduct
                                                        ? p.newIndexId === data.newIndexId
                                                        : (p.product_id || p.id) === (data.product_id || data.id) &&
                                                          p.stock_type === data.stock_type &&
                                                          (p.stock_type === 1 || p.convertion_unit === data.convertion_unit) &&
                                                          (p.newIndexId === data.newIndexId || (!data.isAdditionalProduct && p.id === data.id));

                                                      if (isMatchingProduct) {
                                                        return {
                                                          ...p,
                                                          quantity: newValue,
                                                        };
                                                      }
                                                      return p;
                                                    }),
                                                  );
                                                // markUnsavedChanges()
                                                }}
                                                onWheel={(e) => e.target.blur()}
                                                onKeyDown={(event) => {
                                                  if (event.key === 'ArrowDown' && Number(event.target.value) <= 1) {
                                                    event.preventDefault();
                                                  }
                                                }}
                                              />
                                            </TableCell>
                                          <TableCell>
                                            <Stack direction="row" spacing={1} alignItems="center">
                                              <Remove
                                                fontSize="small"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                  const hasPermission = explodedPermissions?.some((permission) =>
                                                    ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
                                                  )
                                                  if (!hasPermission) {
                                                    return enqueueSnackbar('Access Denied : You do not have Suffient Permission', { variant: 'error' })
                                                  }
                                                  // const formulaEach = Number(data.markUpCost)
                                                  // const retailEachBase = Number(data.price)
                                                  const formulaEach = Number(data.price)
                                                  const retailEachBase = Number(data.markUpCost)
                                                  if (retailEachBase <= formulaEach) {
                                                    return enqueueSnackbar(
                                                      'To apply a negative marketing adjustment, Markup Cost Each must be higher than Unit Price.',
                                                      { variant: 'error' },
                                                    )
                                                  }
                                                  const maxNegative = getMaterialMaxNegativeAdjustment(data);
                                                  const adjustment = Number(data?.adjustment) || 0;
                                                  console.log('aaaaaaaaaaaaaa', data?.adjustment);
                                                  console.log('aaaaaaaaaaaaaa', adjustment);
                                                  console.log('aaaaaaaaaaaaaa', maxNegative);

                                                  if (adjustment > maxNegative) {
                                                    return enqueueSnackbar(
                                                      `Negative Adjustment Amount cannot reduce total below Product Unit Price. Max allowed: $$${maxNegative}`,
                                                      { variant: 'error' }
                                                    );
                                                  }
                                                  const newValue = false
                                                  setSelectedMaterials((prevMaterials) =>
                                                    prevMaterials.map((p) => {
                                                      if (prevMaterials.newIndexId === data.newIndexId) {
                                                        return {
                                                          ...p,
                                                          adj_value_type: newValue,
                                                        };
                                                      }
                                                      return p;
                                                    }),
                                                  )
                                                  data['adj_value_type'] = newValue
                                                  // markUnsavedChanges();
                                                }}
                                              />
                                              <FormControlLabel
                                                control={
                                                  <Switch
                                                    checked={data.adj_value_type}
                                                    onChange={(event) => {
                                                      const newValue = event.target.checked
                                                      const hasPermission = explodedPermissions?.some((permission) =>
                                                        ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
                                                      )
                                                      if (!hasPermission && newValue === false) {
                                                        return enqueueSnackbar('Access Denied : You do not have Suffient Permission', { variant: 'error' })
                                                      }
                                                      if (newValue === false) {
                                                        const formulaEach = Number(data?.price)
                                                        const retailEachBase = Number(data.markUpCost)
                                                        if (retailEachBase <= formulaEach) {
                                                          return enqueueSnackbar(
                                                            'To apply a negative marketing adjustment, Markup Cost Each must be higher than Unit Price.',
                                                            { variant: 'error' },
                                                          )
                                                        }
                                                      }
                                                      const maxNegative = getMaterialMaxNegativeAdjustment(data);
                                                      const adjustment = Number(data.adjustment) || 0;
                                                      if (adjustment > maxNegative && newValue === false) {
                                                        return enqueueSnackbar(
                                                          `Negative Adjustment Amount cannot reduce total below Product Unit Price. Max allowed: $${maxNegative}`,
                                                          { variant: 'error' }
                                                        );
                                                      }

                                                      setSelectedMaterials((prevMaterials) =>
                                                        prevMaterials.map((p) => {
                                                          if (prevMaterials.newIndexId === data.newIndexId) {
                                                            return {
                                                              ...p,
                                                              adj_value_type: newValue,
                                                            };
                                                          }
                                                          return p;
                                                        }),
                                                      )
                                                      data['adj_value_type'] = newValue
                                                      // markUnsavedChanges();
                                                    }}
                                                  />
                                                }
                                                label=""
                                              />
                                              <Add
                                                fontSize="small"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                  const newValue = true
                                                  setSelectedMaterials(
                                                    (prevProducts) =>
                                                      prevProducts.map(
                                                        (product) => {
                                                          if (
                                                            product.newIndexId ===
                                                            data.newIndexId
                                                          ) {
                                                            return {
                                                              ...product,
                                                              adj_value_type: newValue,
                                                            }
                                                          }
                                                          return product
                                                        },
                                                      ),
                                                  )
                                                  data['adj_value_type'] = newValue
                                                  // markUnsavedChanges();
                                                }}
                                              />
                                            </Stack>
                                          </TableCell>
                                          <TableCell>
                                            <TextField
                                              type="number"
                                              inputProps={{ min: 0 }}
                                              // label={
                                              //   data.markAdjType === 2
                                              //     ? '$'
                                              //     : data.markAdjType === 3
                                              //     ? '¢'
                                              //     : '%'
                                              // }
                                              label='$'
                                              value={ data.adjustment ?
                                                Number(data.adjustment) ||
                                                null : ''
                                              }
                                              onWheel={(e) => e.target.blur()}
                                              // onBeforeInput={(e) => {
                                              //   // const char = e.data; // next typed character
                                              //   // const nextValue = e.target.value + char;
                                              //   const inputElement = e.target;
                                              //   const nextValue = inputElement.value;

                                              //   const maxNegative = getMaterialMaxNegativeAdjustment(data);
                                              //   console.log('getMaxNegativeAdjustment1-maxNegative--maxNegative1',maxNegative);
                                              //   console.log('getMaxNegativeAdjustment1-maxNegative--nextValue',nextValue);
                                                
                                                
                                              //   if (Number(nextValue) > maxNegative && (data.adj_value_type === false || data.adj_value_type === 0)) {
                                              //     e.preventDefault(); // ← stops the key BEFORE appearing
                                              //     enqueueSnackbar(
                                              //       `1 Negative Adjustment Amount cannot reduce total below Product Unit Price. Max allowed: $${maxNegative.toFixed(2)}`,
                                              //       { variant: "error" }
                                              //     );
                                              //   }
                                              // }}
                                              onBeforeInput={(e) => {
                                                // const char = e.data; // next typed character
                                                // const nextValue = e.target.value + char;
                                                const inputElement = e.target;
                                                const nextValue = inputElement.value; 
                                            
                                                const maxNegative = getMaterialMaxNegativeAdjustment(data);
                                                if (Number(nextValue) > maxNegative && (data.adj_value_type === false || data.adj_value_type === 0)) {
                                                  e.preventDefault(); // ← stops the key BEFORE appearing
                                                  enqueueSnackbar(
                                                    `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${maxNegative}`,
                                                    { variant: "error" }
                                                  );
                                                }
                                              }}
                                              
                                              onChange={(event) => {
                                                let newValue = event.target.value
                                                const maxNegative = getMaterialMaxNegativeAdjustment(data);
                                                console.log('getMaxNegativeAdjustment1-maxNegative--maxNegative2',maxNegative);
                                                console.log('getMaxNegativeAdjustment1-maxNegative--newValue',newValue);
                                                console.log('getMaxNegativeAdjustment1-maxNegative--newValue',Number(newValue) > maxNegative);
                                                console.log('getMaxNegativeAdjustment1-maxNegative--adj_value_type',data.adj_value_type);
                                                if (Number(newValue) > maxNegative && (data.adj_value_type === false || data.adj_value_type === 0)) {
                                                  enqueueSnackbar(
                                                    `Negative Adjustment Amount cannot reduce total below Product Unit Price. Max allowed: $${maxNegative}`,
                                                    { variant: 'error' }
                                                  );
                                                  
                                                  return;
                                                }
                                                console.log('getMaxNegativeAdjustment1-maxNegative--adj_value_type2',data.adj_value_type);
                                                const numValue = parseFloat(newValue) || 0
                                                if (numValue < 0) {
                                                  newValue = 0
                                                } else {
                                                  newValue = String(numValue)
                                                }
                                                // Allow only two decimal places
                                                if (
                                                  newValue.includes('.')
                                                ) {
                                                  const parts =
                                                    newValue.split('.')
                                                  if (parts[1].length > 2) {
                                                    newValue = `${parts[0]
                                                      }.${parts[1].slice(
                                                        0,
                                                        2,
                                                      )}`
                                                  }
                                                }
                                                data['adjustment'] =
                                                  newValue
                                                setFieldValue(
                                                  adjustmentFieldName,
                                                  newValue,
                                                );
                                                setRefreshCalculation(!refreshCalculation)
                                                // markUnsavedChanges();
                                              }}
                                              onKeyDown={(event) => {
                                                if (
                                                  event.key === '-' ||
                                                  event.key === '+'
                                                ) {
                                                  event.preventDefault()
                                                }
                                                // Prevent arrow down key when value is 0 or would go negative
                                                if (event.key === 'ArrowDown') {
                                                  const inputValue = event.target.value
                                                  const currentValue = parseFloat(inputValue) || 0
                                                  const step = parseFloat(event.target.step) || 1
                                                  if (currentValue - step < 0) {
                                                    event.preventDefault()
                                                  }
                                                }
                                              }}
                                              error={Boolean(
                                                touched[
                                                adjustmentFieldName
                                                ] &&
                                                errors[
                                                adjustmentFieldName
                                                ],
                                              )}
                                              helperText={
                                                touched[
                                                adjustmentFieldName
                                                ] &&
                                                errors[adjustmentFieldName]
                                              }
                                            />
                                          </TableCell>
                                          {/* <TableCell>{(data.price * (data.quantity || 0))?.toFixed(2)}</TableCell> */}
                                          {/* <TableCell>{((data.markUpCost || 0) * (data.quantity || 0))?.toFixed(2)}</TableCell> */}
                                          <TableCell>
                                            {(
                                              (data.markUpCost + (data.adj_value_type ? Number(data.adjustment || 0) : -Number(data.adjustment || 0))) * (data.quantity || 0)
                                            )?.toFixed(2)}
                                          </TableCell>


                                          <TableCell >
                                            {/* <IconButton onClick={() => handleDeleteMaterial(data.id, data.newIndexId,)}>
                                              <Delete />
                                            </IconButton> */}
                                            <IconButton onClick={() => handleDeleteMaterial(data.product_id || data.id, data.stock_type, data.convertion_unit, data.newIndexId)}>
                                              <Delete />
                                            </IconButton>

                                          </TableCell>
                                        </TableRow>
                                        <Modal
                                          open={openMaterialNote[data.newIndexId] || false}
                                          handleClose={() => handleCloseMaterialNote(data.newIndexId)}
                                        >
                                          <Grid container spacing={3} sx={{ justifyContent: 'center', width: '100%' }}>
                                            <Grid item xs={12}>
                                              <Typography variant="h5" sx={{ mb: 2 }}>Note</Typography>
                                              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} sx={{ mb: 2 }}>
                                                <TextField
                                                  fullWidth
                                                  multiline
                                                  rows={4}
                                                  size="medium"
                                                  value={currentNote}
                                                  onChange={handleNoteChange}
                                                  sx={{
                                                    '& .MuiInputBase-input': {
                                                      color: 'red',
                                                    },
                                                  }}
                                                  error={!currentNote.trim() && currentNote.length > 0}
                                                  inputProps={{ maxLength: MAX_CHARACTERS }}
                                                  helperText={
                                                    !currentNote.trim() && currentNote.length > 0
                                                      ? 'Note cannot be empty or contain only spaces'
                                                      : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                                  }
                                                />
                                              </Stack>
                                            </Grid>
                                          </Grid>
                                          <Grid container justifyContent="center" alignItems="center">
                                            <Grid item xs={12} md={4}>
                                              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                                <LoadingButton
                                                  variant="contained"
                                                  onClick={() => handleSaveMaterialNote(data.newIndexId)}
                                                  loading={isSavingNote}
                                                  disabled={!currentNote.trim()}
                                                >
                                                  Save
                                                </LoadingButton>
                                                <LoadingButton
                                                  variant="outlined"
                                                  color="error"
                                                  onClick={() => handleClearMaterialNote(data.newIndexId)}
                                                  loading={isClearingNote}
                                                  disabled={!currentNote.trim()}
                                                >
                                                  Clear
                                                </LoadingButton>
                                              </Box>
                                            </Grid>
                                          </Grid>
                                        </Modal>
                                      </>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Scrollbar>
                          {
                            showAddNewRow ?
                          <Stack sx={{ justifyContent: 'flex-end', alignItems: 'center', display:'flex', flexDirection:'row' }}>
                            {/* <Button
                              variant="outlined"
                              startIcon={
                                <Stack>
                                  {' '}
                                  <Add />{' '}
                                </Stack>
                              }
                              onClick={() => {
                                addNewMaterialRow()
                                // setMarkupType(1)
                              }}
                            >
                              Add Material Row
                            </Button> */}
                            <Typography variant="h6">
                              Total Additional Material Cost:{' '}
                              {selectedMaterialSubTotal}
                            </Typography>
                          </Stack>
                          :""}
                          <Divider />
                          <LabelStyle>Notes</LabelStyle>
                          <TextField
                            fullWidth
                            multiline
                            minRows={3}
                            maxRows={7}
                            label="Notes"
                            {...getFieldProps('notes')}
                            onChange={(e) => {
                              getFieldProps('notes').onChange(e);
                              // markUnsavedChanges();
                            }}
                            error={Boolean(touched.notes && errors.notes)}
                            helperText={touched.notes && errors.notes}
                            InputProps={{
                              sx: {
                                color: 'error.main',
                              }
                            }}
                          />
                          {/* </>} */}
                          {/* <LabelStyle>Extra Discount</LabelStyle> */}
                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                          <TextField
                            // sx={{ width: 400 }}
                            fullWidth
                            type='number'
                            onKeyPress={(event) => {
                              if (event.key === '-') {
                                event.preventDefault();
                              }
                            }}
                            onChange={(event) => {
                              let newValue = event.target.value
                              let data = 0;
                              if (markupType === 1) {
                                data = totalWholesalePrice - totalJobcostSum
                              } else if (markupType === 2) {
                                data = totalRetailPrice - totalJobcostSum
                              }
                              if (Number(newValue) > data) {
                                newValue = data?.toFixed(2);
                              }
                              if (newValue === '-0.00') {
                                newValue = 0;
                              }
                              console.log('newValue-2-------', newValue);
                              setFieldValue('invoice_discount', newValue);
                              // markUnsavedChanges();
                            }}
                            label={hasDiscountPermission ? "Discount (Access Denied)" : "Discount"}
                            disabled={hasDiscountPermission}
                            value={values.invoice_discount}
                            // {...getFieldProps('invoice_discount')}
                            error={Boolean(touched.invoice_discount && errors.invoice_discount)}
                            helperText={touched.invoice_discount && errors.invoice_discount}
                            inputProps={{ max: (markupType === 1) ? totalWholesalePrice - totalJobcostSum : ((markupType === 2) ? totalRetailPrice - totalJobcostSum : 0), min: 0 }}
                          />
                          {/* <Autocomplete
                              // sx={{ width: 400 }}
                              fullWidth
                              id="combo-box-demo"
                              disabled={true}
                              options={taxCategories || []}
                              value={selectedTaxCategory || null}
                              onChange={(event, newValue) => {
                                setSelectedTaxCategory(newValue);
                              }}
                              renderInput={(params) => (
                                <TextField {...params} label="Tax category" />
                              )}
                              getOptionLabel={(option) => option.name ? option.name : ''}
                            /> */}
                          </Stack>
                          <Typography sx={{ color: theme.palette.error.main }}>**All values in the software are rounded to two decimal places in accordance with standard US calculation practices.</Typography>
                          <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={'center'} spacing={{ xs: 3, sm: 2 }}>
                            <Stack sx={{ width: 400 }}>
                              {/* <Typography sx={{ color: 'text.secondary' }}>Sub Total: {RFQSubTotal ? RFQSubTotal?.toFixed(2) : 0}</Typography> */}
                              {/* <Typography sx={{ color: 'text.secondary' }}>Service cost in Product Formula: {InitialServiceCostInProductFormula ? InitialServiceCostInProductFormula?.toFixed(2) : 0}</Typography> */}
                              {/* <Typography >
                            Install Price: {installCost ? installCost : '0.00'}
                          </Typography> */}
                              <Typography >
                                Sub Total: {totalsum ? totalsum.toFixed(2) : '0.00'}
                              </Typography>
                              {/* <Typography >
                                Tax: {parseFloat(taxAmount).toFixed(2) || 0.00}
                              </Typography> */}
                              <Typography sx={{ color: theme.palette.mode === 'light' ? '#FFAF00' : 'yellow' }}>
                                Grand Total: {grandTotal ? parseFloat(grandTotal)?.toFixed(2) : 0.00}
                              </Typography>
                              {/* <Typography sx={{ color: 'yellow' }}>Grand Total : {totalsum ? totalsum?.toFixed(2) : 0.00}</Typography> */}
                              {/* <Typography sx={{ color: 'yellow' }}>Total Product Formula Cost: {totalJobcostSum ? totalJobcostSum?.toFixed(2) : 0}</Typography> */}
                              {/* <Typography sx={{ color: 'text.secondary' }}>Total: {totalsum < 0 ? 0 : totalsum?.toFixed(2)}</Typography> */}
                              <Typography >Total Discount:{DiscountTotal ? DiscountTotal?.toFixed(2) : 0.00}</Typography>

                              {/* <Tooltip title="Sub Total - Total Product Formula Cost">
                                <Typography sx={{ cursor: 'pointer' }}>Total Markup Amount:{(totalsum - totalJobcostSum)?.toFixed(2)}</Typography>
                              </Tooltip> */}

                              {/* <Tooltip title="(Total Markup Amount / Total Product Formula Cost) * 100"> */}
                                {/* <Typography sx={{ color: 'text.secondary', cursor: 'pointer' }}>
                                  Total Markup Percentage:
                                  {markupType === 1
                                    ? (totalProductFormula !== 0
                                      ? ((((totalWholesalePrice - DiscountTotal) - totalProductFormula) / totalProductFormula) * 100).toFixed(2)
                                      : '0.00')
                                    : markupType === 2
                                      ? (totalProductFormula !== 0
                                        ? ((((totalRetailPrice - DiscountTotal) - totalProductFormula) / totalProductFormula) * 100).toFixed(2)
                                        : '0.00')
                                      : '0.00'}
                                </Typography> */}
                                {/* <Typography sx={{  cursor: 'pointer' }}>
                                  Total Markup Percentage:
                                  {(totalJobcostSum !== 0 && totalsum !== 0)
                                    ? (((totalsum - totalJobcostSum) / totalJobcostSum) * 100).toFixed(2)
                                    : '0.00'}
                                </Typography>
                              </Tooltip> */}

                              {/* <Typography sx={{ color: 'text.secondary' }}>Total Product Markup:{(originaltotalMarkup / selectedProducts.length)?.toFixed(2)}</Typography> */}
                              {/* <Typography sx={{ color: 'text.secondary' }}>Total Service Markup:{(originaltotalServiceMarkup / (selectedServices.length + additionalSelectedServices.length))?.toFixed(2)}</Typography> */}
                            </Stack>
                            <Stack direction={'column'} display={'flex'} justifyContent={'center'}>
                            <FormControlLabel
                              control={<Switch {...getFieldProps('welcome_message')} color="primary" checked={values.welcome_message} onChange={(e) => { getFieldProps('welcome_message').onChange(e);}} />}
                              labelPlacement="end"
                              label="Use Custom Welcome Message"
                              sx={{ mt: 6, ml: 5 , mb:2 }}
                            />
                            <FormControlLabel
                          control={
                            <Switch
                            {...getFieldProps('client_approve')}
                              color="primary"
                              checked={values.client_approve}
                              onChange={(event) => { setFieldValue('client_approve', event.target.checked); }}
                            />
                          }
                          labelPlacement="end"
                          label="Enable for Client Approval"
                          sx={{ mt: 0,ml: 5 }}
                        />
                        </Stack>
                          </Stack>
                          {values.welcome_message == true && (
                            <>
                              <Stack>
                                <LabelStyle>Subject</LabelStyle>
                                <TextField
                                  //   fullWidth
                                  type='text'
                                  sx={{ width: 400 }}

                                  {...getFieldProps('subject')}
                                  onChange={(e) => {
                                    getFieldProps('subject').onChange(e);
                                    // markUnsavedChanges();
                                  }}
                                  error={Boolean(touched.subject && errors.subject)}
                                  helperText={touched.subject && errors.subject}
                                />
                              </Stack>
                              <LabelStyle>Email Content</LabelStyle>
                              <TextField
                                fullWidth
                                multiline
                                minRows={3}
                                maxRows={7}
                                label="Email Content"
                                {...getFieldProps('email_content')}
                                onChange={(e) => {
                                  getFieldProps('email_content').onChange(e);
                                  // markUnsavedChanges();
                                }}
                                error={Boolean(touched.email_content && errors.email_content)}
                                helperText={touched.email_content && errors.email_content}
                              />
                            </>
                          )}


                        </>
                      )}

                      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                        <LoadingButton type="submit" variant="contained" loading={isSubmitting}  >
                          Save Estimate
                        </LoadingButton>
                        <LoadingButton
                          type="button"
                          variant="outlined"
                          loading={isSubmitting}
                          onClick={handleSaveDraft}
                        >
                          Save as Draft
                        </LoadingButton>
                        {/* {(userType !== 3 && (explodedPermissions?.some(permission => ['Create Estimate'].includes(permission)))) && (
                          <Button variant="outlined" onClick={() => setOpenPreview(!openPreview)}>
                            Preview
                          </Button>
                        )} */}
                        <Button variant="outlined" onClick={handleCancel}>
                          Cancel
                        </Button>
                      </Box>
                    </Stack>
                  </Card>
                </Grid>
              </Grid>
            </Form>
            {/* 🚀 PROGRESS TRACKING: Progress Modal */}
            {/* <RequestProgressModal
              open={showProgressModal}
              onClose={() => setShowProgressModal(false)}
              requestData={progressRequestData}
              heading={progressRequestData?.processType === 'draft' ? `Saving estimate as draft` : `Creating Estimate`}
            /> */}
            <RequestProgressModal
              open={showProgressModal}
              onClose={() => setShowProgressModal(false)}
              requestData={progressRequestData}
              heading={'Estimate'}
              message="We're processing your request. Please wait..."
            />
          </FormikProvider>
        ) : null}
        {openRequestEstimate && (
          <RequestEstimate 
            setIsLoading = {setIsLoading}
            isLoading = {isLoading}
            allClientsData={allClients}
            projectTypesData={projectTypes}
            open={openRequestEstimate} 
            setOpen={(value) => {
              setOpenRequestEstimate(value);
              if (!value) {
                fetchAllRequest();
              }
            }} 
          />
        )}
        {!open && !openRequestEstimate && (<>
          <Scrollbar>
            <Grid container spacing={2}>
              {/* <Tabs
                value={currentTab}
                scrollButtons="auto"
                variant="scrollable"
                allowScrollButtonsMobile
                onChange={handleChangeTab}

              >
                {ACCOUNT_TABS.map((tabItem) => (
                  <Tab
                    sx={{
                      overflow: 'visible',
                      justifyContent: 'center',
                      //  marginX: 15, mt: 3
                    }}
                    disableRipple
                    key={tabItem.value}
                    // label={
                    //     tabItem.count > 0 ?(<>
                    //     {tabItem.name =="ARCHIVE"? 
                    //     <Typography variant="h6">
                    //     {capitalCase(tabItem.name)}
                    //   </Typography>
                    //   :
                        
                    //     <Badge badgeContent={tabItem.count} color="warning" max={9999} showZero>
                    //     <Typography variant="h6">
                    //       {capitalCase(tabItem.name)}
                    //     </Typography>
                    //     </Badge>
                    // }
                    //     </>)
                    //     :(
                    //     <Typography variant="h6">
                    //       {capitalCase(tabItem.name)}
                    //     </Typography>
                    //   //  </Badge>
                    //   )
                    //   }
                    label={
                    //   <Badge badgeContent={tabItem.count} color="primary">
                     <Typography variant="subtitle2" sx={{textAlign:'center', ml: 0.5, fontSize:'13px'}}>{capitalCaseWithSlash(tabItem.name.replace('/', ' / '))}</Typography>
                    //    </Badge>
                    }
                    // icon={tabItem.icon}
                    value={tabItem.value}
                  />
                ))}
              </Tabs> */}
              {loadingCards ?
                // <Grid container alignItems={'center'} justifyContent={'center'}>
                //   <Stack sx={{ my: 15 }}>
                //     <LoadingScreen />
                //   </Stack>
                // </Grid>
                <SkeletonLoad />
                :
                // filteredUsers?.length > 0 && filteredUsers?.map((row) => {
                //   const team_member = requestTeam?.length > 0 && requestTeam?.filter(member => member.request_id == row.id) || []

                //   return (
                //     <Grid key={row.id} item xs={12} sm={6} md={4}>
                //       <OfficialCard card={row} team_member={team_member} key={row.id} quotationView={1} />
                //     </Grid>

                //     <DragDropContext onDragEnd={handleOnDragEnd}>
                //     <Droppable droppableId="officialRequests" direction="vertical">
                //       {(provided) => (
                //         <Grid container spacing={3} {...provided.droppableProps} ref={provided.innerRef}>
                //           {allRequest.map((row, index) => (
                //             <Draggable key={row.id} draggableId={row.id.toString()} index={index}>
                //               {(provided, snapshot) => (
                //                 <Grid
                //                   item
                //                   xs={12}
                //                   sm={6}
                //                   md={4}
                //                   sx={{mt:3}}
                //                   ref={provided.innerRef}
                //                   {...provided.draggableProps}
                //                   {...provided.dragHandleProps}
                //                   style={{
                //                     ...provided.draggableProps.style,
                //                     opacity: snapshot.isDragging ? 0.5 : 1,
                //                   }}
                //                 >
                //                   <OfficialCard card={row} team_member={team_member} quotationView={1} />
                //                 </Grid>
                //               )}
                //             </Draggable>
                //           ))}
                //           {provided.placeholder}
                //         </Grid>
                //       )}
                //     </Droppable>
                //   </DragDropContext>
                //   )
                // }
                // )

                <>
                  {filteredUsers?.length > 0 ? (
                    <>
                        {valueTab === 'one' &&
                          <DragDropContext onDragEnd={handleOnDragEnd}>
                            <Droppable droppableId="officialRequests" direction="vertical">
                              {(provided) => (
                                <Grid
                                  container
                                  spacing={0}
                                  sx={{
                                    display: 'grid',
                                    gap: 0,
                                    gridTemplateColumns: {
                                      xs: '1fr',                 // mobile: 1 per row
                                      sm: 'repeat(2, 1fr)',      // tablet: 2 per row
                                      md: 'repeat(4, minmax(0, 1fr))', // desktop: logical 6-column grid
                                      lg: 'repeat(4, minmax(0, 1fr))', // desktop: logical 6-column grid
                                      xl: 'repeat(6, minmax(0, 1fr))', // desktop: logical 6-column grid
                                    },
                                    justifyContent: 'center',    // ✅ centers when fewer items
                                  }}
                                  {...provided.droppableProps}
                                  ref={provided.innerRef}
                                >
                                  {filteredUsers.map((row, index) => {
                                    const team_member =
                                      requestTeam?.length > 0
                                        ? requestTeam.filter((member) => member.request_id === row.id)
                                        : [];
                                    console.log("isNewRowIdPresent-----------------------", isNewRowIdPresent);
                                    let estimateNewCard = false
                                    if (isNewRowIdPresent?.length > 0) {
                                      estimateNewCard = isNewRowIdPresent?.split(',').includes(row.id.toString()) || false;
                                    }
                                    return (
                                      <Draggable
                                        key={row.id}
                                        draggableId={row.id.toString()}
                                        index={index}
                                      >
                                        {(provided, snapshot) => (
                                          <Grid
                                            item
                                            // xs={12}
                                            // sm={6}
                                            // md={4}
                                            sx={{ mt: 3 }}
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={{
                                              ...provided.draggableProps.style,
                                              opacity: snapshot.isDragging ? 0.5 : 1,
                                            }}
                                          >
                                            <OfficialCard
                                              isEstimate={true}
                                              card={row}
                                              team_member={team_member}
                                              quotationView={1}
                                              setRenderCards={setRenderCards}
                                              renderCards={renderCards}
                                              handleOpenDetails={handleOpenDetails}
                                              handleOpenViewEstimate={handleOpenViewEstimate}
                                              handleOpenEstimate={handleOpenEstimate} setHandleOpenEstimate={setHandleOpenEstimate} estimateId={estimateId} setEstimateId={setEstimateId} estimateName={estimateName} setEstimateName={setEstimateName} isEditEstimate={isEditEstimate} setIsEditEstimate={setIsEditEstimate}
                                              estimateNewCard={estimateNewCard}
                                              projectEstimate={true}
                                            />
                                          </Grid>
                                        )}
                                      </Draggable>
                                    );
                                  })}
                                  {provided.placeholder}
                                </Grid>
                              )}
                            </Droppable>
                          </DragDropContext>
                        }
                        {valueTab === 'two' &&
                          <DesignOrderList
                            estimate={true}
                            projectData={filteredUsers}
                            currentTab={currentTab}
                            setRenderCards={setRenderCards}
                            renderCards={renderCards}
                            handleOpenDetails={handleOpenDetails}
                            handleOpenViewEstimate={handleOpenViewEstimate}
                          />}
                        {valueTab === 'three' &&
                          <DesignOrderList
                            estimate={true}
                            projectData={filteredUsers}
                            currentTab={currentTab}
                            setRenderCards={setRenderCards}
                            renderCards={renderCards}
                            handleOpenDetails={handleOpenDetails}
                            handleOpenViewEstimate={handleOpenViewEstimate}
                            noImage={true}
                          />
                        }
                    </>
                  ) : (
                    <Grid container alignItems="center" justifyContent="center">
                      <Stack sx={{ my: 15 }}>
                        <Typography gutterBottom align="center" variant="subtitle1">
                          No {capitalCaseWithSlash(currentTab)} Estimate Found
                        </Typography>
                      </Stack>
                    </Grid>
                  )}
                </>

              }
            </Grid>
          </Scrollbar>
          {/* <Scrollbar>
            {allRequest?.length > 0 && (
              Object.entries(allRequest.reduce((acc, row) => {
                const community = row.community_name || "Others";
                if (!acc[community]) {
                  acc[community] = [];
                }
                acc[community].push(row);
                return acc;
              }, {})).map(([community, groupedRequests]) => (
                <div key={community}>
                  <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => handleExpandToggle(community)}>
                  {expandedCommunities[community] ? <ExpandLess /> : <ExpandMore />}
                  <Typography variant="h6" sx={{marginTop:2,marginBottom:2}}>{community}</Typography>
                  </div>
                  {expandedCommunities[community] && (
                  <Grid container spacing={3}>
                   {groupedRequests?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)?.map((row) => {
                      const team_member = requestTeam?.length > 0 && requestTeam?.filter(member => member.request_id == row.id) || [];
                      // console.log("row-----------------------", row);
                      return (
                        <Grid key={row.id} item xs={12} sm={6} md={4}>
                          <OfficialCard card={row} team_member={team_member} />
                        </Grid>
                      );
                    })}
                  </Grid>
                  )}
                </div>
              ))
            )}
          </Scrollbar> */}
          {loadingCards ? "" :
            <Stack gap={2} sx={{ mt: 2 }}>
              <TablePagination
                rowsPerPageOptions={[12, 24, 48]}
                component="div"
                count={totalCount || 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Stack>
          }
          </>
        )}
        {openPreview && (
          <Modal
            open={openPreview}
            handleClose={() => {
              setOpenPreview(false);
            }}
            modalTitle={'Preview'}
          >
            <Grid container sx={{ justifyContent: 'center' }} spacing={3}>
              <Grid item xs={12} md={12}>
                <Stack
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                  }}
                  spacing={2}
                >
                  <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    display="flex"
                    justifyContent="space-between"
                  >
                    <Typography variant="subtitle2">
                      <span style={{ color: theme.palette.primary.darker }}>Name: </span>
                      {preview?.name}
                    </Typography>
                    <Typography variant="subtitle2">
                      <span style={{ color: theme.palette.primary.darker }}>Use custom welcome message: </span>
                      {preview.welcome_message == null ? 'No' : preview.welcome_message == false ? 'No' : 'Yes'}
                    </Typography>
                  </Stack>
                  <Stack>
                    <Typography variant="subtitle2" style={{ color: theme.palette.primary.darker }}>
                      Description:
                    </Typography>
                    <Typography variant="subtitle2" style={{ overflowWrap: 'break-word', wordWrap: 'break-word', wordBreak: 'break-word' }}>
                      {preview?.description}
                    </Typography>
                  </Stack>
                  <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    display="flex"
                    justifyContent="space-between"
                  >
                    {/* <Typography variant="subtitle2">
                      <span style={{ color:theme.palette.primary.darker,
                        overflowWrap: 'break-word', wordWrap: 'break-word',
                         wordBreak: 'break-word' }}>Skills or services required:</span> <br/>
                          <List>
                           {preview?.skills?.map((val, index) => (
                           <ListItem sx={{ listStyleType: 'disc', paddingLeft: '20px' }} key={index}>
                           <ListItemText primary={val.name} />
                           </ListItem>
                                   ))}
                                </List>
                    </Typography> */}
                    {/* <Typography variant="subtitle2">
                      <span style={{ color:theme.palette.primary.darker }}>Workflows: </span> <br/>                                           
                      <List>
                           {preview?.workflows?.map((val, index) => (
                           <ListItem sx={{ listStyleType: 'dics', paddingLeft: '20px' }} key={index}>
                           <ListItemText primary={val.name} />
                           </ListItem>
                                   ))}
                                </List>
                    </Typography> */}
                  </Stack>
                  <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    display="flex"
                    justifyContent="space-between"
                  >
                    <Typography variant="subtitle2">
                      <span style={{ color: theme.palette.primary.darker }}>Job Class: </span>
                      {preview?.project_type?.name}
                    </Typography>
                    <Typography variant="subtitle2">
                      <span style={{ color: theme.palette.primary.darker, }}>Job Types: </span>
                      {preview?.project_categories?.name}
                    </Typography>
                  </Stack>
                  <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    display="flex"
                    justifyContent="space-between"
                  >
                    <Typography variant="subtitle2">
                      <span style={{ color: theme.palette.primary.darker }}>Project: </span>
                      {preview?.community?.name}
                    </Typography>
                    <Typography variant="subtitle2">
                      <span style={{ color: theme.palette.primary.darker, }}>Markup Type: </span>
                      {preview?.markup_type?.name}
                    </Typography>
                  </Stack>

                  <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    display="flex"
                    justifyContent="space-between"
                  >
                    <Typography variant="subtitle2">
                      <span style={{ color: theme.palette.primary.darker }}>Start Date: </span>
                      {formatDateOnly(preview.start)}
                    </Typography>
                    <Typography variant="subtitle2">
                      <span style={{ color: theme.palette.primary.darker }}>Installation Date: </span>
                      {preview.end ? formatDateOnly(preview.end) : 'Not set'}
                    </Typography>
                    {preview.installation_start_date && (
                      <Typography variant="subtitle2">
                        <span style={{ color: theme.palette.primary.darker }}>Installation Start: </span>
                        {formatDateOnly(preview.installation_start_date)}
                      </Typography>
                    )}
                    {preview.installation_end_date && (
                      <Typography variant="subtitle2">
                        <span style={{ color: theme.palette.primary.darker }}>Installation End: </span>
                        {formatDateOnly(preview.installation_end_date)}
                    </Typography>
                    //  {preview.installation_start_date && preview.installation_end_date ? (
                    //     `${formatDateOnly(preview.installation_start_date)} - ${formatDateOnly(preview.installation_end_date)}`
                    //   ) : (
                    //     preview.end ? formatDateOnly(preview.end) : 'Not set'
                    //   )}
                    )}
                  </Stack>
                  <Scrollbar>
                    <TableContainer sx={{ minWidth: 500 }}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            {VALUEPreview?.map((val) => (
                              val.id === 14 ? (
                                <Tooltip key={val.id} title="Selling Price With Marketing Adjustment">
                                  <TableCell>{val.value}</TableCell>
                                </Tooltip>
                                // ) : (val.id === 2 ? (
                                //   <Tooltip key={val.id} title="((Wholesale Price - Product Formula Cost)/Product Formula Cost) * 100">
                                //     <TableCell>{val.value}</TableCell>
                                //   </Tooltip>
                              )
                                : (
                                  <TableCell key={val.id}>{val.value}</TableCell>
                                )
                              // )
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {selectedProducts?.map((data, index) => {
                            const quantityFieldName = `quantity_${index}`;
                            const discountFieldName = `discount_${index}`;
                            const adjustmentFieldName = `adjustment_${index}`;
                            let unitName = UNITS?.filter((item) => item?.id == data?.unit)
                            unitName = unitName[0]?.name
                            let shortUnitName = ''
                            if (unitName == 'Square feet') {
                              shortUnitName = 'Sq ft'
                            } else if (unitName == 'Lineal feet') {
                              shortUnitName = 'Lin ft'
                            } else if (unitName == 'Square Inches') {
                              shortUnitName = 'Sq Inches'
                            } else if (unitName == 'Unit') {
                              shortUnitName = 'Unit'
                            }
                            const rowTotal = calculateTotal(markupType == 1 ? data.price : (markupType == 2 ? data.retail_price : 0), Number(data.quantity), values[discountFieldName], data.locationQuantity, data?.adjustment,data.markAdjType,data.adj_value_type);
                            // Accumulate the totalAmount
                            totalAmount += rowTotal;
                            values['sub_total'] = totalAmount?.toFixed(2)
                            const invoiceAmount = parseFloat(data?.expected_material_cost?.toFixed(2)) + parseFloat(data?.expected_total_service_cost?.toFixed(2))
                            // const markup = ((data.retail_price - data.price) / data.price) * 100;
                            // const markup = (markupType == 1 ? (data.expected_cost / data.price - ) : markupType == 2 ? (data.expected_cost / data.retail_price) : null )


                            let markup = markupType == 1 ? (((data.price - parseFloat(data.expected_cost?.toFixed(2))) / parseFloat(data.expected_cost?.toFixed(2))) * 100)
                              : (markupType == 2 ? (((data.retail_price - parseFloat(data.expected_cost?.toFixed(2))) / parseFloat(data.expected_cost?.toFixed(2))) * 100) : 0);

                            markup = markup ? Number(markup) : 0

                            // let markup = markupType ? (invoiceAmount / rowTotal) : null
                            // markup = markup ? Number(markup) : 0
                            let originalMarkup = markupType == 1 ? data.wholesaleMarkup : markupType == 2 ? data.retailMarkup : 0
                            return (
                              <TableRow key={index}>
                                <TableCell>#{data?.indexId}</TableCell>
                                <TableCell>{data.service_notes ? <Typography sx={{ color: 'red', whiteSpace: 'pre-wrap' }}>{data.service_notes}</Typography> : data.name}</TableCell>
                                {/* <TableCell>{invoiceAmount}</TableCell> */}
                                <TableCell>{(hasMarkupPermission && markupType == 2) ? data.retail_price : null}</TableCell>
                                <TableCell>{(hasMarkupPermission && markupType == 1) ? data.price : null}</TableCell>
                                <TableCell>{hasMarkupPermission ? (data?.SPMA?.toFixed(2) || null) : null}</TableCell>
                                <TableCell>{hasMarkupPermission ? originalMarkup?.toFixed(2) : null}</TableCell>
                                {/* <TableCell>{hasMarkupPermission ? (markup * data.quantity).toFixed(2) : null}</TableCell> */}
                                {/* <TableCell>{shortUnitName}</TableCell> */}
                                <TableCell>
                                  <TextField required
                                    fullWidth
                                    sx={{ width: 85 }}
                                    type='number'
                                    disabled
                                    label={shortUnitName}
                                    value={Number(data.quantity)}
                                    defaultValue={1}
                                  />
                                </TableCell>
                                <TableCell>
                                  <TextField required
                                    fullWidth
                                    type='number'
                                    disabled
                                    label={'Qty'}
                                    value={Number(data.locationQuantity)}
                                    defaultValue={1}
                                  />
                                </TableCell>
                                {/* <TableCell>{data.id}</TableCell> */}
                                <TableCell align="center">
                                  {/* <TextField
                                    disabled
                                    type="number"
                                    label="Discount"
                                    defaultValue={0}
                                    {...getFieldProps(discountFieldName)}
                                  /> */}
                                  {data?.adjustment ? Number(data?.adjustment)?.toFixed(2) : 0}
                                </TableCell>
                                <TableCell>
                                  {calculateTotal(markupType == 1 ? data.price : (markupType == 2 ? data.retail_price : 0), values[quantityFieldName], values[discountFieldName], data.locationQuantity, data?.adjustment,data.markAdjType,data.adj_value_type)?.toFixed(2)}
                                </TableCell>
                              </TableRow>
                            );
                          })}

                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Scrollbar>
                  <Scrollbar>
                    <TableContainer sx={{ minWidth: 500 }}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            {VALUE_SERVICES?.map((val,index) => (
                              <TableCell>{val.value}</TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {selectedServices?.map((data, index) => {
                            let originalMarkup = data.originalMarkup || 0
                            const newQty = data.previousQty * (data.qtyData || 1) * data.locationQuantity;
                            const quantityDifference = Number(data.quantity) - newQty;
                            data['quantityDifference'] = quantityDifference
                            return (
                              <TableRow key={index}>
                                <TableCell>{index + 1}</TableCell>
                                {/* <TableCell>#{data.productIndex}</TableCell> */}
                                <TableCell>{data.service_notes ? <Typography sx={{ color: 'red', whiteSpace: 'pre-wrap' }}>{data.service_notes}</Typography> : data.name}</TableCell>
                                <TableCell>
                                  <IconButton onClick={() => handleOpenServiceNote(data.indexId, data.service_notes)}>
                                    <NoteAdd
                                      sx={{
                                        color: (!data?.service_notes || data?.service_notes === '') ? '' : theme.palette.primary.main,
                                      }}
                                    />
                                  </IconButton>
                                </TableCell>
                                <TableCell>{originalMarkup?.toFixed(2)}</TableCell>
                                <TableCell>{data.cost}</TableCell>
                                <TableCell>{data.total_cost}</TableCell>
                                <TableCell>{data.quantity}</TableCell>
                                <TableCell>{(data.cost * quantityDifference?.toFixed(2))?.toFixed(2)}</TableCell>
                                <TableCell>{(data.unit_cost * quantityDifference?.toFixed(2))?.toFixed(2)}</TableCell>
                                <TableCell>{data.total}</TableCell>
                                <TableCell></TableCell>
                              </TableRow>
                            );
                          })}
                          {additionalSelectedServices?.map((data, index) => {
                            let originalMarkup = data.originalMarkup || 0
                            const quantityDifference = Number(data.quantity)
                            data['quantityDifference'] = quantityDifference
                            return (
                              <TableRow key={index}>
                                <TableCell>{ }</TableCell>
                                <TableCell>{data.service_notes ? <Typography sx={{ color: 'red', whiteSpace: 'pre-wrap' }}>{data.service_notes}</Typography> : data.name}</TableCell>
                                <TableCell>
                                  <IconButton onClick={() => handleOpenServiceNote(data.newIndexId || data.indexId, data.service_notes)}>
                                    <NoteAdd
                                      sx={{
                                        color: (!data?.service_notes || data?.service_notes === '') ? '' : theme.palette.primary.main,
                                      }}
                                    />
                                  </IconButton>
                                </TableCell>
                                <TableCell>{originalMarkup?.toFixed(2)}</TableCell>
                                <TableCell>{data.cost}</TableCell>
                                <TableCell>{data.total_cost}</TableCell>
                                <TableCell>{data?.quantity || 1}</TableCell>
                                <TableCell>{(data.cost * quantityDifference?.toFixed(2))?.toFixed(2)}</TableCell>
                                <TableCell>{data.total}</TableCell>
                                <TableCell></TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Scrollbar>
                  <Stack>
                    <Typography variant="subtitle2" style={{ color: theme.palette.primary.darker }}>
                      Notes:
                    </Typography>
                    <Typography variant="subtitle2" sx={{ overflowWrap: 'break-word', wordWrap: 'break-word', wordBreak: 'break-word', textAlign: "justify",color: 'error.main'  }}>
                      <Scrollbar
                        sx={{
                          maxHeight: 200,
                          '& .simplebar-content': {
                            maxHeight: 200,
                            display: 'flex',
                            flexDirection: 'column',
                          },
                        }}
                      >{preview?.notes}</Scrollbar>

                    </Typography>
                  </Stack>
                  <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    display="flex"
                    justifyContent="space-between"
                  >
                    <Typography variant="subtitle2">
                      <span style={{ color: theme.palette.primary.darker }}>Total Price: </span>
                      {grandTotal ? (grandTotal < 0 ? 0.00 : parseFloat(grandTotal)?.toFixed(2)) : 0.00}
                    </Typography>
                    <Tooltip title="Sub Total - Total Product Formula Cost">
                      <Typography variant="subtitle2" sx={{ cursor: 'pointer' }}>
                        <span style={{ color: theme.palette.primary.darker }}>Total Markup Amount: </span>
                        {markupType == 1 ? ((totalWholesalePrice - DiscountTotal) - totalProductFormula)?.toFixed(2) : ((totalRetailPrice - DiscountTotal) - totalProductFormula)?.toFixed(2)}
                        {/* {originaltotalMarkup ? (originaltotalMarkup / selectedProducts.length)?.toFixed(2) : 0} */}
                      </Typography>
                    </Tooltip>

                    <Tooltip title="(Total Markup Amount / Total Product Formula Cost) * 100">
                      <Typography variant="subtitle2" sx={{ cursor: 'pointer' }}>
                        <span style={{ color: theme.palette.primary.darker }}>Total Markup Percentage: </span>
                        {markupType === 1
                          ? (totalProductFormula !== 0
                            ? ((((totalWholesalePrice - DiscountTotal) - totalProductFormula) / totalProductFormula) * 100).toFixed(2)
                            : '0.00')
                          : markupType === 2
                            ? (totalProductFormula !== 0
                              ? ((((totalRetailPrice - DiscountTotal) - totalProductFormula) / totalProductFormula) * 100).toFixed(2)
                              : '0.00')
                            : '0.00'}
                        {/* {originaltotalMarkup ? (originaltotalMarkup / selectedProducts.length)?.toFixed(2) : 0} */}
                      </Typography>
                    </Tooltip>

                    {/* <Typography variant="subtitle2">
                      <span style={{ color: theme.palette.primary.darker }}>Total Service Markup: </span>
                      {originaltotalServiceMarkup ? (originaltotalServiceMarkup / (selectedServices.length + additionalSelectedServices.length))?.toFixed(2) : 0}
                    </Typography> */}
                    <Typography variant="subtitle2">
                      <span style={{ color: theme.palette.primary.darker }}>Total Discount: </span>
                      {DiscountTotal ? DiscountTotal?.toFixed(2) : 0.00}
                    </Typography>
                  </Stack>
                  <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    display="flex"
                    justifyContent="space-between"
                  >
                    <Typography variant="subtitle2">
                      <Label
                        variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                        color={getStatusColorAndLabel(status).color} >
                        {getStatusColorAndLabel(status).label}
                      </Label>
                    </Typography>
                  </Stack>

                </Stack>
              </Grid>
            </Grid>
          </Modal>
        )}
        
                <Dialog open={openDialog} >
            <DialogTitle>Select Stock Type</DialogTitle>
            <DialogContent>
              <RadioGroup
                value={String(stockType)}
                onChange={(e) => {
                  const val = e.target.value;
                  setStockType(val === '1' ? 1 : 2);
                  if (val === '1') setConvertionUnit(0);
                }}
              >
                <FormControlLabel value="1" control={<Radio />} label="Finished Product" />
                <FormControlLabel value="2" control={<Radio />} label="Partial Finished Product" />
              </RadioGroup>
        
              {stockType === 2 && (
                partialProducts.length > 0 ? (
                  <>
                    <Typography>Select Conversion Unit</Typography>
                    <RadioGroup
                      value={convertionUnit}
                      onChange={(e) => setConvertionUnit(Number(e.target.value))}
                    >
                      {UNITS
                        .filter(u => partialProducts.some(p => p.partial_unit === u.id))
                        .map(u => (
                          <FormControlLabel
                            key={u.id}
                            value={u.id}
                            control={<Radio />}
                            label={u.name}
                          />
                        ))}
                    </RadioGroup>
                  </>
                ) : (
                  <Typography color="error">No partial stock found</Typography>
                )
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={closeDialog} color="error">Cancel</Button>
              <Button
                onClick={handleSubmitPopUp}
                disabled={stockType === 2 && partialProducts.length === 0}
                variant="contained"
              >
                Add Material
              </Button>
            </DialogActions>
          </Dialog>
      </Container>
      <FullScreenDialogEstimate open={handleOpenEstimate} 
      setOpen={setHandleOpenEstimate} handleClickOpen={handleOpenViewEstimate} 
      projectName={estimateName} projectId={estimateId} 
      isEditEstimate={isEditEstimate} setRenderCards={setRenderCards} 
      renderCards={renderCards} setIsEditEstimate={setIsEditEstimate} projectEstimate={true} />

      {/* Auto-save confirmation dialog */}
      <Dialog
        open={openBackConfirm}
        onClose={() => setOpenBackConfirm(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Go back?</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Do you want to auto save this estimate before going back?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleBackConfirmNo} variant="outlined" color="primary">
            No, Go Back
          </Button>
          <Button onClick={handleBackConfirmYes} variant="contained" color="primary">
            Yes, Auto Save
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  )
}